export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  uuid: any,
  timestamptz: any,
  jsonb: any,
  numeric: any,
  smallint: any,
  Date: any,
  bigint: any,
  json: any,
};

export type Add_Campaign_To_Order_Response = {
  __typename?: 'add_campaign_to_order_response',
  affected_rows: Scalars['numeric'],
};

export type Addon = {
  __typename?: 'addon',
  absolute_order: Scalars['Int'],
  addon_addon_groups: Array<Addon_Addon_Group>,
  addon_addon_groups_aggregate: Addon_Addon_Group_Aggregate,
  back_desc_large_screen: Scalars['String'],
  back_desc_small_screen: Scalars['String'],
  benefits: Array<Benefit>,
  benefits_aggregate: Benefit_Aggregate,
  code: Scalars['String'],
  created_at: Scalars['timestamptz'],
  default_status: Scalars['Boolean'],
  exclusion_group?: Maybe<Scalars['String']>,
  external_product_id?: Maybe<Scalars['jsonb']>,
  front_desc_large_screen: Scalars['String'],
  front_desc_small_screen: Scalars['String'],
  group_order: Scalars['Int'],
  id: Scalars['uuid'],
  image: Scalars['String'],
  inclusion_addons: Array<Inclusion_Addon>,
  inclusion_addons_aggregate: Inclusion_Addon_Aggregate,
  is_one_time_purchase: Scalars['Boolean'],
  max_qty: Scalars['Int'],
  min_qty: Scalars['Int'],
  name: Scalars['String'],
  price: Scalars['Int'],
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  recommended_flag: Scalars['Boolean'],
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type: Scalars['String'],
  updated_at: Scalars['timestamptz'],
};


export type AddonAddon_Addon_GroupsArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type AddonAddon_Addon_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type AddonBenefitsArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type AddonBenefits_AggregateArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type AddonExternal_Product_IdArgs = {
  path?: Maybe<Scalars['String']>
};


export type AddonInclusion_AddonsArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type AddonInclusion_Addons_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};

export type Addon_Addon_Group = {
  __typename?: 'addon_addon_group',
  addon: Addon,
  addon_group: Addon_Group,
  addon_group_id: Scalars['uuid'],
  addon_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  updated_at: Scalars['timestamptz'],
};

export type Addon_Addon_Group_Aggregate = {
  __typename?: 'addon_addon_group_aggregate',
  aggregate?: Maybe<Addon_Addon_Group_Aggregate_Fields>,
  nodes: Array<Addon_Addon_Group>,
};

export type Addon_Addon_Group_Aggregate_Fields = {
  __typename?: 'addon_addon_group_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Addon_Addon_Group_Max_Fields>,
  min?: Maybe<Addon_Addon_Group_Min_Fields>,
};


export type Addon_Addon_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Addon_Addon_Group_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Addon_Addon_Group_Max_Order_By>,
  min?: Maybe<Addon_Addon_Group_Min_Order_By>,
};

export type Addon_Addon_Group_Arr_Rel_Insert_Input = {
  data: Array<Addon_Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Addon_Addon_Group_On_Conflict>,
};

export type Addon_Addon_Group_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Addon_Addon_Group_Bool_Exp>>>,
  _not?: Maybe<Addon_Addon_Group_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Addon_Addon_Group_Bool_Exp>>>,
  addon?: Maybe<Addon_Bool_Exp>,
  addon_group?: Maybe<Addon_Group_Bool_Exp>,
  addon_group_id?: Maybe<Uuid_Comparison_Exp>,
  addon_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Addon_Addon_Group_Constraint {
  AddonAddonGroupPkey = 'addon_addon_group_pkey'
}

export type Addon_Addon_Group_Insert_Input = {
  addon?: Maybe<Addon_Obj_Rel_Insert_Input>,
  addon_group?: Maybe<Addon_Group_Obj_Rel_Insert_Input>,
  addon_group_id?: Maybe<Scalars['uuid']>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Addon_Group_Max_Fields = {
  __typename?: 'addon_addon_group_max_fields',
  addon_group_id?: Maybe<Scalars['uuid']>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Addon_Group_Max_Order_By = {
  addon_group_id?: Maybe<Order_By>,
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Addon_Group_Min_Fields = {
  __typename?: 'addon_addon_group_min_fields',
  addon_group_id?: Maybe<Scalars['uuid']>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Addon_Group_Min_Order_By = {
  addon_group_id?: Maybe<Order_By>,
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Addon_Group_Mutation_Response = {
  __typename?: 'addon_addon_group_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Addon_Addon_Group>,
};

export type Addon_Addon_Group_Obj_Rel_Insert_Input = {
  data: Addon_Addon_Group_Insert_Input,
  on_conflict?: Maybe<Addon_Addon_Group_On_Conflict>,
};

export type Addon_Addon_Group_On_Conflict = {
  constraint: Addon_Addon_Group_Constraint,
  update_columns: Array<Addon_Addon_Group_Update_Column>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>,
};

export type Addon_Addon_Group_Order_By = {
  addon?: Maybe<Addon_Order_By>,
  addon_group?: Maybe<Addon_Group_Order_By>,
  addon_group_id?: Maybe<Order_By>,
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Addon_Group_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Addon_Addon_Group_Select_Column {
  AddonGroupId = 'addon_group_id',
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Id = 'id',
  UpdatedAt = 'updated_at'
}

export type Addon_Addon_Group_Set_Input = {
  addon_group_id?: Maybe<Scalars['uuid']>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Addon_Addon_Group_Update_Column {
  AddonGroupId = 'addon_group_id',
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Id = 'id',
  UpdatedAt = 'updated_at'
}

export type Addon_Aggregate = {
  __typename?: 'addon_aggregate',
  aggregate?: Maybe<Addon_Aggregate_Fields>,
  nodes: Array<Addon>,
};

export type Addon_Aggregate_Fields = {
  __typename?: 'addon_aggregate_fields',
  avg?: Maybe<Addon_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Addon_Max_Fields>,
  min?: Maybe<Addon_Min_Fields>,
  stddev?: Maybe<Addon_Stddev_Fields>,
  stddev_pop?: Maybe<Addon_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Addon_Stddev_Samp_Fields>,
  sum?: Maybe<Addon_Sum_Fields>,
  var_pop?: Maybe<Addon_Var_Pop_Fields>,
  var_samp?: Maybe<Addon_Var_Samp_Fields>,
  variance?: Maybe<Addon_Variance_Fields>,
};


export type Addon_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addon_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Addon_Aggregate_Order_By = {
  avg?: Maybe<Addon_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Addon_Max_Order_By>,
  min?: Maybe<Addon_Min_Order_By>,
  stddev?: Maybe<Addon_Stddev_Order_By>,
  stddev_pop?: Maybe<Addon_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Addon_Stddev_Samp_Order_By>,
  sum?: Maybe<Addon_Sum_Order_By>,
  var_pop?: Maybe<Addon_Var_Pop_Order_By>,
  var_samp?: Maybe<Addon_Var_Samp_Order_By>,
  variance?: Maybe<Addon_Variance_Order_By>,
};

export type Addon_Append_Input = {
  external_product_id?: Maybe<Scalars['jsonb']>,
};

export type Addon_Arr_Rel_Insert_Input = {
  data: Array<Addon_Insert_Input>,
  on_conflict?: Maybe<Addon_On_Conflict>,
};

export type Addon_Avg_Fields = {
  __typename?: 'addon_avg_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Avg_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Addon_Bool_Exp>>>,
  _not?: Maybe<Addon_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Addon_Bool_Exp>>>,
  absolute_order?: Maybe<Int_Comparison_Exp>,
  addon_addon_groups?: Maybe<Addon_Addon_Group_Bool_Exp>,
  back_desc_large_screen?: Maybe<String_Comparison_Exp>,
  back_desc_small_screen?: Maybe<String_Comparison_Exp>,
  benefits?: Maybe<Benefit_Bool_Exp>,
  code?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  default_status?: Maybe<Boolean_Comparison_Exp>,
  exclusion_group?: Maybe<String_Comparison_Exp>,
  external_product_id?: Maybe<Jsonb_Comparison_Exp>,
  front_desc_large_screen?: Maybe<String_Comparison_Exp>,
  front_desc_small_screen?: Maybe<String_Comparison_Exp>,
  group_order?: Maybe<Int_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  image?: Maybe<String_Comparison_Exp>,
  inclusion_addons?: Maybe<Inclusion_Addon_Bool_Exp>,
  is_one_time_purchase?: Maybe<Boolean_Comparison_Exp>,
  max_qty?: Maybe<Int_Comparison_Exp>,
  min_qty?: Maybe<Int_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  price?: Maybe<Int_Comparison_Exp>,
  price_book_entry_salesforce_id?: Maybe<String_Comparison_Exp>,
  recommended_flag?: Maybe<Boolean_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  type?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Addon_Constraint {
  AddonCodeKey = 'addon_code_key',
  AddonPkey = 'addon_pkey'
}

export type Addon_Delete_At_Path_Input = {
  external_product_id?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Addon_Delete_Elem_Input = {
  external_product_id?: Maybe<Scalars['Int']>,
};

export type Addon_Delete_Key_Input = {
  external_product_id?: Maybe<Scalars['String']>,
};

export type Addon_Group = {
  __typename?: 'addon_group',
  addon_addon_groups: Array<Addon_Addon_Group>,
  addon_addon_groups_aggregate: Addon_Addon_Group_Aggregate,
  campaign_addon_groups: Array<Campaign_Addon_Group>,
  campaign_addon_groups_aggregate: Campaign_Addon_Group_Aggregate,
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  order: Scalars['Int'],
  short_title?: Maybe<Scalars['String']>,
  subtitle: Scalars['String'],
  title: Scalars['String'],
  type: Addon_Group_Type_Enum,
  updated_at: Scalars['timestamptz'],
};


export type Addon_GroupAddon_Addon_GroupsArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Addon_GroupAddon_Addon_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Addon_GroupCampaign_Addon_GroupsArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type Addon_GroupCampaign_Addon_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};

export type Addon_Group_Aggregate = {
  __typename?: 'addon_group_aggregate',
  aggregate?: Maybe<Addon_Group_Aggregate_Fields>,
  nodes: Array<Addon_Group>,
};

export type Addon_Group_Aggregate_Fields = {
  __typename?: 'addon_group_aggregate_fields',
  avg?: Maybe<Addon_Group_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Addon_Group_Max_Fields>,
  min?: Maybe<Addon_Group_Min_Fields>,
  stddev?: Maybe<Addon_Group_Stddev_Fields>,
  stddev_pop?: Maybe<Addon_Group_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Addon_Group_Stddev_Samp_Fields>,
  sum?: Maybe<Addon_Group_Sum_Fields>,
  var_pop?: Maybe<Addon_Group_Var_Pop_Fields>,
  var_samp?: Maybe<Addon_Group_Var_Samp_Fields>,
  variance?: Maybe<Addon_Group_Variance_Fields>,
};


export type Addon_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addon_Group_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Addon_Group_Aggregate_Order_By = {
  avg?: Maybe<Addon_Group_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Addon_Group_Max_Order_By>,
  min?: Maybe<Addon_Group_Min_Order_By>,
  stddev?: Maybe<Addon_Group_Stddev_Order_By>,
  stddev_pop?: Maybe<Addon_Group_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Addon_Group_Stddev_Samp_Order_By>,
  sum?: Maybe<Addon_Group_Sum_Order_By>,
  var_pop?: Maybe<Addon_Group_Var_Pop_Order_By>,
  var_samp?: Maybe<Addon_Group_Var_Samp_Order_By>,
  variance?: Maybe<Addon_Group_Variance_Order_By>,
};

export type Addon_Group_Arr_Rel_Insert_Input = {
  data: Array<Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Addon_Group_On_Conflict>,
};

export type Addon_Group_Avg_Fields = {
  __typename?: 'addon_group_avg_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Avg_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Addon_Group_Bool_Exp>>>,
  _not?: Maybe<Addon_Group_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Addon_Group_Bool_Exp>>>,
  addon_addon_groups?: Maybe<Addon_Addon_Group_Bool_Exp>,
  campaign_addon_groups?: Maybe<Campaign_Addon_Group_Bool_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  short_title?: Maybe<String_Comparison_Exp>,
  subtitle?: Maybe<String_Comparison_Exp>,
  title?: Maybe<String_Comparison_Exp>,
  type?: Maybe<Addon_Group_Type_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Addon_Group_Constraint {
  AddonGroupPkey = 'addon_group_pkey'
}

export type Addon_Group_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
};

export type Addon_Group_Insert_Input = {
  addon_addon_groups?: Maybe<Addon_Addon_Group_Arr_Rel_Insert_Input>,
  campaign_addon_groups?: Maybe<Campaign_Addon_Group_Arr_Rel_Insert_Input>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  short_title?: Maybe<Scalars['String']>,
  subtitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  type?: Maybe<Addon_Group_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Group_Max_Fields = {
  __typename?: 'addon_group_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  short_title?: Maybe<Scalars['String']>,
  subtitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Group_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  short_title?: Maybe<Order_By>,
  subtitle?: Maybe<Order_By>,
  title?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Group_Min_Fields = {
  __typename?: 'addon_group_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  short_title?: Maybe<Scalars['String']>,
  subtitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Group_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  short_title?: Maybe<Order_By>,
  subtitle?: Maybe<Order_By>,
  title?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Group_Mutation_Response = {
  __typename?: 'addon_group_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Addon_Group>,
};

export type Addon_Group_Obj_Rel_Insert_Input = {
  data: Addon_Group_Insert_Input,
  on_conflict?: Maybe<Addon_Group_On_Conflict>,
};

export type Addon_Group_On_Conflict = {
  constraint: Addon_Group_Constraint,
  update_columns: Array<Addon_Group_Update_Column>,
  where?: Maybe<Addon_Group_Bool_Exp>,
};

export type Addon_Group_Order_By = {
  addon_addon_groups_aggregate?: Maybe<Addon_Addon_Group_Aggregate_Order_By>,
  campaign_addon_groups_aggregate?: Maybe<Campaign_Addon_Group_Aggregate_Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  short_title?: Maybe<Order_By>,
  subtitle?: Maybe<Order_By>,
  title?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Group_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Addon_Group_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Order = 'order',
  ShortTitle = 'short_title',
  Subtitle = 'subtitle',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Addon_Group_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  short_title?: Maybe<Scalars['String']>,
  subtitle?: Maybe<Scalars['String']>,
  title?: Maybe<Scalars['String']>,
  type?: Maybe<Addon_Group_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Group_Stddev_Fields = {
  __typename?: 'addon_group_stddev_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Stddev_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Stddev_Pop_Fields = {
  __typename?: 'addon_group_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Stddev_Samp_Fields = {
  __typename?: 'addon_group_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Sum_Fields = {
  __typename?: 'addon_group_sum_fields',
  order?: Maybe<Scalars['Int']>,
};

export type Addon_Group_Sum_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Type = {
  __typename?: 'addon_group_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Addon_Group_Type_Aggregate = {
  __typename?: 'addon_group_type_aggregate',
  aggregate?: Maybe<Addon_Group_Type_Aggregate_Fields>,
  nodes: Array<Addon_Group_Type>,
};

export type Addon_Group_Type_Aggregate_Fields = {
  __typename?: 'addon_group_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Addon_Group_Type_Max_Fields>,
  min?: Maybe<Addon_Group_Type_Min_Fields>,
};


export type Addon_Group_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addon_Group_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Addon_Group_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Addon_Group_Type_Max_Order_By>,
  min?: Maybe<Addon_Group_Type_Min_Order_By>,
};

export type Addon_Group_Type_Arr_Rel_Insert_Input = {
  data: Array<Addon_Group_Type_Insert_Input>,
  on_conflict?: Maybe<Addon_Group_Type_On_Conflict>,
};

export type Addon_Group_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Addon_Group_Type_Bool_Exp>>>,
  _not?: Maybe<Addon_Group_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Addon_Group_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Addon_Group_Type_Constraint {
  AddonGroupTypePkey = 'addon_group_type_pkey'
}

export enum Addon_Group_Type_Enum {
  Portal = 'PORTAL',
  SelectMany = 'SELECT_MANY',
  SelectOne = 'SELECT_ONE'
}

export type Addon_Group_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Addon_Group_Type_Enum>,
  _in?: Maybe<Array<Addon_Group_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Addon_Group_Type_Enum>,
  _nin?: Maybe<Array<Addon_Group_Type_Enum>>,
};

export type Addon_Group_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Addon_Group_Type_Max_Fields = {
  __typename?: 'addon_group_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Addon_Group_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Group_Type_Min_Fields = {
  __typename?: 'addon_group_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Addon_Group_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Group_Type_Mutation_Response = {
  __typename?: 'addon_group_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Addon_Group_Type>,
};

export type Addon_Group_Type_Obj_Rel_Insert_Input = {
  data: Addon_Group_Type_Insert_Input,
  on_conflict?: Maybe<Addon_Group_Type_On_Conflict>,
};

export type Addon_Group_Type_On_Conflict = {
  constraint: Addon_Group_Type_Constraint,
  update_columns: Array<Addon_Group_Type_Update_Column>,
  where?: Maybe<Addon_Group_Type_Bool_Exp>,
};

export type Addon_Group_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Group_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Addon_Group_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Addon_Group_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Addon_Group_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Addon_Group_Update_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Order = 'order',
  ShortTitle = 'short_title',
  Subtitle = 'subtitle',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Addon_Group_Var_Pop_Fields = {
  __typename?: 'addon_group_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Var_Samp_Fields = {
  __typename?: 'addon_group_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Group_Variance_Fields = {
  __typename?: 'addon_group_variance_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Addon_Group_Variance_Order_By = {
  order?: Maybe<Order_By>,
};

export type Addon_Inc_Input = {
  absolute_order?: Maybe<Scalars['Int']>,
  group_order?: Maybe<Scalars['Int']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
};

export type Addon_Insert_Input = {
  absolute_order?: Maybe<Scalars['Int']>,
  addon_addon_groups?: Maybe<Addon_Addon_Group_Arr_Rel_Insert_Input>,
  back_desc_large_screen?: Maybe<Scalars['String']>,
  back_desc_small_screen?: Maybe<Scalars['String']>,
  benefits?: Maybe<Benefit_Arr_Rel_Insert_Input>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_status?: Maybe<Scalars['Boolean']>,
  exclusion_group?: Maybe<Scalars['String']>,
  external_product_id?: Maybe<Scalars['jsonb']>,
  front_desc_large_screen?: Maybe<Scalars['String']>,
  front_desc_small_screen?: Maybe<Scalars['String']>,
  group_order?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  inclusion_addons?: Maybe<Inclusion_Addon_Arr_Rel_Insert_Input>,
  is_one_time_purchase?: Maybe<Scalars['Boolean']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  recommended_flag?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Max_Fields = {
  __typename?: 'addon_max_fields',
  absolute_order?: Maybe<Scalars['Int']>,
  back_desc_large_screen?: Maybe<Scalars['String']>,
  back_desc_small_screen?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  exclusion_group?: Maybe<Scalars['String']>,
  front_desc_large_screen?: Maybe<Scalars['String']>,
  front_desc_small_screen?: Maybe<Scalars['String']>,
  group_order?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Max_Order_By = {
  absolute_order?: Maybe<Order_By>,
  back_desc_large_screen?: Maybe<Order_By>,
  back_desc_small_screen?: Maybe<Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  exclusion_group?: Maybe<Order_By>,
  front_desc_large_screen?: Maybe<Order_By>,
  front_desc_small_screen?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Min_Fields = {
  __typename?: 'addon_min_fields',
  absolute_order?: Maybe<Scalars['Int']>,
  back_desc_large_screen?: Maybe<Scalars['String']>,
  back_desc_small_screen?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  exclusion_group?: Maybe<Scalars['String']>,
  front_desc_large_screen?: Maybe<Scalars['String']>,
  front_desc_small_screen?: Maybe<Scalars['String']>,
  group_order?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Min_Order_By = {
  absolute_order?: Maybe<Order_By>,
  back_desc_large_screen?: Maybe<Order_By>,
  back_desc_small_screen?: Maybe<Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  exclusion_group?: Maybe<Order_By>,
  front_desc_large_screen?: Maybe<Order_By>,
  front_desc_small_screen?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Mutation_Response = {
  __typename?: 'addon_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Addon>,
};

export type Addon_Obj_Rel_Insert_Input = {
  data: Addon_Insert_Input,
  on_conflict?: Maybe<Addon_On_Conflict>,
};

export type Addon_On_Conflict = {
  constraint: Addon_Constraint,
  update_columns: Array<Addon_Update_Column>,
  where?: Maybe<Addon_Bool_Exp>,
};

export type Addon_Order_By = {
  absolute_order?: Maybe<Order_By>,
  addon_addon_groups_aggregate?: Maybe<Addon_Addon_Group_Aggregate_Order_By>,
  back_desc_large_screen?: Maybe<Order_By>,
  back_desc_small_screen?: Maybe<Order_By>,
  benefits_aggregate?: Maybe<Benefit_Aggregate_Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_status?: Maybe<Order_By>,
  exclusion_group?: Maybe<Order_By>,
  external_product_id?: Maybe<Order_By>,
  front_desc_large_screen?: Maybe<Order_By>,
  front_desc_small_screen?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  inclusion_addons_aggregate?: Maybe<Inclusion_Addon_Aggregate_Order_By>,
  is_one_time_purchase?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  recommended_flag?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Addon_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Addon_Prepend_Input = {
  external_product_id?: Maybe<Scalars['jsonb']>,
};

export type Addon_Price = {
  __typename?: 'addon_price',
  addon_type: Scalars['String'],
  allowed?: Maybe<Scalars['Boolean']>,
  duration?: Maybe<Scalars['Int']>,
  id: Scalars['uuid'],
  key: Scalars['String'],
  product?: Maybe<Scalars['String']>,
  updated_on: Scalars['timestamptz'],
  value: Scalars['Int'],
};

export type Addon_Price_Aggregate = {
  __typename?: 'addon_price_aggregate',
  aggregate?: Maybe<Addon_Price_Aggregate_Fields>,
  nodes: Array<Addon_Price>,
};

export type Addon_Price_Aggregate_Fields = {
  __typename?: 'addon_price_aggregate_fields',
  avg?: Maybe<Addon_Price_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Addon_Price_Max_Fields>,
  min?: Maybe<Addon_Price_Min_Fields>,
  stddev?: Maybe<Addon_Price_Stddev_Fields>,
  stddev_pop?: Maybe<Addon_Price_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Addon_Price_Stddev_Samp_Fields>,
  sum?: Maybe<Addon_Price_Sum_Fields>,
  var_pop?: Maybe<Addon_Price_Var_Pop_Fields>,
  var_samp?: Maybe<Addon_Price_Var_Samp_Fields>,
  variance?: Maybe<Addon_Price_Variance_Fields>,
};


export type Addon_Price_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Addon_Price_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Addon_Price_Aggregate_Order_By = {
  avg?: Maybe<Addon_Price_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Addon_Price_Max_Order_By>,
  min?: Maybe<Addon_Price_Min_Order_By>,
  stddev?: Maybe<Addon_Price_Stddev_Order_By>,
  stddev_pop?: Maybe<Addon_Price_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Addon_Price_Stddev_Samp_Order_By>,
  sum?: Maybe<Addon_Price_Sum_Order_By>,
  var_pop?: Maybe<Addon_Price_Var_Pop_Order_By>,
  var_samp?: Maybe<Addon_Price_Var_Samp_Order_By>,
  variance?: Maybe<Addon_Price_Variance_Order_By>,
};

export type Addon_Price_Arr_Rel_Insert_Input = {
  data: Array<Addon_Price_Insert_Input>,
  on_conflict?: Maybe<Addon_Price_On_Conflict>,
};

export type Addon_Price_Avg_Fields = {
  __typename?: 'addon_price_avg_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Avg_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Addon_Price_Bool_Exp>>>,
  _not?: Maybe<Addon_Price_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Addon_Price_Bool_Exp>>>,
  addon_type?: Maybe<String_Comparison_Exp>,
  allowed?: Maybe<Boolean_Comparison_Exp>,
  duration?: Maybe<Int_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  key?: Maybe<String_Comparison_Exp>,
  product?: Maybe<String_Comparison_Exp>,
  updated_on?: Maybe<Timestamptz_Comparison_Exp>,
  value?: Maybe<Int_Comparison_Exp>,
};

export enum Addon_Price_Constraint {
  AddonPricePkey = 'addon_price_pkey'
}

export type Addon_Price_Inc_Input = {
  duration?: Maybe<Scalars['Int']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Insert_Input = {
  addon_type?: Maybe<Scalars['String']>,
  allowed?: Maybe<Scalars['Boolean']>,
  duration?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  key?: Maybe<Scalars['String']>,
  product?: Maybe<Scalars['String']>,
  updated_on?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Max_Fields = {
  __typename?: 'addon_price_max_fields',
  addon_type?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  key?: Maybe<Scalars['String']>,
  product?: Maybe<Scalars['String']>,
  updated_on?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Max_Order_By = {
  addon_type?: Maybe<Order_By>,
  duration?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  product?: Maybe<Order_By>,
  updated_on?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Min_Fields = {
  __typename?: 'addon_price_min_fields',
  addon_type?: Maybe<Scalars['String']>,
  duration?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  key?: Maybe<Scalars['String']>,
  product?: Maybe<Scalars['String']>,
  updated_on?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Min_Order_By = {
  addon_type?: Maybe<Order_By>,
  duration?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  product?: Maybe<Order_By>,
  updated_on?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Mutation_Response = {
  __typename?: 'addon_price_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Addon_Price>,
};

export type Addon_Price_Obj_Rel_Insert_Input = {
  data: Addon_Price_Insert_Input,
  on_conflict?: Maybe<Addon_Price_On_Conflict>,
};

export type Addon_Price_On_Conflict = {
  constraint: Addon_Price_Constraint,
  update_columns: Array<Addon_Price_Update_Column>,
  where?: Maybe<Addon_Price_Bool_Exp>,
};

export type Addon_Price_Order_By = {
  addon_type?: Maybe<Order_By>,
  allowed?: Maybe<Order_By>,
  duration?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  product?: Maybe<Order_By>,
  updated_on?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Addon_Price_Select_Column {
  AddonType = 'addon_type',
  Allowed = 'allowed',
  Duration = 'duration',
  Id = 'id',
  Key = 'key',
  Product = 'product',
  UpdatedOn = 'updated_on',
  Value = 'value'
}

export type Addon_Price_Set_Input = {
  addon_type?: Maybe<Scalars['String']>,
  allowed?: Maybe<Scalars['Boolean']>,
  duration?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  key?: Maybe<Scalars['String']>,
  product?: Maybe<Scalars['String']>,
  updated_on?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Stddev_Fields = {
  __typename?: 'addon_price_stddev_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Stddev_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Stddev_Pop_Fields = {
  __typename?: 'addon_price_stddev_pop_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Stddev_Pop_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Stddev_Samp_Fields = {
  __typename?: 'addon_price_stddev_samp_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Stddev_Samp_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Sum_Fields = {
  __typename?: 'addon_price_sum_fields',
  duration?: Maybe<Scalars['Int']>,
  value?: Maybe<Scalars['Int']>,
};

export type Addon_Price_Sum_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export enum Addon_Price_Update_Column {
  AddonType = 'addon_type',
  Allowed = 'allowed',
  Duration = 'duration',
  Id = 'id',
  Key = 'key',
  Product = 'product',
  UpdatedOn = 'updated_on',
  Value = 'value'
}

export type Addon_Price_Var_Pop_Fields = {
  __typename?: 'addon_price_var_pop_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Var_Pop_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Var_Samp_Fields = {
  __typename?: 'addon_price_var_samp_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Var_Samp_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Addon_Price_Variance_Fields = {
  __typename?: 'addon_price_variance_fields',
  duration?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Addon_Price_Variance_Order_By = {
  duration?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export enum Addon_Select_Column {
  AbsoluteOrder = 'absolute_order',
  BackDescLargeScreen = 'back_desc_large_screen',
  BackDescSmallScreen = 'back_desc_small_screen',
  Code = 'code',
  CreatedAt = 'created_at',
  DefaultStatus = 'default_status',
  ExclusionGroup = 'exclusion_group',
  ExternalProductId = 'external_product_id',
  FrontDescLargeScreen = 'front_desc_large_screen',
  FrontDescSmallScreen = 'front_desc_small_screen',
  GroupOrder = 'group_order',
  Id = 'id',
  Image = 'image',
  IsOneTimePurchase = 'is_one_time_purchase',
  MaxQty = 'max_qty',
  MinQty = 'min_qty',
  Name = 'name',
  Price = 'price',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  RecommendedFlag = 'recommended_flag',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Addon_Set_Input = {
  absolute_order?: Maybe<Scalars['Int']>,
  back_desc_large_screen?: Maybe<Scalars['String']>,
  back_desc_small_screen?: Maybe<Scalars['String']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_status?: Maybe<Scalars['Boolean']>,
  exclusion_group?: Maybe<Scalars['String']>,
  external_product_id?: Maybe<Scalars['jsonb']>,
  front_desc_large_screen?: Maybe<Scalars['String']>,
  front_desc_small_screen?: Maybe<Scalars['String']>,
  group_order?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  is_one_time_purchase?: Maybe<Scalars['Boolean']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  recommended_flag?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Addon_Stddev_Fields = {
  __typename?: 'addon_stddev_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Stddev_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Stddev_Pop_Fields = {
  __typename?: 'addon_stddev_pop_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Stddev_Pop_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Stddev_Samp_Fields = {
  __typename?: 'addon_stddev_samp_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Stddev_Samp_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Sum_Fields = {
  __typename?: 'addon_sum_fields',
  absolute_order?: Maybe<Scalars['Int']>,
  group_order?: Maybe<Scalars['Int']>,
  max_qty?: Maybe<Scalars['Int']>,
  min_qty?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
};

export type Addon_Sum_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export enum Addon_Update_Column {
  AbsoluteOrder = 'absolute_order',
  BackDescLargeScreen = 'back_desc_large_screen',
  BackDescSmallScreen = 'back_desc_small_screen',
  Code = 'code',
  CreatedAt = 'created_at',
  DefaultStatus = 'default_status',
  ExclusionGroup = 'exclusion_group',
  ExternalProductId = 'external_product_id',
  FrontDescLargeScreen = 'front_desc_large_screen',
  FrontDescSmallScreen = 'front_desc_small_screen',
  GroupOrder = 'group_order',
  Id = 'id',
  Image = 'image',
  IsOneTimePurchase = 'is_one_time_purchase',
  MaxQty = 'max_qty',
  MinQty = 'min_qty',
  Name = 'name',
  Price = 'price',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  RecommendedFlag = 'recommended_flag',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Addon_Var_Pop_Fields = {
  __typename?: 'addon_var_pop_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Var_Pop_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Var_Samp_Fields = {
  __typename?: 'addon_var_samp_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Var_Samp_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Addon_Variance_Fields = {
  __typename?: 'addon_variance_fields',
  absolute_order?: Maybe<Scalars['Float']>,
  group_order?: Maybe<Scalars['Float']>,
  max_qty?: Maybe<Scalars['Float']>,
  min_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Addon_Variance_Order_By = {
  absolute_order?: Maybe<Order_By>,
  group_order?: Maybe<Order_By>,
  max_qty?: Maybe<Order_By>,
  min_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type AddonResponse = {
  __typename?: 'AddonResponse',
  id: Scalars['String'],
  price: Scalars['numeric'],
};

export type Address_Auto_Complete = {
  __typename?: 'address_auto_complete',
  canonical_address_id: Scalars['String'],
  full_address: Scalars['String'],
  highlighted_full_address: Scalars['String'],
  id: Scalars['String'],
};

export type Address_Auto_Complete_Group = {
  __typename?: 'address_auto_complete_group',
  completions?: Maybe<Array<Maybe<Address_Auto_Complete>>>,
};

export type Address_Detail = {
  __typename?: 'address_detail',
  address_line_1?: Maybe<Scalars['String']>,
  address_line_2?: Maybe<Scalars['String']>,
  box_identifier?: Maybe<Scalars['String']>,
  box_type?: Maybe<Scalars['String']>,
  canonical_address?: Maybe<Scalars['String']>,
  canonical_address_id?: Maybe<Scalars['String']>,
  dpid?: Maybe<Scalars['String']>,
  full_address?: Maybe<Scalars['String']>,
  gnaf_id?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['String']>,
  legal_parcel_id?: Maybe<Scalars['String']>,
  level_number?: Maybe<Scalars['String']>,
  level_type?: Maybe<Scalars['String']>,
  locality_name?: Maybe<Scalars['String']>,
  longitude?: Maybe<Scalars['String']>,
  lot_identifier?: Maybe<Scalars['String']>,
  meshblock?: Maybe<Scalars['String']>,
  meshblock_2016?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  primary_point_indicator?: Maybe<Scalars['String']>,
  sa1_id?: Maybe<Scalars['String']>,
  sa2_id?: Maybe<Scalars['String']>,
  site_name?: Maybe<Scalars['String']>,
  state_territory?: Maybe<Scalars['String']>,
  street?: Maybe<Scalars['String']>,
  street_name?: Maybe<Scalars['String']>,
  street_number_1?: Maybe<Scalars['String']>,
  street_number_2?: Maybe<Scalars['String']>,
  street_suffix?: Maybe<Scalars['String']>,
  street_type?: Maybe<Scalars['String']>,
  success?: Maybe<Scalars['Boolean']>,
  unit_identifier?: Maybe<Scalars['String']>,
  unit_type?: Maybe<Scalars['String']>,
};

export type Addresses_Dlnz = {
  __typename?: 'Addresses_dlnz',
  VerifyItemAddress_v22?: Maybe<VerifyItemAddressV22_Dlnz>,
};

export type Addresses_Nicn = {
  __typename?: 'Addresses_nicn',
  VerifyItemAddress_v22?: Maybe<VerifyItemAddressV22_Nicn>,
};

export type Addresses_Ppnz = {
  __typename?: 'Addresses_ppnz',
  VerifyItemAddress_v22?: Maybe<VerifyItemAddressV22_Ppnz>,
};

export type AssignExperimentOutput = {
  __typename?: 'AssignExperimentOutput',
  assigned_to_experiments?: Maybe<Array<Maybe<Scalars['String']>>>,
  users_ending_with: Scalars['Int'],
};

export type Attachment = {
  __typename?: 'attachment',
  created_at: Scalars['timestamptz'],
  download_url?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  owner_id: Scalars['uuid'],
  parent_id: Scalars['uuid'],
  parent_type?: Maybe<Attachment_Parent_Type_Enum>,
  status?: Maybe<Attachment_Status_Enum>,
  type: Attachment_Type_Enum,
  updated_at: Scalars['timestamptz'],
};

export type Attachment_Aggregate = {
  __typename?: 'attachment_aggregate',
  aggregate?: Maybe<Attachment_Aggregate_Fields>,
  nodes: Array<Attachment>,
};

export type Attachment_Aggregate_Fields = {
  __typename?: 'attachment_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Attachment_Max_Fields>,
  min?: Maybe<Attachment_Min_Fields>,
};


export type Attachment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Attachment_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Attachment_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Attachment_Max_Order_By>,
  min?: Maybe<Attachment_Min_Order_By>,
};

export type Attachment_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Insert_Input>,
  on_conflict?: Maybe<Attachment_On_Conflict>,
};

export type Attachment_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Attachment_Bool_Exp>>>,
  _not?: Maybe<Attachment_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Attachment_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  download_url?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  parent_id?: Maybe<Uuid_Comparison_Exp>,
  parent_type?: Maybe<Attachment_Parent_Type_Enum_Comparison_Exp>,
  status?: Maybe<Attachment_Status_Enum_Comparison_Exp>,
  type?: Maybe<Attachment_Type_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Attachment_Constraint {
  AttachmentPkey = 'attachment_pkey'
}

export type Attachment_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  download_url?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
  parent_id?: Maybe<Scalars['uuid']>,
  parent_type?: Maybe<Attachment_Parent_Type_Enum>,
  status?: Maybe<Attachment_Status_Enum>,
  type?: Maybe<Attachment_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Attachment_Max_Fields = {
  __typename?: 'attachment_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  download_url?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
  parent_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Attachment_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  download_url?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  parent_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Attachment_Min_Fields = {
  __typename?: 'attachment_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  download_url?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
  parent_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Attachment_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  download_url?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  parent_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Attachment_Mutation_Response = {
  __typename?: 'attachment_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Attachment>,
};

export type Attachment_Obj_Rel_Insert_Input = {
  data: Attachment_Insert_Input,
  on_conflict?: Maybe<Attachment_On_Conflict>,
};

export type Attachment_On_Conflict = {
  constraint: Attachment_Constraint,
  update_columns: Array<Attachment_Update_Column>,
  where?: Maybe<Attachment_Bool_Exp>,
};

export type Attachment_Order_By = {
  created_at?: Maybe<Order_By>,
  download_url?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  parent_id?: Maybe<Order_By>,
  parent_type?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Attachment_Parent_Type = {
  __typename?: 'attachment_parent_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Attachment_Parent_Type_Aggregate = {
  __typename?: 'attachment_parent_type_aggregate',
  aggregate?: Maybe<Attachment_Parent_Type_Aggregate_Fields>,
  nodes: Array<Attachment_Parent_Type>,
};

export type Attachment_Parent_Type_Aggregate_Fields = {
  __typename?: 'attachment_parent_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Attachment_Parent_Type_Max_Fields>,
  min?: Maybe<Attachment_Parent_Type_Min_Fields>,
};


export type Attachment_Parent_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Attachment_Parent_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Attachment_Parent_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Attachment_Parent_Type_Max_Order_By>,
  min?: Maybe<Attachment_Parent_Type_Min_Order_By>,
};

export type Attachment_Parent_Type_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Parent_Type_Insert_Input>,
  on_conflict?: Maybe<Attachment_Parent_Type_On_Conflict>,
};

export type Attachment_Parent_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Attachment_Parent_Type_Bool_Exp>>>,
  _not?: Maybe<Attachment_Parent_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Attachment_Parent_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Attachment_Parent_Type_Constraint {
  AttachmentParentTypePkey = 'attachment_parent_type_pkey'
}

export enum Attachment_Parent_Type_Enum {
  ListingDocument = 'listing_document',
  ListingMedia = 'listing_media'
}

export type Attachment_Parent_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Attachment_Parent_Type_Enum>,
  _in?: Maybe<Array<Attachment_Parent_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Attachment_Parent_Type_Enum>,
  _nin?: Maybe<Array<Attachment_Parent_Type_Enum>>,
};

export type Attachment_Parent_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Parent_Type_Max_Fields = {
  __typename?: 'attachment_parent_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Parent_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Parent_Type_Min_Fields = {
  __typename?: 'attachment_parent_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Parent_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Parent_Type_Mutation_Response = {
  __typename?: 'attachment_parent_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Attachment_Parent_Type>,
};

export type Attachment_Parent_Type_Obj_Rel_Insert_Input = {
  data: Attachment_Parent_Type_Insert_Input,
  on_conflict?: Maybe<Attachment_Parent_Type_On_Conflict>,
};

export type Attachment_Parent_Type_On_Conflict = {
  constraint: Attachment_Parent_Type_Constraint,
  update_columns: Array<Attachment_Parent_Type_Update_Column>,
  where?: Maybe<Attachment_Parent_Type_Bool_Exp>,
};

export type Attachment_Parent_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Parent_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Attachment_Parent_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Attachment_Parent_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Attachment_Parent_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Attachment_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Attachment_Select_Column {
  CreatedAt = 'created_at',
  DownloadUrl = 'download_url',
  Id = 'id',
  OwnerId = 'owner_id',
  ParentId = 'parent_id',
  ParentType = 'parent_type',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Attachment_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  download_url?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
  parent_id?: Maybe<Scalars['uuid']>,
  parent_type?: Maybe<Attachment_Parent_Type_Enum>,
  status?: Maybe<Attachment_Status_Enum>,
  type?: Maybe<Attachment_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Attachment_Status = {
  __typename?: 'attachment_status',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Attachment_Status_Aggregate = {
  __typename?: 'attachment_status_aggregate',
  aggregate?: Maybe<Attachment_Status_Aggregate_Fields>,
  nodes: Array<Attachment_Status>,
};

export type Attachment_Status_Aggregate_Fields = {
  __typename?: 'attachment_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Attachment_Status_Max_Fields>,
  min?: Maybe<Attachment_Status_Min_Fields>,
};


export type Attachment_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Attachment_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Attachment_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Attachment_Status_Max_Order_By>,
  min?: Maybe<Attachment_Status_Min_Order_By>,
};

export type Attachment_Status_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Status_Insert_Input>,
  on_conflict?: Maybe<Attachment_Status_On_Conflict>,
};

export type Attachment_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Attachment_Status_Bool_Exp>>>,
  _not?: Maybe<Attachment_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Attachment_Status_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Attachment_Status_Constraint {
  AttachmentStatusPkey = 'attachment_status_pkey'
}

export enum Attachment_Status_Enum {
  Failed = 'failed',
  Loaded = 'loaded',
  Loading = 'loading'
}

export type Attachment_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Attachment_Status_Enum>,
  _in?: Maybe<Array<Attachment_Status_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Attachment_Status_Enum>,
  _nin?: Maybe<Array<Attachment_Status_Enum>>,
};

export type Attachment_Status_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Status_Max_Fields = {
  __typename?: 'attachment_status_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Status_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Status_Min_Fields = {
  __typename?: 'attachment_status_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Status_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Status_Mutation_Response = {
  __typename?: 'attachment_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Attachment_Status>,
};

export type Attachment_Status_Obj_Rel_Insert_Input = {
  data: Attachment_Status_Insert_Input,
  on_conflict?: Maybe<Attachment_Status_On_Conflict>,
};

export type Attachment_Status_On_Conflict = {
  constraint: Attachment_Status_Constraint,
  update_columns: Array<Attachment_Status_Update_Column>,
  where?: Maybe<Attachment_Status_Bool_Exp>,
};

export type Attachment_Status_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Status_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Attachment_Status_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Attachment_Status_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Attachment_Status_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Attachment_Type = {
  __typename?: 'attachment_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Attachment_Type_Aggregate = {
  __typename?: 'attachment_type_aggregate',
  aggregate?: Maybe<Attachment_Type_Aggregate_Fields>,
  nodes: Array<Attachment_Type>,
};

export type Attachment_Type_Aggregate_Fields = {
  __typename?: 'attachment_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Attachment_Type_Max_Fields>,
  min?: Maybe<Attachment_Type_Min_Fields>,
};


export type Attachment_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Attachment_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Attachment_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Attachment_Type_Max_Order_By>,
  min?: Maybe<Attachment_Type_Min_Order_By>,
};

export type Attachment_Type_Arr_Rel_Insert_Input = {
  data: Array<Attachment_Type_Insert_Input>,
  on_conflict?: Maybe<Attachment_Type_On_Conflict>,
};

export type Attachment_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Attachment_Type_Bool_Exp>>>,
  _not?: Maybe<Attachment_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Attachment_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Attachment_Type_Constraint {
  AttachmentTypePkey = 'attachment_type_pkey'
}

export enum Attachment_Type_Enum {
  EvidenceOfAuthority = 'EVIDENCE_OF_AUTHORITY',
  FloorPlan = 'FLOOR_PLAN',
  Photo = 'PHOTO',
  ProofOfId = 'PROOF_OF_ID',
  ProofOfOwnership = 'PROOF_OF_OWNERSHIP',
  StatementOfInformation = 'STATEMENT_OF_INFORMATION'
}

export type Attachment_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Attachment_Type_Enum>,
  _in?: Maybe<Array<Attachment_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Attachment_Type_Enum>,
  _nin?: Maybe<Array<Attachment_Type_Enum>>,
};

export type Attachment_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Type_Max_Fields = {
  __typename?: 'attachment_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Type_Min_Fields = {
  __typename?: 'attachment_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Attachment_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Type_Mutation_Response = {
  __typename?: 'attachment_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Attachment_Type>,
};

export type Attachment_Type_Obj_Rel_Insert_Input = {
  data: Attachment_Type_Insert_Input,
  on_conflict?: Maybe<Attachment_Type_On_Conflict>,
};

export type Attachment_Type_On_Conflict = {
  constraint: Attachment_Type_Constraint,
  update_columns: Array<Attachment_Type_Update_Column>,
  where?: Maybe<Attachment_Type_Bool_Exp>,
};

export type Attachment_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Attachment_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Attachment_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Attachment_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Attachment_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Attachment_Update_Column {
  CreatedAt = 'created_at',
  DownloadUrl = 'download_url',
  Id = 'id',
  OwnerId = 'owner_id',
  ParentId = 'parent_id',
  ParentType = 'parent_type',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Attributes = {
  __typename?: 'Attributes',
  itype?: Maybe<Scalars['String']>,
};

export type Attributes_Dlau = {
  __typename?: 'Attributes_dlau',
  itype?: Maybe<Scalars['String']>,
};

export type Auth_Response = {
  __typename?: 'auth_response',
  jwt: Scalars['String'],
};

export type Benefit = {
  __typename?: 'benefit',
  addon: Addon,
  addon_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  description: Scalars['String'],
  id: Scalars['uuid'],
  order: Scalars['Int'],
  updated_at: Scalars['timestamptz'],
};

export type Benefit_Aggregate = {
  __typename?: 'benefit_aggregate',
  aggregate?: Maybe<Benefit_Aggregate_Fields>,
  nodes: Array<Benefit>,
};

export type Benefit_Aggregate_Fields = {
  __typename?: 'benefit_aggregate_fields',
  avg?: Maybe<Benefit_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Benefit_Max_Fields>,
  min?: Maybe<Benefit_Min_Fields>,
  stddev?: Maybe<Benefit_Stddev_Fields>,
  stddev_pop?: Maybe<Benefit_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Benefit_Stddev_Samp_Fields>,
  sum?: Maybe<Benefit_Sum_Fields>,
  var_pop?: Maybe<Benefit_Var_Pop_Fields>,
  var_samp?: Maybe<Benefit_Var_Samp_Fields>,
  variance?: Maybe<Benefit_Variance_Fields>,
};


export type Benefit_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Benefit_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Benefit_Aggregate_Order_By = {
  avg?: Maybe<Benefit_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Benefit_Max_Order_By>,
  min?: Maybe<Benefit_Min_Order_By>,
  stddev?: Maybe<Benefit_Stddev_Order_By>,
  stddev_pop?: Maybe<Benefit_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Benefit_Stddev_Samp_Order_By>,
  sum?: Maybe<Benefit_Sum_Order_By>,
  var_pop?: Maybe<Benefit_Var_Pop_Order_By>,
  var_samp?: Maybe<Benefit_Var_Samp_Order_By>,
  variance?: Maybe<Benefit_Variance_Order_By>,
};

export type Benefit_Arr_Rel_Insert_Input = {
  data: Array<Benefit_Insert_Input>,
  on_conflict?: Maybe<Benefit_On_Conflict>,
};

export type Benefit_Avg_Fields = {
  __typename?: 'benefit_avg_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Avg_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Benefit_Bool_Exp>>>,
  _not?: Maybe<Benefit_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Benefit_Bool_Exp>>>,
  addon?: Maybe<Addon_Bool_Exp>,
  addon_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Benefit_Constraint {
  BenefitPkey = 'benefit_pkey'
}

export type Benefit_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
};

export type Benefit_Insert_Input = {
  addon?: Maybe<Addon_Obj_Rel_Insert_Input>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Benefit_Max_Fields = {
  __typename?: 'benefit_max_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Benefit_Max_Order_By = {
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Benefit_Min_Fields = {
  __typename?: 'benefit_min_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Benefit_Min_Order_By = {
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Benefit_Mutation_Response = {
  __typename?: 'benefit_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Benefit>,
};

export type Benefit_Obj_Rel_Insert_Input = {
  data: Benefit_Insert_Input,
  on_conflict?: Maybe<Benefit_On_Conflict>,
};

export type Benefit_On_Conflict = {
  constraint: Benefit_Constraint,
  update_columns: Array<Benefit_Update_Column>,
  where?: Maybe<Benefit_Bool_Exp>,
};

export type Benefit_Order_By = {
  addon?: Maybe<Addon_Order_By>,
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Benefit_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Benefit_Select_Column {
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Benefit_Set_Input = {
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Benefit_Stddev_Fields = {
  __typename?: 'benefit_stddev_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Stddev_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Stddev_Pop_Fields = {
  __typename?: 'benefit_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Stddev_Samp_Fields = {
  __typename?: 'benefit_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Sum_Fields = {
  __typename?: 'benefit_sum_fields',
  order?: Maybe<Scalars['Int']>,
};

export type Benefit_Sum_Order_By = {
  order?: Maybe<Order_By>,
};

export enum Benefit_Update_Column {
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Benefit_Var_Pop_Fields = {
  __typename?: 'benefit_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Var_Samp_Fields = {
  __typename?: 'benefit_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Benefit_Variance_Fields = {
  __typename?: 'benefit_variance_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Benefit_Variance_Order_By = {
  order?: Maybe<Order_By>,
};


export type Bigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>,
  _gt?: Maybe<Scalars['bigint']>,
  _gte?: Maybe<Scalars['bigint']>,
  _in?: Maybe<Array<Scalars['bigint']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['bigint']>,
  _lte?: Maybe<Scalars['bigint']>,
  _neq?: Maybe<Scalars['bigint']>,
  _nin?: Maybe<Array<Scalars['bigint']>>,
};

export type Bmp_Listing = {
  __typename?: 'bmp_listing',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bmp_listing_contacts: Array<Bmp_Listing_Contact>,
  bmp_listing_contacts_aggregate: Bmp_Listing_Contact_Aggregate,
  bmp_listing_inspections: Array<Bmp_Listing_Inspection>,
  bmp_listing_inspections_aggregate: Bmp_Listing_Inspection_Aggregate,
  bmp_listing_media: Array<Bmp_Listing_Media>,
  bmp_listing_media_aggregate: Bmp_Listing_Media_Aggregate,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};


export type Bmp_ListingBmp_Listing_ContactsArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Bmp_ListingBmp_Listing_Contacts_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Bmp_ListingBmp_Listing_InspectionsArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Bmp_ListingBmp_Listing_Inspections_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Bmp_ListingBmp_Listing_MediaArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Bmp_ListingBmp_Listing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Bmp_ListingExperimentsArgs = {
  path?: Maybe<Scalars['String']>
};

export type Bmp_Listing_Aggregate = {
  __typename?: 'bmp_listing_aggregate',
  aggregate?: Maybe<Bmp_Listing_Aggregate_Fields>,
  nodes: Array<Bmp_Listing>,
};

export type Bmp_Listing_Aggregate_Fields = {
  __typename?: 'bmp_listing_aggregate_fields',
  avg?: Maybe<Bmp_Listing_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Bmp_Listing_Max_Fields>,
  min?: Maybe<Bmp_Listing_Min_Fields>,
  stddev?: Maybe<Bmp_Listing_Stddev_Fields>,
  stddev_pop?: Maybe<Bmp_Listing_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Bmp_Listing_Stddev_Samp_Fields>,
  sum?: Maybe<Bmp_Listing_Sum_Fields>,
  var_pop?: Maybe<Bmp_Listing_Var_Pop_Fields>,
  var_samp?: Maybe<Bmp_Listing_Var_Samp_Fields>,
  variance?: Maybe<Bmp_Listing_Variance_Fields>,
};


export type Bmp_Listing_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bmp_Listing_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Bmp_Listing_Aggregate_Order_By = {
  avg?: Maybe<Bmp_Listing_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Bmp_Listing_Max_Order_By>,
  min?: Maybe<Bmp_Listing_Min_Order_By>,
  stddev?: Maybe<Bmp_Listing_Stddev_Order_By>,
  stddev_pop?: Maybe<Bmp_Listing_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Bmp_Listing_Stddev_Samp_Order_By>,
  sum?: Maybe<Bmp_Listing_Sum_Order_By>,
  var_pop?: Maybe<Bmp_Listing_Var_Pop_Order_By>,
  var_samp?: Maybe<Bmp_Listing_Var_Samp_Order_By>,
  variance?: Maybe<Bmp_Listing_Variance_Order_By>,
};

export type Bmp_Listing_Append_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type Bmp_Listing_Arr_Rel_Insert_Input = {
  data: Array<Bmp_Listing_Insert_Input>,
  on_conflict?: Maybe<Bmp_Listing_On_Conflict>,
};

export type Bmp_Listing_Avg_Fields = {
  __typename?: 'bmp_listing_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bmp_Listing_Bool_Exp>>>,
  _not?: Maybe<Bmp_Listing_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Bmp_Listing_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  auction_dateTime?: Maybe<Timestamptz_Comparison_Exp>,
  auction_location?: Maybe<String_Comparison_Exp>,
  auction_online?: Maybe<Boolean_Comparison_Exp>,
  authority?: Maybe<String_Comparison_Exp>,
  availableFrom?: Maybe<Timestamptz_Comparison_Exp>,
  bmp_listing_contacts?: Maybe<Bmp_Listing_Contact_Bool_Exp>,
  bmp_listing_inspections?: Maybe<Bmp_Listing_Inspection_Bool_Exp>,
  bmp_listing_media?: Maybe<Bmp_Listing_Media_Bool_Exp>,
  bond?: Maybe<Int_Comparison_Exp>,
  commercial_status?: Maybe<String_Comparison_Exp>,
  contactPreference?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  crossOver?: Maybe<String_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  domainAdId?: Maybe<Int_Comparison_Exp>,
  enquiry_code?: Maybe<Int_Comparison_Exp>,
  experiments?: Maybe<Jsonb_Comparison_Exp>,
  externalLink?: Maybe<String_Comparison_Exp>,
  features?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inspectionDetails_inspectionDescription?: Maybe<String_Comparison_Exp>,
  isNewDevelopment?: Maybe<Boolean_Comparison_Exp>,
  isRural?: Maybe<Boolean_Comparison_Exp>,
  lifeStyleType?: Maybe<String_Comparison_Exp>,
  listingAction?: Maybe<String_Comparison_Exp>,
  otherEnquiryEmail?: Maybe<String_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  price_asking?: Maybe<Int_Comparison_Exp>,
  price_displayOption?: Maybe<String_Comparison_Exp>,
  price_displayText?: Maybe<String_Comparison_Exp>,
  price_from?: Maybe<Int_Comparison_Exp>,
  price_single?: Maybe<Int_Comparison_Exp>,
  price_textOption?: Maybe<String_Comparison_Exp>,
  price_to?: Maybe<Int_Comparison_Exp>,
  price_view?: Maybe<String_Comparison_Exp>,
  proof_of_ownership_status?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_1?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_2?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_displayOption?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_municipality?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_street?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_page?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_reference?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_type?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_unitNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_bathRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_bedRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carportSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_energyEfficiencyRating?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_garageSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_left?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_rear?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_right?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_parkingInfo_information?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<String_Comparison_Exp>,
  propertyDetails_yearBuilt?: Maybe<Int_Comparison_Exp>,
  providerAdId?: Maybe<String_Comparison_Exp>,
  publishing_status?: Maybe<String_Comparison_Exp>,
  saleType?: Maybe<String_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  search_price?: Maybe<Int_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData?: Maybe<String_Comparison_Exp>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Int_Comparison_Exp>,
  soi_comparableData_declarationText?: Maybe<String_Comparison_Exp>,
  soi_documentationUrl?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice_from?: Maybe<Int_Comparison_Exp>,
  soi_estimatedPrice_to?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_declarationText?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice_postcode?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_priceType?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_source?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_suburb?: Maybe<String_Comparison_Exp>,
  status?: Maybe<String_Comparison_Exp>,
  summary?: Maybe<String_Comparison_Exp>,
  supplementary_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_measurement?: Maybe<Numeric_Comparison_Exp>,
  supplementary_metadata_measurementUnit?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_name?: Maybe<String_Comparison_Exp>,
  supplementary_name?: Maybe<String_Comparison_Exp>,
  supplementary_types?: Maybe<String_Comparison_Exp>,
  temporary_add_on_flag?: Maybe<Boolean_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  zone?: Maybe<String_Comparison_Exp>,
};

export enum Bmp_Listing_Constraint {
  BmpListingPkey = 'bmp_listing_pkey'
}

export type Bmp_Listing_Contact = {
  __typename?: 'bmp_listing_contact',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Scalars['String']>,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Contact_Aggregate = {
  __typename?: 'bmp_listing_contact_aggregate',
  aggregate?: Maybe<Bmp_Listing_Contact_Aggregate_Fields>,
  nodes: Array<Bmp_Listing_Contact>,
};

export type Bmp_Listing_Contact_Aggregate_Fields = {
  __typename?: 'bmp_listing_contact_aggregate_fields',
  avg?: Maybe<Bmp_Listing_Contact_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Bmp_Listing_Contact_Max_Fields>,
  min?: Maybe<Bmp_Listing_Contact_Min_Fields>,
  stddev?: Maybe<Bmp_Listing_Contact_Stddev_Fields>,
  stddev_pop?: Maybe<Bmp_Listing_Contact_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Bmp_Listing_Contact_Stddev_Samp_Fields>,
  sum?: Maybe<Bmp_Listing_Contact_Sum_Fields>,
  var_pop?: Maybe<Bmp_Listing_Contact_Var_Pop_Fields>,
  var_samp?: Maybe<Bmp_Listing_Contact_Var_Samp_Fields>,
  variance?: Maybe<Bmp_Listing_Contact_Variance_Fields>,
};


export type Bmp_Listing_Contact_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Bmp_Listing_Contact_Aggregate_Order_By = {
  avg?: Maybe<Bmp_Listing_Contact_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Bmp_Listing_Contact_Max_Order_By>,
  min?: Maybe<Bmp_Listing_Contact_Min_Order_By>,
  stddev?: Maybe<Bmp_Listing_Contact_Stddev_Order_By>,
  stddev_pop?: Maybe<Bmp_Listing_Contact_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Bmp_Listing_Contact_Stddev_Samp_Order_By>,
  sum?: Maybe<Bmp_Listing_Contact_Sum_Order_By>,
  var_pop?: Maybe<Bmp_Listing_Contact_Var_Pop_Order_By>,
  var_samp?: Maybe<Bmp_Listing_Contact_Var_Samp_Order_By>,
  variance?: Maybe<Bmp_Listing_Contact_Variance_Order_By>,
};

export type Bmp_Listing_Contact_Arr_Rel_Insert_Input = {
  data: Array<Bmp_Listing_Contact_Insert_Input>,
};

export type Bmp_Listing_Contact_Avg_Fields = {
  __typename?: 'bmp_listing_contact_avg_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Avg_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bmp_Listing_Contact_Bool_Exp>>>,
  _not?: Maybe<Bmp_Listing_Contact_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Bmp_Listing_Contact_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  domainAgencyID?: Maybe<String_Comparison_Exp>,
  domainAgentId?: Maybe<Int_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  fax?: Maybe<String_Comparison_Exp>,
  firstName?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  lastName?: Maybe<String_Comparison_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  mobile?: Maybe<String_Comparison_Exp>,
  phone?: Maybe<String_Comparison_Exp>,
  phoneType?: Maybe<String_Comparison_Exp>,
  portal?: Maybe<String_Comparison_Exp>,
  receiveEmails?: Maybe<Boolean_Comparison_Exp>,
  socialMedia?: Maybe<String_Comparison_Exp>,
  socialMedia_URL?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export type Bmp_Listing_Contact_Inc_Input = {
  domainAgentId?: Maybe<Scalars['Int']>,
};

export type Bmp_Listing_Contact_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Scalars['String']>,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Contact_Max_Fields = {
  __typename?: 'bmp_listing_contact_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Scalars['String']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Contact_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  portal?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Min_Fields = {
  __typename?: 'bmp_listing_contact_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Scalars['String']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Contact_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  portal?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Mutation_Response = {
  __typename?: 'bmp_listing_contact_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Bmp_Listing_Contact>,
};

export type Bmp_Listing_Contact_Obj_Rel_Insert_Input = {
  data: Bmp_Listing_Contact_Insert_Input,
};

export type Bmp_Listing_Contact_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  portal?: Maybe<Order_By>,
  receiveEmails?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export enum Bmp_Listing_Contact_Select_Column {
  CreatedAt = 'created_at',
  DomainAgencyId = 'domainAgencyID',
  DomainAgentId = 'domainAgentId',
  Email = 'email',
  Fax = 'fax',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  ListingId = 'listing_id',
  Mobile = 'mobile',
  Phone = 'phone',
  PhoneType = 'phoneType',
  Portal = 'portal',
  ReceiveEmails = 'receiveEmails',
  SocialMedia = 'socialMedia',
  SocialMediaUrl = 'socialMedia_URL',
  UpdatedAt = 'updated_at'
}

export type Bmp_Listing_Contact_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Scalars['String']>,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Contact_Stddev_Fields = {
  __typename?: 'bmp_listing_contact_stddev_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Stddev_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Stddev_Pop_Fields = {
  __typename?: 'bmp_listing_contact_stddev_pop_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Stddev_Pop_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Stddev_Samp_Fields = {
  __typename?: 'bmp_listing_contact_stddev_samp_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Stddev_Samp_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Sum_Fields = {
  __typename?: 'bmp_listing_contact_sum_fields',
  domainAgentId?: Maybe<Scalars['Int']>,
};

export type Bmp_Listing_Contact_Sum_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Var_Pop_Fields = {
  __typename?: 'bmp_listing_contact_var_pop_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Var_Pop_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Var_Samp_Fields = {
  __typename?: 'bmp_listing_contact_var_samp_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Var_Samp_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Contact_Variance_Fields = {
  __typename?: 'bmp_listing_contact_variance_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Contact_Variance_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Bmp_Listing_Delete_At_Path_Input = {
  experiments?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Bmp_Listing_Delete_Elem_Input = {
  experiments?: Maybe<Scalars['Int']>,
};

export type Bmp_Listing_Delete_Key_Input = {
  experiments?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Bmp_Listing_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bmp_listing_contacts?: Maybe<Bmp_Listing_Contact_Arr_Rel_Insert_Input>,
  bmp_listing_inspections?: Maybe<Bmp_Listing_Inspection_Arr_Rel_Insert_Input>,
  bmp_listing_media?: Maybe<Bmp_Listing_Media_Arr_Rel_Insert_Input>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Inspection = {
  __typename?: 'bmp_listing_inspection',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_private?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Inspection_Aggregate = {
  __typename?: 'bmp_listing_inspection_aggregate',
  aggregate?: Maybe<Bmp_Listing_Inspection_Aggregate_Fields>,
  nodes: Array<Bmp_Listing_Inspection>,
};

export type Bmp_Listing_Inspection_Aggregate_Fields = {
  __typename?: 'bmp_listing_inspection_aggregate_fields',
  avg?: Maybe<Bmp_Listing_Inspection_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Bmp_Listing_Inspection_Max_Fields>,
  min?: Maybe<Bmp_Listing_Inspection_Min_Fields>,
  stddev?: Maybe<Bmp_Listing_Inspection_Stddev_Fields>,
  stddev_pop?: Maybe<Bmp_Listing_Inspection_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Bmp_Listing_Inspection_Stddev_Samp_Fields>,
  sum?: Maybe<Bmp_Listing_Inspection_Sum_Fields>,
  var_pop?: Maybe<Bmp_Listing_Inspection_Var_Pop_Fields>,
  var_samp?: Maybe<Bmp_Listing_Inspection_Var_Samp_Fields>,
  variance?: Maybe<Bmp_Listing_Inspection_Variance_Fields>,
};


export type Bmp_Listing_Inspection_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Bmp_Listing_Inspection_Aggregate_Order_By = {
  avg?: Maybe<Bmp_Listing_Inspection_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Bmp_Listing_Inspection_Max_Order_By>,
  min?: Maybe<Bmp_Listing_Inspection_Min_Order_By>,
  stddev?: Maybe<Bmp_Listing_Inspection_Stddev_Order_By>,
  stddev_pop?: Maybe<Bmp_Listing_Inspection_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Bmp_Listing_Inspection_Stddev_Samp_Order_By>,
  sum?: Maybe<Bmp_Listing_Inspection_Sum_Order_By>,
  var_pop?: Maybe<Bmp_Listing_Inspection_Var_Pop_Order_By>,
  var_samp?: Maybe<Bmp_Listing_Inspection_Var_Samp_Order_By>,
  variance?: Maybe<Bmp_Listing_Inspection_Variance_Order_By>,
};

export type Bmp_Listing_Inspection_Arr_Rel_Insert_Input = {
  data: Array<Bmp_Listing_Inspection_Insert_Input>,
};

export type Bmp_Listing_Inspection_Avg_Fields = {
  __typename?: 'bmp_listing_inspection_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bmp_Listing_Inspection_Bool_Exp>>>,
  _not?: Maybe<Bmp_Listing_Inspection_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Bmp_Listing_Inspection_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  from?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  is_private?: Maybe<Boolean_Comparison_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  repeat?: Maybe<Boolean_Comparison_Exp>,
  to?: Maybe<Timestamptz_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export type Bmp_Listing_Inspection_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type Bmp_Listing_Inspection_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_private?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Inspection_Max_Fields = {
  __typename?: 'bmp_listing_inspection_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Inspection_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Min_Fields = {
  __typename?: 'bmp_listing_inspection_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Inspection_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Mutation_Response = {
  __typename?: 'bmp_listing_inspection_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Bmp_Listing_Inspection>,
};

export type Bmp_Listing_Inspection_Obj_Rel_Insert_Input = {
  data: Bmp_Listing_Inspection_Insert_Input,
};

export type Bmp_Listing_Inspection_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  is_private?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  repeat?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export enum Bmp_Listing_Inspection_Select_Column {
  AgentPointId = 'agent_point_id',
  CreatedAt = 'created_at',
  From = 'from',
  Id = 'id',
  IsPrivate = 'is_private',
  ListingId = 'listing_id',
  Repeat = 'repeat',
  To = 'to',
  UpdatedAt = 'updated_at'
}

export type Bmp_Listing_Inspection_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_private?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Bmp_Listing_Inspection_Stddev_Fields = {
  __typename?: 'bmp_listing_inspection_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Stddev_Pop_Fields = {
  __typename?: 'bmp_listing_inspection_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Stddev_Samp_Fields = {
  __typename?: 'bmp_listing_inspection_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Sum_Fields = {
  __typename?: 'bmp_listing_inspection_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type Bmp_Listing_Inspection_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Var_Pop_Fields = {
  __typename?: 'bmp_listing_inspection_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Var_Samp_Fields = {
  __typename?: 'bmp_listing_inspection_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Inspection_Variance_Fields = {
  __typename?: 'bmp_listing_inspection_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Inspection_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Bmp_Listing_Max_Fields = {
  __typename?: 'bmp_listing_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Bmp_Listing_Media = {
  __typename?: 'bmp_listing_media',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded?: Maybe<Scalars['Boolean']>,
  is_uploaded?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  media: Array<Surrounding_Suburb_Listing>,
  media_aggregate: Surrounding_Suburb_Listing_Aggregate,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};


export type Bmp_Listing_MediaMediaArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Bmp_Listing_MediaMedia_AggregateArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};

export type Bmp_Listing_Media_Aggregate = {
  __typename?: 'bmp_listing_media_aggregate',
  aggregate?: Maybe<Bmp_Listing_Media_Aggregate_Fields>,
  nodes: Array<Bmp_Listing_Media>,
};

export type Bmp_Listing_Media_Aggregate_Fields = {
  __typename?: 'bmp_listing_media_aggregate_fields',
  avg?: Maybe<Bmp_Listing_Media_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Bmp_Listing_Media_Max_Fields>,
  min?: Maybe<Bmp_Listing_Media_Min_Fields>,
  stddev?: Maybe<Bmp_Listing_Media_Stddev_Fields>,
  stddev_pop?: Maybe<Bmp_Listing_Media_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Bmp_Listing_Media_Stddev_Samp_Fields>,
  sum?: Maybe<Bmp_Listing_Media_Sum_Fields>,
  var_pop?: Maybe<Bmp_Listing_Media_Var_Pop_Fields>,
  var_samp?: Maybe<Bmp_Listing_Media_Var_Samp_Fields>,
  variance?: Maybe<Bmp_Listing_Media_Variance_Fields>,
};


export type Bmp_Listing_Media_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Bmp_Listing_Media_Aggregate_Order_By = {
  avg?: Maybe<Bmp_Listing_Media_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Bmp_Listing_Media_Max_Order_By>,
  min?: Maybe<Bmp_Listing_Media_Min_Order_By>,
  stddev?: Maybe<Bmp_Listing_Media_Stddev_Order_By>,
  stddev_pop?: Maybe<Bmp_Listing_Media_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Bmp_Listing_Media_Stddev_Samp_Order_By>,
  sum?: Maybe<Bmp_Listing_Media_Sum_Order_By>,
  var_pop?: Maybe<Bmp_Listing_Media_Var_Pop_Order_By>,
  var_samp?: Maybe<Bmp_Listing_Media_Var_Samp_Order_By>,
  variance?: Maybe<Bmp_Listing_Media_Variance_Order_By>,
};

export type Bmp_Listing_Media_Arr_Rel_Insert_Input = {
  data: Array<Bmp_Listing_Media_Insert_Input>,
};

export type Bmp_Listing_Media_Avg_Fields = {
  __typename?: 'bmp_listing_media_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bmp_Listing_Media_Bool_Exp>>>,
  _not?: Maybe<Bmp_Listing_Media_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Bmp_Listing_Media_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  attachment_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  desc?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  images_id_attribute?: Maybe<String_Comparison_Exp>,
  is_downloaded?: Maybe<Boolean_Comparison_Exp>,
  is_uploaded?: Maybe<Boolean_Comparison_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  media?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>,
  mime_type?: Maybe<String_Comparison_Exp>,
  objects_id_attribute?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Smallint_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  processed_error?: Maybe<String_Comparison_Exp>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum_Comparison_Exp>,
  thumbnail_1212?: Maybe<String_Comparison_Exp>,
  thumbnail_1818?: Maybe<String_Comparison_Exp>,
  thumbnail_185?: Maybe<String_Comparison_Exp>,
  thumbnail_284?: Maybe<String_Comparison_Exp>,
  thumbnail_370?: Maybe<String_Comparison_Exp>,
  thumbnail_555?: Maybe<String_Comparison_Exp>,
  thumbnail_568?: Maybe<String_Comparison_Exp>,
  thumbnail_606?: Maybe<String_Comparison_Exp>,
  thumbnail_852?: Maybe<String_Comparison_Exp>,
  type?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  url?: Maybe<String_Comparison_Exp>,
};

export type Bmp_Listing_Media_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  order?: Maybe<Scalars['smallint']>,
};

export type Bmp_Listing_Media_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded?: Maybe<Scalars['Boolean']>,
  is_uploaded?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  media?: Maybe<Surrounding_Suburb_Listing_Arr_Rel_Insert_Input>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Media_Max_Fields = {
  __typename?: 'bmp_listing_media_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Media_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Min_Fields = {
  __typename?: 'bmp_listing_media_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Media_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Mutation_Response = {
  __typename?: 'bmp_listing_media_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Bmp_Listing_Media>,
};

export type Bmp_Listing_Media_Obj_Rel_Insert_Input = {
  data: Bmp_Listing_Media_Insert_Input,
};

export type Bmp_Listing_Media_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  is_downloaded?: Maybe<Order_By>,
  is_uploaded?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  media_aggregate?: Maybe<Surrounding_Suburb_Listing_Aggregate_Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  processing_status?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export enum Bmp_Listing_Media_Select_Column {
  AgentPointId = 'agent_point_id',
  AttachmentId = 'attachment_id',
  CreatedAt = 'created_at',
  Desc = 'desc',
  Id = 'id',
  ImagesIdAttribute = 'images_id_attribute',
  IsDownloaded = 'is_downloaded',
  IsUploaded = 'is_uploaded',
  ListingId = 'listing_id',
  MimeType = 'mime_type',
  ObjectsIdAttribute = 'objects_id_attribute',
  Order = 'order',
  OwnerId = 'owner_id',
  ProcessedError = 'processed_error',
  ProcessingStatus = 'processing_status',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Url = 'url'
}

export type Bmp_Listing_Media_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded?: Maybe<Scalars['Boolean']>,
  is_uploaded?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Media_Stddev_Fields = {
  __typename?: 'bmp_listing_media_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Stddev_Pop_Fields = {
  __typename?: 'bmp_listing_media_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Stddev_Samp_Fields = {
  __typename?: 'bmp_listing_media_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Sum_Fields = {
  __typename?: 'bmp_listing_media_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  order?: Maybe<Scalars['smallint']>,
};

export type Bmp_Listing_Media_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Var_Pop_Fields = {
  __typename?: 'bmp_listing_media_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Var_Samp_Fields = {
  __typename?: 'bmp_listing_media_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Media_Variance_Fields = {
  __typename?: 'bmp_listing_media_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Media_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Bmp_Listing_Min_Fields = {
  __typename?: 'bmp_listing_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Bmp_Listing_Mutation_Response = {
  __typename?: 'bmp_listing_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Bmp_Listing>,
};

export type Bmp_Listing_Obj_Rel_Insert_Input = {
  data: Bmp_Listing_Insert_Input,
  on_conflict?: Maybe<Bmp_Listing_On_Conflict>,
};

export type Bmp_Listing_On_Conflict = {
  constraint: Bmp_Listing_Constraint,
  update_columns: Array<Bmp_Listing_Update_Column>,
  where?: Maybe<Bmp_Listing_Bool_Exp>,
};

export type Bmp_Listing_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  auction_online?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bmp_listing_contacts_aggregate?: Maybe<Bmp_Listing_Contact_Aggregate_Order_By>,
  bmp_listing_inspections_aggregate?: Maybe<Bmp_Listing_Inspection_Aggregate_Order_By>,
  bmp_listing_media_aggregate?: Maybe<Bmp_Listing_Media_Aggregate_Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  experiments?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  isNewDevelopment?: Maybe<Order_By>,
  isRural?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  temporary_add_on_flag?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Bmp_Listing_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Bmp_Listing_Prepend_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type Bmp_Listing_Search = {
  __typename?: 'bmp_listing_search',
  bathrooms?: Maybe<Scalars['Int']>,
  bedrooms?: Maybe<Scalars['Int']>,
  bmp_listing?: Maybe<Bmp_Listing>,
  carSpaces?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  postcode?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  search_source?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Search_Aggregate = {
  __typename?: 'bmp_listing_search_aggregate',
  aggregate?: Maybe<Bmp_Listing_Search_Aggregate_Fields>,
  nodes: Array<Bmp_Listing_Search>,
};

export type Bmp_Listing_Search_Aggregate_Fields = {
  __typename?: 'bmp_listing_search_aggregate_fields',
  avg?: Maybe<Bmp_Listing_Search_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Bmp_Listing_Search_Max_Fields>,
  min?: Maybe<Bmp_Listing_Search_Min_Fields>,
  stddev?: Maybe<Bmp_Listing_Search_Stddev_Fields>,
  stddev_pop?: Maybe<Bmp_Listing_Search_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Bmp_Listing_Search_Stddev_Samp_Fields>,
  sum?: Maybe<Bmp_Listing_Search_Sum_Fields>,
  var_pop?: Maybe<Bmp_Listing_Search_Var_Pop_Fields>,
  var_samp?: Maybe<Bmp_Listing_Search_Var_Samp_Fields>,
  variance?: Maybe<Bmp_Listing_Search_Variance_Fields>,
};


export type Bmp_Listing_Search_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Bmp_Listing_Search_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Bmp_Listing_Search_Aggregate_Order_By = {
  avg?: Maybe<Bmp_Listing_Search_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Bmp_Listing_Search_Max_Order_By>,
  min?: Maybe<Bmp_Listing_Search_Min_Order_By>,
  stddev?: Maybe<Bmp_Listing_Search_Stddev_Order_By>,
  stddev_pop?: Maybe<Bmp_Listing_Search_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Bmp_Listing_Search_Stddev_Samp_Order_By>,
  sum?: Maybe<Bmp_Listing_Search_Sum_Order_By>,
  var_pop?: Maybe<Bmp_Listing_Search_Var_Pop_Order_By>,
  var_samp?: Maybe<Bmp_Listing_Search_Var_Samp_Order_By>,
  variance?: Maybe<Bmp_Listing_Search_Variance_Order_By>,
};

export type Bmp_Listing_Search_Avg_Fields = {
  __typename?: 'bmp_listing_search_avg_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Avg_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Bmp_Listing_Search_Bool_Exp>>>,
  _not?: Maybe<Bmp_Listing_Search_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Bmp_Listing_Search_Bool_Exp>>>,
  bathrooms?: Maybe<Int_Comparison_Exp>,
  bedrooms?: Maybe<Int_Comparison_Exp>,
  bmp_listing?: Maybe<Bmp_Listing_Bool_Exp>,
  carSpaces?: Maybe<Int_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  postcode?: Maybe<String_Comparison_Exp>,
  propertyType?: Maybe<String_Comparison_Exp>,
  saleType?: Maybe<String_Comparison_Exp>,
  search_source?: Maybe<String_Comparison_Exp>,
  state?: Maybe<String_Comparison_Exp>,
  suburb?: Maybe<String_Comparison_Exp>,
  summary?: Maybe<String_Comparison_Exp>,
};

export type Bmp_Listing_Search_Max_Fields = {
  __typename?: 'bmp_listing_search_max_fields',
  bathrooms?: Maybe<Scalars['Int']>,
  bedrooms?: Maybe<Scalars['Int']>,
  carSpaces?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  postcode?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  search_source?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Search_Max_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  propertyType?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  search_source?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Min_Fields = {
  __typename?: 'bmp_listing_search_min_fields',
  bathrooms?: Maybe<Scalars['Int']>,
  bedrooms?: Maybe<Scalars['Int']>,
  carSpaces?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['uuid']>,
  postcode?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  search_source?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Search_Min_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  propertyType?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  search_source?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  bmp_listing?: Maybe<Bmp_Listing_Order_By>,
  carSpaces?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  propertyType?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  search_source?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
};

export enum Bmp_Listing_Search_Select_Column {
  Bathrooms = 'bathrooms',
  Bedrooms = 'bedrooms',
  CarSpaces = 'carSpaces',
  Id = 'id',
  Postcode = 'postcode',
  PropertyType = 'propertyType',
  SaleType = 'saleType',
  SearchSource = 'search_source',
  State = 'state',
  Suburb = 'suburb',
  Summary = 'summary'
}

export type Bmp_Listing_Search_Stddev_Fields = {
  __typename?: 'bmp_listing_search_stddev_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Stddev_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Stddev_Pop_Fields = {
  __typename?: 'bmp_listing_search_stddev_pop_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Stddev_Pop_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Stddev_Samp_Fields = {
  __typename?: 'bmp_listing_search_stddev_samp_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Stddev_Samp_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Sum_Fields = {
  __typename?: 'bmp_listing_search_sum_fields',
  bathrooms?: Maybe<Scalars['Int']>,
  bedrooms?: Maybe<Scalars['Int']>,
  carSpaces?: Maybe<Scalars['Int']>,
};

export type Bmp_Listing_Search_Sum_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Var_Pop_Fields = {
  __typename?: 'bmp_listing_search_var_pop_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Var_Pop_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Var_Samp_Fields = {
  __typename?: 'bmp_listing_search_var_samp_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Var_Samp_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export type Bmp_Listing_Search_Variance_Fields = {
  __typename?: 'bmp_listing_search_variance_fields',
  bathrooms?: Maybe<Scalars['Float']>,
  bedrooms?: Maybe<Scalars['Float']>,
  carSpaces?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Search_Variance_Order_By = {
  bathrooms?: Maybe<Order_By>,
  bedrooms?: Maybe<Order_By>,
  carSpaces?: Maybe<Order_By>,
};

export enum Bmp_Listing_Select_Column {
  AgentPointId = 'agent_point_id',
  AuctionDateTime = 'auction_dateTime',
  AuctionLocation = 'auction_location',
  AuctionOnline = 'auction_online',
  Authority = 'authority',
  AvailableFrom = 'availableFrom',
  Bond = 'bond',
  CommercialStatus = 'commercial_status',
  ContactPreference = 'contactPreference',
  CreatedAt = 'created_at',
  CrossOver = 'crossOver',
  Description = 'description',
  DomainAdId = 'domainAdId',
  EnquiryCode = 'enquiry_code',
  Experiments = 'experiments',
  ExternalLink = 'externalLink',
  Features = 'features',
  Id = 'id',
  InspectionDetailsInspectionDescription = 'inspectionDetails_inspectionDescription',
  IsNewDevelopment = 'isNewDevelopment',
  IsRural = 'isRural',
  LifeStyleType = 'lifeStyleType',
  ListingAction = 'listingAction',
  OtherEnquiryEmail = 'otherEnquiryEmail',
  OwnerId = 'owner_id',
  PriceAsking = 'price_asking',
  PriceDisplayOption = 'price_displayOption',
  PriceDisplayText = 'price_displayText',
  PriceFrom = 'price_from',
  PriceSingle = 'price_single',
  PriceTextOption = 'price_textOption',
  PriceTo = 'price_to',
  PriceView = 'price_view',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressMunicipality = 'propertyDetails_address_municipality',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressPostcodeBeforeCheckout = 'propertyDetails_address_postcode_before_checkout',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStateBeforeCheckout = 'propertyDetails_address_state_before_checkout',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetDirectoryPage = 'propertyDetails_address_streetDirectory_page',
  PropertyDetailsAddressStreetDirectoryReference = 'propertyDetails_address_streetDirectory_reference',
  PropertyDetailsAddressStreetDirectoryType = 'propertyDetails_address_streetDirectory_type',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressSuburbBeforeCheckout = 'propertyDetails_address_suburb_before_checkout',
  PropertyDetailsAddressSuggestedGeoLocation = 'propertyDetails_address_suggestedGeoLocation',
  PropertyDetailsAddressSuggestedGeoLocationLatitude = 'propertyDetails_address_suggestedGeoLocation_latitude',
  PropertyDetailsAddressSuggestedGeoLocationLongitude = 'propertyDetails_address_suggestedGeoLocation_longitude',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PropertyDetailsAreaFrom = 'propertyDetails_area_from',
  PropertyDetailsAreaTo = 'propertyDetails_area_to',
  PropertyDetailsAreaUnit = 'propertyDetails_area_unit',
  PropertyDetailsAreaValue = 'propertyDetails_area_value',
  PropertyDetailsBathRooms = 'propertyDetails_bathRooms',
  PropertyDetailsBedRooms = 'propertyDetails_bedRooms',
  PropertyDetailsCarSpaces = 'propertyDetails_carSpaces',
  PropertyDetailsCarportSpaces = 'propertyDetails_carportSpaces',
  PropertyDetailsEnergyEfficiencyRating = 'propertyDetails_energyEfficiencyRating',
  PropertyDetailsGarageSpaces = 'propertyDetails_garageSpaces',
  PropertyDetailsLandAreaDepthLeft = 'propertyDetails_landArea_depth_left',
  PropertyDetailsLandAreaDepthRear = 'propertyDetails_landArea_depth_rear',
  PropertyDetailsLandAreaDepthRight = 'propertyDetails_landArea_depth_right',
  PropertyDetailsLandAreaDepthUnit = 'propertyDetails_landArea_depth_unit',
  PropertyDetailsLandAreaFrom = 'propertyDetails_landArea_from',
  PropertyDetailsLandAreaFrontage = 'propertyDetails_landArea_frontage',
  PropertyDetailsLandAreaFrontageUnit = 'propertyDetails_landArea_frontage_unit',
  PropertyDetailsLandAreaTo = 'propertyDetails_landArea_to',
  PropertyDetailsLandAreaUnit = 'propertyDetails_landArea_unit',
  PropertyDetailsLandAreaValue = 'propertyDetails_landArea_value',
  PropertyDetailsParkingInfoInformation = 'propertyDetails_parkingInfo_information',
  PropertyDetailsPropertyType = 'propertyDetails_propertyType',
  PropertyDetailsPropertyTypeHotWaterServiceType = 'propertyDetails_propertyType_hotWaterServiceType',
  PropertyDetailsYearBuilt = 'propertyDetails_yearBuilt',
  ProviderAdId = 'providerAdId',
  PublishingStatus = 'publishing_status',
  SaleType = 'saleType',
  SalesforceId = 'salesforce_id',
  SearchPrice = 'search_price',
  SfUpdatedAt = 'sf_updated_at',
  SoiComparableData = 'soi_comparableData',
  SoiComparableDataComparablePropertyDateOf = 'soi_comparableData_comparableProperty_dateOf',
  SoiComparableDataComparablePropertySoldPr = 'soi_comparableData_comparableProperty_soldPr',
  SoiComparableDataDeclarationText = 'soi_comparableData_declarationText',
  SoiDocumentationUrl = 'soi_documentationUrl',
  SoiEstimatedPrice = 'soi_estimatedPrice',
  SoiEstimatedPriceFrom = 'soi_estimatedPrice_from',
  SoiEstimatedPriceTo = 'soi_estimatedPrice_to',
  SoiSuburbMedianPrice = 'soi_suburbMedianPrice',
  SoiSuburbMedianPriceDeclarationText = 'soi_suburbMedianPrice_declarationText',
  SoiSuburbMedianPriceMedianPrice = 'soi_suburbMedianPrice_medianPrice',
  SoiSuburbMedianPricePostcode = 'soi_suburbMedianPrice_postcode',
  SoiSuburbMedianPricePriceType = 'soi_suburbMedianPrice_priceType',
  SoiSuburbMedianPriceSource = 'soi_suburbMedianPrice_source',
  SoiSuburbMedianPriceSourceDateFrom = 'soi_suburbMedianPrice_sourceDateFrom',
  SoiSuburbMedianPriceSourceDateTo = 'soi_suburbMedianPrice_sourceDateTo',
  SoiSuburbMedianPriceSuburb = 'soi_suburbMedianPrice_suburb',
  Status = 'status',
  Summary = 'summary',
  SupplementaryDescription = 'supplementary_description',
  SupplementaryMetadataDescription = 'supplementary_metadata_description',
  SupplementaryMetadataMeasurement = 'supplementary_metadata_measurement',
  SupplementaryMetadataMeasurementUnit = 'supplementary_metadata_measurementUnit',
  SupplementaryMetadataName = 'supplementary_metadata_name',
  SupplementaryName = 'supplementary_name',
  SupplementaryTypes = 'supplementary_types',
  TemporaryAddOnFlag = 'temporary_add_on_flag',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Bmp_Listing_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Bmp_Listing_Stddev_Fields = {
  __typename?: 'bmp_listing_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Stddev_Pop_Fields = {
  __typename?: 'bmp_listing_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Stddev_Samp_Fields = {
  __typename?: 'bmp_listing_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Sum_Fields = {
  __typename?: 'bmp_listing_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Bmp_Listing_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export enum Bmp_Listing_Update_Column {
  AgentPointId = 'agent_point_id',
  AuctionDateTime = 'auction_dateTime',
  AuctionLocation = 'auction_location',
  AuctionOnline = 'auction_online',
  Authority = 'authority',
  AvailableFrom = 'availableFrom',
  Bond = 'bond',
  CommercialStatus = 'commercial_status',
  ContactPreference = 'contactPreference',
  CreatedAt = 'created_at',
  CrossOver = 'crossOver',
  Description = 'description',
  DomainAdId = 'domainAdId',
  EnquiryCode = 'enquiry_code',
  Experiments = 'experiments',
  ExternalLink = 'externalLink',
  Features = 'features',
  Id = 'id',
  InspectionDetailsInspectionDescription = 'inspectionDetails_inspectionDescription',
  IsNewDevelopment = 'isNewDevelopment',
  IsRural = 'isRural',
  LifeStyleType = 'lifeStyleType',
  ListingAction = 'listingAction',
  OtherEnquiryEmail = 'otherEnquiryEmail',
  OwnerId = 'owner_id',
  PriceAsking = 'price_asking',
  PriceDisplayOption = 'price_displayOption',
  PriceDisplayText = 'price_displayText',
  PriceFrom = 'price_from',
  PriceSingle = 'price_single',
  PriceTextOption = 'price_textOption',
  PriceTo = 'price_to',
  PriceView = 'price_view',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressMunicipality = 'propertyDetails_address_municipality',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressPostcodeBeforeCheckout = 'propertyDetails_address_postcode_before_checkout',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStateBeforeCheckout = 'propertyDetails_address_state_before_checkout',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetDirectoryPage = 'propertyDetails_address_streetDirectory_page',
  PropertyDetailsAddressStreetDirectoryReference = 'propertyDetails_address_streetDirectory_reference',
  PropertyDetailsAddressStreetDirectoryType = 'propertyDetails_address_streetDirectory_type',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressSuburbBeforeCheckout = 'propertyDetails_address_suburb_before_checkout',
  PropertyDetailsAddressSuggestedGeoLocation = 'propertyDetails_address_suggestedGeoLocation',
  PropertyDetailsAddressSuggestedGeoLocationLatitude = 'propertyDetails_address_suggestedGeoLocation_latitude',
  PropertyDetailsAddressSuggestedGeoLocationLongitude = 'propertyDetails_address_suggestedGeoLocation_longitude',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PropertyDetailsAreaFrom = 'propertyDetails_area_from',
  PropertyDetailsAreaTo = 'propertyDetails_area_to',
  PropertyDetailsAreaUnit = 'propertyDetails_area_unit',
  PropertyDetailsAreaValue = 'propertyDetails_area_value',
  PropertyDetailsBathRooms = 'propertyDetails_bathRooms',
  PropertyDetailsBedRooms = 'propertyDetails_bedRooms',
  PropertyDetailsCarSpaces = 'propertyDetails_carSpaces',
  PropertyDetailsCarportSpaces = 'propertyDetails_carportSpaces',
  PropertyDetailsEnergyEfficiencyRating = 'propertyDetails_energyEfficiencyRating',
  PropertyDetailsGarageSpaces = 'propertyDetails_garageSpaces',
  PropertyDetailsLandAreaDepthLeft = 'propertyDetails_landArea_depth_left',
  PropertyDetailsLandAreaDepthRear = 'propertyDetails_landArea_depth_rear',
  PropertyDetailsLandAreaDepthRight = 'propertyDetails_landArea_depth_right',
  PropertyDetailsLandAreaDepthUnit = 'propertyDetails_landArea_depth_unit',
  PropertyDetailsLandAreaFrom = 'propertyDetails_landArea_from',
  PropertyDetailsLandAreaFrontage = 'propertyDetails_landArea_frontage',
  PropertyDetailsLandAreaFrontageUnit = 'propertyDetails_landArea_frontage_unit',
  PropertyDetailsLandAreaTo = 'propertyDetails_landArea_to',
  PropertyDetailsLandAreaUnit = 'propertyDetails_landArea_unit',
  PropertyDetailsLandAreaValue = 'propertyDetails_landArea_value',
  PropertyDetailsParkingInfoInformation = 'propertyDetails_parkingInfo_information',
  PropertyDetailsPropertyType = 'propertyDetails_propertyType',
  PropertyDetailsPropertyTypeHotWaterServiceType = 'propertyDetails_propertyType_hotWaterServiceType',
  PropertyDetailsYearBuilt = 'propertyDetails_yearBuilt',
  ProviderAdId = 'providerAdId',
  PublishingStatus = 'publishing_status',
  SaleType = 'saleType',
  SalesforceId = 'salesforce_id',
  SearchPrice = 'search_price',
  SfUpdatedAt = 'sf_updated_at',
  SoiComparableData = 'soi_comparableData',
  SoiComparableDataComparablePropertyDateOf = 'soi_comparableData_comparableProperty_dateOf',
  SoiComparableDataComparablePropertySoldPr = 'soi_comparableData_comparableProperty_soldPr',
  SoiComparableDataDeclarationText = 'soi_comparableData_declarationText',
  SoiDocumentationUrl = 'soi_documentationUrl',
  SoiEstimatedPrice = 'soi_estimatedPrice',
  SoiEstimatedPriceFrom = 'soi_estimatedPrice_from',
  SoiEstimatedPriceTo = 'soi_estimatedPrice_to',
  SoiSuburbMedianPrice = 'soi_suburbMedianPrice',
  SoiSuburbMedianPriceDeclarationText = 'soi_suburbMedianPrice_declarationText',
  SoiSuburbMedianPriceMedianPrice = 'soi_suburbMedianPrice_medianPrice',
  SoiSuburbMedianPricePostcode = 'soi_suburbMedianPrice_postcode',
  SoiSuburbMedianPricePriceType = 'soi_suburbMedianPrice_priceType',
  SoiSuburbMedianPriceSource = 'soi_suburbMedianPrice_source',
  SoiSuburbMedianPriceSourceDateFrom = 'soi_suburbMedianPrice_sourceDateFrom',
  SoiSuburbMedianPriceSourceDateTo = 'soi_suburbMedianPrice_sourceDateTo',
  SoiSuburbMedianPriceSuburb = 'soi_suburbMedianPrice_suburb',
  Status = 'status',
  Summary = 'summary',
  SupplementaryDescription = 'supplementary_description',
  SupplementaryMetadataDescription = 'supplementary_metadata_description',
  SupplementaryMetadataMeasurement = 'supplementary_metadata_measurement',
  SupplementaryMetadataMeasurementUnit = 'supplementary_metadata_measurementUnit',
  SupplementaryMetadataName = 'supplementary_metadata_name',
  SupplementaryName = 'supplementary_name',
  SupplementaryTypes = 'supplementary_types',
  TemporaryAddOnFlag = 'temporary_add_on_flag',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Bmp_Listing_Var_Pop_Fields = {
  __typename?: 'bmp_listing_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Var_Samp_Fields = {
  __typename?: 'bmp_listing_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Bmp_Listing_Variance_Fields = {
  __typename?: 'bmp_listing_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Bmp_Listing_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>,
  _gt?: Maybe<Scalars['Boolean']>,
  _gte?: Maybe<Scalars['Boolean']>,
  _in?: Maybe<Array<Scalars['Boolean']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['Boolean']>,
  _lte?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Scalars['Boolean']>,
  _nin?: Maybe<Array<Scalars['Boolean']>>,
};

export type BulkOnBoardingEmailResponse = {
  __typename?: 'BulkOnBoardingEmailResponse',
  agentPointId?: Maybe<Scalars['numeric']>,
  email?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
};

export type Cache = {
  __typename?: 'cache',
  created_at: Scalars['timestamptz'],
  expires_at: Scalars['timestamptz'],
  key: Scalars['String'],
  updated_at: Scalars['timestamptz'],
  value: Scalars['String'],
};

export type Cache_Aggregate = {
  __typename?: 'cache_aggregate',
  aggregate?: Maybe<Cache_Aggregate_Fields>,
  nodes: Array<Cache>,
};

export type Cache_Aggregate_Fields = {
  __typename?: 'cache_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Cache_Max_Fields>,
  min?: Maybe<Cache_Min_Fields>,
};


export type Cache_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Cache_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Cache_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Cache_Max_Order_By>,
  min?: Maybe<Cache_Min_Order_By>,
};

export type Cache_Arr_Rel_Insert_Input = {
  data: Array<Cache_Insert_Input>,
  on_conflict?: Maybe<Cache_On_Conflict>,
};

export type Cache_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Cache_Bool_Exp>>>,
  _not?: Maybe<Cache_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Cache_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  expires_at?: Maybe<Timestamptz_Comparison_Exp>,
  key?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Cache_Constraint {
  CachePkey = 'cache_pkey'
}

export type Cache_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  expires_at?: Maybe<Scalars['timestamptz']>,
  key?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['String']>,
};

export type Cache_Max_Fields = {
  __typename?: 'cache_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  expires_at?: Maybe<Scalars['timestamptz']>,
  key?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['String']>,
};

export type Cache_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  expires_at?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Cache_Min_Fields = {
  __typename?: 'cache_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  expires_at?: Maybe<Scalars['timestamptz']>,
  key?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['String']>,
};

export type Cache_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  expires_at?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Cache_Mutation_Response = {
  __typename?: 'cache_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Cache>,
};

export type Cache_Obj_Rel_Insert_Input = {
  data: Cache_Insert_Input,
  on_conflict?: Maybe<Cache_On_Conflict>,
};

export type Cache_On_Conflict = {
  constraint: Cache_Constraint,
  update_columns: Array<Cache_Update_Column>,
  where?: Maybe<Cache_Bool_Exp>,
};

export type Cache_Order_By = {
  created_at?: Maybe<Order_By>,
  expires_at?: Maybe<Order_By>,
  key?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Cache_Pk_Columns_Input = {
  key: Scalars['String'],
};

export enum Cache_Select_Column {
  CreatedAt = 'created_at',
  ExpiresAt = 'expires_at',
  Key = 'key',
  UpdatedAt = 'updated_at',
  Value = 'value'
}

export type Cache_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  expires_at?: Maybe<Scalars['timestamptz']>,
  key?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['String']>,
};

export enum Cache_Update_Column {
  CreatedAt = 'created_at',
  ExpiresAt = 'expires_at',
  Key = 'key',
  UpdatedAt = 'updated_at',
  Value = 'value'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Campaign = {
  __typename?: 'campaign',
  campaign_addon_groups: Array<Campaign_Addon_Group>,
  campaign_addon_groups_aggregate: Campaign_Addon_Group_Aggregate,
  campaign_inclusion_groups: Array<Campaign_Inclusion_Group>,
  campaign_inclusion_groups_aggregate: Campaign_Inclusion_Group_Aggregate,
  campaign_selling_points: Array<Campaign_Selling_Point>,
  campaign_selling_points_aggregate: Campaign_Selling_Point_Aggregate,
  code: Scalars['String'],
  created_at: Scalars['timestamptz'],
  desc?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  image?: Maybe<Scalars['String']>,
  image_nonprimary_hero_apartment?: Maybe<Scalars['String']>,
  image_nonprimary_hero_house?: Maybe<Scalars['String']>,
  image_nonprimary_hero_land?: Maybe<Scalars['String']>,
  image_nonprimary_hero_townhouse?: Maybe<Scalars['String']>,
  image_nonprimary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_hero_apartment?: Maybe<Scalars['String']>,
  image_primary_hero_house?: Maybe<Scalars['String']>,
  image_primary_hero_land?: Maybe<Scalars['String']>,
  image_primary_hero_townhouse?: Maybe<Scalars['String']>,
  image_primary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_overlay_apartment?: Maybe<Scalars['String']>,
  image_primary_overlay_house?: Maybe<Scalars['String']>,
  image_primary_overlay_land?: Maybe<Scalars['String']>,
  image_primary_overlay_townhouse?: Maybe<Scalars['String']>,
  image_primary_overlay_unit?: Maybe<Scalars['String']>,
  name: Scalars['String'],
  order: Scalars['Int'],
  price: Scalars['Int'],
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  price_description: Scalars['String'],
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type: Scalars['String'],
  updated_at: Scalars['timestamptz'],
};


export type CampaignCampaign_Addon_GroupsArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type CampaignCampaign_Addon_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type CampaignCampaign_Inclusion_GroupsArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type CampaignCampaign_Inclusion_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type CampaignCampaign_Selling_PointsArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type CampaignCampaign_Selling_Points_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};

export type Campaign_Addon_Group = {
  __typename?: 'campaign_addon_group',
  addon_group: Addon_Group,
  addon_group_id: Scalars['uuid'],
  campaign: Campaign,
  campaign_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  updated_at: Scalars['timestamptz'],
};

export type Campaign_Addon_Group_Aggregate = {
  __typename?: 'campaign_addon_group_aggregate',
  aggregate?: Maybe<Campaign_Addon_Group_Aggregate_Fields>,
  nodes: Array<Campaign_Addon_Group>,
};

export type Campaign_Addon_Group_Aggregate_Fields = {
  __typename?: 'campaign_addon_group_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Campaign_Addon_Group_Max_Fields>,
  min?: Maybe<Campaign_Addon_Group_Min_Fields>,
};


export type Campaign_Addon_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Campaign_Addon_Group_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Campaign_Addon_Group_Max_Order_By>,
  min?: Maybe<Campaign_Addon_Group_Min_Order_By>,
};

export type Campaign_Addon_Group_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Campaign_Addon_Group_On_Conflict>,
};

export type Campaign_Addon_Group_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Campaign_Addon_Group_Bool_Exp>>>,
  _not?: Maybe<Campaign_Addon_Group_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Campaign_Addon_Group_Bool_Exp>>>,
  addon_group?: Maybe<Addon_Group_Bool_Exp>,
  addon_group_id?: Maybe<Uuid_Comparison_Exp>,
  campaign?: Maybe<Campaign_Bool_Exp>,
  campaign_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Campaign_Addon_Group_Constraint {
  CampaignAddonGroupPkey = 'campaign_addon_group_pkey'
}

export type Campaign_Addon_Group_Insert_Input = {
  addon_group?: Maybe<Addon_Group_Obj_Rel_Insert_Input>,
  addon_group_id?: Maybe<Scalars['uuid']>,
  campaign?: Maybe<Campaign_Obj_Rel_Insert_Input>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Addon_Group_Max_Fields = {
  __typename?: 'campaign_addon_group_max_fields',
  addon_group_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Addon_Group_Max_Order_By = {
  addon_group_id?: Maybe<Order_By>,
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Addon_Group_Min_Fields = {
  __typename?: 'campaign_addon_group_min_fields',
  addon_group_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Addon_Group_Min_Order_By = {
  addon_group_id?: Maybe<Order_By>,
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Addon_Group_Mutation_Response = {
  __typename?: 'campaign_addon_group_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Campaign_Addon_Group>,
};

export type Campaign_Addon_Group_Obj_Rel_Insert_Input = {
  data: Campaign_Addon_Group_Insert_Input,
  on_conflict?: Maybe<Campaign_Addon_Group_On_Conflict>,
};

export type Campaign_Addon_Group_On_Conflict = {
  constraint: Campaign_Addon_Group_Constraint,
  update_columns: Array<Campaign_Addon_Group_Update_Column>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>,
};

export type Campaign_Addon_Group_Order_By = {
  addon_group?: Maybe<Addon_Group_Order_By>,
  addon_group_id?: Maybe<Order_By>,
  campaign?: Maybe<Campaign_Order_By>,
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Addon_Group_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Campaign_Addon_Group_Select_Column {
  AddonGroupId = 'addon_group_id',
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Addon_Group_Set_Input = {
  addon_group_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Campaign_Addon_Group_Update_Column {
  AddonGroupId = 'addon_group_id',
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Aggregate = {
  __typename?: 'campaign_aggregate',
  aggregate?: Maybe<Campaign_Aggregate_Fields>,
  nodes: Array<Campaign>,
};

export type Campaign_Aggregate_Fields = {
  __typename?: 'campaign_aggregate_fields',
  avg?: Maybe<Campaign_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Campaign_Max_Fields>,
  min?: Maybe<Campaign_Min_Fields>,
  stddev?: Maybe<Campaign_Stddev_Fields>,
  stddev_pop?: Maybe<Campaign_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Campaign_Stddev_Samp_Fields>,
  sum?: Maybe<Campaign_Sum_Fields>,
  var_pop?: Maybe<Campaign_Var_Pop_Fields>,
  var_samp?: Maybe<Campaign_Var_Samp_Fields>,
  variance?: Maybe<Campaign_Variance_Fields>,
};


export type Campaign_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Campaign_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Campaign_Aggregate_Order_By = {
  avg?: Maybe<Campaign_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Campaign_Max_Order_By>,
  min?: Maybe<Campaign_Min_Order_By>,
  stddev?: Maybe<Campaign_Stddev_Order_By>,
  stddev_pop?: Maybe<Campaign_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Campaign_Stddev_Samp_Order_By>,
  sum?: Maybe<Campaign_Sum_Order_By>,
  var_pop?: Maybe<Campaign_Var_Pop_Order_By>,
  var_samp?: Maybe<Campaign_Var_Samp_Order_By>,
  variance?: Maybe<Campaign_Variance_Order_By>,
};

export type Campaign_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Insert_Input>,
  on_conflict?: Maybe<Campaign_On_Conflict>,
};

export type Campaign_Avg_Fields = {
  __typename?: 'campaign_avg_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Avg_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Campaign_Bool_Exp>>>,
  _not?: Maybe<Campaign_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Campaign_Bool_Exp>>>,
  campaign_addon_groups?: Maybe<Campaign_Addon_Group_Bool_Exp>,
  campaign_inclusion_groups?: Maybe<Campaign_Inclusion_Group_Bool_Exp>,
  campaign_selling_points?: Maybe<Campaign_Selling_Point_Bool_Exp>,
  code?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  desc?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  image?: Maybe<String_Comparison_Exp>,
  image_nonprimary_hero_apartment?: Maybe<String_Comparison_Exp>,
  image_nonprimary_hero_house?: Maybe<String_Comparison_Exp>,
  image_nonprimary_hero_land?: Maybe<String_Comparison_Exp>,
  image_nonprimary_hero_townhouse?: Maybe<String_Comparison_Exp>,
  image_nonprimary_hero_unit?: Maybe<String_Comparison_Exp>,
  image_primary_hero_apartment?: Maybe<String_Comparison_Exp>,
  image_primary_hero_house?: Maybe<String_Comparison_Exp>,
  image_primary_hero_land?: Maybe<String_Comparison_Exp>,
  image_primary_hero_townhouse?: Maybe<String_Comparison_Exp>,
  image_primary_hero_unit?: Maybe<String_Comparison_Exp>,
  image_primary_overlay_apartment?: Maybe<String_Comparison_Exp>,
  image_primary_overlay_house?: Maybe<String_Comparison_Exp>,
  image_primary_overlay_land?: Maybe<String_Comparison_Exp>,
  image_primary_overlay_townhouse?: Maybe<String_Comparison_Exp>,
  image_primary_overlay_unit?: Maybe<String_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  price?: Maybe<Int_Comparison_Exp>,
  price_book_entry_salesforce_id?: Maybe<String_Comparison_Exp>,
  price_description?: Maybe<String_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  type?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Campaign_Constraint {
  CampaignCodeKey = 'campaign_code_key',
  CampaignPkey = 'campaign_pkey'
}

export type Campaign_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
};

export type Campaign_Inclusion_Group = {
  __typename?: 'campaign_inclusion_group',
  campaign: Campaign,
  campaign_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  inclusion_group: Inclusion_Group,
  inclusion_group_id: Scalars['uuid'],
  updated_at: Scalars['timestamptz'],
};

export type Campaign_Inclusion_Group_Aggregate = {
  __typename?: 'campaign_inclusion_group_aggregate',
  aggregate?: Maybe<Campaign_Inclusion_Group_Aggregate_Fields>,
  nodes: Array<Campaign_Inclusion_Group>,
};

export type Campaign_Inclusion_Group_Aggregate_Fields = {
  __typename?: 'campaign_inclusion_group_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Campaign_Inclusion_Group_Max_Fields>,
  min?: Maybe<Campaign_Inclusion_Group_Min_Fields>,
};


export type Campaign_Inclusion_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Campaign_Inclusion_Group_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Campaign_Inclusion_Group_Max_Order_By>,
  min?: Maybe<Campaign_Inclusion_Group_Min_Order_By>,
};

export type Campaign_Inclusion_Group_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Inclusion_Group_Insert_Input>,
  on_conflict?: Maybe<Campaign_Inclusion_Group_On_Conflict>,
};

export type Campaign_Inclusion_Group_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Campaign_Inclusion_Group_Bool_Exp>>>,
  _not?: Maybe<Campaign_Inclusion_Group_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Campaign_Inclusion_Group_Bool_Exp>>>,
  campaign?: Maybe<Campaign_Bool_Exp>,
  campaign_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inclusion_group?: Maybe<Inclusion_Group_Bool_Exp>,
  inclusion_group_id?: Maybe<Uuid_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Campaign_Inclusion_Group_Constraint {
  CampaignInclusionGroupPkey = 'campaign_inclusion_group_pkey'
}

export type Campaign_Inclusion_Group_Insert_Input = {
  campaign?: Maybe<Campaign_Obj_Rel_Insert_Input>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_group?: Maybe<Inclusion_Group_Obj_Rel_Insert_Input>,
  inclusion_group_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Inclusion_Group_Max_Fields = {
  __typename?: 'campaign_inclusion_group_max_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_group_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Inclusion_Group_Max_Order_By = {
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_group_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Inclusion_Group_Min_Fields = {
  __typename?: 'campaign_inclusion_group_min_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_group_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Inclusion_Group_Min_Order_By = {
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_group_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Inclusion_Group_Mutation_Response = {
  __typename?: 'campaign_inclusion_group_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Campaign_Inclusion_Group>,
};

export type Campaign_Inclusion_Group_Obj_Rel_Insert_Input = {
  data: Campaign_Inclusion_Group_Insert_Input,
  on_conflict?: Maybe<Campaign_Inclusion_Group_On_Conflict>,
};

export type Campaign_Inclusion_Group_On_Conflict = {
  constraint: Campaign_Inclusion_Group_Constraint,
  update_columns: Array<Campaign_Inclusion_Group_Update_Column>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>,
};

export type Campaign_Inclusion_Group_Order_By = {
  campaign?: Maybe<Campaign_Order_By>,
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_group?: Maybe<Inclusion_Group_Order_By>,
  inclusion_group_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Inclusion_Group_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Campaign_Inclusion_Group_Select_Column {
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  InclusionGroupId = 'inclusion_group_id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Inclusion_Group_Set_Input = {
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_group_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Campaign_Inclusion_Group_Update_Column {
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  InclusionGroupId = 'inclusion_group_id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Insert_Input = {
  campaign_addon_groups?: Maybe<Campaign_Addon_Group_Arr_Rel_Insert_Input>,
  campaign_inclusion_groups?: Maybe<Campaign_Inclusion_Group_Arr_Rel_Insert_Input>,
  campaign_selling_points?: Maybe<Campaign_Selling_Point_Arr_Rel_Insert_Input>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  image_nonprimary_hero_apartment?: Maybe<Scalars['String']>,
  image_nonprimary_hero_house?: Maybe<Scalars['String']>,
  image_nonprimary_hero_land?: Maybe<Scalars['String']>,
  image_nonprimary_hero_townhouse?: Maybe<Scalars['String']>,
  image_nonprimary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_hero_apartment?: Maybe<Scalars['String']>,
  image_primary_hero_house?: Maybe<Scalars['String']>,
  image_primary_hero_land?: Maybe<Scalars['String']>,
  image_primary_hero_townhouse?: Maybe<Scalars['String']>,
  image_primary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_overlay_apartment?: Maybe<Scalars['String']>,
  image_primary_overlay_house?: Maybe<Scalars['String']>,
  image_primary_overlay_land?: Maybe<Scalars['String']>,
  image_primary_overlay_townhouse?: Maybe<Scalars['String']>,
  image_primary_overlay_unit?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  price_description?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Max_Fields = {
  __typename?: 'campaign_max_fields',
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  image_nonprimary_hero_apartment?: Maybe<Scalars['String']>,
  image_nonprimary_hero_house?: Maybe<Scalars['String']>,
  image_nonprimary_hero_land?: Maybe<Scalars['String']>,
  image_nonprimary_hero_townhouse?: Maybe<Scalars['String']>,
  image_nonprimary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_hero_apartment?: Maybe<Scalars['String']>,
  image_primary_hero_house?: Maybe<Scalars['String']>,
  image_primary_hero_land?: Maybe<Scalars['String']>,
  image_primary_hero_townhouse?: Maybe<Scalars['String']>,
  image_primary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_overlay_apartment?: Maybe<Scalars['String']>,
  image_primary_overlay_house?: Maybe<Scalars['String']>,
  image_primary_overlay_land?: Maybe<Scalars['String']>,
  image_primary_overlay_townhouse?: Maybe<Scalars['String']>,
  image_primary_overlay_unit?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  price_description?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Max_Order_By = {
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  image_nonprimary_hero_apartment?: Maybe<Order_By>,
  image_nonprimary_hero_house?: Maybe<Order_By>,
  image_nonprimary_hero_land?: Maybe<Order_By>,
  image_nonprimary_hero_townhouse?: Maybe<Order_By>,
  image_nonprimary_hero_unit?: Maybe<Order_By>,
  image_primary_hero_apartment?: Maybe<Order_By>,
  image_primary_hero_house?: Maybe<Order_By>,
  image_primary_hero_land?: Maybe<Order_By>,
  image_primary_hero_townhouse?: Maybe<Order_By>,
  image_primary_hero_unit?: Maybe<Order_By>,
  image_primary_overlay_apartment?: Maybe<Order_By>,
  image_primary_overlay_house?: Maybe<Order_By>,
  image_primary_overlay_land?: Maybe<Order_By>,
  image_primary_overlay_townhouse?: Maybe<Order_By>,
  image_primary_overlay_unit?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  price_description?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Min_Fields = {
  __typename?: 'campaign_min_fields',
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  image_nonprimary_hero_apartment?: Maybe<Scalars['String']>,
  image_nonprimary_hero_house?: Maybe<Scalars['String']>,
  image_nonprimary_hero_land?: Maybe<Scalars['String']>,
  image_nonprimary_hero_townhouse?: Maybe<Scalars['String']>,
  image_nonprimary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_hero_apartment?: Maybe<Scalars['String']>,
  image_primary_hero_house?: Maybe<Scalars['String']>,
  image_primary_hero_land?: Maybe<Scalars['String']>,
  image_primary_hero_townhouse?: Maybe<Scalars['String']>,
  image_primary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_overlay_apartment?: Maybe<Scalars['String']>,
  image_primary_overlay_house?: Maybe<Scalars['String']>,
  image_primary_overlay_land?: Maybe<Scalars['String']>,
  image_primary_overlay_townhouse?: Maybe<Scalars['String']>,
  image_primary_overlay_unit?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  price_description?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Min_Order_By = {
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  image_nonprimary_hero_apartment?: Maybe<Order_By>,
  image_nonprimary_hero_house?: Maybe<Order_By>,
  image_nonprimary_hero_land?: Maybe<Order_By>,
  image_nonprimary_hero_townhouse?: Maybe<Order_By>,
  image_nonprimary_hero_unit?: Maybe<Order_By>,
  image_primary_hero_apartment?: Maybe<Order_By>,
  image_primary_hero_house?: Maybe<Order_By>,
  image_primary_hero_land?: Maybe<Order_By>,
  image_primary_hero_townhouse?: Maybe<Order_By>,
  image_primary_hero_unit?: Maybe<Order_By>,
  image_primary_overlay_apartment?: Maybe<Order_By>,
  image_primary_overlay_house?: Maybe<Order_By>,
  image_primary_overlay_land?: Maybe<Order_By>,
  image_primary_overlay_townhouse?: Maybe<Order_By>,
  image_primary_overlay_unit?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  price_description?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Mutation_Response = {
  __typename?: 'campaign_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Campaign>,
};

export type Campaign_Obj_Rel_Insert_Input = {
  data: Campaign_Insert_Input,
  on_conflict?: Maybe<Campaign_On_Conflict>,
};

export type Campaign_On_Conflict = {
  constraint: Campaign_Constraint,
  update_columns: Array<Campaign_Update_Column>,
  where?: Maybe<Campaign_Bool_Exp>,
};

export type Campaign_Order_By = {
  campaign_addon_groups_aggregate?: Maybe<Campaign_Addon_Group_Aggregate_Order_By>,
  campaign_inclusion_groups_aggregate?: Maybe<Campaign_Inclusion_Group_Aggregate_Order_By>,
  campaign_selling_points_aggregate?: Maybe<Campaign_Selling_Point_Aggregate_Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  image_nonprimary_hero_apartment?: Maybe<Order_By>,
  image_nonprimary_hero_house?: Maybe<Order_By>,
  image_nonprimary_hero_land?: Maybe<Order_By>,
  image_nonprimary_hero_townhouse?: Maybe<Order_By>,
  image_nonprimary_hero_unit?: Maybe<Order_By>,
  image_primary_hero_apartment?: Maybe<Order_By>,
  image_primary_hero_house?: Maybe<Order_By>,
  image_primary_hero_land?: Maybe<Order_By>,
  image_primary_hero_townhouse?: Maybe<Order_By>,
  image_primary_hero_unit?: Maybe<Order_By>,
  image_primary_overlay_apartment?: Maybe<Order_By>,
  image_primary_overlay_house?: Maybe<Order_By>,
  image_primary_overlay_land?: Maybe<Order_By>,
  image_primary_overlay_townhouse?: Maybe<Order_By>,
  image_primary_overlay_unit?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  price_description?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Campaign_Select_Column {
  Code = 'code',
  CreatedAt = 'created_at',
  Desc = 'desc',
  Id = 'id',
  Image = 'image',
  ImageNonprimaryHeroApartment = 'image_nonprimary_hero_apartment',
  ImageNonprimaryHeroHouse = 'image_nonprimary_hero_house',
  ImageNonprimaryHeroLand = 'image_nonprimary_hero_land',
  ImageNonprimaryHeroTownhouse = 'image_nonprimary_hero_townhouse',
  ImageNonprimaryHeroUnit = 'image_nonprimary_hero_unit',
  ImagePrimaryHeroApartment = 'image_primary_hero_apartment',
  ImagePrimaryHeroHouse = 'image_primary_hero_house',
  ImagePrimaryHeroLand = 'image_primary_hero_land',
  ImagePrimaryHeroTownhouse = 'image_primary_hero_townhouse',
  ImagePrimaryHeroUnit = 'image_primary_hero_unit',
  ImagePrimaryOverlayApartment = 'image_primary_overlay_apartment',
  ImagePrimaryOverlayHouse = 'image_primary_overlay_house',
  ImagePrimaryOverlayLand = 'image_primary_overlay_land',
  ImagePrimaryOverlayTownhouse = 'image_primary_overlay_townhouse',
  ImagePrimaryOverlayUnit = 'image_primary_overlay_unit',
  Name = 'name',
  Order = 'order',
  Price = 'price',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  PriceDescription = 'price_description',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Campaign_Selling_Point = {
  __typename?: 'campaign_selling_point',
  campaign: Campaign,
  campaign_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  selling_point: Selling_Point,
  selling_point_id: Scalars['uuid'],
  updated_at: Scalars['timestamptz'],
};

export type Campaign_Selling_Point_Aggregate = {
  __typename?: 'campaign_selling_point_aggregate',
  aggregate?: Maybe<Campaign_Selling_Point_Aggregate_Fields>,
  nodes: Array<Campaign_Selling_Point>,
};

export type Campaign_Selling_Point_Aggregate_Fields = {
  __typename?: 'campaign_selling_point_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Campaign_Selling_Point_Max_Fields>,
  min?: Maybe<Campaign_Selling_Point_Min_Fields>,
};


export type Campaign_Selling_Point_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Campaign_Selling_Point_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Campaign_Selling_Point_Max_Order_By>,
  min?: Maybe<Campaign_Selling_Point_Min_Order_By>,
};

export type Campaign_Selling_Point_Arr_Rel_Insert_Input = {
  data: Array<Campaign_Selling_Point_Insert_Input>,
  on_conflict?: Maybe<Campaign_Selling_Point_On_Conflict>,
};

export type Campaign_Selling_Point_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Campaign_Selling_Point_Bool_Exp>>>,
  _not?: Maybe<Campaign_Selling_Point_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Campaign_Selling_Point_Bool_Exp>>>,
  campaign?: Maybe<Campaign_Bool_Exp>,
  campaign_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  selling_point?: Maybe<Selling_Point_Bool_Exp>,
  selling_point_id?: Maybe<Uuid_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Campaign_Selling_Point_Constraint {
  CampaignSellingPointPkey = 'campaign_selling_point_pkey'
}

export type Campaign_Selling_Point_Insert_Input = {
  campaign?: Maybe<Campaign_Obj_Rel_Insert_Input>,
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  selling_point?: Maybe<Selling_Point_Obj_Rel_Insert_Input>,
  selling_point_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Selling_Point_Max_Fields = {
  __typename?: 'campaign_selling_point_max_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  selling_point_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Selling_Point_Max_Order_By = {
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  selling_point_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Selling_Point_Min_Fields = {
  __typename?: 'campaign_selling_point_min_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  selling_point_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Selling_Point_Min_Order_By = {
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  selling_point_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Selling_Point_Mutation_Response = {
  __typename?: 'campaign_selling_point_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Campaign_Selling_Point>,
};

export type Campaign_Selling_Point_Obj_Rel_Insert_Input = {
  data: Campaign_Selling_Point_Insert_Input,
  on_conflict?: Maybe<Campaign_Selling_Point_On_Conflict>,
};

export type Campaign_Selling_Point_On_Conflict = {
  constraint: Campaign_Selling_Point_Constraint,
  update_columns: Array<Campaign_Selling_Point_Update_Column>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>,
};

export type Campaign_Selling_Point_Order_By = {
  campaign?: Maybe<Campaign_Order_By>,
  campaign_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  selling_point?: Maybe<Selling_Point_Order_By>,
  selling_point_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Campaign_Selling_Point_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Campaign_Selling_Point_Select_Column {
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  SellingPointId = 'selling_point_id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Selling_Point_Set_Input = {
  campaign_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  selling_point_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Campaign_Selling_Point_Update_Column {
  CampaignId = 'campaign_id',
  CreatedAt = 'created_at',
  Id = 'id',
  SellingPointId = 'selling_point_id',
  UpdatedAt = 'updated_at'
}

export type Campaign_Set_Input = {
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  image_nonprimary_hero_apartment?: Maybe<Scalars['String']>,
  image_nonprimary_hero_house?: Maybe<Scalars['String']>,
  image_nonprimary_hero_land?: Maybe<Scalars['String']>,
  image_nonprimary_hero_townhouse?: Maybe<Scalars['String']>,
  image_nonprimary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_hero_apartment?: Maybe<Scalars['String']>,
  image_primary_hero_house?: Maybe<Scalars['String']>,
  image_primary_hero_land?: Maybe<Scalars['String']>,
  image_primary_hero_townhouse?: Maybe<Scalars['String']>,
  image_primary_hero_unit?: Maybe<Scalars['String']>,
  image_primary_overlay_apartment?: Maybe<Scalars['String']>,
  image_primary_overlay_house?: Maybe<Scalars['String']>,
  image_primary_overlay_land?: Maybe<Scalars['String']>,
  image_primary_overlay_townhouse?: Maybe<Scalars['String']>,
  image_primary_overlay_unit?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  price_description?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Campaign_Stddev_Fields = {
  __typename?: 'campaign_stddev_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Stddev_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Stddev_Pop_Fields = {
  __typename?: 'campaign_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Stddev_Samp_Fields = {
  __typename?: 'campaign_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Sum_Fields = {
  __typename?: 'campaign_sum_fields',
  order?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
};

export type Campaign_Sum_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export enum Campaign_Update_Column {
  Code = 'code',
  CreatedAt = 'created_at',
  Desc = 'desc',
  Id = 'id',
  Image = 'image',
  ImageNonprimaryHeroApartment = 'image_nonprimary_hero_apartment',
  ImageNonprimaryHeroHouse = 'image_nonprimary_hero_house',
  ImageNonprimaryHeroLand = 'image_nonprimary_hero_land',
  ImageNonprimaryHeroTownhouse = 'image_nonprimary_hero_townhouse',
  ImageNonprimaryHeroUnit = 'image_nonprimary_hero_unit',
  ImagePrimaryHeroApartment = 'image_primary_hero_apartment',
  ImagePrimaryHeroHouse = 'image_primary_hero_house',
  ImagePrimaryHeroLand = 'image_primary_hero_land',
  ImagePrimaryHeroTownhouse = 'image_primary_hero_townhouse',
  ImagePrimaryHeroUnit = 'image_primary_hero_unit',
  ImagePrimaryOverlayApartment = 'image_primary_overlay_apartment',
  ImagePrimaryOverlayHouse = 'image_primary_overlay_house',
  ImagePrimaryOverlayLand = 'image_primary_overlay_land',
  ImagePrimaryOverlayTownhouse = 'image_primary_overlay_townhouse',
  ImagePrimaryOverlayUnit = 'image_primary_overlay_unit',
  Name = 'name',
  Order = 'order',
  Price = 'price',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  PriceDescription = 'price_description',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Campaign_Var_Pop_Fields = {
  __typename?: 'campaign_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Var_Samp_Fields = {
  __typename?: 'campaign_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Campaign_Variance_Fields = {
  __typename?: 'campaign_variance_fields',
  order?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
};

export type Campaign_Variance_Order_By = {
  order?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
};

export type Cancel_Order_Response = {
  __typename?: 'cancel_order_response',
  affected_rows: Scalars['numeric'],
};

export type CancelExperimentsOutput = {
  __typename?: 'CancelExperimentsOutput',
  message?: Maybe<Scalars['String']>,
};

export type Check_Duplicate_Listing_For_Address = {
  __typename?: 'check_duplicate_listing_for_address',
  duplicate?: Maybe<Scalars['Boolean']>,
};

export type Check_Transaction_Response = {
  __typename?: 'check_transaction_response',
  status: Scalars['String'],
};

export type Checkout_Order_Response = {
  __typename?: 'checkout_order_response',
  fromPaymentMethod: Scalars['String'],
  orderId: Scalars['String'],
  originId: Scalars['String'],
  success: Scalars['Boolean'],
};

export type Clear_Addons_From_Order_Response = {
  __typename?: 'clear_addons_from_order_response',
  affected_rows: Scalars['numeric'],
};

export type Clear_Normal_Addons_From_Order_Response = {
  __typename?: 'clear_normal_addons_from_order_response',
  affected_rows: Scalars['numeric'],
};

export type Commercial_Status_Type = {
  __typename?: 'commercial_status_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Commercial_Status_Type_Aggregate = {
  __typename?: 'commercial_status_type_aggregate',
  aggregate?: Maybe<Commercial_Status_Type_Aggregate_Fields>,
  nodes: Array<Commercial_Status_Type>,
};

export type Commercial_Status_Type_Aggregate_Fields = {
  __typename?: 'commercial_status_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Commercial_Status_Type_Max_Fields>,
  min?: Maybe<Commercial_Status_Type_Min_Fields>,
};


export type Commercial_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Commercial_Status_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Commercial_Status_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Commercial_Status_Type_Max_Order_By>,
  min?: Maybe<Commercial_Status_Type_Min_Order_By>,
};

export type Commercial_Status_Type_Arr_Rel_Insert_Input = {
  data: Array<Commercial_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Commercial_Status_Type_On_Conflict>,
};

export type Commercial_Status_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Commercial_Status_Type_Bool_Exp>>>,
  _not?: Maybe<Commercial_Status_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Commercial_Status_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Commercial_Status_Type_Constraint {
  CommercialStatusTypePkey = 'commercial_status_type_pkey'
}

export enum Commercial_Status_Type_Enum {
  Leased = 'LEASED',
  Listed = 'LISTED',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  Sold = 'SOLD',
  UnderOffer = 'UNDER_OFFER',
  Withdrawn = 'WITHDRAWN'
}

export type Commercial_Status_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Commercial_Status_Type_Enum>,
  _in?: Maybe<Array<Commercial_Status_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Commercial_Status_Type_Enum>,
  _nin?: Maybe<Array<Commercial_Status_Type_Enum>>,
};

export type Commercial_Status_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Commercial_Status_Type_Max_Fields = {
  __typename?: 'commercial_status_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Commercial_Status_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Commercial_Status_Type_Min_Fields = {
  __typename?: 'commercial_status_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Commercial_Status_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Commercial_Status_Type_Mutation_Response = {
  __typename?: 'commercial_status_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Commercial_Status_Type>,
};

export type Commercial_Status_Type_Obj_Rel_Insert_Input = {
  data: Commercial_Status_Type_Insert_Input,
  on_conflict?: Maybe<Commercial_Status_Type_On_Conflict>,
};

export type Commercial_Status_Type_On_Conflict = {
  constraint: Commercial_Status_Type_Constraint,
  update_columns: Array<Commercial_Status_Type_Update_Column>,
  where?: Maybe<Commercial_Status_Type_Bool_Exp>,
};

export type Commercial_Status_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Commercial_Status_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Commercial_Status_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Commercial_Status_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Commercial_Status_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Coupon = {
  __typename?: 'coupon',
  campaign?: Maybe<Campaign>,
  campaign_id?: Maybe<Scalars['uuid']>,
  code: Scalars['String'],
  created_at: Scalars['timestamptz'],
  created_by: Scalars['uuid'],
  description: Scalars['String'],
  id: Scalars['uuid'],
  is_active: Scalars['Boolean'],
  max_uses: Scalars['Int'],
  order_items: Array<Order_Item>,
  order_items_aggregate: Order_Item_Aggregate,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type: Coupon_Type_Enum,
  unlimited_uses: Scalars['Boolean'],
  updated_at: Scalars['timestamptz'],
  user: User,
  valid_after: Scalars['timestamptz'],
  valid_until?: Maybe<Scalars['timestamptz']>,
  value: Scalars['numeric'],
};


export type CouponOrder_ItemsArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type CouponOrder_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};

export type Coupon_Aggregate = {
  __typename?: 'coupon_aggregate',
  aggregate?: Maybe<Coupon_Aggregate_Fields>,
  nodes: Array<Coupon>,
};

export type Coupon_Aggregate_Fields = {
  __typename?: 'coupon_aggregate_fields',
  avg?: Maybe<Coupon_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Coupon_Max_Fields>,
  min?: Maybe<Coupon_Min_Fields>,
  stddev?: Maybe<Coupon_Stddev_Fields>,
  stddev_pop?: Maybe<Coupon_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Coupon_Stddev_Samp_Fields>,
  sum?: Maybe<Coupon_Sum_Fields>,
  var_pop?: Maybe<Coupon_Var_Pop_Fields>,
  var_samp?: Maybe<Coupon_Var_Samp_Fields>,
  variance?: Maybe<Coupon_Variance_Fields>,
};


export type Coupon_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Coupon_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Coupon_Aggregate_Order_By = {
  avg?: Maybe<Coupon_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Coupon_Max_Order_By>,
  min?: Maybe<Coupon_Min_Order_By>,
  stddev?: Maybe<Coupon_Stddev_Order_By>,
  stddev_pop?: Maybe<Coupon_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Coupon_Stddev_Samp_Order_By>,
  sum?: Maybe<Coupon_Sum_Order_By>,
  var_pop?: Maybe<Coupon_Var_Pop_Order_By>,
  var_samp?: Maybe<Coupon_Var_Samp_Order_By>,
  variance?: Maybe<Coupon_Variance_Order_By>,
};

export type Coupon_Arr_Rel_Insert_Input = {
  data: Array<Coupon_Insert_Input>,
  on_conflict?: Maybe<Coupon_On_Conflict>,
};

export type Coupon_Avg_Fields = {
  __typename?: 'coupon_avg_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Avg_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Coupon_Bool_Exp>>>,
  _not?: Maybe<Coupon_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Coupon_Bool_Exp>>>,
  campaign?: Maybe<Campaign_Bool_Exp>,
  campaign_id?: Maybe<Uuid_Comparison_Exp>,
  code?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  created_by?: Maybe<Uuid_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  is_active?: Maybe<Boolean_Comparison_Exp>,
  max_uses?: Maybe<Int_Comparison_Exp>,
  order_items?: Maybe<Order_Item_Bool_Exp>,
  price_book_entry_salesforce_id?: Maybe<String_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  type?: Maybe<Coupon_Type_Enum_Comparison_Exp>,
  unlimited_uses?: Maybe<Boolean_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
  valid_after?: Maybe<Timestamptz_Comparison_Exp>,
  valid_until?: Maybe<Timestamptz_Comparison_Exp>,
  value?: Maybe<Numeric_Comparison_Exp>,
};

export enum Coupon_Constraint {
  CouponCodeKey = 'coupon_code_key',
  CouponPkey = 'coupon_pkey'
}

export type Coupon_Inc_Input = {
  max_uses?: Maybe<Scalars['Int']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Insert_Input = {
  campaign?: Maybe<Campaign_Obj_Rel_Insert_Input>,
  campaign_id?: Maybe<Scalars['uuid']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  created_by?: Maybe<Scalars['uuid']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  is_active?: Maybe<Scalars['Boolean']>,
  max_uses?: Maybe<Scalars['Int']>,
  order_items?: Maybe<Order_Item_Arr_Rel_Insert_Input>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Coupon_Type_Enum>,
  unlimited_uses?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
  valid_after?: Maybe<Scalars['timestamptz']>,
  valid_until?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Max_Fields = {
  __typename?: 'coupon_max_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  created_by?: Maybe<Scalars['uuid']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  max_uses?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  valid_after?: Maybe<Scalars['timestamptz']>,
  valid_until?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Max_Order_By = {
  campaign_id?: Maybe<Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  created_by?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  max_uses?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  valid_after?: Maybe<Order_By>,
  valid_until?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Min_Fields = {
  __typename?: 'coupon_min_fields',
  campaign_id?: Maybe<Scalars['uuid']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  created_by?: Maybe<Scalars['uuid']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  max_uses?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  valid_after?: Maybe<Scalars['timestamptz']>,
  valid_until?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Min_Order_By = {
  campaign_id?: Maybe<Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  created_by?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  max_uses?: Maybe<Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  valid_after?: Maybe<Order_By>,
  valid_until?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Mutation_Response = {
  __typename?: 'coupon_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Coupon>,
};

export type Coupon_Obj_Rel_Insert_Input = {
  data: Coupon_Insert_Input,
  on_conflict?: Maybe<Coupon_On_Conflict>,
};

export type Coupon_On_Conflict = {
  constraint: Coupon_Constraint,
  update_columns: Array<Coupon_Update_Column>,
  where?: Maybe<Coupon_Bool_Exp>,
};

export type Coupon_Order_By = {
  campaign?: Maybe<Campaign_Order_By>,
  campaign_id?: Maybe<Order_By>,
  code?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  created_by?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  is_active?: Maybe<Order_By>,
  max_uses?: Maybe<Order_By>,
  order_items_aggregate?: Maybe<Order_Item_Aggregate_Order_By>,
  price_book_entry_salesforce_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  unlimited_uses?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
  valid_after?: Maybe<Order_By>,
  valid_until?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Coupon_Select_Column {
  CampaignId = 'campaign_id',
  Code = 'code',
  CreatedAt = 'created_at',
  CreatedBy = 'created_by',
  Description = 'description',
  Id = 'id',
  IsActive = 'is_active',
  MaxUses = 'max_uses',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UnlimitedUses = 'unlimited_uses',
  UpdatedAt = 'updated_at',
  ValidAfter = 'valid_after',
  ValidUntil = 'valid_until',
  Value = 'value'
}

export type Coupon_Set_Input = {
  campaign_id?: Maybe<Scalars['uuid']>,
  code?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  created_by?: Maybe<Scalars['uuid']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  is_active?: Maybe<Scalars['Boolean']>,
  max_uses?: Maybe<Scalars['Int']>,
  price_book_entry_salesforce_id?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  type?: Maybe<Coupon_Type_Enum>,
  unlimited_uses?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  valid_after?: Maybe<Scalars['timestamptz']>,
  valid_until?: Maybe<Scalars['timestamptz']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Stddev_Fields = {
  __typename?: 'coupon_stddev_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Stddev_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Stddev_Pop_Fields = {
  __typename?: 'coupon_stddev_pop_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Stddev_Pop_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Stddev_Samp_Fields = {
  __typename?: 'coupon_stddev_samp_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Stddev_Samp_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Sum_Fields = {
  __typename?: 'coupon_sum_fields',
  max_uses?: Maybe<Scalars['Int']>,
  value?: Maybe<Scalars['numeric']>,
};

export type Coupon_Sum_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Type = {
  __typename?: 'coupon_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Coupon_Type_Aggregate = {
  __typename?: 'coupon_type_aggregate',
  aggregate?: Maybe<Coupon_Type_Aggregate_Fields>,
  nodes: Array<Coupon_Type>,
};

export type Coupon_Type_Aggregate_Fields = {
  __typename?: 'coupon_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Coupon_Type_Max_Fields>,
  min?: Maybe<Coupon_Type_Min_Fields>,
};


export type Coupon_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Coupon_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Coupon_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Coupon_Type_Max_Order_By>,
  min?: Maybe<Coupon_Type_Min_Order_By>,
};

export type Coupon_Type_Arr_Rel_Insert_Input = {
  data: Array<Coupon_Type_Insert_Input>,
  on_conflict?: Maybe<Coupon_Type_On_Conflict>,
};

export type Coupon_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Coupon_Type_Bool_Exp>>>,
  _not?: Maybe<Coupon_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Coupon_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Coupon_Type_Constraint {
  CouponTypePkey = 'coupon_type_pkey'
}

export enum Coupon_Type_Enum {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type Coupon_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Coupon_Type_Enum>,
  _in?: Maybe<Array<Coupon_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Coupon_Type_Enum>,
  _nin?: Maybe<Array<Coupon_Type_Enum>>,
};

export type Coupon_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Coupon_Type_Max_Fields = {
  __typename?: 'coupon_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Coupon_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Type_Min_Fields = {
  __typename?: 'coupon_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Coupon_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Type_Mutation_Response = {
  __typename?: 'coupon_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Coupon_Type>,
};

export type Coupon_Type_Obj_Rel_Insert_Input = {
  data: Coupon_Type_Insert_Input,
  on_conflict?: Maybe<Coupon_Type_On_Conflict>,
};

export type Coupon_Type_On_Conflict = {
  constraint: Coupon_Type_Constraint,
  update_columns: Array<Coupon_Type_Update_Column>,
  where?: Maybe<Coupon_Type_Bool_Exp>,
};

export type Coupon_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Coupon_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Coupon_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Coupon_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Coupon_Update_Column {
  CampaignId = 'campaign_id',
  Code = 'code',
  CreatedAt = 'created_at',
  CreatedBy = 'created_by',
  Description = 'description',
  Id = 'id',
  IsActive = 'is_active',
  MaxUses = 'max_uses',
  PriceBookEntrySalesforceId = 'price_book_entry_salesforce_id',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Type = 'type',
  UnlimitedUses = 'unlimited_uses',
  UpdatedAt = 'updated_at',
  ValidAfter = 'valid_after',
  ValidUntil = 'valid_until',
  Value = 'value'
}

export type Coupon_Update_Order_Response = {
  __typename?: 'coupon_update_order_response',
  updated: Scalars['Boolean'],
};

export type Coupon_Var_Pop_Fields = {
  __typename?: 'coupon_var_pop_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Var_Pop_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Var_Samp_Fields = {
  __typename?: 'coupon_var_samp_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Var_Samp_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Coupon_Variance_Fields = {
  __typename?: 'coupon_variance_fields',
  max_uses?: Maybe<Scalars['Float']>,
  value?: Maybe<Scalars['Float']>,
};

export type Coupon_Variance_Order_By = {
  max_uses?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Create_Order_Response = {
  __typename?: 'create_order_response',
  id: Scalars['uuid'],
};

export type CreateAccountPayInput = {
  campaign_code: Scalars['String'],
  cancel_url?: Maybe<Scalars['String']>,
  email: Scalars['String'],
  failure_url?: Maybe<Scalars['String']>,
  first_name: Scalars['String'],
  front_end_base_url?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  homepage_url?: Maybe<Scalars['String']>,
  last_name: Scalars['String'],
  payment_method: Scalars['String'],
  property_type?: Maybe<Scalars['String']>,
  sale_type: Scalars['String'],
  submitted_via?: Maybe<Scalars['String']>,
  success_url?: Maybe<Scalars['String']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
};

export type CreateAccountPayOutput = {
  __typename?: 'CreateAccountPayOutput',
  after_payment_redirect_url?: Maybe<Scalars['String']>,
  error?: Maybe<Scalars['String']>,
  jwt?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['String']>,
  order_id?: Maybe<Scalars['String']>,
  origin_id?: Maybe<Scalars['String']>,
  payment_url?: Maybe<Scalars['String']>,
};


export type Delist_Response = {
  __typename?: 'delist_response',
  error: Scalars['String'],
  success: Scalars['Boolean'],
};

export type DriverLicenceRequestAu = {
  BirthDate: Scalars['String'],
  ExpiryDate?: Maybe<Scalars['String']>,
  FamilyName: Scalars['String'],
  GivenName: Scalars['String'],
  LicenceNumber: Scalars['String'],
  MiddleName?: Maybe<Scalars['String']>,
  StateOfIssue: Scalars['String'],
};

export type DriverLicenceRequestNz = {
  dob: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  licenseNumber: Scalars['String'],
  licenseVersionNumber: Scalars['String'],
};

export type DriverLicenceResponseAu = {
  __typename?: 'DriverLicenceResponseAu',
  VerifyDocumentResult?: Maybe<VerifyDocumentResult_Dlau>,
  fieldDetails?: Maybe<FieldDetails_Dlau>,
  pdfLink?: Maybe<Scalars['String']>,
  rapidID?: Maybe<Scalars['String']>,
};

export type DriverLicenceResponseNz = {
  __typename?: 'DriverLicenceResponseNz',
  Message?: Maybe<Scalars['String']>,
  Results?: Maybe<Results_Dlnz>,
  SafeHarbour?: Maybe<Scalars['String']>,
  Status?: Maybe<Scalars['String']>,
  pdfLink?: Maybe<Scalars['String']>,
  rapidID?: Maybe<Scalars['String']>,
};

export type Enquiry = {
  __typename?: 'enquiry',
  call_result?: Maybe<Enquiry_Call_Result_Enum>,
  created_at: Scalars['timestamptz'],
  external_id: Scalars['String'],
  form_details?: Maybe<Scalars['jsonb']>,
  id: Scalars['uuid'],
  lead_email?: Maybe<Scalars['String']>,
  lead_message?: Maybe<Scalars['String']>,
  lead_name?: Maybe<Scalars['String']>,
  lead_phone_number?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  medium?: Maybe<Enquiry_Medium_Type_Enum>,
  source?: Maybe<Scalars['String']>,
  updated_at: Scalars['timestamptz'],
};


export type EnquiryForm_DetailsArgs = {
  path?: Maybe<Scalars['String']>
};

export type Enquiry_Aggregate = {
  __typename?: 'enquiry_aggregate',
  aggregate?: Maybe<Enquiry_Aggregate_Fields>,
  nodes: Array<Enquiry>,
};

export type Enquiry_Aggregate_Fields = {
  __typename?: 'enquiry_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Enquiry_Max_Fields>,
  min?: Maybe<Enquiry_Min_Fields>,
};


export type Enquiry_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enquiry_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Enquiry_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Enquiry_Max_Order_By>,
  min?: Maybe<Enquiry_Min_Order_By>,
};

export type Enquiry_Append_Input = {
  form_details?: Maybe<Scalars['jsonb']>,
};

export type Enquiry_Arr_Rel_Insert_Input = {
  data: Array<Enquiry_Insert_Input>,
  on_conflict?: Maybe<Enquiry_On_Conflict>,
};

export type Enquiry_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enquiry_Bool_Exp>>>,
  _not?: Maybe<Enquiry_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Enquiry_Bool_Exp>>>,
  call_result?: Maybe<Enquiry_Call_Result_Enum_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  external_id?: Maybe<String_Comparison_Exp>,
  form_details?: Maybe<Jsonb_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  lead_email?: Maybe<String_Comparison_Exp>,
  lead_message?: Maybe<String_Comparison_Exp>,
  lead_name?: Maybe<String_Comparison_Exp>,
  lead_phone_number?: Maybe<String_Comparison_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  medium?: Maybe<Enquiry_Medium_Type_Enum_Comparison_Exp>,
  source?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export type Enquiry_Call_Result = {
  __typename?: 'enquiry_call_result',
  comment: Scalars['String'],
  value: Scalars['String'],
};

export type Enquiry_Call_Result_Aggregate = {
  __typename?: 'enquiry_call_result_aggregate',
  aggregate?: Maybe<Enquiry_Call_Result_Aggregate_Fields>,
  nodes: Array<Enquiry_Call_Result>,
};

export type Enquiry_Call_Result_Aggregate_Fields = {
  __typename?: 'enquiry_call_result_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Enquiry_Call_Result_Max_Fields>,
  min?: Maybe<Enquiry_Call_Result_Min_Fields>,
};


export type Enquiry_Call_Result_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enquiry_Call_Result_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Enquiry_Call_Result_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Enquiry_Call_Result_Max_Order_By>,
  min?: Maybe<Enquiry_Call_Result_Min_Order_By>,
};

export type Enquiry_Call_Result_Arr_Rel_Insert_Input = {
  data: Array<Enquiry_Call_Result_Insert_Input>,
  on_conflict?: Maybe<Enquiry_Call_Result_On_Conflict>,
};

export type Enquiry_Call_Result_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enquiry_Call_Result_Bool_Exp>>>,
  _not?: Maybe<Enquiry_Call_Result_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Enquiry_Call_Result_Bool_Exp>>>,
  comment?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Enquiry_Call_Result_Constraint {
  EnquiryCallResultPkey = 'enquiry_call_result_pkey',
  EnquiryCallResultValueKey = 'enquiry_call_result_value_key'
}

export enum Enquiry_Call_Result_Enum {
  CallConnected = 'CALL_CONNECTED',
  CallMissed = 'CALL_MISSED',
  ConnectionImpossible = 'CONNECTION_IMPOSSIBLE'
}

export type Enquiry_Call_Result_Enum_Comparison_Exp = {
  _eq?: Maybe<Enquiry_Call_Result_Enum>,
  _in?: Maybe<Array<Enquiry_Call_Result_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Enquiry_Call_Result_Enum>,
  _nin?: Maybe<Array<Enquiry_Call_Result_Enum>>,
};

export type Enquiry_Call_Result_Insert_Input = {
  comment?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Call_Result_Max_Fields = {
  __typename?: 'enquiry_call_result_max_fields',
  comment?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Call_Result_Max_Order_By = {
  comment?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Call_Result_Min_Fields = {
  __typename?: 'enquiry_call_result_min_fields',
  comment?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Call_Result_Min_Order_By = {
  comment?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Call_Result_Mutation_Response = {
  __typename?: 'enquiry_call_result_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Enquiry_Call_Result>,
};

export type Enquiry_Call_Result_Obj_Rel_Insert_Input = {
  data: Enquiry_Call_Result_Insert_Input,
  on_conflict?: Maybe<Enquiry_Call_Result_On_Conflict>,
};

export type Enquiry_Call_Result_On_Conflict = {
  constraint: Enquiry_Call_Result_Constraint,
  update_columns: Array<Enquiry_Call_Result_Update_Column>,
  where?: Maybe<Enquiry_Call_Result_Bool_Exp>,
};

export type Enquiry_Call_Result_Order_By = {
  comment?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Call_Result_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Enquiry_Call_Result_Select_Column {
  Comment = 'comment',
  Value = 'value'
}

export type Enquiry_Call_Result_Set_Input = {
  comment?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Enquiry_Call_Result_Update_Column {
  Comment = 'comment',
  Value = 'value'
}

export enum Enquiry_Constraint {
  EnquiryPkey = 'enquiry_pkey',
  EnquiryTwilioIdKey = 'enquiry_twilio_id_key'
}

export type Enquiry_Delete_At_Path_Input = {
  form_details?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Enquiry_Delete_Elem_Input = {
  form_details?: Maybe<Scalars['Int']>,
};

export type Enquiry_Delete_Key_Input = {
  form_details?: Maybe<Scalars['String']>,
};

export type Enquiry_Insert_Input = {
  call_result?: Maybe<Enquiry_Call_Result_Enum>,
  created_at?: Maybe<Scalars['timestamptz']>,
  external_id?: Maybe<Scalars['String']>,
  form_details?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  lead_email?: Maybe<Scalars['String']>,
  lead_message?: Maybe<Scalars['String']>,
  lead_name?: Maybe<Scalars['String']>,
  lead_phone_number?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  medium?: Maybe<Enquiry_Medium_Type_Enum>,
  source?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Enquiry_Max_Fields = {
  __typename?: 'enquiry_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  external_id?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lead_email?: Maybe<Scalars['String']>,
  lead_message?: Maybe<Scalars['String']>,
  lead_name?: Maybe<Scalars['String']>,
  lead_phone_number?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  source?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Enquiry_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  external_id?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lead_email?: Maybe<Order_By>,
  lead_message?: Maybe<Order_By>,
  lead_name?: Maybe<Order_By>,
  lead_phone_number?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  source?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Enquiry_Medium_Type = {
  __typename?: 'enquiry_medium_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Enquiry_Medium_Type_Aggregate = {
  __typename?: 'enquiry_medium_type_aggregate',
  aggregate?: Maybe<Enquiry_Medium_Type_Aggregate_Fields>,
  nodes: Array<Enquiry_Medium_Type>,
};

export type Enquiry_Medium_Type_Aggregate_Fields = {
  __typename?: 'enquiry_medium_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Enquiry_Medium_Type_Max_Fields>,
  min?: Maybe<Enquiry_Medium_Type_Min_Fields>,
};


export type Enquiry_Medium_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Enquiry_Medium_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Enquiry_Medium_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Enquiry_Medium_Type_Max_Order_By>,
  min?: Maybe<Enquiry_Medium_Type_Min_Order_By>,
};

export type Enquiry_Medium_Type_Arr_Rel_Insert_Input = {
  data: Array<Enquiry_Medium_Type_Insert_Input>,
  on_conflict?: Maybe<Enquiry_Medium_Type_On_Conflict>,
};

export type Enquiry_Medium_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Enquiry_Medium_Type_Bool_Exp>>>,
  _not?: Maybe<Enquiry_Medium_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Enquiry_Medium_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Enquiry_Medium_Type_Constraint {
  EnquiryMediumTypePkey = 'enquiry_medium_type_pkey'
}

export enum Enquiry_Medium_Type_Enum {
  DirectCall = 'DIRECT_CALL',
  DirectEmail = 'DIRECT_EMAIL',
  PortalCall = 'PORTAL_CALL',
  PortalForm = 'PORTAL_FORM'
}

export type Enquiry_Medium_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Enquiry_Medium_Type_Enum>,
  _in?: Maybe<Array<Enquiry_Medium_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Enquiry_Medium_Type_Enum>,
  _nin?: Maybe<Array<Enquiry_Medium_Type_Enum>>,
};

export type Enquiry_Medium_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Medium_Type_Max_Fields = {
  __typename?: 'enquiry_medium_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Medium_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Medium_Type_Min_Fields = {
  __typename?: 'enquiry_medium_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Enquiry_Medium_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Medium_Type_Mutation_Response = {
  __typename?: 'enquiry_medium_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Enquiry_Medium_Type>,
};

export type Enquiry_Medium_Type_Obj_Rel_Insert_Input = {
  data: Enquiry_Medium_Type_Insert_Input,
  on_conflict?: Maybe<Enquiry_Medium_Type_On_Conflict>,
};

export type Enquiry_Medium_Type_On_Conflict = {
  constraint: Enquiry_Medium_Type_Constraint,
  update_columns: Array<Enquiry_Medium_Type_Update_Column>,
  where?: Maybe<Enquiry_Medium_Type_Bool_Exp>,
};

export type Enquiry_Medium_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Enquiry_Medium_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Enquiry_Medium_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Enquiry_Medium_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Enquiry_Medium_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Enquiry_Min_Fields = {
  __typename?: 'enquiry_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  external_id?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lead_email?: Maybe<Scalars['String']>,
  lead_message?: Maybe<Scalars['String']>,
  lead_name?: Maybe<Scalars['String']>,
  lead_phone_number?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  source?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Enquiry_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  external_id?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lead_email?: Maybe<Order_By>,
  lead_message?: Maybe<Order_By>,
  lead_name?: Maybe<Order_By>,
  lead_phone_number?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  source?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Enquiry_Mutation_Response = {
  __typename?: 'enquiry_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Enquiry>,
};

export type Enquiry_Obj_Rel_Insert_Input = {
  data: Enquiry_Insert_Input,
  on_conflict?: Maybe<Enquiry_On_Conflict>,
};

export type Enquiry_On_Conflict = {
  constraint: Enquiry_Constraint,
  update_columns: Array<Enquiry_Update_Column>,
  where?: Maybe<Enquiry_Bool_Exp>,
};

export type Enquiry_Order_By = {
  call_result?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  external_id?: Maybe<Order_By>,
  form_details?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lead_email?: Maybe<Order_By>,
  lead_message?: Maybe<Order_By>,
  lead_name?: Maybe<Order_By>,
  lead_phone_number?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  medium?: Maybe<Order_By>,
  source?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Enquiry_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Enquiry_Prepend_Input = {
  form_details?: Maybe<Scalars['jsonb']>,
};

export enum Enquiry_Select_Column {
  CallResult = 'call_result',
  CreatedAt = 'created_at',
  ExternalId = 'external_id',
  FormDetails = 'form_details',
  Id = 'id',
  LeadEmail = 'lead_email',
  LeadMessage = 'lead_message',
  LeadName = 'lead_name',
  LeadPhoneNumber = 'lead_phone_number',
  ListingId = 'listing_id',
  Medium = 'medium',
  Source = 'source',
  UpdatedAt = 'updated_at'
}

export type Enquiry_Set_Input = {
  call_result?: Maybe<Enquiry_Call_Result_Enum>,
  created_at?: Maybe<Scalars['timestamptz']>,
  external_id?: Maybe<Scalars['String']>,
  form_details?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  lead_email?: Maybe<Scalars['String']>,
  lead_message?: Maybe<Scalars['String']>,
  lead_name?: Maybe<Scalars['String']>,
  lead_phone_number?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  medium?: Maybe<Enquiry_Medium_Type_Enum>,
  source?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Enquiry_Update_Column {
  CallResult = 'call_result',
  CreatedAt = 'created_at',
  ExternalId = 'external_id',
  FormDetails = 'form_details',
  Id = 'id',
  LeadEmail = 'lead_email',
  LeadMessage = 'lead_message',
  LeadName = 'lead_name',
  LeadPhoneNumber = 'lead_phone_number',
  ListingId = 'listing_id',
  Medium = 'medium',
  Source = 'source',
  UpdatedAt = 'updated_at'
}

export type Experiment = {
  __typename?: 'experiment',
  created_at: Scalars['timestamptz'],
  desc: Scalars['String'],
  exclude_submitted_via?: Maybe<Scalars['jsonb']>,
  is_active: Scalars['Boolean'],
  name: Experiment_Name_Enum,
  updated_at: Scalars['timestamptz'],
  users_ending_with: Scalars['jsonb'],
};


export type ExperimentExclude_Submitted_ViaArgs = {
  path?: Maybe<Scalars['String']>
};


export type ExperimentUsers_Ending_WithArgs = {
  path?: Maybe<Scalars['String']>
};

export type Experiment_Aggregate = {
  __typename?: 'experiment_aggregate',
  aggregate?: Maybe<Experiment_Aggregate_Fields>,
  nodes: Array<Experiment>,
};

export type Experiment_Aggregate_Fields = {
  __typename?: 'experiment_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Experiment_Max_Fields>,
  min?: Maybe<Experiment_Min_Fields>,
};


export type Experiment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Experiment_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Experiment_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Experiment_Max_Order_By>,
  min?: Maybe<Experiment_Min_Order_By>,
};

export type Experiment_Append_Input = {
  exclude_submitted_via?: Maybe<Scalars['jsonb']>,
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export type Experiment_Arr_Rel_Insert_Input = {
  data: Array<Experiment_Insert_Input>,
  on_conflict?: Maybe<Experiment_On_Conflict>,
};

export type Experiment_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Experiment_Bool_Exp>>>,
  _not?: Maybe<Experiment_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Experiment_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  desc?: Maybe<String_Comparison_Exp>,
  exclude_submitted_via?: Maybe<Jsonb_Comparison_Exp>,
  is_active?: Maybe<Boolean_Comparison_Exp>,
  name?: Maybe<Experiment_Name_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  users_ending_with?: Maybe<Jsonb_Comparison_Exp>,
};

export enum Experiment_Constraint {
  ExperimentPkey = 'experiment_pkey'
}

export type Experiment_Delete_At_Path_Input = {
  exclude_submitted_via?: Maybe<Array<Maybe<Scalars['String']>>>,
  users_ending_with?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Experiment_Delete_Elem_Input = {
  exclude_submitted_via?: Maybe<Scalars['Int']>,
  users_ending_with?: Maybe<Scalars['Int']>,
};

export type Experiment_Delete_Key_Input = {
  exclude_submitted_via?: Maybe<Scalars['String']>,
  users_ending_with?: Maybe<Scalars['String']>,
};

export type Experiment_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  exclude_submitted_via?: Maybe<Scalars['jsonb']>,
  is_active?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Experiment_Name_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export type Experiment_Max_Fields = {
  __typename?: 'experiment_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Experiment_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Experiment_Min_Fields = {
  __typename?: 'experiment_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Experiment_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Experiment_Mutation_Response = {
  __typename?: 'experiment_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Experiment>,
};

export type Experiment_Name = {
  __typename?: 'experiment_name',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Experiment_Name_Aggregate = {
  __typename?: 'experiment_name_aggregate',
  aggregate?: Maybe<Experiment_Name_Aggregate_Fields>,
  nodes: Array<Experiment_Name>,
};

export type Experiment_Name_Aggregate_Fields = {
  __typename?: 'experiment_name_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Experiment_Name_Max_Fields>,
  min?: Maybe<Experiment_Name_Min_Fields>,
};


export type Experiment_Name_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Experiment_Name_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Experiment_Name_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Experiment_Name_Max_Order_By>,
  min?: Maybe<Experiment_Name_Min_Order_By>,
};

export type Experiment_Name_Arr_Rel_Insert_Input = {
  data: Array<Experiment_Name_Insert_Input>,
  on_conflict?: Maybe<Experiment_Name_On_Conflict>,
};

export type Experiment_Name_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Experiment_Name_Bool_Exp>>>,
  _not?: Maybe<Experiment_Name_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Experiment_Name_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Experiment_Name_Constraint {
  ExperimentNamePkey = 'experiment_name_pkey'
}

export enum Experiment_Name_Enum {
  OnboardingA = 'Onboarding_A',
  OnboardingB = 'Onboarding_B',
  RecommendationA = 'Recommendation_A',
  RecommendationB = 'Recommendation_B',
  RecommendationC = 'Recommendation_C'
}

export type Experiment_Name_Enum_Comparison_Exp = {
  _eq?: Maybe<Experiment_Name_Enum>,
  _in?: Maybe<Array<Experiment_Name_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Experiment_Name_Enum>,
  _nin?: Maybe<Array<Experiment_Name_Enum>>,
};

export type Experiment_Name_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Experiment_Name_Max_Fields = {
  __typename?: 'experiment_name_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Experiment_Name_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Experiment_Name_Min_Fields = {
  __typename?: 'experiment_name_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Experiment_Name_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Experiment_Name_Mutation_Response = {
  __typename?: 'experiment_name_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Experiment_Name>,
};

export type Experiment_Name_Obj_Rel_Insert_Input = {
  data: Experiment_Name_Insert_Input,
  on_conflict?: Maybe<Experiment_Name_On_Conflict>,
};

export type Experiment_Name_On_Conflict = {
  constraint: Experiment_Name_Constraint,
  update_columns: Array<Experiment_Name_Update_Column>,
  where?: Maybe<Experiment_Name_Bool_Exp>,
};

export type Experiment_Name_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Experiment_Name_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Experiment_Name_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Experiment_Name_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Experiment_Name_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Experiment_Obj_Rel_Insert_Input = {
  data: Experiment_Insert_Input,
  on_conflict?: Maybe<Experiment_On_Conflict>,
};

export type Experiment_On_Conflict = {
  constraint: Experiment_Constraint,
  update_columns: Array<Experiment_Update_Column>,
  where?: Maybe<Experiment_Bool_Exp>,
};

export type Experiment_Order_By = {
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  exclude_submitted_via?: Maybe<Order_By>,
  is_active?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  users_ending_with?: Maybe<Order_By>,
};

export type Experiment_Pk_Columns_Input = {
  name: Experiment_Name_Enum,
};

export type Experiment_Prepend_Input = {
  exclude_submitted_via?: Maybe<Scalars['jsonb']>,
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export enum Experiment_Select_Column {
  CreatedAt = 'created_at',
  Desc = 'desc',
  ExcludeSubmittedVia = 'exclude_submitted_via',
  IsActive = 'is_active',
  Name = 'name',
  UpdatedAt = 'updated_at',
  UsersEndingWith = 'users_ending_with'
}

export type Experiment_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  exclude_submitted_via?: Maybe<Scalars['jsonb']>,
  is_active?: Maybe<Scalars['Boolean']>,
  name?: Maybe<Experiment_Name_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export type Experiment_Stat = {
  __typename?: 'experiment_stat',
  desc?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  percent?: Maybe<Scalars['numeric']>,
  user_count?: Maybe<Scalars['bigint']>,
  users_ending_with?: Maybe<Scalars['jsonb']>,
};


export type Experiment_StatUsers_Ending_WithArgs = {
  path?: Maybe<Scalars['String']>
};

export type Experiment_Stat_Aggregate = {
  __typename?: 'experiment_stat_aggregate',
  aggregate?: Maybe<Experiment_Stat_Aggregate_Fields>,
  nodes: Array<Experiment_Stat>,
};

export type Experiment_Stat_Aggregate_Fields = {
  __typename?: 'experiment_stat_aggregate_fields',
  avg?: Maybe<Experiment_Stat_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Experiment_Stat_Max_Fields>,
  min?: Maybe<Experiment_Stat_Min_Fields>,
  stddev?: Maybe<Experiment_Stat_Stddev_Fields>,
  stddev_pop?: Maybe<Experiment_Stat_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Experiment_Stat_Stddev_Samp_Fields>,
  sum?: Maybe<Experiment_Stat_Sum_Fields>,
  var_pop?: Maybe<Experiment_Stat_Var_Pop_Fields>,
  var_samp?: Maybe<Experiment_Stat_Var_Samp_Fields>,
  variance?: Maybe<Experiment_Stat_Variance_Fields>,
};


export type Experiment_Stat_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Experiment_Stat_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Experiment_Stat_Aggregate_Order_By = {
  avg?: Maybe<Experiment_Stat_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Experiment_Stat_Max_Order_By>,
  min?: Maybe<Experiment_Stat_Min_Order_By>,
  stddev?: Maybe<Experiment_Stat_Stddev_Order_By>,
  stddev_pop?: Maybe<Experiment_Stat_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Experiment_Stat_Stddev_Samp_Order_By>,
  sum?: Maybe<Experiment_Stat_Sum_Order_By>,
  var_pop?: Maybe<Experiment_Stat_Var_Pop_Order_By>,
  var_samp?: Maybe<Experiment_Stat_Var_Samp_Order_By>,
  variance?: Maybe<Experiment_Stat_Variance_Order_By>,
};

export type Experiment_Stat_Append_Input = {
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export type Experiment_Stat_Avg_Fields = {
  __typename?: 'experiment_stat_avg_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Avg_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Experiment_Stat_Bool_Exp>>>,
  _not?: Maybe<Experiment_Stat_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Experiment_Stat_Bool_Exp>>>,
  desc?: Maybe<String_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  percent?: Maybe<Numeric_Comparison_Exp>,
  user_count?: Maybe<Bigint_Comparison_Exp>,
  users_ending_with?: Maybe<Jsonb_Comparison_Exp>,
};

export type Experiment_Stat_Delete_At_Path_Input = {
  users_ending_with?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Experiment_Stat_Delete_Elem_Input = {
  users_ending_with?: Maybe<Scalars['Int']>,
};

export type Experiment_Stat_Delete_Key_Input = {
  users_ending_with?: Maybe<Scalars['String']>,
};

export type Experiment_Stat_Max_Fields = {
  __typename?: 'experiment_stat_max_fields',
  desc?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  percent?: Maybe<Scalars['numeric']>,
  user_count?: Maybe<Scalars['bigint']>,
};

export type Experiment_Stat_Max_Order_By = {
  desc?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Min_Fields = {
  __typename?: 'experiment_stat_min_fields',
  desc?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  percent?: Maybe<Scalars['numeric']>,
  user_count?: Maybe<Scalars['bigint']>,
};

export type Experiment_Stat_Min_Order_By = {
  desc?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Order_By = {
  desc?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
  users_ending_with?: Maybe<Order_By>,
};

export type Experiment_Stat_Prepend_Input = {
  users_ending_with?: Maybe<Scalars['jsonb']>,
};

export enum Experiment_Stat_Select_Column {
  Desc = 'desc',
  Name = 'name',
  Percent = 'percent',
  UserCount = 'user_count',
  UsersEndingWith = 'users_ending_with'
}

export type Experiment_Stat_Stddev_Fields = {
  __typename?: 'experiment_stat_stddev_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Stddev_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Stddev_Pop_Fields = {
  __typename?: 'experiment_stat_stddev_pop_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Stddev_Pop_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Stddev_Samp_Fields = {
  __typename?: 'experiment_stat_stddev_samp_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Stddev_Samp_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Sum_Fields = {
  __typename?: 'experiment_stat_sum_fields',
  percent?: Maybe<Scalars['numeric']>,
  user_count?: Maybe<Scalars['bigint']>,
};

export type Experiment_Stat_Sum_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Var_Pop_Fields = {
  __typename?: 'experiment_stat_var_pop_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Var_Pop_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Var_Samp_Fields = {
  __typename?: 'experiment_stat_var_samp_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Var_Samp_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export type Experiment_Stat_Variance_Fields = {
  __typename?: 'experiment_stat_variance_fields',
  percent?: Maybe<Scalars['Float']>,
  user_count?: Maybe<Scalars['Float']>,
};

export type Experiment_Stat_Variance_Order_By = {
  percent?: Maybe<Order_By>,
  user_count?: Maybe<Order_By>,
};

export enum Experiment_Update_Column {
  CreatedAt = 'created_at',
  Desc = 'desc',
  ExcludeSubmittedVia = 'exclude_submitted_via',
  IsActive = 'is_active',
  Name = 'name',
  UpdatedAt = 'updated_at',
  UsersEndingWith = 'users_ending_with'
}

export type External_Auth = {
  __typename?: 'external_auth',
  auth_source: Scalars['String'],
  auth_source_id: Scalars['String'],
  refresh_token?: Maybe<Scalars['String']>,
  token_expiry_date?: Maybe<Scalars['timestamptz']>,
  user: User,
  user_id: Scalars['uuid'],
};

export type External_Auth_Aggregate = {
  __typename?: 'external_auth_aggregate',
  aggregate?: Maybe<External_Auth_Aggregate_Fields>,
  nodes: Array<External_Auth>,
};

export type External_Auth_Aggregate_Fields = {
  __typename?: 'external_auth_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<External_Auth_Max_Fields>,
  min?: Maybe<External_Auth_Min_Fields>,
};


export type External_Auth_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<External_Auth_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type External_Auth_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<External_Auth_Max_Order_By>,
  min?: Maybe<External_Auth_Min_Order_By>,
};

export type External_Auth_Arr_Rel_Insert_Input = {
  data: Array<External_Auth_Insert_Input>,
  on_conflict?: Maybe<External_Auth_On_Conflict>,
};

export type External_Auth_Bool_Exp = {
  _and?: Maybe<Array<Maybe<External_Auth_Bool_Exp>>>,
  _not?: Maybe<External_Auth_Bool_Exp>,
  _or?: Maybe<Array<Maybe<External_Auth_Bool_Exp>>>,
  auth_source?: Maybe<String_Comparison_Exp>,
  auth_source_id?: Maybe<String_Comparison_Exp>,
  refresh_token?: Maybe<String_Comparison_Exp>,
  token_expiry_date?: Maybe<Timestamptz_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
  user_id?: Maybe<Uuid_Comparison_Exp>,
};

export enum External_Auth_Constraint {
  ExternalAuthAuthSourceIdKey = 'external_auth_auth_source_id_key',
  ExternalAuthPkey = 'external_auth_pkey'
}

export type External_Auth_Insert_Input = {
  auth_source?: Maybe<Scalars['String']>,
  auth_source_id?: Maybe<Scalars['String']>,
  refresh_token?: Maybe<Scalars['String']>,
  token_expiry_date?: Maybe<Scalars['timestamptz']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type External_Auth_Max_Fields = {
  __typename?: 'external_auth_max_fields',
  auth_source?: Maybe<Scalars['String']>,
  auth_source_id?: Maybe<Scalars['String']>,
  refresh_token?: Maybe<Scalars['String']>,
  token_expiry_date?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type External_Auth_Max_Order_By = {
  auth_source?: Maybe<Order_By>,
  auth_source_id?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  token_expiry_date?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
};

export type External_Auth_Min_Fields = {
  __typename?: 'external_auth_min_fields',
  auth_source?: Maybe<Scalars['String']>,
  auth_source_id?: Maybe<Scalars['String']>,
  refresh_token?: Maybe<Scalars['String']>,
  token_expiry_date?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type External_Auth_Min_Order_By = {
  auth_source?: Maybe<Order_By>,
  auth_source_id?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  token_expiry_date?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
};

export type External_Auth_Mutation_Response = {
  __typename?: 'external_auth_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<External_Auth>,
};

export type External_Auth_Obj_Rel_Insert_Input = {
  data: External_Auth_Insert_Input,
  on_conflict?: Maybe<External_Auth_On_Conflict>,
};

export type External_Auth_On_Conflict = {
  constraint: External_Auth_Constraint,
  update_columns: Array<External_Auth_Update_Column>,
  where?: Maybe<External_Auth_Bool_Exp>,
};

export type External_Auth_Order_By = {
  auth_source?: Maybe<Order_By>,
  auth_source_id?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  token_expiry_date?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
  user_id?: Maybe<Order_By>,
};

export type External_Auth_Pk_Columns_Input = {
  user_id: Scalars['uuid'],
};

export enum External_Auth_Select_Column {
  AuthSource = 'auth_source',
  AuthSourceId = 'auth_source_id',
  RefreshToken = 'refresh_token',
  TokenExpiryDate = 'token_expiry_date',
  UserId = 'user_id'
}

export type External_Auth_Set_Input = {
  auth_source?: Maybe<Scalars['String']>,
  auth_source_id?: Maybe<Scalars['String']>,
  refresh_token?: Maybe<Scalars['String']>,
  token_expiry_date?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export enum External_Auth_Update_Column {
  AuthSource = 'auth_source',
  AuthSourceId = 'auth_source_id',
  RefreshToken = 'refresh_token',
  TokenExpiryDate = 'token_expiry_date',
  UserId = 'user_id'
}

export type Feedback = {
  __typename?: 'feedback',
  created_at?: Maybe<Scalars['timestamptz']>,
  event_type?: Maybe<Listing_Event_Type_Enum>,
  feedback_items?: Maybe<Scalars['jsonb']>,
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  owner_id: Scalars['uuid'],
  score: Scalars['numeric'],
};


export type FeedbackFeedback_ItemsArgs = {
  path?: Maybe<Scalars['String']>
};

export type Feedback_Aggregate = {
  __typename?: 'feedback_aggregate',
  aggregate?: Maybe<Feedback_Aggregate_Fields>,
  nodes: Array<Feedback>,
};

export type Feedback_Aggregate_Fields = {
  __typename?: 'feedback_aggregate_fields',
  avg?: Maybe<Feedback_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Feedback_Max_Fields>,
  min?: Maybe<Feedback_Min_Fields>,
  stddev?: Maybe<Feedback_Stddev_Fields>,
  stddev_pop?: Maybe<Feedback_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Feedback_Stddev_Samp_Fields>,
  sum?: Maybe<Feedback_Sum_Fields>,
  var_pop?: Maybe<Feedback_Var_Pop_Fields>,
  var_samp?: Maybe<Feedback_Var_Samp_Fields>,
  variance?: Maybe<Feedback_Variance_Fields>,
};


export type Feedback_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Feedback_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Feedback_Aggregate_Order_By = {
  avg?: Maybe<Feedback_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Feedback_Max_Order_By>,
  min?: Maybe<Feedback_Min_Order_By>,
  stddev?: Maybe<Feedback_Stddev_Order_By>,
  stddev_pop?: Maybe<Feedback_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Feedback_Stddev_Samp_Order_By>,
  sum?: Maybe<Feedback_Sum_Order_By>,
  var_pop?: Maybe<Feedback_Var_Pop_Order_By>,
  var_samp?: Maybe<Feedback_Var_Samp_Order_By>,
  variance?: Maybe<Feedback_Variance_Order_By>,
};

export type Feedback_Append_Input = {
  feedback_items?: Maybe<Scalars['jsonb']>,
};

export type Feedback_Arr_Rel_Insert_Input = {
  data: Array<Feedback_Insert_Input>,
  on_conflict?: Maybe<Feedback_On_Conflict>,
};

export type Feedback_Avg_Fields = {
  __typename?: 'feedback_avg_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Avg_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Feedback_Bool_Exp>>>,
  _not?: Maybe<Feedback_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Feedback_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  event_type?: Maybe<Listing_Event_Type_Enum_Comparison_Exp>,
  feedback_items?: Maybe<Jsonb_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  message?: Maybe<String_Comparison_Exp>,
  message_type?: Maybe<String_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  score?: Maybe<Numeric_Comparison_Exp>,
};

export enum Feedback_Constraint {
  FeedbackPkey = 'feedback_pkey'
}

export type Feedback_Delete_At_Path_Input = {
  feedback_items?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Feedback_Delete_Elem_Input = {
  feedback_items?: Maybe<Scalars['Int']>,
};

export type Feedback_Delete_Key_Input = {
  feedback_items?: Maybe<Scalars['String']>,
};

export type Feedback_Inc_Input = {
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  event_type?: Maybe<Listing_Event_Type_Enum>,
  feedback_items?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Max_Fields = {
  __typename?: 'feedback_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  message?: Maybe<Order_By>,
  message_type?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  score?: Maybe<Order_By>,
};

export type Feedback_Min_Fields = {
  __typename?: 'feedback_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  message?: Maybe<Order_By>,
  message_type?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  score?: Maybe<Order_By>,
};

export type Feedback_Mutation_Response = {
  __typename?: 'feedback_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Feedback>,
};

export type Feedback_Obj_Rel_Insert_Input = {
  data: Feedback_Insert_Input,
  on_conflict?: Maybe<Feedback_On_Conflict>,
};

export type Feedback_On_Conflict = {
  constraint: Feedback_Constraint,
  update_columns: Array<Feedback_Update_Column>,
  where?: Maybe<Feedback_Bool_Exp>,
};

export type Feedback_Order_By = {
  created_at?: Maybe<Order_By>,
  event_type?: Maybe<Order_By>,
  feedback_items?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  message?: Maybe<Order_By>,
  message_type?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  score?: Maybe<Order_By>,
};

export type Feedback_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Feedback_Prepend_Input = {
  feedback_items?: Maybe<Scalars['jsonb']>,
};

export enum Feedback_Select_Column {
  CreatedAt = 'created_at',
  EventType = 'event_type',
  FeedbackItems = 'feedback_items',
  Id = 'id',
  ListingId = 'listing_id',
  Message = 'message',
  MessageType = 'message_type',
  OwnerId = 'owner_id',
  Score = 'score'
}

export type Feedback_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  event_type?: Maybe<Listing_Event_Type_Enum>,
  feedback_items?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Stddev_Fields = {
  __typename?: 'feedback_stddev_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Stddev_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Stddev_Pop_Fields = {
  __typename?: 'feedback_stddev_pop_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Stddev_Pop_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Stddev_Samp_Fields = {
  __typename?: 'feedback_stddev_samp_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Stddev_Samp_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Sum_Fields = {
  __typename?: 'feedback_sum_fields',
  score?: Maybe<Scalars['numeric']>,
};

export type Feedback_Sum_Order_By = {
  score?: Maybe<Order_By>,
};

export enum Feedback_Update_Column {
  CreatedAt = 'created_at',
  EventType = 'event_type',
  FeedbackItems = 'feedback_items',
  Id = 'id',
  ListingId = 'listing_id',
  Message = 'message',
  MessageType = 'message_type',
  OwnerId = 'owner_id',
  Score = 'score'
}

export type Feedback_Var_Pop_Fields = {
  __typename?: 'feedback_var_pop_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Var_Pop_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Var_Samp_Fields = {
  __typename?: 'feedback_var_samp_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Var_Samp_Order_By = {
  score?: Maybe<Order_By>,
};

export type Feedback_Variance_Fields = {
  __typename?: 'feedback_variance_fields',
  score?: Maybe<Scalars['Float']>,
};

export type Feedback_Variance_Order_By = {
  score?: Maybe<Order_By>,
};

export type FieldDetails_Dlau = {
  __typename?: 'FieldDetails_dlau',
  BirthDate?: Maybe<Scalars['String']>,
  FamilyName?: Maybe<Scalars['String']>,
  GivenName?: Maybe<Scalars['String']>,
  LicenceNumber?: Maybe<Scalars['String']>,
  StateOfIssue?: Maybe<Scalars['String']>,
};

export type FieldDetails_Ppau = {
  __typename?: 'FieldDetails_ppau',
  BirthDate?: Maybe<Scalars['String']>,
  FamilyName?: Maybe<Scalars['String']>,
  Gender?: Maybe<Scalars['String']>,
  GivenName?: Maybe<Scalars['String']>,
  TravelDocumentNumber?: Maybe<Scalars['String']>,
};

export type Frontend_Config_Response = {
  __typename?: 'frontend_config_response',
  stripe_public_key: Scalars['String'],
};

export type Google_Auth_Url_Response = {
  __typename?: 'google_auth_url_response',
  error?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Inclusion = {
  __typename?: 'inclusion',
  created_at: Scalars['timestamptz'],
  description: Scalars['String'],
  group_id: Scalars['uuid'],
  id: Scalars['uuid'],
  inclusion_addons: Array<Inclusion_Addon>,
  inclusion_addons_aggregate: Inclusion_Addon_Aggregate,
  inclusion_group: Inclusion_Group,
  metro?: Maybe<Metro_Type_Enum>,
  name: Scalars['String'],
  order: Scalars['Int'],
  updated_at: Scalars['timestamptz'],
  zone?: Maybe<Zone_Type_Enum>,
};


export type InclusionInclusion_AddonsArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type InclusionInclusion_Addons_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};

export type Inclusion_Addon = {
  __typename?: 'inclusion_addon',
  addon: Addon,
  addon_id: Scalars['uuid'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  inclusion: Inclusion,
  inclusion_id: Scalars['uuid'],
  updated_at: Scalars['timestamptz'],
};

export type Inclusion_Addon_Aggregate = {
  __typename?: 'inclusion_addon_aggregate',
  aggregate?: Maybe<Inclusion_Addon_Aggregate_Fields>,
  nodes: Array<Inclusion_Addon>,
};

export type Inclusion_Addon_Aggregate_Fields = {
  __typename?: 'inclusion_addon_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Inclusion_Addon_Max_Fields>,
  min?: Maybe<Inclusion_Addon_Min_Fields>,
};


export type Inclusion_Addon_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Inclusion_Addon_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Inclusion_Addon_Max_Order_By>,
  min?: Maybe<Inclusion_Addon_Min_Order_By>,
};

export type Inclusion_Addon_Arr_Rel_Insert_Input = {
  data: Array<Inclusion_Addon_Insert_Input>,
  on_conflict?: Maybe<Inclusion_Addon_On_Conflict>,
};

export type Inclusion_Addon_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Inclusion_Addon_Bool_Exp>>>,
  _not?: Maybe<Inclusion_Addon_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Inclusion_Addon_Bool_Exp>>>,
  addon?: Maybe<Addon_Bool_Exp>,
  addon_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inclusion?: Maybe<Inclusion_Bool_Exp>,
  inclusion_id?: Maybe<Uuid_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Inclusion_Addon_Constraint {
  InclusionAddonPkey = 'inclusion_addon_pkey'
}

export type Inclusion_Addon_Insert_Input = {
  addon?: Maybe<Addon_Obj_Rel_Insert_Input>,
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion?: Maybe<Inclusion_Obj_Rel_Insert_Input>,
  inclusion_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Addon_Max_Fields = {
  __typename?: 'inclusion_addon_max_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Addon_Max_Order_By = {
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Addon_Min_Fields = {
  __typename?: 'inclusion_addon_min_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Addon_Min_Order_By = {
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Addon_Mutation_Response = {
  __typename?: 'inclusion_addon_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Inclusion_Addon>,
};

export type Inclusion_Addon_Obj_Rel_Insert_Input = {
  data: Inclusion_Addon_Insert_Input,
  on_conflict?: Maybe<Inclusion_Addon_On_Conflict>,
};

export type Inclusion_Addon_On_Conflict = {
  constraint: Inclusion_Addon_Constraint,
  update_columns: Array<Inclusion_Addon_Update_Column>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>,
};

export type Inclusion_Addon_Order_By = {
  addon?: Maybe<Addon_Order_By>,
  addon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion?: Maybe<Inclusion_Order_By>,
  inclusion_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Addon_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Inclusion_Addon_Select_Column {
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Id = 'id',
  InclusionId = 'inclusion_id',
  UpdatedAt = 'updated_at'
}

export type Inclusion_Addon_Set_Input = {
  addon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Inclusion_Addon_Update_Column {
  AddonId = 'addon_id',
  CreatedAt = 'created_at',
  Id = 'id',
  InclusionId = 'inclusion_id',
  UpdatedAt = 'updated_at'
}

export type Inclusion_Aggregate = {
  __typename?: 'inclusion_aggregate',
  aggregate?: Maybe<Inclusion_Aggregate_Fields>,
  nodes: Array<Inclusion>,
};

export type Inclusion_Aggregate_Fields = {
  __typename?: 'inclusion_aggregate_fields',
  avg?: Maybe<Inclusion_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Inclusion_Max_Fields>,
  min?: Maybe<Inclusion_Min_Fields>,
  stddev?: Maybe<Inclusion_Stddev_Fields>,
  stddev_pop?: Maybe<Inclusion_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Inclusion_Stddev_Samp_Fields>,
  sum?: Maybe<Inclusion_Sum_Fields>,
  var_pop?: Maybe<Inclusion_Var_Pop_Fields>,
  var_samp?: Maybe<Inclusion_Var_Samp_Fields>,
  variance?: Maybe<Inclusion_Variance_Fields>,
};


export type Inclusion_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Inclusion_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Inclusion_Aggregate_Order_By = {
  avg?: Maybe<Inclusion_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Inclusion_Max_Order_By>,
  min?: Maybe<Inclusion_Min_Order_By>,
  stddev?: Maybe<Inclusion_Stddev_Order_By>,
  stddev_pop?: Maybe<Inclusion_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Inclusion_Stddev_Samp_Order_By>,
  sum?: Maybe<Inclusion_Sum_Order_By>,
  var_pop?: Maybe<Inclusion_Var_Pop_Order_By>,
  var_samp?: Maybe<Inclusion_Var_Samp_Order_By>,
  variance?: Maybe<Inclusion_Variance_Order_By>,
};

export type Inclusion_Arr_Rel_Insert_Input = {
  data: Array<Inclusion_Insert_Input>,
  on_conflict?: Maybe<Inclusion_On_Conflict>,
};

export type Inclusion_Avg_Fields = {
  __typename?: 'inclusion_avg_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Avg_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Inclusion_Bool_Exp>>>,
  _not?: Maybe<Inclusion_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Inclusion_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  group_id?: Maybe<Uuid_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inclusion_addons?: Maybe<Inclusion_Addon_Bool_Exp>,
  inclusion_group?: Maybe<Inclusion_Group_Bool_Exp>,
  metro?: Maybe<Metro_Type_Enum_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  zone?: Maybe<Zone_Type_Enum_Comparison_Exp>,
};

export enum Inclusion_Constraint {
  InclusionPkey = 'inclusion_pkey'
}

export type Inclusion_Group = {
  __typename?: 'inclusion_group',
  campaign_inclusion_groups: Array<Campaign_Inclusion_Group>,
  campaign_inclusion_groups_aggregate: Campaign_Inclusion_Group_Aggregate,
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  inclusions: Array<Inclusion>,
  inclusions_aggregate: Inclusion_Aggregate,
  name: Scalars['String'],
  order: Scalars['Int'],
  updated_at: Scalars['timestamptz'],
};


export type Inclusion_GroupCampaign_Inclusion_GroupsArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Inclusion_GroupCampaign_Inclusion_Groups_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Inclusion_GroupInclusionsArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};


export type Inclusion_GroupInclusions_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};

export type Inclusion_Group_Aggregate = {
  __typename?: 'inclusion_group_aggregate',
  aggregate?: Maybe<Inclusion_Group_Aggregate_Fields>,
  nodes: Array<Inclusion_Group>,
};

export type Inclusion_Group_Aggregate_Fields = {
  __typename?: 'inclusion_group_aggregate_fields',
  avg?: Maybe<Inclusion_Group_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Inclusion_Group_Max_Fields>,
  min?: Maybe<Inclusion_Group_Min_Fields>,
  stddev?: Maybe<Inclusion_Group_Stddev_Fields>,
  stddev_pop?: Maybe<Inclusion_Group_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Inclusion_Group_Stddev_Samp_Fields>,
  sum?: Maybe<Inclusion_Group_Sum_Fields>,
  var_pop?: Maybe<Inclusion_Group_Var_Pop_Fields>,
  var_samp?: Maybe<Inclusion_Group_Var_Samp_Fields>,
  variance?: Maybe<Inclusion_Group_Variance_Fields>,
};


export type Inclusion_Group_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Inclusion_Group_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Inclusion_Group_Aggregate_Order_By = {
  avg?: Maybe<Inclusion_Group_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Inclusion_Group_Max_Order_By>,
  min?: Maybe<Inclusion_Group_Min_Order_By>,
  stddev?: Maybe<Inclusion_Group_Stddev_Order_By>,
  stddev_pop?: Maybe<Inclusion_Group_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Inclusion_Group_Stddev_Samp_Order_By>,
  sum?: Maybe<Inclusion_Group_Sum_Order_By>,
  var_pop?: Maybe<Inclusion_Group_Var_Pop_Order_By>,
  var_samp?: Maybe<Inclusion_Group_Var_Samp_Order_By>,
  variance?: Maybe<Inclusion_Group_Variance_Order_By>,
};

export type Inclusion_Group_Arr_Rel_Insert_Input = {
  data: Array<Inclusion_Group_Insert_Input>,
  on_conflict?: Maybe<Inclusion_Group_On_Conflict>,
};

export type Inclusion_Group_Avg_Fields = {
  __typename?: 'inclusion_group_avg_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Avg_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Inclusion_Group_Bool_Exp>>>,
  _not?: Maybe<Inclusion_Group_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Inclusion_Group_Bool_Exp>>>,
  campaign_inclusion_groups?: Maybe<Campaign_Inclusion_Group_Bool_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inclusions?: Maybe<Inclusion_Bool_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Inclusion_Group_Constraint {
  InclusionGroupPkey = 'inclusion_group_pkey'
}

export type Inclusion_Group_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
};

export type Inclusion_Group_Insert_Input = {
  campaign_inclusion_groups?: Maybe<Campaign_Inclusion_Group_Arr_Rel_Insert_Input>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  inclusions?: Maybe<Inclusion_Arr_Rel_Insert_Input>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Group_Max_Fields = {
  __typename?: 'inclusion_group_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Group_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Group_Min_Fields = {
  __typename?: 'inclusion_group_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Group_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Group_Mutation_Response = {
  __typename?: 'inclusion_group_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Inclusion_Group>,
};

export type Inclusion_Group_Obj_Rel_Insert_Input = {
  data: Inclusion_Group_Insert_Input,
  on_conflict?: Maybe<Inclusion_Group_On_Conflict>,
};

export type Inclusion_Group_On_Conflict = {
  constraint: Inclusion_Group_Constraint,
  update_columns: Array<Inclusion_Group_Update_Column>,
  where?: Maybe<Inclusion_Group_Bool_Exp>,
};

export type Inclusion_Group_Order_By = {
  campaign_inclusion_groups_aggregate?: Maybe<Campaign_Inclusion_Group_Aggregate_Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusions_aggregate?: Maybe<Inclusion_Aggregate_Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Group_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Inclusion_Group_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Inclusion_Group_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Group_Stddev_Fields = {
  __typename?: 'inclusion_group_stddev_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Stddev_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Stddev_Pop_Fields = {
  __typename?: 'inclusion_group_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Stddev_Samp_Fields = {
  __typename?: 'inclusion_group_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Sum_Fields = {
  __typename?: 'inclusion_group_sum_fields',
  order?: Maybe<Scalars['Int']>,
};

export type Inclusion_Group_Sum_Order_By = {
  order?: Maybe<Order_By>,
};

export enum Inclusion_Group_Update_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Inclusion_Group_Var_Pop_Fields = {
  __typename?: 'inclusion_group_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Var_Samp_Fields = {
  __typename?: 'inclusion_group_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Group_Variance_Fields = {
  __typename?: 'inclusion_group_variance_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Group_Variance_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
};

export type Inclusion_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  group_id?: Maybe<Scalars['uuid']>,
  id?: Maybe<Scalars['uuid']>,
  inclusion_addons?: Maybe<Inclusion_Addon_Arr_Rel_Insert_Input>,
  inclusion_group?: Maybe<Inclusion_Group_Obj_Rel_Insert_Input>,
  metro?: Maybe<Metro_Type_Enum>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Zone_Type_Enum>,
};

export type Inclusion_Max_Fields = {
  __typename?: 'inclusion_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  group_id?: Maybe<Scalars['uuid']>,
  id?: Maybe<Scalars['uuid']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  group_id?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Min_Fields = {
  __typename?: 'inclusion_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  group_id?: Maybe<Scalars['uuid']>,
  id?: Maybe<Scalars['uuid']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Inclusion_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  group_id?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Inclusion_Mutation_Response = {
  __typename?: 'inclusion_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Inclusion>,
};

export type Inclusion_Obj_Rel_Insert_Input = {
  data: Inclusion_Insert_Input,
  on_conflict?: Maybe<Inclusion_On_Conflict>,
};

export type Inclusion_On_Conflict = {
  constraint: Inclusion_Constraint,
  update_columns: Array<Inclusion_Update_Column>,
  where?: Maybe<Inclusion_Bool_Exp>,
};

export type Inclusion_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  group_id?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inclusion_addons_aggregate?: Maybe<Inclusion_Addon_Aggregate_Order_By>,
  inclusion_group?: Maybe<Inclusion_Group_Order_By>,
  metro?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Inclusion_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Inclusion_Select_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  GroupId = 'group_id',
  Id = 'id',
  Metro = 'metro',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Inclusion_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  group_id?: Maybe<Scalars['uuid']>,
  id?: Maybe<Scalars['uuid']>,
  metro?: Maybe<Metro_Type_Enum>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Zone_Type_Enum>,
};

export type Inclusion_Stddev_Fields = {
  __typename?: 'inclusion_stddev_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Stddev_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Stddev_Pop_Fields = {
  __typename?: 'inclusion_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Stddev_Samp_Fields = {
  __typename?: 'inclusion_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Sum_Fields = {
  __typename?: 'inclusion_sum_fields',
  order?: Maybe<Scalars['Int']>,
};

export type Inclusion_Sum_Order_By = {
  order?: Maybe<Order_By>,
};

export enum Inclusion_Update_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  GroupId = 'group_id',
  Id = 'id',
  Metro = 'metro',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Inclusion_Var_Pop_Fields = {
  __typename?: 'inclusion_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Var_Samp_Fields = {
  __typename?: 'inclusion_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Inclusion_Variance_Fields = {
  __typename?: 'inclusion_variance_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Inclusion_Variance_Order_By = {
  order?: Maybe<Order_By>,
};

export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>,
  _gt?: Maybe<Scalars['Int']>,
  _gte?: Maybe<Scalars['Int']>,
  _in?: Maybe<Array<Scalars['Int']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['Int']>,
  _lte?: Maybe<Scalars['Int']>,
  _neq?: Maybe<Scalars['Int']>,
  _nin?: Maybe<Array<Scalars['Int']>>,
};

export type Item = {
  __typename?: 'Item',
  VerifyItem_v22?: Maybe<VerifyItemV22_Ppnz>,
};

export type Item_Dlnz = {
  __typename?: 'Item_dlnz',
  VerifyItem_v22?: Maybe<VerifyItemV22_Dlnz>,
};

export type Item_Nicn = {
  __typename?: 'Item_nicn',
  VerifyItem_v22?: Maybe<VerifyItemV22_Nicn>,
};


export type Json_Comparison_Exp = {
  _eq?: Maybe<Scalars['json']>,
  _gt?: Maybe<Scalars['json']>,
  _gte?: Maybe<Scalars['json']>,
  _in?: Maybe<Array<Scalars['json']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['json']>,
  _lte?: Maybe<Scalars['json']>,
  _neq?: Maybe<Scalars['json']>,
  _nin?: Maybe<Array<Scalars['json']>>,
};

export type Json_Response = {
  __typename?: 'json_response',
  data?: Maybe<Scalars['String']>,
  message: Scalars['String'],
  success: Scalars['Boolean'],
};


export type Jsonb_Comparison_Exp = {
  _contained_in?: Maybe<Scalars['jsonb']>,
  _contains?: Maybe<Scalars['jsonb']>,
  _eq?: Maybe<Scalars['jsonb']>,
  _gt?: Maybe<Scalars['jsonb']>,
  _gte?: Maybe<Scalars['jsonb']>,
  _has_key?: Maybe<Scalars['String']>,
  _has_keys_all?: Maybe<Array<Scalars['String']>>,
  _has_keys_any?: Maybe<Array<Scalars['String']>>,
  _in?: Maybe<Array<Scalars['jsonb']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['jsonb']>,
  _lte?: Maybe<Scalars['jsonb']>,
  _neq?: Maybe<Scalars['jsonb']>,
  _nin?: Maybe<Array<Scalars['jsonb']>>,
};

export type Listing = {
  __typename?: 'listing',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status: Commercial_Status_Type_Enum,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  delivery_address_1?: Maybe<Scalars['String']>,
  delivery_address_2?: Maybe<Scalars['String']>,
  delivery_address_postcode?: Maybe<Scalars['String']>,
  delivery_address_state?: Maybe<Scalars['String']>,
  delivery_address_street?: Maybe<Scalars['String']>,
  delivery_address_streetNumber?: Maybe<Scalars['String']>,
  delivery_address_suburb?: Maybe<Scalars['String']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  delivery_address_unitNumber?: Maybe<Scalars['String']>,
  delivery_to_property_address: Scalars['Boolean'],
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code: Scalars['Int'],
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  feedbacks: Array<Feedback>,
  feedbacks_aggregate: Feedback_Aggregate,
  id: Scalars['uuid'],
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  listing_contacts: Array<Listing_Contact>,
  listing_contacts_aggregate: Listing_Contact_Aggregate,
  listing_documents: Array<Listing_Document>,
  listing_documents_aggregate: Listing_Document_Aggregate,
  listing_events: Array<Listing_Event>,
  listing_events_aggregate: Listing_Event_Aggregate,
  listing_inspections: Array<Listing_Inspection>,
  listing_inspections_aggregate: Listing_Inspection_Aggregate,
  listing_media: Array<Listing_Media>,
  listing_media_aggregate: Listing_Media_Aggregate,
  listing_onboardings: Array<Listing_Onboarding>,
  listing_onboardings_aggregate: Listing_Onboarding_Aggregate,
  listing_parkings: Array<Listing_Parking>,
  listing_parkings_aggregate: Listing_Parking_Aggregate,
  listing_publish_errors: Array<Listing_Publish_Errors>,
  listing_publish_errors_aggregate: Listing_Publish_Errors_Aggregate,
  listing_publish_statuses: Array<Listing_Publish_Status>,
  listing_publish_statuses_aggregate: Listing_Publish_Status_Aggregate,
  listing_soi_comparable_properties: Array<Listing_Soi_Comparable_Property>,
  listing_soi_comparable_properties_aggregate: Listing_Soi_Comparable_Property_Aggregate,
  orders: Array<Order>,
  orders_aggregate: Order_Aggregate,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id: Scalars['uuid'],
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status: Listing_Document_Status_Enum,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Publishing_Status_Type_Enum>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status: Scalars['String'],
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag: Scalars['Boolean'],
  updated_at: Scalars['timestamptz'],
  user: User,
  zone?: Maybe<Zone_Type_Enum>,
};


export type ListingExperimentsArgs = {
  path?: Maybe<Scalars['String']>
};


export type ListingFeedbacksArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type ListingFeedbacks_AggregateArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type ListingListing_ContactsArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type ListingListing_Contacts_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type ListingListing_DocumentsArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type ListingListing_Documents_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type ListingListing_EventsArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type ListingListing_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type ListingListing_InspectionsArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type ListingListing_Inspections_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type ListingListing_MediaArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type ListingListing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type ListingListing_OnboardingsArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type ListingListing_Onboardings_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type ListingListing_ParkingsArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type ListingListing_Parkings_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type ListingListing_Publish_ErrorsArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type ListingListing_Publish_Errors_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type ListingListing_Publish_StatusesArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type ListingListing_Publish_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type ListingListing_Soi_Comparable_PropertiesArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type ListingListing_Soi_Comparable_Properties_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type ListingOrdersArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};


export type ListingOrders_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};

export type Listing_Advisor_Context_Response = {
  __typename?: 'listing_advisor_context_response',
  metro?: Maybe<Scalars['String']>,
  zone?: Maybe<Scalars['String']>,
};

export type Listing_Aggregate = {
  __typename?: 'listing_aggregate',
  aggregate?: Maybe<Listing_Aggregate_Fields>,
  nodes: Array<Listing>,
};

export type Listing_Aggregate_Fields = {
  __typename?: 'listing_aggregate_fields',
  avg?: Maybe<Listing_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Max_Fields>,
  min?: Maybe<Listing_Min_Fields>,
  stddev?: Maybe<Listing_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Sum_Fields>,
  var_pop?: Maybe<Listing_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Var_Samp_Fields>,
  variance?: Maybe<Listing_Variance_Fields>,
};


export type Listing_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Aggregate_Order_By = {
  avg?: Maybe<Listing_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Max_Order_By>,
  min?: Maybe<Listing_Min_Order_By>,
  stddev?: Maybe<Listing_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Sum_Order_By>,
  var_pop?: Maybe<Listing_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Variance_Order_By>,
};

export type Listing_Append_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type Listing_Arr_Rel_Insert_Input = {
  data: Array<Listing_Insert_Input>,
  on_conflict?: Maybe<Listing_On_Conflict>,
};

export type Listing_Avg_Fields = {
  __typename?: 'listing_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Bool_Exp>>>,
  _not?: Maybe<Listing_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  auction_dateTime?: Maybe<Timestamptz_Comparison_Exp>,
  auction_location?: Maybe<String_Comparison_Exp>,
  auction_online?: Maybe<Boolean_Comparison_Exp>,
  authority?: Maybe<String_Comparison_Exp>,
  availableFrom?: Maybe<Timestamptz_Comparison_Exp>,
  bond?: Maybe<Int_Comparison_Exp>,
  commercial_status?: Maybe<Commercial_Status_Type_Enum_Comparison_Exp>,
  contactPreference?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  crossOver?: Maybe<String_Comparison_Exp>,
  delivery_address_1?: Maybe<String_Comparison_Exp>,
  delivery_address_2?: Maybe<String_Comparison_Exp>,
  delivery_address_postcode?: Maybe<String_Comparison_Exp>,
  delivery_address_state?: Maybe<String_Comparison_Exp>,
  delivery_address_street?: Maybe<String_Comparison_Exp>,
  delivery_address_streetNumber?: Maybe<String_Comparison_Exp>,
  delivery_address_suburb?: Maybe<String_Comparison_Exp>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Numeric_Comparison_Exp>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Numeric_Comparison_Exp>,
  delivery_address_unitNumber?: Maybe<String_Comparison_Exp>,
  delivery_to_property_address?: Maybe<Boolean_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  domainAdId?: Maybe<Int_Comparison_Exp>,
  enquiry_code?: Maybe<Int_Comparison_Exp>,
  experiments?: Maybe<Jsonb_Comparison_Exp>,
  externalLink?: Maybe<String_Comparison_Exp>,
  features?: Maybe<String_Comparison_Exp>,
  feedbacks?: Maybe<Feedback_Bool_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inspectionDetails_inspectionDescription?: Maybe<String_Comparison_Exp>,
  isNewDevelopment?: Maybe<Boolean_Comparison_Exp>,
  isRural?: Maybe<Boolean_Comparison_Exp>,
  lifeStyleType?: Maybe<String_Comparison_Exp>,
  listingAction?: Maybe<String_Comparison_Exp>,
  listing_contacts?: Maybe<Listing_Contact_Bool_Exp>,
  listing_documents?: Maybe<Listing_Document_Bool_Exp>,
  listing_events?: Maybe<Listing_Event_Bool_Exp>,
  listing_inspections?: Maybe<Listing_Inspection_Bool_Exp>,
  listing_media?: Maybe<Listing_Media_Bool_Exp>,
  listing_onboardings?: Maybe<Listing_Onboarding_Bool_Exp>,
  listing_parkings?: Maybe<Listing_Parking_Bool_Exp>,
  listing_publish_errors?: Maybe<Listing_Publish_Errors_Bool_Exp>,
  listing_publish_statuses?: Maybe<Listing_Publish_Status_Bool_Exp>,
  listing_soi_comparable_properties?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>,
  orders?: Maybe<Order_Bool_Exp>,
  otherEnquiryEmail?: Maybe<String_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  price_asking?: Maybe<Int_Comparison_Exp>,
  price_displayOption?: Maybe<String_Comparison_Exp>,
  price_displayText?: Maybe<String_Comparison_Exp>,
  price_from?: Maybe<Int_Comparison_Exp>,
  price_single?: Maybe<Int_Comparison_Exp>,
  price_textOption?: Maybe<String_Comparison_Exp>,
  price_to?: Maybe<Int_Comparison_Exp>,
  price_view?: Maybe<String_Comparison_Exp>,
  proof_of_ownership_status?: Maybe<Listing_Document_Status_Enum_Comparison_Exp>,
  propertyDetails_address_1?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_2?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_displayOption?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_municipality?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_street?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_page?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_reference?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_type?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_unitNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_bathRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_bedRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carportSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_energyEfficiencyRating?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_garageSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_left?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_rear?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_right?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_parkingInfo_information?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<String_Comparison_Exp>,
  propertyDetails_yearBuilt?: Maybe<Int_Comparison_Exp>,
  providerAdId?: Maybe<String_Comparison_Exp>,
  publishing_status?: Maybe<Publishing_Status_Type_Enum_Comparison_Exp>,
  saleType?: Maybe<String_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  search_price?: Maybe<Int_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData?: Maybe<String_Comparison_Exp>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Int_Comparison_Exp>,
  soi_comparableData_declarationText?: Maybe<String_Comparison_Exp>,
  soi_documentationUrl?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice_from?: Maybe<Int_Comparison_Exp>,
  soi_estimatedPrice_to?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_declarationText?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice_postcode?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_priceType?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_source?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_suburb?: Maybe<String_Comparison_Exp>,
  status?: Maybe<String_Comparison_Exp>,
  summary?: Maybe<String_Comparison_Exp>,
  supplementary_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_measurement?: Maybe<Numeric_Comparison_Exp>,
  supplementary_metadata_measurementUnit?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_name?: Maybe<String_Comparison_Exp>,
  supplementary_name?: Maybe<String_Comparison_Exp>,
  supplementary_types?: Maybe<String_Comparison_Exp>,
  temporary_add_on_flag?: Maybe<Boolean_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
  zone?: Maybe<Zone_Type_Enum_Comparison_Exp>,
};

export enum Listing_Constraint {
  ListingAgentPointIdKey = 'listing_agent_point_id_key',
  ListingEnquiryCodeKey = 'listing_enquiry_code_key',
  ListingIdKey = 'listing_id_key',
  ListingPkey = 'listing_pkey'
}

export type Listing_Contact = {
  __typename?: 'listing_contact',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  lastName?: Maybe<Scalars['String']>,
  listing?: Maybe<Listing>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal: Listing_Publish_Portal_Source_Enum,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Contact_Aggregate = {
  __typename?: 'listing_contact_aggregate',
  aggregate?: Maybe<Listing_Contact_Aggregate_Fields>,
  nodes: Array<Listing_Contact>,
};

export type Listing_Contact_Aggregate_Fields = {
  __typename?: 'listing_contact_aggregate_fields',
  avg?: Maybe<Listing_Contact_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Contact_Max_Fields>,
  min?: Maybe<Listing_Contact_Min_Fields>,
  stddev?: Maybe<Listing_Contact_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Contact_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Contact_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Contact_Sum_Fields>,
  var_pop?: Maybe<Listing_Contact_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Contact_Var_Samp_Fields>,
  variance?: Maybe<Listing_Contact_Variance_Fields>,
};


export type Listing_Contact_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Contact_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Contact_Aggregate_Order_By = {
  avg?: Maybe<Listing_Contact_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Contact_Max_Order_By>,
  min?: Maybe<Listing_Contact_Min_Order_By>,
  stddev?: Maybe<Listing_Contact_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Contact_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Contact_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Contact_Sum_Order_By>,
  var_pop?: Maybe<Listing_Contact_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Contact_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Contact_Variance_Order_By>,
};

export type Listing_Contact_Arr_Rel_Insert_Input = {
  data: Array<Listing_Contact_Insert_Input>,
  on_conflict?: Maybe<Listing_Contact_On_Conflict>,
};

export type Listing_Contact_Avg_Fields = {
  __typename?: 'listing_contact_avg_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Avg_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Contact_Bool_Exp>>>,
  _not?: Maybe<Listing_Contact_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Contact_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  domainAgencyID?: Maybe<String_Comparison_Exp>,
  domainAgentId?: Maybe<Int_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  fax?: Maybe<String_Comparison_Exp>,
  firstName?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  lastName?: Maybe<String_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  mobile?: Maybe<String_Comparison_Exp>,
  phone?: Maybe<String_Comparison_Exp>,
  phoneType?: Maybe<String_Comparison_Exp>,
  portal?: Maybe<Listing_Publish_Portal_Source_Enum_Comparison_Exp>,
  receiveEmails?: Maybe<Boolean_Comparison_Exp>,
  socialMedia?: Maybe<String_Comparison_Exp>,
  socialMedia_URL?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Listing_Contact_Constraint {
  ListingContactPkey = 'listing_contact_pkey'
}

export type Listing_Contact_Inc_Input = {
  domainAgentId?: Maybe<Scalars['Int']>,
};

export type Listing_Contact_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Listing_Publish_Portal_Source_Enum>,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Contact_Max_Fields = {
  __typename?: 'listing_contact_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Contact_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Contact_Min_Fields = {
  __typename?: 'listing_contact_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Contact_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Contact_Mutation_Response = {
  __typename?: 'listing_contact_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Contact>,
};

export type Listing_Contact_Obj_Rel_Insert_Input = {
  data: Listing_Contact_Insert_Input,
  on_conflict?: Maybe<Listing_Contact_On_Conflict>,
};

export type Listing_Contact_On_Conflict = {
  constraint: Listing_Contact_Constraint,
  update_columns: Array<Listing_Contact_Update_Column>,
  where?: Maybe<Listing_Contact_Bool_Exp>,
};

export type Listing_Contact_Order_By = {
  created_at?: Maybe<Order_By>,
  domainAgencyID?: Maybe<Order_By>,
  domainAgentId?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  fax?: Maybe<Order_By>,
  firstName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  lastName?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  mobile?: Maybe<Order_By>,
  phone?: Maybe<Order_By>,
  phoneType?: Maybe<Order_By>,
  portal?: Maybe<Order_By>,
  receiveEmails?: Maybe<Order_By>,
  socialMedia?: Maybe<Order_By>,
  socialMedia_URL?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Contact_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Contact_Select_Column {
  CreatedAt = 'created_at',
  DomainAgencyId = 'domainAgencyID',
  DomainAgentId = 'domainAgentId',
  Email = 'email',
  Fax = 'fax',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  ListingId = 'listing_id',
  Mobile = 'mobile',
  Phone = 'phone',
  PhoneType = 'phoneType',
  Portal = 'portal',
  ReceiveEmails = 'receiveEmails',
  SocialMedia = 'socialMedia',
  SocialMediaUrl = 'socialMedia_URL',
  UpdatedAt = 'updated_at'
}

export type Listing_Contact_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  domainAgencyID?: Maybe<Scalars['String']>,
  domainAgentId?: Maybe<Scalars['Int']>,
  email?: Maybe<Scalars['String']>,
  fax?: Maybe<Scalars['String']>,
  firstName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  lastName?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mobile?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  phoneType?: Maybe<Scalars['String']>,
  portal?: Maybe<Listing_Publish_Portal_Source_Enum>,
  receiveEmails?: Maybe<Scalars['Boolean']>,
  socialMedia?: Maybe<Scalars['String']>,
  socialMedia_URL?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Contact_Stddev_Fields = {
  __typename?: 'listing_contact_stddev_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Stddev_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Stddev_Pop_Fields = {
  __typename?: 'listing_contact_stddev_pop_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Stddev_Pop_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Stddev_Samp_Fields = {
  __typename?: 'listing_contact_stddev_samp_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Stddev_Samp_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Sum_Fields = {
  __typename?: 'listing_contact_sum_fields',
  domainAgentId?: Maybe<Scalars['Int']>,
};

export type Listing_Contact_Sum_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export enum Listing_Contact_Update_Column {
  CreatedAt = 'created_at',
  DomainAgencyId = 'domainAgencyID',
  DomainAgentId = 'domainAgentId',
  Email = 'email',
  Fax = 'fax',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  ListingId = 'listing_id',
  Mobile = 'mobile',
  Phone = 'phone',
  PhoneType = 'phoneType',
  Portal = 'portal',
  ReceiveEmails = 'receiveEmails',
  SocialMedia = 'socialMedia',
  SocialMediaUrl = 'socialMedia_URL',
  UpdatedAt = 'updated_at'
}

export type Listing_Contact_Var_Pop_Fields = {
  __typename?: 'listing_contact_var_pop_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Var_Pop_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Var_Samp_Fields = {
  __typename?: 'listing_contact_var_samp_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Var_Samp_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Contact_Variance_Fields = {
  __typename?: 'listing_contact_variance_fields',
  domainAgentId?: Maybe<Scalars['Float']>,
};

export type Listing_Contact_Variance_Order_By = {
  domainAgentId?: Maybe<Order_By>,
};

export type Listing_Delete_At_Path_Input = {
  experiments?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Listing_Delete_Elem_Input = {
  experiments?: Maybe<Scalars['Int']>,
};

export type Listing_Delete_Key_Input = {
  experiments?: Maybe<Scalars['String']>,
};

export type Listing_Detail = {
  __typename?: 'listing_detail',
  agent_point_id?: Maybe<Scalars['numeric']>,
  commercial_status?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  phone_number?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  user_id?: Maybe<Scalars['uuid']>,
  zone?: Maybe<Scalars['String']>,
};

export type Listing_Detail_Aggregate = {
  __typename?: 'listing_detail_aggregate',
  aggregate?: Maybe<Listing_Detail_Aggregate_Fields>,
  nodes: Array<Listing_Detail>,
};

export type Listing_Detail_Aggregate_Fields = {
  __typename?: 'listing_detail_aggregate_fields',
  avg?: Maybe<Listing_Detail_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Detail_Max_Fields>,
  min?: Maybe<Listing_Detail_Min_Fields>,
  stddev?: Maybe<Listing_Detail_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Detail_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Detail_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Detail_Sum_Fields>,
  var_pop?: Maybe<Listing_Detail_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Detail_Var_Samp_Fields>,
  variance?: Maybe<Listing_Detail_Variance_Fields>,
};


export type Listing_Detail_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Detail_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Detail_Aggregate_Order_By = {
  avg?: Maybe<Listing_Detail_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Detail_Max_Order_By>,
  min?: Maybe<Listing_Detail_Min_Order_By>,
  stddev?: Maybe<Listing_Detail_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Detail_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Detail_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Detail_Sum_Order_By>,
  var_pop?: Maybe<Listing_Detail_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Detail_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Detail_Variance_Order_By>,
};

export type Listing_Detail_Avg_Fields = {
  __typename?: 'listing_detail_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Detail_Bool_Exp>>>,
  _not?: Maybe<Listing_Detail_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Detail_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  commercial_status?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  enquiry_code?: Maybe<Int_Comparison_Exp>,
  first_name?: Maybe<String_Comparison_Exp>,
  full_name?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  last_name?: Maybe<String_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  phone_number?: Maybe<String_Comparison_Exp>,
  proof_of_ownership_status?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_1?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_2?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_street?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_unitNumber?: Maybe<String_Comparison_Exp>,
  publishing_status?: Maybe<String_Comparison_Exp>,
  user_id?: Maybe<Uuid_Comparison_Exp>,
  zone?: Maybe<String_Comparison_Exp>,
};

export type Listing_Detail_Max_Fields = {
  __typename?: 'listing_detail_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  commercial_status?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  phone_number?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  user_id?: Maybe<Scalars['uuid']>,
  zone?: Maybe<Scalars['String']>,
};

export type Listing_Detail_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Listing_Detail_Min_Fields = {
  __typename?: 'listing_detail_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  commercial_status?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  phone_number?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  user_id?: Maybe<Scalars['uuid']>,
  zone?: Maybe<Scalars['String']>,
};

export type Listing_Detail_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Listing_Detail_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export enum Listing_Detail_Select_Column {
  AgentPointId = 'agent_point_id',
  CommercialStatus = 'commercial_status',
  CreatedAt = 'created_at',
  Email = 'email',
  EnquiryCode = 'enquiry_code',
  FirstName = 'first_name',
  FullName = 'full_name',
  Id = 'id',
  LastName = 'last_name',
  OwnerId = 'owner_id',
  PhoneNumber = 'phone_number',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PublishingStatus = 'publishing_status',
  UserId = 'user_id',
  Zone = 'zone'
}

export type Listing_Detail_Stddev_Fields = {
  __typename?: 'listing_detail_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Stddev_Pop_Fields = {
  __typename?: 'listing_detail_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Stddev_Samp_Fields = {
  __typename?: 'listing_detail_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Sum_Fields = {
  __typename?: 'listing_detail_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  enquiry_code?: Maybe<Scalars['Int']>,
};

export type Listing_Detail_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Var_Pop_Fields = {
  __typename?: 'listing_detail_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Var_Samp_Fields = {
  __typename?: 'listing_detail_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Detail_Variance_Fields = {
  __typename?: 'listing_detail_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
};

export type Listing_Detail_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
};

export type Listing_Document = {
  __typename?: 'listing_document',
  attachment: Array<Attachment>,
  attachment_aggregate: Attachment_Aggregate,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  listing?: Maybe<Listing>,
  listing_id?: Maybe<Scalars['uuid']>,
  status?: Maybe<Listing_Document_Status_Enum>,
  type?: Maybe<Listing_Document_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};


export type Listing_DocumentAttachmentArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Listing_DocumentAttachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};

export type Listing_Document_Aggregate = {
  __typename?: 'listing_document_aggregate',
  aggregate?: Maybe<Listing_Document_Aggregate_Fields>,
  nodes: Array<Listing_Document>,
};

export type Listing_Document_Aggregate_Fields = {
  __typename?: 'listing_document_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Document_Max_Fields>,
  min?: Maybe<Listing_Document_Min_Fields>,
};


export type Listing_Document_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Document_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Document_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Document_Max_Order_By>,
  min?: Maybe<Listing_Document_Min_Order_By>,
};

export type Listing_Document_Arr_Rel_Insert_Input = {
  data: Array<Listing_Document_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_On_Conflict>,
};

export type Listing_Document_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Document_Bool_Exp>>>,
  _not?: Maybe<Listing_Document_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Document_Bool_Exp>>>,
  attachment?: Maybe<Attachment_Bool_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  status?: Maybe<Listing_Document_Status_Enum_Comparison_Exp>,
  type?: Maybe<Listing_Document_Type_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  url?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Document_Constraint {
  ListingDocumentPkey = 'listing_document_pkey'
}

export type Listing_Document_Insert_Input = {
  attachment?: Maybe<Attachment_Arr_Rel_Insert_Input>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  status?: Maybe<Listing_Document_Status_Enum>,
  type?: Maybe<Listing_Document_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Document_Max_Fields = {
  __typename?: 'listing_document_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Document_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Document_Min_Fields = {
  __typename?: 'listing_document_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Document_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Document_Mutation_Response = {
  __typename?: 'listing_document_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Document>,
};

export type Listing_Document_Obj_Rel_Insert_Input = {
  data: Listing_Document_Insert_Input,
  on_conflict?: Maybe<Listing_Document_On_Conflict>,
};

export type Listing_Document_On_Conflict = {
  constraint: Listing_Document_Constraint,
  update_columns: Array<Listing_Document_Update_Column>,
  where?: Maybe<Listing_Document_Bool_Exp>,
};

export type Listing_Document_Order_By = {
  attachment_aggregate?: Maybe<Attachment_Aggregate_Order_By>,
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Document_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Document_Select_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  ListingId = 'listing_id',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Url = 'url'
}

export type Listing_Document_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  status?: Maybe<Listing_Document_Status_Enum>,
  type?: Maybe<Listing_Document_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Document_Status = {
  __typename?: 'listing_document_status',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Document_Status_Aggregate = {
  __typename?: 'listing_document_status_aggregate',
  aggregate?: Maybe<Listing_Document_Status_Aggregate_Fields>,
  nodes: Array<Listing_Document_Status>,
};

export type Listing_Document_Status_Aggregate_Fields = {
  __typename?: 'listing_document_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Document_Status_Max_Fields>,
  min?: Maybe<Listing_Document_Status_Min_Fields>,
};


export type Listing_Document_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Document_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Document_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Document_Status_Max_Order_By>,
  min?: Maybe<Listing_Document_Status_Min_Order_By>,
};

export type Listing_Document_Status_Arr_Rel_Insert_Input = {
  data: Array<Listing_Document_Status_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_Status_On_Conflict>,
};

export type Listing_Document_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Document_Status_Bool_Exp>>>,
  _not?: Maybe<Listing_Document_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Document_Status_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Document_Status_Constraint {
  ListingDocumentStatusPkey = 'listing_document_status_pkey'
}

export enum Listing_Document_Status_Enum {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  NotSubmitted = 'NOT_SUBMITTED',
  PendingReview = 'PENDING_REVIEW',
  Uploaded = 'UPLOADED'
}

export type Listing_Document_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Document_Status_Enum>,
  _in?: Maybe<Array<Listing_Document_Status_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Document_Status_Enum>,
  _nin?: Maybe<Array<Listing_Document_Status_Enum>>,
};

export type Listing_Document_Status_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Status_Max_Fields = {
  __typename?: 'listing_document_status_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Status_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Status_Min_Fields = {
  __typename?: 'listing_document_status_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Status_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Status_Mutation_Response = {
  __typename?: 'listing_document_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Document_Status>,
};

export type Listing_Document_Status_Obj_Rel_Insert_Input = {
  data: Listing_Document_Status_Insert_Input,
  on_conflict?: Maybe<Listing_Document_Status_On_Conflict>,
};

export type Listing_Document_Status_On_Conflict = {
  constraint: Listing_Document_Status_Constraint,
  update_columns: Array<Listing_Document_Status_Update_Column>,
  where?: Maybe<Listing_Document_Status_Bool_Exp>,
};

export type Listing_Document_Status_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Status_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Document_Status_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Document_Status_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Document_Status_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Document_Type = {
  __typename?: 'listing_document_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Document_Type_Aggregate = {
  __typename?: 'listing_document_type_aggregate',
  aggregate?: Maybe<Listing_Document_Type_Aggregate_Fields>,
  nodes: Array<Listing_Document_Type>,
};

export type Listing_Document_Type_Aggregate_Fields = {
  __typename?: 'listing_document_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Document_Type_Max_Fields>,
  min?: Maybe<Listing_Document_Type_Min_Fields>,
};


export type Listing_Document_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Document_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Document_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Document_Type_Max_Order_By>,
  min?: Maybe<Listing_Document_Type_Min_Order_By>,
};

export type Listing_Document_Type_Arr_Rel_Insert_Input = {
  data: Array<Listing_Document_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_Type_On_Conflict>,
};

export type Listing_Document_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Document_Type_Bool_Exp>>>,
  _not?: Maybe<Listing_Document_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Document_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Document_Type_Constraint {
  ListingDocumentTypePkey = 'listing_document_type_pkey'
}

export enum Listing_Document_Type_Enum {
  EvidenceOfAuthority = 'EVIDENCE_OF_AUTHORITY',
  ProofOfId = 'PROOF_OF_ID',
  ProofOfOwnership = 'PROOF_OF_OWNERSHIP'
}

export type Listing_Document_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Document_Type_Enum>,
  _in?: Maybe<Array<Listing_Document_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Document_Type_Enum>,
  _nin?: Maybe<Array<Listing_Document_Type_Enum>>,
};

export type Listing_Document_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Type_Max_Fields = {
  __typename?: 'listing_document_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Type_Min_Fields = {
  __typename?: 'listing_document_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Document_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Type_Mutation_Response = {
  __typename?: 'listing_document_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Document_Type>,
};

export type Listing_Document_Type_Obj_Rel_Insert_Input = {
  data: Listing_Document_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Document_Type_On_Conflict>,
};

export type Listing_Document_Type_On_Conflict = {
  constraint: Listing_Document_Type_Constraint,
  update_columns: Array<Listing_Document_Type_Update_Column>,
  where?: Maybe<Listing_Document_Type_Bool_Exp>,
};

export type Listing_Document_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Document_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Document_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Document_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Document_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Listing_Document_Update_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  ListingId = 'listing_id',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Url = 'url'
}

export type Listing_Event = {
  __typename?: 'listing_event',
  created_at: Scalars['timestamptz'],
  event_data?: Maybe<Scalars['jsonb']>,
  event_type: Listing_Event_Type_Enum,
  id: Scalars['uuid'],
  listing: Listing,
  listingId: Scalars['uuid'],
  owner_id: Scalars['uuid'],
  user: User,
};


export type Listing_EventEvent_DataArgs = {
  path?: Maybe<Scalars['String']>
};

export type Listing_Event_Aggregate = {
  __typename?: 'listing_event_aggregate',
  aggregate?: Maybe<Listing_Event_Aggregate_Fields>,
  nodes: Array<Listing_Event>,
};

export type Listing_Event_Aggregate_Fields = {
  __typename?: 'listing_event_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Event_Max_Fields>,
  min?: Maybe<Listing_Event_Min_Fields>,
};


export type Listing_Event_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Event_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Event_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Event_Max_Order_By>,
  min?: Maybe<Listing_Event_Min_Order_By>,
};

export type Listing_Event_Append_Input = {
  event_data?: Maybe<Scalars['jsonb']>,
};

export type Listing_Event_Arr_Rel_Insert_Input = {
  data: Array<Listing_Event_Insert_Input>,
  on_conflict?: Maybe<Listing_Event_On_Conflict>,
};

export type Listing_Event_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Event_Bool_Exp>>>,
  _not?: Maybe<Listing_Event_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Event_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  event_data?: Maybe<Jsonb_Comparison_Exp>,
  event_type?: Maybe<Listing_Event_Type_Enum_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listingId?: Maybe<Uuid_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
};

export enum Listing_Event_Constraint {
  ListingEventPkey = 'listing_event_pkey'
}

export type Listing_Event_Delete_At_Path_Input = {
  event_data?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Listing_Event_Delete_Elem_Input = {
  event_data?: Maybe<Scalars['Int']>,
};

export type Listing_Event_Delete_Key_Input = {
  event_data?: Maybe<Scalars['String']>,
};

export type Listing_Event_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  event_data?: Maybe<Scalars['jsonb']>,
  event_type?: Maybe<Listing_Event_Type_Enum>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listingId?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
};

export type Listing_Event_Max_Fields = {
  __typename?: 'listing_event_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listingId?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Event_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listingId?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
};

export type Listing_Event_Min_Fields = {
  __typename?: 'listing_event_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listingId?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Event_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listingId?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
};

export type Listing_Event_Mutation_Response = {
  __typename?: 'listing_event_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Event>,
};

export type Listing_Event_Obj_Rel_Insert_Input = {
  data: Listing_Event_Insert_Input,
  on_conflict?: Maybe<Listing_Event_On_Conflict>,
};

export type Listing_Event_On_Conflict = {
  constraint: Listing_Event_Constraint,
  update_columns: Array<Listing_Event_Update_Column>,
  where?: Maybe<Listing_Event_Bool_Exp>,
};

export type Listing_Event_Order_By = {
  created_at?: Maybe<Order_By>,
  event_data?: Maybe<Order_By>,
  event_type?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listingId?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
};

export type Listing_Event_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Listing_Event_Prepend_Input = {
  event_data?: Maybe<Scalars['jsonb']>,
};

export enum Listing_Event_Select_Column {
  CreatedAt = 'created_at',
  EventData = 'event_data',
  EventType = 'event_type',
  Id = 'id',
  ListingId = 'listingId',
  OwnerId = 'owner_id'
}

export type Listing_Event_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  event_data?: Maybe<Scalars['jsonb']>,
  event_type?: Maybe<Listing_Event_Type_Enum>,
  id?: Maybe<Scalars['uuid']>,
  listingId?: Maybe<Scalars['uuid']>,
  owner_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Event_Type = {
  __typename?: 'listing_event_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Event_Type_Aggregate = {
  __typename?: 'listing_event_type_aggregate',
  aggregate?: Maybe<Listing_Event_Type_Aggregate_Fields>,
  nodes: Array<Listing_Event_Type>,
};

export type Listing_Event_Type_Aggregate_Fields = {
  __typename?: 'listing_event_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Event_Type_Max_Fields>,
  min?: Maybe<Listing_Event_Type_Min_Fields>,
};


export type Listing_Event_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Event_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Event_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Event_Type_Max_Order_By>,
  min?: Maybe<Listing_Event_Type_Min_Order_By>,
};

export type Listing_Event_Type_Arr_Rel_Insert_Input = {
  data: Array<Listing_Event_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Event_Type_On_Conflict>,
};

export type Listing_Event_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Event_Type_Bool_Exp>>>,
  _not?: Maybe<Listing_Event_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Event_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Event_Type_Constraint {
  ListingEventTypePkey = 'listing_event_type_pkey'
}

export enum Listing_Event_Type_Enum {
  FailedPublishing = 'FAILED_PUBLISHING',
  Leased = 'LEASED',
  Listed = 'LISTED',
  New = 'NEW',
  OnboardingComplete = 'ONBOARDING_COMPLETE',
  OnholdInProgress = 'ONHOLD_IN_PROGRESS',
  OnHold = 'ON_HOLD',
  PaidListing = 'PAID_LISTING',
  SentUnderOfferReminder = 'SENT_UNDER_OFFER_REMINDER',
  Sold = 'SOLD',
  UnderOffer = 'UNDER_OFFER',
  UnderOfferInProgress = 'UNDER_OFFER_IN_PROGRESS',
  UnderReview = 'UNDER_REVIEW',
  Withdrawn = 'WITHDRAWN',
  WithdrawnInProgress = 'WITHDRAWN_IN_PROGRESS',
  AuctionWarningQld = 'auction_warning_qld',
  ProofOfOwnershipDeclined = 'proof_of_ownership_declined',
  ProofOfOwnershipSubmitted = 'proof_of_ownership_submitted',
  VisitedCampaign = 'visited_campaign',
  VisitedPreview = 'visited_preview'
}

export type Listing_Event_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Event_Type_Enum>,
  _in?: Maybe<Array<Listing_Event_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Event_Type_Enum>,
  _nin?: Maybe<Array<Listing_Event_Type_Enum>>,
};

export type Listing_Event_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Event_Type_Max_Fields = {
  __typename?: 'listing_event_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Event_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Event_Type_Min_Fields = {
  __typename?: 'listing_event_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Event_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Event_Type_Mutation_Response = {
  __typename?: 'listing_event_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Event_Type>,
};

export type Listing_Event_Type_Obj_Rel_Insert_Input = {
  data: Listing_Event_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Event_Type_On_Conflict>,
};

export type Listing_Event_Type_On_Conflict = {
  constraint: Listing_Event_Type_Constraint,
  update_columns: Array<Listing_Event_Type_Update_Column>,
  where?: Maybe<Listing_Event_Type_Bool_Exp>,
};

export type Listing_Event_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Event_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Event_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Event_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Event_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Listing_Event_Update_Column {
  CreatedAt = 'created_at',
  EventData = 'event_data',
  EventType = 'event_type',
  Id = 'id',
  ListingId = 'listingId',
  OwnerId = 'owner_id'
}

export type Listing_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Listing_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Commercial_Status_Type_Enum>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  delivery_address_1?: Maybe<Scalars['String']>,
  delivery_address_2?: Maybe<Scalars['String']>,
  delivery_address_postcode?: Maybe<Scalars['String']>,
  delivery_address_state?: Maybe<Scalars['String']>,
  delivery_address_street?: Maybe<Scalars['String']>,
  delivery_address_streetNumber?: Maybe<Scalars['String']>,
  delivery_address_suburb?: Maybe<Scalars['String']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  delivery_address_unitNumber?: Maybe<Scalars['String']>,
  delivery_to_property_address?: Maybe<Scalars['Boolean']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  feedbacks?: Maybe<Feedback_Arr_Rel_Insert_Input>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  listing_contacts?: Maybe<Listing_Contact_Arr_Rel_Insert_Input>,
  listing_documents?: Maybe<Listing_Document_Arr_Rel_Insert_Input>,
  listing_events?: Maybe<Listing_Event_Arr_Rel_Insert_Input>,
  listing_inspections?: Maybe<Listing_Inspection_Arr_Rel_Insert_Input>,
  listing_media?: Maybe<Listing_Media_Arr_Rel_Insert_Input>,
  listing_onboardings?: Maybe<Listing_Onboarding_Arr_Rel_Insert_Input>,
  listing_parkings?: Maybe<Listing_Parking_Arr_Rel_Insert_Input>,
  listing_publish_errors?: Maybe<Listing_Publish_Errors_Arr_Rel_Insert_Input>,
  listing_publish_statuses?: Maybe<Listing_Publish_Status_Arr_Rel_Insert_Input>,
  listing_soi_comparable_properties?: Maybe<Listing_Soi_Comparable_Property_Arr_Rel_Insert_Input>,
  orders?: Maybe<Order_Arr_Rel_Insert_Input>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Listing_Document_Status_Enum>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Publishing_Status_Type_Enum>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
  zone?: Maybe<Zone_Type_Enum>,
};

export type Listing_Inspection = {
  __typename?: 'listing_inspection',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id: Scalars['uuid'],
  is_private?: Maybe<Scalars['Boolean']>,
  listing: Listing,
  listing_id: Scalars['uuid'],
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Inspection_Aggregate = {
  __typename?: 'listing_inspection_aggregate',
  aggregate?: Maybe<Listing_Inspection_Aggregate_Fields>,
  nodes: Array<Listing_Inspection>,
};

export type Listing_Inspection_Aggregate_Fields = {
  __typename?: 'listing_inspection_aggregate_fields',
  avg?: Maybe<Listing_Inspection_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Inspection_Max_Fields>,
  min?: Maybe<Listing_Inspection_Min_Fields>,
  stddev?: Maybe<Listing_Inspection_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Inspection_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Inspection_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Inspection_Sum_Fields>,
  var_pop?: Maybe<Listing_Inspection_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Inspection_Var_Samp_Fields>,
  variance?: Maybe<Listing_Inspection_Variance_Fields>,
};


export type Listing_Inspection_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Inspection_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Inspection_Aggregate_Order_By = {
  avg?: Maybe<Listing_Inspection_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Inspection_Max_Order_By>,
  min?: Maybe<Listing_Inspection_Min_Order_By>,
  stddev?: Maybe<Listing_Inspection_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Inspection_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Inspection_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Inspection_Sum_Order_By>,
  var_pop?: Maybe<Listing_Inspection_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Inspection_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Inspection_Variance_Order_By>,
};

export type Listing_Inspection_Arr_Rel_Insert_Input = {
  data: Array<Listing_Inspection_Insert_Input>,
  on_conflict?: Maybe<Listing_Inspection_On_Conflict>,
};

export type Listing_Inspection_Avg_Fields = {
  __typename?: 'listing_inspection_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Inspection_Bool_Exp>>>,
  _not?: Maybe<Listing_Inspection_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Inspection_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  from?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  is_private?: Maybe<Boolean_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  repeat?: Maybe<Boolean_Comparison_Exp>,
  to?: Maybe<Timestamptz_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Listing_Inspection_Constraint {
  ListingInspectionAgentPointIdKey = 'listing_inspection_agent_point_id_key',
  ListingInspectionPkey = 'listing_inspection_pkey'
}

export type Listing_Inspection_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type Listing_Inspection_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_private?: Maybe<Scalars['Boolean']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Inspection_Max_Fields = {
  __typename?: 'listing_inspection_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Inspection_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Inspection_Min_Fields = {
  __typename?: 'listing_inspection_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Inspection_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Inspection_Mutation_Response = {
  __typename?: 'listing_inspection_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Inspection>,
};

export type Listing_Inspection_Obj_Rel_Insert_Input = {
  data: Listing_Inspection_Insert_Input,
  on_conflict?: Maybe<Listing_Inspection_On_Conflict>,
};

export type Listing_Inspection_On_Conflict = {
  constraint: Listing_Inspection_Constraint,
  update_columns: Array<Listing_Inspection_Update_Column>,
  where?: Maybe<Listing_Inspection_Bool_Exp>,
};

export type Listing_Inspection_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  from?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  is_private?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  repeat?: Maybe<Order_By>,
  to?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Inspection_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Inspection_Select_Column {
  AgentPointId = 'agent_point_id',
  CreatedAt = 'created_at',
  From = 'from',
  Id = 'id',
  IsPrivate = 'is_private',
  ListingId = 'listing_id',
  Repeat = 'repeat',
  To = 'to',
  UpdatedAt = 'updated_at'
}

export type Listing_Inspection_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  from?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_private?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  repeat?: Maybe<Scalars['Boolean']>,
  to?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Inspection_Stddev_Fields = {
  __typename?: 'listing_inspection_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Stddev_Pop_Fields = {
  __typename?: 'listing_inspection_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Stddev_Samp_Fields = {
  __typename?: 'listing_inspection_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Sum_Fields = {
  __typename?: 'listing_inspection_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type Listing_Inspection_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export enum Listing_Inspection_Update_Column {
  AgentPointId = 'agent_point_id',
  CreatedAt = 'created_at',
  From = 'from',
  Id = 'id',
  IsPrivate = 'is_private',
  ListingId = 'listing_id',
  Repeat = 'repeat',
  To = 'to',
  UpdatedAt = 'updated_at'
}

export type Listing_Inspection_Var_Pop_Fields = {
  __typename?: 'listing_inspection_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Var_Samp_Fields = {
  __typename?: 'listing_inspection_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Inspection_Variance_Fields = {
  __typename?: 'listing_inspection_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type Listing_Inspection_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type Listing_Max_Fields = {
  __typename?: 'listing_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  delivery_address_1?: Maybe<Scalars['String']>,
  delivery_address_2?: Maybe<Scalars['String']>,
  delivery_address_postcode?: Maybe<Scalars['String']>,
  delivery_address_state?: Maybe<Scalars['String']>,
  delivery_address_street?: Maybe<Scalars['String']>,
  delivery_address_streetNumber?: Maybe<Scalars['String']>,
  delivery_address_suburb?: Maybe<Scalars['String']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  delivery_address_unitNumber?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  delivery_address_1?: Maybe<Order_By>,
  delivery_address_2?: Maybe<Order_By>,
  delivery_address_postcode?: Maybe<Order_By>,
  delivery_address_state?: Maybe<Order_By>,
  delivery_address_street?: Maybe<Order_By>,
  delivery_address_streetNumber?: Maybe<Order_By>,
  delivery_address_suburb?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  delivery_address_unitNumber?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Media = {
  __typename?: 'listing_media',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment: Array<Attachment>,
  attachmentByAttachmentId?: Maybe<Attachment>,
  attachment_aggregate: Attachment_Aggregate,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded: Scalars['Boolean'],
  is_uploaded: Scalars['Boolean'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order: Scalars['smallint'],
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Listing_Media_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};


export type Listing_MediaAttachmentArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Listing_MediaAttachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};

export type Listing_Media_Aggregate = {
  __typename?: 'listing_media_aggregate',
  aggregate?: Maybe<Listing_Media_Aggregate_Fields>,
  nodes: Array<Listing_Media>,
};

export type Listing_Media_Aggregate_Fields = {
  __typename?: 'listing_media_aggregate_fields',
  avg?: Maybe<Listing_Media_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Media_Max_Fields>,
  min?: Maybe<Listing_Media_Min_Fields>,
  stddev?: Maybe<Listing_Media_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Media_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Media_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Media_Sum_Fields>,
  var_pop?: Maybe<Listing_Media_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Media_Var_Samp_Fields>,
  variance?: Maybe<Listing_Media_Variance_Fields>,
};


export type Listing_Media_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Media_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Media_Aggregate_Order_By = {
  avg?: Maybe<Listing_Media_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Media_Max_Order_By>,
  min?: Maybe<Listing_Media_Min_Order_By>,
  stddev?: Maybe<Listing_Media_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Media_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Media_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Media_Sum_Order_By>,
  var_pop?: Maybe<Listing_Media_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Media_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Media_Variance_Order_By>,
};

export type Listing_Media_Arr_Rel_Insert_Input = {
  data: Array<Listing_Media_Insert_Input>,
  on_conflict?: Maybe<Listing_Media_On_Conflict>,
};

export type Listing_Media_Avg_Fields = {
  __typename?: 'listing_media_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Media_Bool_Exp>>>,
  _not?: Maybe<Listing_Media_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Media_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  attachment?: Maybe<Attachment_Bool_Exp>,
  attachmentByAttachmentId?: Maybe<Attachment_Bool_Exp>,
  attachment_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  desc?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  images_id_attribute?: Maybe<String_Comparison_Exp>,
  is_downloaded?: Maybe<Boolean_Comparison_Exp>,
  is_uploaded?: Maybe<Boolean_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  mime_type?: Maybe<String_Comparison_Exp>,
  objects_id_attribute?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Smallint_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  processed_error?: Maybe<String_Comparison_Exp>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum_Comparison_Exp>,
  thumbnail_1212?: Maybe<String_Comparison_Exp>,
  thumbnail_1818?: Maybe<String_Comparison_Exp>,
  thumbnail_185?: Maybe<String_Comparison_Exp>,
  thumbnail_284?: Maybe<String_Comparison_Exp>,
  thumbnail_370?: Maybe<String_Comparison_Exp>,
  thumbnail_555?: Maybe<String_Comparison_Exp>,
  thumbnail_568?: Maybe<String_Comparison_Exp>,
  thumbnail_606?: Maybe<String_Comparison_Exp>,
  thumbnail_852?: Maybe<String_Comparison_Exp>,
  type?: Maybe<Listing_Media_Type_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  url?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Media_Constraint {
  ListingMediaAgentPointIdKey = 'listing_media_agent_point_id_key',
  ListingMediaPkey = 'listing_media_pkey'
}

export type Listing_Media_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  order?: Maybe<Scalars['smallint']>,
};

export type Listing_Media_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment?: Maybe<Attachment_Arr_Rel_Insert_Input>,
  attachmentByAttachmentId?: Maybe<Attachment_Obj_Rel_Insert_Input>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded?: Maybe<Scalars['Boolean']>,
  is_uploaded?: Maybe<Scalars['Boolean']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Listing_Media_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Media_Max_Fields = {
  __typename?: 'listing_media_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Media_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Media_Min_Fields = {
  __typename?: 'listing_media_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Media_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Media_Mutation_Response = {
  __typename?: 'listing_media_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Media>,
};

export type Listing_Media_Obj_Rel_Insert_Input = {
  data: Listing_Media_Insert_Input,
  on_conflict?: Maybe<Listing_Media_On_Conflict>,
};

export type Listing_Media_On_Conflict = {
  constraint: Listing_Media_Constraint,
  update_columns: Array<Listing_Media_Update_Column>,
  where?: Maybe<Listing_Media_Bool_Exp>,
};

export type Listing_Media_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  attachmentByAttachmentId?: Maybe<Attachment_Order_By>,
  attachment_aggregate?: Maybe<Attachment_Aggregate_Order_By>,
  attachment_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  desc?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  images_id_attribute?: Maybe<Order_By>,
  is_downloaded?: Maybe<Order_By>,
  is_uploaded?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  mime_type?: Maybe<Order_By>,
  objects_id_attribute?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_error?: Maybe<Order_By>,
  processing_status?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Listing_Media_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Media_Select_Column {
  AgentPointId = 'agent_point_id',
  AttachmentId = 'attachment_id',
  CreatedAt = 'created_at',
  Desc = 'desc',
  Id = 'id',
  ImagesIdAttribute = 'images_id_attribute',
  IsDownloaded = 'is_downloaded',
  IsUploaded = 'is_uploaded',
  ListingId = 'listing_id',
  MimeType = 'mime_type',
  ObjectsIdAttribute = 'objects_id_attribute',
  Order = 'order',
  OwnerId = 'owner_id',
  ProcessedError = 'processed_error',
  ProcessingStatus = 'processing_status',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Url = 'url'
}

export type Listing_Media_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  attachment_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  desc?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  images_id_attribute?: Maybe<Scalars['String']>,
  is_downloaded?: Maybe<Scalars['Boolean']>,
  is_uploaded?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  mime_type?: Maybe<Scalars['String']>,
  objects_id_attribute?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['smallint']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_error?: Maybe<Scalars['String']>,
  processing_status?: Maybe<Salesforce_Sync_Status_Enum>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  type?: Maybe<Listing_Media_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  url?: Maybe<Scalars['String']>,
};

export type Listing_Media_Stddev_Fields = {
  __typename?: 'listing_media_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Stddev_Pop_Fields = {
  __typename?: 'listing_media_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Stddev_Samp_Fields = {
  __typename?: 'listing_media_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Sum_Fields = {
  __typename?: 'listing_media_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  order?: Maybe<Scalars['smallint']>,
};

export type Listing_Media_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Type = {
  __typename?: 'listing_media_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Media_Type_Aggregate = {
  __typename?: 'listing_media_type_aggregate',
  aggregate?: Maybe<Listing_Media_Type_Aggregate_Fields>,
  nodes: Array<Listing_Media_Type>,
};

export type Listing_Media_Type_Aggregate_Fields = {
  __typename?: 'listing_media_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Media_Type_Max_Fields>,
  min?: Maybe<Listing_Media_Type_Min_Fields>,
};


export type Listing_Media_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Media_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Media_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Media_Type_Max_Order_By>,
  min?: Maybe<Listing_Media_Type_Min_Order_By>,
};

export type Listing_Media_Type_Arr_Rel_Insert_Input = {
  data: Array<Listing_Media_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Media_Type_On_Conflict>,
};

export type Listing_Media_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Media_Type_Bool_Exp>>>,
  _not?: Maybe<Listing_Media_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Media_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Media_Type_Constraint {
  ListingMediaTypePkey = 'listing_media_type_pkey'
}

export enum Listing_Media_Type_Enum {
  FloorPlan = 'FLOOR_PLAN',
  Photo = 'PHOTO',
  StatementOfInformation = 'STATEMENT_OF_INFORMATION',
  StockPhoto = 'STOCK_PHOTO',
  VideoLink = 'VIDEO_LINK',
  VirtualTourLink = 'VIRTUAL_TOUR_LINK'
}

export type Listing_Media_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Media_Type_Enum>,
  _in?: Maybe<Array<Listing_Media_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Media_Type_Enum>,
  _nin?: Maybe<Array<Listing_Media_Type_Enum>>,
};

export type Listing_Media_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Media_Type_Max_Fields = {
  __typename?: 'listing_media_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Media_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Media_Type_Min_Fields = {
  __typename?: 'listing_media_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Media_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Media_Type_Mutation_Response = {
  __typename?: 'listing_media_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Media_Type>,
};

export type Listing_Media_Type_Obj_Rel_Insert_Input = {
  data: Listing_Media_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Media_Type_On_Conflict>,
};

export type Listing_Media_Type_On_Conflict = {
  constraint: Listing_Media_Type_Constraint,
  update_columns: Array<Listing_Media_Type_Update_Column>,
  where?: Maybe<Listing_Media_Type_Bool_Exp>,
};

export type Listing_Media_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Media_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Media_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Media_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Media_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Listing_Media_Update_Column {
  AgentPointId = 'agent_point_id',
  AttachmentId = 'attachment_id',
  CreatedAt = 'created_at',
  Desc = 'desc',
  Id = 'id',
  ImagesIdAttribute = 'images_id_attribute',
  IsDownloaded = 'is_downloaded',
  IsUploaded = 'is_uploaded',
  ListingId = 'listing_id',
  MimeType = 'mime_type',
  ObjectsIdAttribute = 'objects_id_attribute',
  Order = 'order',
  OwnerId = 'owner_id',
  ProcessedError = 'processed_error',
  ProcessingStatus = 'processing_status',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  Type = 'type',
  UpdatedAt = 'updated_at',
  Url = 'url'
}

export type Listing_Media_Var_Pop_Fields = {
  __typename?: 'listing_media_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Var_Samp_Fields = {
  __typename?: 'listing_media_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Media_Variance_Fields = {
  __typename?: 'listing_media_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  order?: Maybe<Scalars['Float']>,
};

export type Listing_Media_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
};

export type Listing_Metadata = {
  __typename?: 'listing_metadata',
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  is_processed: Scalars['Boolean'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  type: Scalars['String'],
  value?: Maybe<Scalars['String']>,
};

export type Listing_Metadata_Aggregate = {
  __typename?: 'listing_metadata_aggregate',
  aggregate?: Maybe<Listing_Metadata_Aggregate_Fields>,
  nodes: Array<Listing_Metadata>,
};

export type Listing_Metadata_Aggregate_Fields = {
  __typename?: 'listing_metadata_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Metadata_Max_Fields>,
  min?: Maybe<Listing_Metadata_Min_Fields>,
};


export type Listing_Metadata_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Metadata_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Metadata_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Metadata_Max_Order_By>,
  min?: Maybe<Listing_Metadata_Min_Order_By>,
};

export type Listing_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Listing_Metadata_Insert_Input>,
  on_conflict?: Maybe<Listing_Metadata_On_Conflict>,
};

export type Listing_Metadata_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Metadata_Bool_Exp>>>,
  _not?: Maybe<Listing_Metadata_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Metadata_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  is_processed?: Maybe<Boolean_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  type?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Metadata_Constraint {
  ListingMetadataPkey = 'listing_metadata_pkey'
}

export type Listing_Metadata_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_processed?: Maybe<Scalars['Boolean']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  type?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Metadata_Max_Fields = {
  __typename?: 'listing_metadata_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  type?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Metadata_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Metadata_Min_Fields = {
  __typename?: 'listing_metadata_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  type?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Metadata_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Metadata_Mutation_Response = {
  __typename?: 'listing_metadata_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Metadata>,
};

export type Listing_Metadata_Obj_Rel_Insert_Input = {
  data: Listing_Metadata_Insert_Input,
  on_conflict?: Maybe<Listing_Metadata_On_Conflict>,
};

export type Listing_Metadata_On_Conflict = {
  constraint: Listing_Metadata_Constraint,
  update_columns: Array<Listing_Metadata_Update_Column>,
  where?: Maybe<Listing_Metadata_Bool_Exp>,
};

export type Listing_Metadata_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  is_processed?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Metadata_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Metadata_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  IsProcessed = 'is_processed',
  ListingId = 'listing_id',
  Type = 'type',
  Value = 'value'
}

export type Listing_Metadata_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  is_processed?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  type?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Metadata_Update_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  IsProcessed = 'is_processed',
  ListingId = 'listing_id',
  Type = 'type',
  Value = 'value'
}

export type Listing_Min_Fields = {
  __typename?: 'listing_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  delivery_address_1?: Maybe<Scalars['String']>,
  delivery_address_2?: Maybe<Scalars['String']>,
  delivery_address_postcode?: Maybe<Scalars['String']>,
  delivery_address_state?: Maybe<Scalars['String']>,
  delivery_address_street?: Maybe<Scalars['String']>,
  delivery_address_streetNumber?: Maybe<Scalars['String']>,
  delivery_address_suburb?: Maybe<Scalars['String']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  delivery_address_unitNumber?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  delivery_address_1?: Maybe<Order_By>,
  delivery_address_2?: Maybe<Order_By>,
  delivery_address_postcode?: Maybe<Order_By>,
  delivery_address_state?: Maybe<Order_By>,
  delivery_address_street?: Maybe<Order_By>,
  delivery_address_streetNumber?: Maybe<Order_By>,
  delivery_address_suburb?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  delivery_address_unitNumber?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Mutation_Response = {
  __typename?: 'listing_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing>,
};

export type Listing_Obj_Rel_Insert_Input = {
  data: Listing_Insert_Input,
  on_conflict?: Maybe<Listing_On_Conflict>,
};

export type Listing_On_Conflict = {
  constraint: Listing_Constraint,
  update_columns: Array<Listing_Update_Column>,
  where?: Maybe<Listing_Bool_Exp>,
};

export type Listing_Onboarding = {
  __typename?: 'listing_onboarding',
  budget_size?: Maybe<Onboarding_Budget_Size_Enum>,
  created_at: Scalars['timestamptz'],
  finished: Scalars['Boolean'],
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  rating_inspection: Scalars['Int'],
  rating_negotiation: Scalars['Int'],
  rating_overall: Scalars['Int'],
  rating_technology: Scalars['Int'],
  rating_valuing: Scalars['Int'],
  reason_selling?: Maybe<Onboarding_Reason_Selling_Enum>,
  reason_selling_other?: Maybe<Scalars['String']>,
  skipped: Scalars['Boolean'],
  step_completed: Scalars['Int'],
  timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Enum>,
  updated_at: Scalars['timestamptz'],
  user: User,
  user_id: Scalars['uuid'],
};

export type Listing_Onboarding_Aggregate = {
  __typename?: 'listing_onboarding_aggregate',
  aggregate?: Maybe<Listing_Onboarding_Aggregate_Fields>,
  nodes: Array<Listing_Onboarding>,
};

export type Listing_Onboarding_Aggregate_Fields = {
  __typename?: 'listing_onboarding_aggregate_fields',
  avg?: Maybe<Listing_Onboarding_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Onboarding_Max_Fields>,
  min?: Maybe<Listing_Onboarding_Min_Fields>,
  stddev?: Maybe<Listing_Onboarding_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Onboarding_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Onboarding_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Onboarding_Sum_Fields>,
  var_pop?: Maybe<Listing_Onboarding_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Onboarding_Var_Samp_Fields>,
  variance?: Maybe<Listing_Onboarding_Variance_Fields>,
};


export type Listing_Onboarding_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Onboarding_Aggregate_Order_By = {
  avg?: Maybe<Listing_Onboarding_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Onboarding_Max_Order_By>,
  min?: Maybe<Listing_Onboarding_Min_Order_By>,
  stddev?: Maybe<Listing_Onboarding_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Onboarding_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Onboarding_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Onboarding_Sum_Order_By>,
  var_pop?: Maybe<Listing_Onboarding_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Onboarding_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Onboarding_Variance_Order_By>,
};

export type Listing_Onboarding_Arr_Rel_Insert_Input = {
  data: Array<Listing_Onboarding_Insert_Input>,
  on_conflict?: Maybe<Listing_Onboarding_On_Conflict>,
};

export type Listing_Onboarding_Avg_Fields = {
  __typename?: 'listing_onboarding_avg_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Avg_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Onboarding_Bool_Exp>>>,
  _not?: Maybe<Listing_Onboarding_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Onboarding_Bool_Exp>>>,
  budget_size?: Maybe<Onboarding_Budget_Size_Enum_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  finished?: Maybe<Boolean_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  rating_inspection?: Maybe<Int_Comparison_Exp>,
  rating_negotiation?: Maybe<Int_Comparison_Exp>,
  rating_overall?: Maybe<Int_Comparison_Exp>,
  rating_technology?: Maybe<Int_Comparison_Exp>,
  rating_valuing?: Maybe<Int_Comparison_Exp>,
  reason_selling?: Maybe<Onboarding_Reason_Selling_Enum_Comparison_Exp>,
  reason_selling_other?: Maybe<String_Comparison_Exp>,
  skipped?: Maybe<Boolean_Comparison_Exp>,
  step_completed?: Maybe<Int_Comparison_Exp>,
  timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
  user_id?: Maybe<Uuid_Comparison_Exp>,
};

export enum Listing_Onboarding_Constraint {
  ListingOnboardingPkey = 'listing_onboarding_pkey'
}

export type Listing_Onboarding_Inc_Input = {
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  step_completed?: Maybe<Scalars['Int']>,
};

export type Listing_Onboarding_Insert_Input = {
  budget_size?: Maybe<Onboarding_Budget_Size_Enum>,
  created_at?: Maybe<Scalars['timestamptz']>,
  finished?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  reason_selling?: Maybe<Onboarding_Reason_Selling_Enum>,
  reason_selling_other?: Maybe<Scalars['String']>,
  skipped?: Maybe<Scalars['Boolean']>,
  step_completed?: Maybe<Scalars['Int']>,
  timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Onboarding_Max_Fields = {
  __typename?: 'listing_onboarding_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  reason_selling_other?: Maybe<Scalars['String']>,
  step_completed?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Onboarding_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  reason_selling_other?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
};

export type Listing_Onboarding_Min_Fields = {
  __typename?: 'listing_onboarding_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  reason_selling_other?: Maybe<Scalars['String']>,
  step_completed?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Onboarding_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  reason_selling_other?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  user_id?: Maybe<Order_By>,
};

export type Listing_Onboarding_Mutation_Response = {
  __typename?: 'listing_onboarding_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Onboarding>,
};

export type Listing_Onboarding_Obj_Rel_Insert_Input = {
  data: Listing_Onboarding_Insert_Input,
  on_conflict?: Maybe<Listing_Onboarding_On_Conflict>,
};

export type Listing_Onboarding_On_Conflict = {
  constraint: Listing_Onboarding_Constraint,
  update_columns: Array<Listing_Onboarding_Update_Column>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>,
};

export type Listing_Onboarding_Order_By = {
  budget_size?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  finished?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  reason_selling?: Maybe<Order_By>,
  reason_selling_other?: Maybe<Order_By>,
  skipped?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
  timeframe_selling?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
  user_id?: Maybe<Order_By>,
};

export type Listing_Onboarding_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Onboarding_Select_Column {
  BudgetSize = 'budget_size',
  CreatedAt = 'created_at',
  Finished = 'finished',
  Id = 'id',
  ListingId = 'listing_id',
  RatingInspection = 'rating_inspection',
  RatingNegotiation = 'rating_negotiation',
  RatingOverall = 'rating_overall',
  RatingTechnology = 'rating_technology',
  RatingValuing = 'rating_valuing',
  ReasonSelling = 'reason_selling',
  ReasonSellingOther = 'reason_selling_other',
  Skipped = 'skipped',
  StepCompleted = 'step_completed',
  TimeframeSelling = 'timeframe_selling',
  UpdatedAt = 'updated_at',
  UserId = 'user_id'
}

export type Listing_Onboarding_Set_Input = {
  budget_size?: Maybe<Onboarding_Budget_Size_Enum>,
  created_at?: Maybe<Scalars['timestamptz']>,
  finished?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  reason_selling?: Maybe<Onboarding_Reason_Selling_Enum>,
  reason_selling_other?: Maybe<Scalars['String']>,
  skipped?: Maybe<Scalars['Boolean']>,
  step_completed?: Maybe<Scalars['Int']>,
  timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user_id?: Maybe<Scalars['uuid']>,
};

export type Listing_Onboarding_Stddev_Fields = {
  __typename?: 'listing_onboarding_stddev_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Stddev_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Stddev_Pop_Fields = {
  __typename?: 'listing_onboarding_stddev_pop_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Stddev_Pop_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Stddev_Samp_Fields = {
  __typename?: 'listing_onboarding_stddev_samp_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Stddev_Samp_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Sum_Fields = {
  __typename?: 'listing_onboarding_sum_fields',
  rating_inspection?: Maybe<Scalars['Int']>,
  rating_negotiation?: Maybe<Scalars['Int']>,
  rating_overall?: Maybe<Scalars['Int']>,
  rating_technology?: Maybe<Scalars['Int']>,
  rating_valuing?: Maybe<Scalars['Int']>,
  step_completed?: Maybe<Scalars['Int']>,
};

export type Listing_Onboarding_Sum_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export enum Listing_Onboarding_Update_Column {
  BudgetSize = 'budget_size',
  CreatedAt = 'created_at',
  Finished = 'finished',
  Id = 'id',
  ListingId = 'listing_id',
  RatingInspection = 'rating_inspection',
  RatingNegotiation = 'rating_negotiation',
  RatingOverall = 'rating_overall',
  RatingTechnology = 'rating_technology',
  RatingValuing = 'rating_valuing',
  ReasonSelling = 'reason_selling',
  ReasonSellingOther = 'reason_selling_other',
  Skipped = 'skipped',
  StepCompleted = 'step_completed',
  TimeframeSelling = 'timeframe_selling',
  UpdatedAt = 'updated_at',
  UserId = 'user_id'
}

export type Listing_Onboarding_Var_Pop_Fields = {
  __typename?: 'listing_onboarding_var_pop_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Var_Pop_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Var_Samp_Fields = {
  __typename?: 'listing_onboarding_var_samp_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Var_Samp_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Onboarding_Variance_Fields = {
  __typename?: 'listing_onboarding_variance_fields',
  rating_inspection?: Maybe<Scalars['Float']>,
  rating_negotiation?: Maybe<Scalars['Float']>,
  rating_overall?: Maybe<Scalars['Float']>,
  rating_technology?: Maybe<Scalars['Float']>,
  rating_valuing?: Maybe<Scalars['Float']>,
  step_completed?: Maybe<Scalars['Float']>,
};

export type Listing_Onboarding_Variance_Order_By = {
  rating_inspection?: Maybe<Order_By>,
  rating_negotiation?: Maybe<Order_By>,
  rating_overall?: Maybe<Order_By>,
  rating_technology?: Maybe<Order_By>,
  rating_valuing?: Maybe<Order_By>,
  step_completed?: Maybe<Order_By>,
};

export type Listing_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  auction_online?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  delivery_address_1?: Maybe<Order_By>,
  delivery_address_2?: Maybe<Order_By>,
  delivery_address_postcode?: Maybe<Order_By>,
  delivery_address_state?: Maybe<Order_By>,
  delivery_address_street?: Maybe<Order_By>,
  delivery_address_streetNumber?: Maybe<Order_By>,
  delivery_address_suburb?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  delivery_address_unitNumber?: Maybe<Order_By>,
  delivery_to_property_address?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  experiments?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  feedbacks_aggregate?: Maybe<Feedback_Aggregate_Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  isNewDevelopment?: Maybe<Order_By>,
  isRural?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  listing_contacts_aggregate?: Maybe<Listing_Contact_Aggregate_Order_By>,
  listing_documents_aggregate?: Maybe<Listing_Document_Aggregate_Order_By>,
  listing_events_aggregate?: Maybe<Listing_Event_Aggregate_Order_By>,
  listing_inspections_aggregate?: Maybe<Listing_Inspection_Aggregate_Order_By>,
  listing_media_aggregate?: Maybe<Listing_Media_Aggregate_Order_By>,
  listing_onboardings_aggregate?: Maybe<Listing_Onboarding_Aggregate_Order_By>,
  listing_parkings_aggregate?: Maybe<Listing_Parking_Aggregate_Order_By>,
  listing_publish_errors_aggregate?: Maybe<Listing_Publish_Errors_Aggregate_Order_By>,
  listing_publish_statuses_aggregate?: Maybe<Listing_Publish_Status_Aggregate_Order_By>,
  listing_soi_comparable_properties_aggregate?: Maybe<Listing_Soi_Comparable_Property_Aggregate_Order_By>,
  orders_aggregate?: Maybe<Order_Aggregate_Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  temporary_add_on_flag?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
  zone?: Maybe<Order_By>,
};

export type Listing_Parking = {
  __typename?: 'listing_parking',
  created_at?: Maybe<Scalars['timestamptz']>,
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  numberOfSpaces?: Maybe<Scalars['numeric']>,
  parkingType?: Maybe<Scalars['String']>,
  remote_garage?: Maybe<Scalars['Boolean']>,
  secure_parking?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Parking_Aggregate = {
  __typename?: 'listing_parking_aggregate',
  aggregate?: Maybe<Listing_Parking_Aggregate_Fields>,
  nodes: Array<Listing_Parking>,
};

export type Listing_Parking_Aggregate_Fields = {
  __typename?: 'listing_parking_aggregate_fields',
  avg?: Maybe<Listing_Parking_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Parking_Max_Fields>,
  min?: Maybe<Listing_Parking_Min_Fields>,
  stddev?: Maybe<Listing_Parking_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Parking_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Parking_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Parking_Sum_Fields>,
  var_pop?: Maybe<Listing_Parking_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Parking_Var_Samp_Fields>,
  variance?: Maybe<Listing_Parking_Variance_Fields>,
};


export type Listing_Parking_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Parking_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Parking_Aggregate_Order_By = {
  avg?: Maybe<Listing_Parking_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Parking_Max_Order_By>,
  min?: Maybe<Listing_Parking_Min_Order_By>,
  stddev?: Maybe<Listing_Parking_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Parking_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Parking_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Parking_Sum_Order_By>,
  var_pop?: Maybe<Listing_Parking_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Parking_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Parking_Variance_Order_By>,
};

export type Listing_Parking_Arr_Rel_Insert_Input = {
  data: Array<Listing_Parking_Insert_Input>,
  on_conflict?: Maybe<Listing_Parking_On_Conflict>,
};

export type Listing_Parking_Avg_Fields = {
  __typename?: 'listing_parking_avg_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Avg_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Parking_Bool_Exp>>>,
  _not?: Maybe<Listing_Parking_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Parking_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  numberOfSpaces?: Maybe<Numeric_Comparison_Exp>,
  parkingType?: Maybe<String_Comparison_Exp>,
  remote_garage?: Maybe<Boolean_Comparison_Exp>,
  secure_parking?: Maybe<Boolean_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Listing_Parking_Constraint {
  ListingParkingPkey = 'listing_parking_pkey'
}

export type Listing_Parking_Inc_Input = {
  numberOfSpaces?: Maybe<Scalars['numeric']>,
};

export type Listing_Parking_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  numberOfSpaces?: Maybe<Scalars['numeric']>,
  parkingType?: Maybe<Scalars['String']>,
  remote_garage?: Maybe<Scalars['Boolean']>,
  secure_parking?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Parking_Max_Fields = {
  __typename?: 'listing_parking_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  numberOfSpaces?: Maybe<Scalars['numeric']>,
  parkingType?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Parking_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  numberOfSpaces?: Maybe<Order_By>,
  parkingType?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Parking_Min_Fields = {
  __typename?: 'listing_parking_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  numberOfSpaces?: Maybe<Scalars['numeric']>,
  parkingType?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Parking_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  numberOfSpaces?: Maybe<Order_By>,
  parkingType?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Parking_Mutation_Response = {
  __typename?: 'listing_parking_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Parking>,
};

export type Listing_Parking_Obj_Rel_Insert_Input = {
  data: Listing_Parking_Insert_Input,
  on_conflict?: Maybe<Listing_Parking_On_Conflict>,
};

export type Listing_Parking_On_Conflict = {
  constraint: Listing_Parking_Constraint,
  update_columns: Array<Listing_Parking_Update_Column>,
  where?: Maybe<Listing_Parking_Bool_Exp>,
};

export type Listing_Parking_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  numberOfSpaces?: Maybe<Order_By>,
  parkingType?: Maybe<Order_By>,
  remote_garage?: Maybe<Order_By>,
  secure_parking?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Parking_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Parking_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  ListingId = 'listing_id',
  NumberOfSpaces = 'numberOfSpaces',
  ParkingType = 'parkingType',
  RemoteGarage = 'remote_garage',
  SecureParking = 'secure_parking',
  UpdatedAt = 'updated_at'
}

export type Listing_Parking_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  numberOfSpaces?: Maybe<Scalars['numeric']>,
  parkingType?: Maybe<Scalars['String']>,
  remote_garage?: Maybe<Scalars['Boolean']>,
  secure_parking?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Parking_Stddev_Fields = {
  __typename?: 'listing_parking_stddev_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Stddev_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Stddev_Pop_Fields = {
  __typename?: 'listing_parking_stddev_pop_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Stddev_Pop_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Stddev_Samp_Fields = {
  __typename?: 'listing_parking_stddev_samp_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Stddev_Samp_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Sum_Fields = {
  __typename?: 'listing_parking_sum_fields',
  numberOfSpaces?: Maybe<Scalars['numeric']>,
};

export type Listing_Parking_Sum_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export enum Listing_Parking_Update_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  ListingId = 'listing_id',
  NumberOfSpaces = 'numberOfSpaces',
  ParkingType = 'parkingType',
  RemoteGarage = 'remote_garage',
  SecureParking = 'secure_parking',
  UpdatedAt = 'updated_at'
}

export type Listing_Parking_Var_Pop_Fields = {
  __typename?: 'listing_parking_var_pop_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Var_Pop_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Var_Samp_Fields = {
  __typename?: 'listing_parking_var_samp_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Var_Samp_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Parking_Variance_Fields = {
  __typename?: 'listing_parking_variance_fields',
  numberOfSpaces?: Maybe<Scalars['Float']>,
};

export type Listing_Parking_Variance_Order_By = {
  numberOfSpaces?: Maybe<Order_By>,
};

export type Listing_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Listing_Prepend_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type Listing_Publish_Errors = {
  __typename?: 'listing_publish_errors',
  agent_id?: Maybe<Scalars['String']>,
  created_at: Scalars['timestamptz'],
  error_field?: Maybe<Scalars['String']>,
  error_message?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum>,
  updated_at: Scalars['timestamptz'],
};

export type Listing_Publish_Errors_Aggregate = {
  __typename?: 'listing_publish_errors_aggregate',
  aggregate?: Maybe<Listing_Publish_Errors_Aggregate_Fields>,
  nodes: Array<Listing_Publish_Errors>,
};

export type Listing_Publish_Errors_Aggregate_Fields = {
  __typename?: 'listing_publish_errors_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Publish_Errors_Max_Fields>,
  min?: Maybe<Listing_Publish_Errors_Min_Fields>,
};


export type Listing_Publish_Errors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Publish_Errors_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Publish_Errors_Max_Order_By>,
  min?: Maybe<Listing_Publish_Errors_Min_Order_By>,
};

export type Listing_Publish_Errors_Arr_Rel_Insert_Input = {
  data: Array<Listing_Publish_Errors_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Errors_On_Conflict>,
};

export type Listing_Publish_Errors_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Publish_Errors_Bool_Exp>>>,
  _not?: Maybe<Listing_Publish_Errors_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Publish_Errors_Bool_Exp>>>,
  agent_id?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  error_field?: Maybe<String_Comparison_Exp>,
  error_message?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Listing_Publish_Errors_Constraint {
  ListingPublishErrorsIdKey = 'listing_publish_errors_id_key',
  ListingPublishErrorsPkey = 'listing_publish_errors_pkey'
}

export type Listing_Publish_Errors_Insert_Input = {
  agent_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  error_field?: Maybe<Scalars['String']>,
  error_message?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Publish_Errors_Max_Fields = {
  __typename?: 'listing_publish_errors_max_fields',
  agent_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  error_field?: Maybe<Scalars['String']>,
  error_message?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Publish_Errors_Max_Order_By = {
  agent_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  error_field?: Maybe<Order_By>,
  error_message?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Publish_Errors_Min_Fields = {
  __typename?: 'listing_publish_errors_min_fields',
  agent_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  error_field?: Maybe<Scalars['String']>,
  error_message?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Publish_Errors_Min_Order_By = {
  agent_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  error_field?: Maybe<Order_By>,
  error_message?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Publish_Errors_Mutation_Response = {
  __typename?: 'listing_publish_errors_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Publish_Errors>,
};

export type Listing_Publish_Errors_Obj_Rel_Insert_Input = {
  data: Listing_Publish_Errors_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Errors_On_Conflict>,
};

export type Listing_Publish_Errors_On_Conflict = {
  constraint: Listing_Publish_Errors_Constraint,
  update_columns: Array<Listing_Publish_Errors_Update_Column>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>,
};

export type Listing_Publish_Errors_Order_By = {
  agent_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  error_field?: Maybe<Order_By>,
  error_message?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  portal_source?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Publish_Errors_Pk_Columns_Input = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid'],
};

export enum Listing_Publish_Errors_Select_Column {
  AgentId = 'agent_id',
  CreatedAt = 'created_at',
  ErrorField = 'error_field',
  ErrorMessage = 'error_message',
  Id = 'id',
  ListingId = 'listing_id',
  PortalSource = 'portal_source',
  UpdatedAt = 'updated_at'
}

export type Listing_Publish_Errors_Set_Input = {
  agent_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  error_field?: Maybe<Scalars['String']>,
  error_message?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Listing_Publish_Errors_Update_Column {
  AgentId = 'agent_id',
  CreatedAt = 'created_at',
  ErrorField = 'error_field',
  ErrorMessage = 'error_message',
  Id = 'id',
  ListingId = 'listing_id',
  PortalSource = 'portal_source',
  UpdatedAt = 'updated_at'
}

export type Listing_Publish_Portal_Source = {
  __typename?: 'listing_publish_portal_source',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Publish_Portal_Source_Aggregate = {
  __typename?: 'listing_publish_portal_source_aggregate',
  aggregate?: Maybe<Listing_Publish_Portal_Source_Aggregate_Fields>,
  nodes: Array<Listing_Publish_Portal_Source>,
};

export type Listing_Publish_Portal_Source_Aggregate_Fields = {
  __typename?: 'listing_publish_portal_source_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Publish_Portal_Source_Max_Fields>,
  min?: Maybe<Listing_Publish_Portal_Source_Min_Fields>,
};


export type Listing_Publish_Portal_Source_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Publish_Portal_Source_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Publish_Portal_Source_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Publish_Portal_Source_Max_Order_By>,
  min?: Maybe<Listing_Publish_Portal_Source_Min_Order_By>,
};

export type Listing_Publish_Portal_Source_Arr_Rel_Insert_Input = {
  data: Array<Listing_Publish_Portal_Source_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Portal_Source_On_Conflict>,
};

export type Listing_Publish_Portal_Source_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Publish_Portal_Source_Bool_Exp>>>,
  _not?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Publish_Portal_Source_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Publish_Portal_Source_Constraint {
  ListingPublishPortalSourcePkey = 'listing_publish_portal_source_pkey'
}

export enum Listing_Publish_Portal_Source_Enum {
  Allhomes = 'allhomes',
  Bmp = 'bmp',
  Domain = 'domain',
  Homely = 'homely',
  Homesales = 'homesales',
  Rea = 'rea'
}

export type Listing_Publish_Portal_Source_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Publish_Portal_Source_Enum>,
  _in?: Maybe<Array<Listing_Publish_Portal_Source_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Publish_Portal_Source_Enum>,
  _nin?: Maybe<Array<Listing_Publish_Portal_Source_Enum>>,
};

export type Listing_Publish_Portal_Source_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Portal_Source_Max_Fields = {
  __typename?: 'listing_publish_portal_source_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Portal_Source_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Portal_Source_Min_Fields = {
  __typename?: 'listing_publish_portal_source_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Portal_Source_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Portal_Source_Mutation_Response = {
  __typename?: 'listing_publish_portal_source_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Publish_Portal_Source>,
};

export type Listing_Publish_Portal_Source_Obj_Rel_Insert_Input = {
  data: Listing_Publish_Portal_Source_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Portal_Source_On_Conflict>,
};

export type Listing_Publish_Portal_Source_On_Conflict = {
  constraint: Listing_Publish_Portal_Source_Constraint,
  update_columns: Array<Listing_Publish_Portal_Source_Update_Column>,
  where?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>,
};

export type Listing_Publish_Portal_Source_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Portal_Source_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Publish_Portal_Source_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Publish_Portal_Source_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Publish_Portal_Source_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Publish_Status = {
  __typename?: 'listing_publish_status',
  created_at: Scalars['timestamptz'],
  current_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  custom_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  enabled?: Maybe<Scalars['Boolean']>,
  id: Scalars['uuid'],
  is_test?: Maybe<Scalars['Boolean']>,
  listing: Listing,
  listing_id: Scalars['uuid'],
  portal_source: Listing_Publish_Portal_Source_Enum,
  portal_source_id?: Maybe<Scalars['String']>,
  process_job_id?: Maybe<Scalars['String']>,
  publish_status: Listing_Publish_Status_Type_Enum,
  request?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
  test_xml?: Maybe<Scalars['String']>,
  test_xml_name?: Maybe<Scalars['String']>,
  unique_id?: Maybe<Scalars['String']>,
  update_date?: Maybe<Scalars['String']>,
  updated_at: Scalars['timestamptz'],
  xml_file_name?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Aggregate = {
  __typename?: 'listing_publish_status_aggregate',
  aggregate?: Maybe<Listing_Publish_Status_Aggregate_Fields>,
  nodes: Array<Listing_Publish_Status>,
};

export type Listing_Publish_Status_Aggregate_Fields = {
  __typename?: 'listing_publish_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Publish_Status_Max_Fields>,
  min?: Maybe<Listing_Publish_Status_Min_Fields>,
};


export type Listing_Publish_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Publish_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Publish_Status_Max_Order_By>,
  min?: Maybe<Listing_Publish_Status_Min_Order_By>,
};

export type Listing_Publish_Status_Arr_Rel_Insert_Input = {
  data: Array<Listing_Publish_Status_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Status_On_Conflict>,
};

export type Listing_Publish_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Publish_Status_Bool_Exp>>>,
  _not?: Maybe<Listing_Publish_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Publish_Status_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  current_portal_status?: Maybe<Commercial_Status_Type_Enum_Comparison_Exp>,
  custom_portal_status?: Maybe<Commercial_Status_Type_Enum_Comparison_Exp>,
  enabled?: Maybe<Boolean_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  is_test?: Maybe<Boolean_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum_Comparison_Exp>,
  portal_source_id?: Maybe<String_Comparison_Exp>,
  process_job_id?: Maybe<String_Comparison_Exp>,
  publish_status?: Maybe<Listing_Publish_Status_Type_Enum_Comparison_Exp>,
  request?: Maybe<String_Comparison_Exp>,
  response?: Maybe<String_Comparison_Exp>,
  test_xml?: Maybe<String_Comparison_Exp>,
  test_xml_name?: Maybe<String_Comparison_Exp>,
  unique_id?: Maybe<String_Comparison_Exp>,
  update_date?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  xml_file_name?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Publish_Status_Constraint {
  ListingPublishStatusIdKey = 'listing_publish_status_id_key',
  ListingPublishStatusPkey = 'listing_publish_status_pkey'
}

export type Listing_Publish_Status_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  current_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  custom_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  enabled?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['uuid']>,
  is_test?: Maybe<Scalars['Boolean']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum>,
  portal_source_id?: Maybe<Scalars['String']>,
  process_job_id?: Maybe<Scalars['String']>,
  publish_status?: Maybe<Listing_Publish_Status_Type_Enum>,
  request?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
  test_xml?: Maybe<Scalars['String']>,
  test_xml_name?: Maybe<Scalars['String']>,
  unique_id?: Maybe<Scalars['String']>,
  update_date?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  xml_file_name?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Max_Fields = {
  __typename?: 'listing_publish_status_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source_id?: Maybe<Scalars['String']>,
  process_job_id?: Maybe<Scalars['String']>,
  request?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
  test_xml?: Maybe<Scalars['String']>,
  test_xml_name?: Maybe<Scalars['String']>,
  unique_id?: Maybe<Scalars['String']>,
  update_date?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  xml_file_name?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  portal_source_id?: Maybe<Order_By>,
  process_job_id?: Maybe<Order_By>,
  request?: Maybe<Order_By>,
  response?: Maybe<Order_By>,
  test_xml?: Maybe<Order_By>,
  test_xml_name?: Maybe<Order_By>,
  unique_id?: Maybe<Order_By>,
  update_date?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  xml_file_name?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Min_Fields = {
  __typename?: 'listing_publish_status_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source_id?: Maybe<Scalars['String']>,
  process_job_id?: Maybe<Scalars['String']>,
  request?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
  test_xml?: Maybe<Scalars['String']>,
  test_xml_name?: Maybe<Scalars['String']>,
  unique_id?: Maybe<Scalars['String']>,
  update_date?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  xml_file_name?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  portal_source_id?: Maybe<Order_By>,
  process_job_id?: Maybe<Order_By>,
  request?: Maybe<Order_By>,
  response?: Maybe<Order_By>,
  test_xml?: Maybe<Order_By>,
  test_xml_name?: Maybe<Order_By>,
  unique_id?: Maybe<Order_By>,
  update_date?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  xml_file_name?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Mutation_Response = {
  __typename?: 'listing_publish_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Publish_Status>,
};

export type Listing_Publish_Status_Obj_Rel_Insert_Input = {
  data: Listing_Publish_Status_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Status_On_Conflict>,
};

export type Listing_Publish_Status_On_Conflict = {
  constraint: Listing_Publish_Status_Constraint,
  update_columns: Array<Listing_Publish_Status_Update_Column>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>,
};

export type Listing_Publish_Status_Order_By = {
  created_at?: Maybe<Order_By>,
  current_portal_status?: Maybe<Order_By>,
  custom_portal_status?: Maybe<Order_By>,
  enabled?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  is_test?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  portal_source?: Maybe<Order_By>,
  portal_source_id?: Maybe<Order_By>,
  process_job_id?: Maybe<Order_By>,
  publish_status?: Maybe<Order_By>,
  request?: Maybe<Order_By>,
  response?: Maybe<Order_By>,
  test_xml?: Maybe<Order_By>,
  test_xml_name?: Maybe<Order_By>,
  unique_id?: Maybe<Order_By>,
  update_date?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  xml_file_name?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Pk_Columns_Input = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid'],
};

export enum Listing_Publish_Status_Select_Column {
  CreatedAt = 'created_at',
  CurrentPortalStatus = 'current_portal_status',
  CustomPortalStatus = 'custom_portal_status',
  Enabled = 'enabled',
  Id = 'id',
  IsTest = 'is_test',
  ListingId = 'listing_id',
  PortalSource = 'portal_source',
  PortalSourceId = 'portal_source_id',
  ProcessJobId = 'process_job_id',
  PublishStatus = 'publish_status',
  Request = 'request',
  Response = 'response',
  TestXml = 'test_xml',
  TestXmlName = 'test_xml_name',
  UniqueId = 'unique_id',
  UpdateDate = 'update_date',
  UpdatedAt = 'updated_at',
  XmlFileName = 'xml_file_name'
}

export type Listing_Publish_Status_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  current_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  custom_portal_status?: Maybe<Commercial_Status_Type_Enum>,
  enabled?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['uuid']>,
  is_test?: Maybe<Scalars['Boolean']>,
  listing_id?: Maybe<Scalars['uuid']>,
  portal_source?: Maybe<Listing_Publish_Portal_Source_Enum>,
  portal_source_id?: Maybe<Scalars['String']>,
  process_job_id?: Maybe<Scalars['String']>,
  publish_status?: Maybe<Listing_Publish_Status_Type_Enum>,
  request?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
  test_xml?: Maybe<Scalars['String']>,
  test_xml_name?: Maybe<Scalars['String']>,
  unique_id?: Maybe<Scalars['String']>,
  update_date?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  xml_file_name?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Type = {
  __typename?: 'listing_publish_status_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Listing_Publish_Status_Type_Aggregate = {
  __typename?: 'listing_publish_status_type_aggregate',
  aggregate?: Maybe<Listing_Publish_Status_Type_Aggregate_Fields>,
  nodes: Array<Listing_Publish_Status_Type>,
};

export type Listing_Publish_Status_Type_Aggregate_Fields = {
  __typename?: 'listing_publish_status_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Publish_Status_Type_Max_Fields>,
  min?: Maybe<Listing_Publish_Status_Type_Min_Fields>,
};


export type Listing_Publish_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Publish_Status_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Publish_Status_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Publish_Status_Type_Max_Order_By>,
  min?: Maybe<Listing_Publish_Status_Type_Min_Order_By>,
};

export type Listing_Publish_Status_Type_Arr_Rel_Insert_Input = {
  data: Array<Listing_Publish_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Status_Type_On_Conflict>,
};

export type Listing_Publish_Status_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Publish_Status_Type_Bool_Exp>>>,
  _not?: Maybe<Listing_Publish_Status_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Publish_Status_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Listing_Publish_Status_Type_Constraint {
  ListingPublishStatusTypePkey = 'listing_publish_status_type_pkey'
}

export enum Listing_Publish_Status_Type_Enum {
  Draft = 'draft',
  Error = 'error',
  Processed = 'processed',
  Processing = 'processing',
  Queued = 'queued'
}

export type Listing_Publish_Status_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Listing_Publish_Status_Type_Enum>,
  _in?: Maybe<Array<Listing_Publish_Status_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Listing_Publish_Status_Type_Enum>,
  _nin?: Maybe<Array<Listing_Publish_Status_Type_Enum>>,
};

export type Listing_Publish_Status_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Type_Max_Fields = {
  __typename?: 'listing_publish_status_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Type_Min_Fields = {
  __typename?: 'listing_publish_status_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Listing_Publish_Status_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Type_Mutation_Response = {
  __typename?: 'listing_publish_status_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Publish_Status_Type>,
};

export type Listing_Publish_Status_Type_Obj_Rel_Insert_Input = {
  data: Listing_Publish_Status_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Status_Type_On_Conflict>,
};

export type Listing_Publish_Status_Type_On_Conflict = {
  constraint: Listing_Publish_Status_Type_Constraint,
  update_columns: Array<Listing_Publish_Status_Type_Update_Column>,
  where?: Maybe<Listing_Publish_Status_Type_Bool_Exp>,
};

export type Listing_Publish_Status_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Listing_Publish_Status_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Listing_Publish_Status_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Listing_Publish_Status_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Listing_Publish_Status_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Listing_Publish_Status_Update_Column {
  CreatedAt = 'created_at',
  CurrentPortalStatus = 'current_portal_status',
  CustomPortalStatus = 'custom_portal_status',
  Enabled = 'enabled',
  Id = 'id',
  IsTest = 'is_test',
  ListingId = 'listing_id',
  PortalSource = 'portal_source',
  PortalSourceId = 'portal_source_id',
  ProcessJobId = 'process_job_id',
  PublishStatus = 'publish_status',
  Request = 'request',
  Response = 'response',
  TestXml = 'test_xml',
  TestXmlName = 'test_xml_name',
  UniqueId = 'unique_id',
  UpdateDate = 'update_date',
  UpdatedAt = 'updated_at',
  XmlFileName = 'xml_file_name'
}

export type Listing_Search = {
  __typename?: 'listing_search',
  id?: Maybe<Scalars['uuid']>,
  listing_search_data?: Maybe<Listing>,
  search_source?: Maybe<Scalars['String']>,
};

export type Listing_Search_Aggregate = {
  __typename?: 'listing_search_aggregate',
  aggregate?: Maybe<Listing_Search_Aggregate_Fields>,
  nodes: Array<Listing_Search>,
};

export type Listing_Search_Aggregate_Fields = {
  __typename?: 'listing_search_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Search_Max_Fields>,
  min?: Maybe<Listing_Search_Min_Fields>,
};


export type Listing_Search_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Search_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Search_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Search_Max_Order_By>,
  min?: Maybe<Listing_Search_Min_Order_By>,
};

export type Listing_Search_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Search_Bool_Exp>>>,
  _not?: Maybe<Listing_Search_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Search_Bool_Exp>>>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing_search_data?: Maybe<Listing_Bool_Exp>,
  search_source?: Maybe<String_Comparison_Exp>,
};

export type Listing_Search_Max_Fields = {
  __typename?: 'listing_search_max_fields',
  id?: Maybe<Scalars['uuid']>,
  search_source?: Maybe<Scalars['String']>,
};

export type Listing_Search_Max_Order_By = {
  id?: Maybe<Order_By>,
  search_source?: Maybe<Order_By>,
};

export type Listing_Search_Min_Fields = {
  __typename?: 'listing_search_min_fields',
  id?: Maybe<Scalars['uuid']>,
  search_source?: Maybe<Scalars['String']>,
};

export type Listing_Search_Min_Order_By = {
  id?: Maybe<Order_By>,
  search_source?: Maybe<Order_By>,
};

export type Listing_Search_Order_By = {
  id?: Maybe<Order_By>,
  listing_search_data?: Maybe<Listing_Order_By>,
  search_source?: Maybe<Order_By>,
};

export enum Listing_Search_Select_Column {
  Id = 'id',
  SearchSource = 'search_source'
}

export enum Listing_Select_Column {
  AgentPointId = 'agent_point_id',
  AuctionDateTime = 'auction_dateTime',
  AuctionLocation = 'auction_location',
  AuctionOnline = 'auction_online',
  Authority = 'authority',
  AvailableFrom = 'availableFrom',
  Bond = 'bond',
  CommercialStatus = 'commercial_status',
  ContactPreference = 'contactPreference',
  CreatedAt = 'created_at',
  CrossOver = 'crossOver',
  DeliveryAddress_1 = 'delivery_address_1',
  DeliveryAddress_2 = 'delivery_address_2',
  DeliveryAddressPostcode = 'delivery_address_postcode',
  DeliveryAddressState = 'delivery_address_state',
  DeliveryAddressStreet = 'delivery_address_street',
  DeliveryAddressStreetNumber = 'delivery_address_streetNumber',
  DeliveryAddressSuburb = 'delivery_address_suburb',
  DeliveryAddressSuggestedGeoLocationLatitude = 'delivery_address_suggestedGeoLocation_latitude',
  DeliveryAddressSuggestedGeoLocationLongitude = 'delivery_address_suggestedGeoLocation_longitude',
  DeliveryAddressUnitNumber = 'delivery_address_unitNumber',
  DeliveryToPropertyAddress = 'delivery_to_property_address',
  Description = 'description',
  DomainAdId = 'domainAdId',
  EnquiryCode = 'enquiry_code',
  Experiments = 'experiments',
  ExternalLink = 'externalLink',
  Features = 'features',
  Id = 'id',
  InspectionDetailsInspectionDescription = 'inspectionDetails_inspectionDescription',
  IsNewDevelopment = 'isNewDevelopment',
  IsRural = 'isRural',
  LifeStyleType = 'lifeStyleType',
  ListingAction = 'listingAction',
  OtherEnquiryEmail = 'otherEnquiryEmail',
  OwnerId = 'owner_id',
  PriceAsking = 'price_asking',
  PriceDisplayOption = 'price_displayOption',
  PriceDisplayText = 'price_displayText',
  PriceFrom = 'price_from',
  PriceSingle = 'price_single',
  PriceTextOption = 'price_textOption',
  PriceTo = 'price_to',
  PriceView = 'price_view',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressMunicipality = 'propertyDetails_address_municipality',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressPostcodeBeforeCheckout = 'propertyDetails_address_postcode_before_checkout',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStateBeforeCheckout = 'propertyDetails_address_state_before_checkout',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetDirectoryPage = 'propertyDetails_address_streetDirectory_page',
  PropertyDetailsAddressStreetDirectoryReference = 'propertyDetails_address_streetDirectory_reference',
  PropertyDetailsAddressStreetDirectoryType = 'propertyDetails_address_streetDirectory_type',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressSuburbBeforeCheckout = 'propertyDetails_address_suburb_before_checkout',
  PropertyDetailsAddressSuggestedGeoLocation = 'propertyDetails_address_suggestedGeoLocation',
  PropertyDetailsAddressSuggestedGeoLocationLatitude = 'propertyDetails_address_suggestedGeoLocation_latitude',
  PropertyDetailsAddressSuggestedGeoLocationLongitude = 'propertyDetails_address_suggestedGeoLocation_longitude',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PropertyDetailsAreaFrom = 'propertyDetails_area_from',
  PropertyDetailsAreaTo = 'propertyDetails_area_to',
  PropertyDetailsAreaUnit = 'propertyDetails_area_unit',
  PropertyDetailsAreaValue = 'propertyDetails_area_value',
  PropertyDetailsBathRooms = 'propertyDetails_bathRooms',
  PropertyDetailsBedRooms = 'propertyDetails_bedRooms',
  PropertyDetailsCarSpaces = 'propertyDetails_carSpaces',
  PropertyDetailsCarportSpaces = 'propertyDetails_carportSpaces',
  PropertyDetailsEnergyEfficiencyRating = 'propertyDetails_energyEfficiencyRating',
  PropertyDetailsGarageSpaces = 'propertyDetails_garageSpaces',
  PropertyDetailsLandAreaDepthLeft = 'propertyDetails_landArea_depth_left',
  PropertyDetailsLandAreaDepthRear = 'propertyDetails_landArea_depth_rear',
  PropertyDetailsLandAreaDepthRight = 'propertyDetails_landArea_depth_right',
  PropertyDetailsLandAreaDepthUnit = 'propertyDetails_landArea_depth_unit',
  PropertyDetailsLandAreaFrom = 'propertyDetails_landArea_from',
  PropertyDetailsLandAreaFrontage = 'propertyDetails_landArea_frontage',
  PropertyDetailsLandAreaFrontageUnit = 'propertyDetails_landArea_frontage_unit',
  PropertyDetailsLandAreaTo = 'propertyDetails_landArea_to',
  PropertyDetailsLandAreaUnit = 'propertyDetails_landArea_unit',
  PropertyDetailsLandAreaValue = 'propertyDetails_landArea_value',
  PropertyDetailsParkingInfoInformation = 'propertyDetails_parkingInfo_information',
  PropertyDetailsPropertyType = 'propertyDetails_propertyType',
  PropertyDetailsPropertyTypeHotWaterServiceType = 'propertyDetails_propertyType_hotWaterServiceType',
  PropertyDetailsYearBuilt = 'propertyDetails_yearBuilt',
  ProviderAdId = 'providerAdId',
  PublishingStatus = 'publishing_status',
  SaleType = 'saleType',
  SalesforceId = 'salesforce_id',
  SearchPrice = 'search_price',
  SfUpdatedAt = 'sf_updated_at',
  SoiComparableData = 'soi_comparableData',
  SoiComparableDataComparablePropertyDateOf = 'soi_comparableData_comparableProperty_dateOf',
  SoiComparableDataComparablePropertySoldPr = 'soi_comparableData_comparableProperty_soldPr',
  SoiComparableDataDeclarationText = 'soi_comparableData_declarationText',
  SoiDocumentationUrl = 'soi_documentationUrl',
  SoiEstimatedPrice = 'soi_estimatedPrice',
  SoiEstimatedPriceFrom = 'soi_estimatedPrice_from',
  SoiEstimatedPriceTo = 'soi_estimatedPrice_to',
  SoiSuburbMedianPrice = 'soi_suburbMedianPrice',
  SoiSuburbMedianPriceDeclarationText = 'soi_suburbMedianPrice_declarationText',
  SoiSuburbMedianPriceMedianPrice = 'soi_suburbMedianPrice_medianPrice',
  SoiSuburbMedianPricePostcode = 'soi_suburbMedianPrice_postcode',
  SoiSuburbMedianPricePriceType = 'soi_suburbMedianPrice_priceType',
  SoiSuburbMedianPriceSource = 'soi_suburbMedianPrice_source',
  SoiSuburbMedianPriceSourceDateFrom = 'soi_suburbMedianPrice_sourceDateFrom',
  SoiSuburbMedianPriceSourceDateTo = 'soi_suburbMedianPrice_sourceDateTo',
  SoiSuburbMedianPriceSuburb = 'soi_suburbMedianPrice_suburb',
  Status = 'status',
  Summary = 'summary',
  SupplementaryDescription = 'supplementary_description',
  SupplementaryMetadataDescription = 'supplementary_metadata_description',
  SupplementaryMetadataMeasurement = 'supplementary_metadata_measurement',
  SupplementaryMetadataMeasurementUnit = 'supplementary_metadata_measurementUnit',
  SupplementaryMetadataName = 'supplementary_metadata_name',
  SupplementaryName = 'supplementary_name',
  SupplementaryTypes = 'supplementary_types',
  TemporaryAddOnFlag = 'temporary_add_on_flag',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Listing_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Commercial_Status_Type_Enum>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  delivery_address_1?: Maybe<Scalars['String']>,
  delivery_address_2?: Maybe<Scalars['String']>,
  delivery_address_postcode?: Maybe<Scalars['String']>,
  delivery_address_state?: Maybe<Scalars['String']>,
  delivery_address_street?: Maybe<Scalars['String']>,
  delivery_address_streetNumber?: Maybe<Scalars['String']>,
  delivery_address_suburb?: Maybe<Scalars['String']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  delivery_address_unitNumber?: Maybe<Scalars['String']>,
  delivery_to_property_address?: Maybe<Scalars['Boolean']>,
  description?: Maybe<Scalars['String']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  experiments?: Maybe<Scalars['jsonb']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Listing_Document_Status_Enum>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Publishing_Status_Type_Enum>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Zone_Type_Enum>,
};

export type Listing_Soi_Comparable_Property = {
  __typename?: 'listing_soi_comparable_property',
  address?: Maybe<Scalars['String']>,
  address_postcode?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_street?: Maybe<Scalars['String']>,
  address_streetNumber?: Maybe<Scalars['String']>,
  address_suburb?: Maybe<Scalars['String']>,
  address_unitNumber?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  date_of_sale?: Maybe<Scalars['timestamptz']>,
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  sold_price?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Soi_Comparable_Property_Aggregate = {
  __typename?: 'listing_soi_comparable_property_aggregate',
  aggregate?: Maybe<Listing_Soi_Comparable_Property_Aggregate_Fields>,
  nodes: Array<Listing_Soi_Comparable_Property>,
};

export type Listing_Soi_Comparable_Property_Aggregate_Fields = {
  __typename?: 'listing_soi_comparable_property_aggregate_fields',
  avg?: Maybe<Listing_Soi_Comparable_Property_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Listing_Soi_Comparable_Property_Max_Fields>,
  min?: Maybe<Listing_Soi_Comparable_Property_Min_Fields>,
  stddev?: Maybe<Listing_Soi_Comparable_Property_Stddev_Fields>,
  stddev_pop?: Maybe<Listing_Soi_Comparable_Property_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Listing_Soi_Comparable_Property_Stddev_Samp_Fields>,
  sum?: Maybe<Listing_Soi_Comparable_Property_Sum_Fields>,
  var_pop?: Maybe<Listing_Soi_Comparable_Property_Var_Pop_Fields>,
  var_samp?: Maybe<Listing_Soi_Comparable_Property_Var_Samp_Fields>,
  variance?: Maybe<Listing_Soi_Comparable_Property_Variance_Fields>,
};


export type Listing_Soi_Comparable_Property_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Listing_Soi_Comparable_Property_Aggregate_Order_By = {
  avg?: Maybe<Listing_Soi_Comparable_Property_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Listing_Soi_Comparable_Property_Max_Order_By>,
  min?: Maybe<Listing_Soi_Comparable_Property_Min_Order_By>,
  stddev?: Maybe<Listing_Soi_Comparable_Property_Stddev_Order_By>,
  stddev_pop?: Maybe<Listing_Soi_Comparable_Property_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Listing_Soi_Comparable_Property_Stddev_Samp_Order_By>,
  sum?: Maybe<Listing_Soi_Comparable_Property_Sum_Order_By>,
  var_pop?: Maybe<Listing_Soi_Comparable_Property_Var_Pop_Order_By>,
  var_samp?: Maybe<Listing_Soi_Comparable_Property_Var_Samp_Order_By>,
  variance?: Maybe<Listing_Soi_Comparable_Property_Variance_Order_By>,
};

export type Listing_Soi_Comparable_Property_Arr_Rel_Insert_Input = {
  data: Array<Listing_Soi_Comparable_Property_Insert_Input>,
  on_conflict?: Maybe<Listing_Soi_Comparable_Property_On_Conflict>,
};

export type Listing_Soi_Comparable_Property_Avg_Fields = {
  __typename?: 'listing_soi_comparable_property_avg_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Avg_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Listing_Soi_Comparable_Property_Bool_Exp>>>,
  _not?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Listing_Soi_Comparable_Property_Bool_Exp>>>,
  address?: Maybe<String_Comparison_Exp>,
  address_postcode?: Maybe<String_Comparison_Exp>,
  address_state?: Maybe<String_Comparison_Exp>,
  address_street?: Maybe<String_Comparison_Exp>,
  address_streetNumber?: Maybe<String_Comparison_Exp>,
  address_suburb?: Maybe<String_Comparison_Exp>,
  address_unitNumber?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  date_of_sale?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  sold_price?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Listing_Soi_Comparable_Property_Constraint {
  ListingSoiComparablePropertyPkey = 'listing_soi_comparable_property_pkey'
}

export type Listing_Soi_Comparable_Property_Inc_Input = {
  sold_price?: Maybe<Scalars['Int']>,
};

export type Listing_Soi_Comparable_Property_Insert_Input = {
  address?: Maybe<Scalars['String']>,
  address_postcode?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_street?: Maybe<Scalars['String']>,
  address_streetNumber?: Maybe<Scalars['String']>,
  address_suburb?: Maybe<Scalars['String']>,
  address_unitNumber?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  date_of_sale?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  sold_price?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Soi_Comparable_Property_Max_Fields = {
  __typename?: 'listing_soi_comparable_property_max_fields',
  address?: Maybe<Scalars['String']>,
  address_postcode?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_street?: Maybe<Scalars['String']>,
  address_streetNumber?: Maybe<Scalars['String']>,
  address_suburb?: Maybe<Scalars['String']>,
  address_unitNumber?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  date_of_sale?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  sold_price?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Soi_Comparable_Property_Max_Order_By = {
  address?: Maybe<Order_By>,
  address_postcode?: Maybe<Order_By>,
  address_state?: Maybe<Order_By>,
  address_street?: Maybe<Order_By>,
  address_streetNumber?: Maybe<Order_By>,
  address_suburb?: Maybe<Order_By>,
  address_unitNumber?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  date_of_sale?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  sold_price?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Min_Fields = {
  __typename?: 'listing_soi_comparable_property_min_fields',
  address?: Maybe<Scalars['String']>,
  address_postcode?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_street?: Maybe<Scalars['String']>,
  address_streetNumber?: Maybe<Scalars['String']>,
  address_suburb?: Maybe<Scalars['String']>,
  address_unitNumber?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  date_of_sale?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  sold_price?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Soi_Comparable_Property_Min_Order_By = {
  address?: Maybe<Order_By>,
  address_postcode?: Maybe<Order_By>,
  address_state?: Maybe<Order_By>,
  address_street?: Maybe<Order_By>,
  address_streetNumber?: Maybe<Order_By>,
  address_suburb?: Maybe<Order_By>,
  address_unitNumber?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  date_of_sale?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  sold_price?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Mutation_Response = {
  __typename?: 'listing_soi_comparable_property_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Listing_Soi_Comparable_Property>,
};

export type Listing_Soi_Comparable_Property_Obj_Rel_Insert_Input = {
  data: Listing_Soi_Comparable_Property_Insert_Input,
  on_conflict?: Maybe<Listing_Soi_Comparable_Property_On_Conflict>,
};

export type Listing_Soi_Comparable_Property_On_Conflict = {
  constraint: Listing_Soi_Comparable_Property_Constraint,
  update_columns: Array<Listing_Soi_Comparable_Property_Update_Column>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>,
};

export type Listing_Soi_Comparable_Property_Order_By = {
  address?: Maybe<Order_By>,
  address_postcode?: Maybe<Order_By>,
  address_state?: Maybe<Order_By>,
  address_street?: Maybe<Order_By>,
  address_streetNumber?: Maybe<Order_By>,
  address_suburb?: Maybe<Order_By>,
  address_unitNumber?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  date_of_sale?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  sold_price?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Listing_Soi_Comparable_Property_Select_Column {
  Address = 'address',
  AddressPostcode = 'address_postcode',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreetNumber = 'address_streetNumber',
  AddressSuburb = 'address_suburb',
  AddressUnitNumber = 'address_unitNumber',
  CreatedAt = 'created_at',
  DateOfSale = 'date_of_sale',
  Id = 'id',
  ListingId = 'listing_id',
  SoldPrice = 'sold_price',
  UpdatedAt = 'updated_at'
}

export type Listing_Soi_Comparable_Property_Set_Input = {
  address?: Maybe<Scalars['String']>,
  address_postcode?: Maybe<Scalars['String']>,
  address_state?: Maybe<Scalars['String']>,
  address_street?: Maybe<Scalars['String']>,
  address_streetNumber?: Maybe<Scalars['String']>,
  address_suburb?: Maybe<Scalars['String']>,
  address_unitNumber?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  date_of_sale?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  sold_price?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Listing_Soi_Comparable_Property_Stddev_Fields = {
  __typename?: 'listing_soi_comparable_property_stddev_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Stddev_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Stddev_Pop_Fields = {
  __typename?: 'listing_soi_comparable_property_stddev_pop_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Stddev_Pop_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Stddev_Samp_Fields = {
  __typename?: 'listing_soi_comparable_property_stddev_samp_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Stddev_Samp_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Sum_Fields = {
  __typename?: 'listing_soi_comparable_property_sum_fields',
  sold_price?: Maybe<Scalars['Int']>,
};

export type Listing_Soi_Comparable_Property_Sum_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export enum Listing_Soi_Comparable_Property_Update_Column {
  Address = 'address',
  AddressPostcode = 'address_postcode',
  AddressState = 'address_state',
  AddressStreet = 'address_street',
  AddressStreetNumber = 'address_streetNumber',
  AddressSuburb = 'address_suburb',
  AddressUnitNumber = 'address_unitNumber',
  CreatedAt = 'created_at',
  DateOfSale = 'date_of_sale',
  Id = 'id',
  ListingId = 'listing_id',
  SoldPrice = 'sold_price',
  UpdatedAt = 'updated_at'
}

export type Listing_Soi_Comparable_Property_Var_Pop_Fields = {
  __typename?: 'listing_soi_comparable_property_var_pop_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Var_Pop_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Var_Samp_Fields = {
  __typename?: 'listing_soi_comparable_property_var_samp_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Var_Samp_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Soi_Comparable_Property_Variance_Fields = {
  __typename?: 'listing_soi_comparable_property_variance_fields',
  sold_price?: Maybe<Scalars['Float']>,
};

export type Listing_Soi_Comparable_Property_Variance_Order_By = {
  sold_price?: Maybe<Order_By>,
};

export type Listing_Stddev_Fields = {
  __typename?: 'listing_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Stddev_Pop_Fields = {
  __typename?: 'listing_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Stddev_Samp_Fields = {
  __typename?: 'listing_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Sum_Fields = {
  __typename?: 'listing_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Listing_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export enum Listing_Update_Column {
  AgentPointId = 'agent_point_id',
  AuctionDateTime = 'auction_dateTime',
  AuctionLocation = 'auction_location',
  AuctionOnline = 'auction_online',
  Authority = 'authority',
  AvailableFrom = 'availableFrom',
  Bond = 'bond',
  CommercialStatus = 'commercial_status',
  ContactPreference = 'contactPreference',
  CreatedAt = 'created_at',
  CrossOver = 'crossOver',
  DeliveryAddress_1 = 'delivery_address_1',
  DeliveryAddress_2 = 'delivery_address_2',
  DeliveryAddressPostcode = 'delivery_address_postcode',
  DeliveryAddressState = 'delivery_address_state',
  DeliveryAddressStreet = 'delivery_address_street',
  DeliveryAddressStreetNumber = 'delivery_address_streetNumber',
  DeliveryAddressSuburb = 'delivery_address_suburb',
  DeliveryAddressSuggestedGeoLocationLatitude = 'delivery_address_suggestedGeoLocation_latitude',
  DeliveryAddressSuggestedGeoLocationLongitude = 'delivery_address_suggestedGeoLocation_longitude',
  DeliveryAddressUnitNumber = 'delivery_address_unitNumber',
  DeliveryToPropertyAddress = 'delivery_to_property_address',
  Description = 'description',
  DomainAdId = 'domainAdId',
  EnquiryCode = 'enquiry_code',
  Experiments = 'experiments',
  ExternalLink = 'externalLink',
  Features = 'features',
  Id = 'id',
  InspectionDetailsInspectionDescription = 'inspectionDetails_inspectionDescription',
  IsNewDevelopment = 'isNewDevelopment',
  IsRural = 'isRural',
  LifeStyleType = 'lifeStyleType',
  ListingAction = 'listingAction',
  OtherEnquiryEmail = 'otherEnquiryEmail',
  OwnerId = 'owner_id',
  PriceAsking = 'price_asking',
  PriceDisplayOption = 'price_displayOption',
  PriceDisplayText = 'price_displayText',
  PriceFrom = 'price_from',
  PriceSingle = 'price_single',
  PriceTextOption = 'price_textOption',
  PriceTo = 'price_to',
  PriceView = 'price_view',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressMunicipality = 'propertyDetails_address_municipality',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressPostcodeBeforeCheckout = 'propertyDetails_address_postcode_before_checkout',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStateBeforeCheckout = 'propertyDetails_address_state_before_checkout',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetDirectoryPage = 'propertyDetails_address_streetDirectory_page',
  PropertyDetailsAddressStreetDirectoryReference = 'propertyDetails_address_streetDirectory_reference',
  PropertyDetailsAddressStreetDirectoryType = 'propertyDetails_address_streetDirectory_type',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressSuburbBeforeCheckout = 'propertyDetails_address_suburb_before_checkout',
  PropertyDetailsAddressSuggestedGeoLocation = 'propertyDetails_address_suggestedGeoLocation',
  PropertyDetailsAddressSuggestedGeoLocationLatitude = 'propertyDetails_address_suggestedGeoLocation_latitude',
  PropertyDetailsAddressSuggestedGeoLocationLongitude = 'propertyDetails_address_suggestedGeoLocation_longitude',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PropertyDetailsAreaFrom = 'propertyDetails_area_from',
  PropertyDetailsAreaTo = 'propertyDetails_area_to',
  PropertyDetailsAreaUnit = 'propertyDetails_area_unit',
  PropertyDetailsAreaValue = 'propertyDetails_area_value',
  PropertyDetailsBathRooms = 'propertyDetails_bathRooms',
  PropertyDetailsBedRooms = 'propertyDetails_bedRooms',
  PropertyDetailsCarSpaces = 'propertyDetails_carSpaces',
  PropertyDetailsCarportSpaces = 'propertyDetails_carportSpaces',
  PropertyDetailsEnergyEfficiencyRating = 'propertyDetails_energyEfficiencyRating',
  PropertyDetailsGarageSpaces = 'propertyDetails_garageSpaces',
  PropertyDetailsLandAreaDepthLeft = 'propertyDetails_landArea_depth_left',
  PropertyDetailsLandAreaDepthRear = 'propertyDetails_landArea_depth_rear',
  PropertyDetailsLandAreaDepthRight = 'propertyDetails_landArea_depth_right',
  PropertyDetailsLandAreaDepthUnit = 'propertyDetails_landArea_depth_unit',
  PropertyDetailsLandAreaFrom = 'propertyDetails_landArea_from',
  PropertyDetailsLandAreaFrontage = 'propertyDetails_landArea_frontage',
  PropertyDetailsLandAreaFrontageUnit = 'propertyDetails_landArea_frontage_unit',
  PropertyDetailsLandAreaTo = 'propertyDetails_landArea_to',
  PropertyDetailsLandAreaUnit = 'propertyDetails_landArea_unit',
  PropertyDetailsLandAreaValue = 'propertyDetails_landArea_value',
  PropertyDetailsParkingInfoInformation = 'propertyDetails_parkingInfo_information',
  PropertyDetailsPropertyType = 'propertyDetails_propertyType',
  PropertyDetailsPropertyTypeHotWaterServiceType = 'propertyDetails_propertyType_hotWaterServiceType',
  PropertyDetailsYearBuilt = 'propertyDetails_yearBuilt',
  ProviderAdId = 'providerAdId',
  PublishingStatus = 'publishing_status',
  SaleType = 'saleType',
  SalesforceId = 'salesforce_id',
  SearchPrice = 'search_price',
  SfUpdatedAt = 'sf_updated_at',
  SoiComparableData = 'soi_comparableData',
  SoiComparableDataComparablePropertyDateOf = 'soi_comparableData_comparableProperty_dateOf',
  SoiComparableDataComparablePropertySoldPr = 'soi_comparableData_comparableProperty_soldPr',
  SoiComparableDataDeclarationText = 'soi_comparableData_declarationText',
  SoiDocumentationUrl = 'soi_documentationUrl',
  SoiEstimatedPrice = 'soi_estimatedPrice',
  SoiEstimatedPriceFrom = 'soi_estimatedPrice_from',
  SoiEstimatedPriceTo = 'soi_estimatedPrice_to',
  SoiSuburbMedianPrice = 'soi_suburbMedianPrice',
  SoiSuburbMedianPriceDeclarationText = 'soi_suburbMedianPrice_declarationText',
  SoiSuburbMedianPriceMedianPrice = 'soi_suburbMedianPrice_medianPrice',
  SoiSuburbMedianPricePostcode = 'soi_suburbMedianPrice_postcode',
  SoiSuburbMedianPricePriceType = 'soi_suburbMedianPrice_priceType',
  SoiSuburbMedianPriceSource = 'soi_suburbMedianPrice_source',
  SoiSuburbMedianPriceSourceDateFrom = 'soi_suburbMedianPrice_sourceDateFrom',
  SoiSuburbMedianPriceSourceDateTo = 'soi_suburbMedianPrice_sourceDateTo',
  SoiSuburbMedianPriceSuburb = 'soi_suburbMedianPrice_suburb',
  Status = 'status',
  Summary = 'summary',
  SupplementaryDescription = 'supplementary_description',
  SupplementaryMetadataDescription = 'supplementary_metadata_description',
  SupplementaryMetadataMeasurement = 'supplementary_metadata_measurement',
  SupplementaryMetadataMeasurementUnit = 'supplementary_metadata_measurementUnit',
  SupplementaryMetadataName = 'supplementary_metadata_name',
  SupplementaryName = 'supplementary_name',
  SupplementaryTypes = 'supplementary_types',
  TemporaryAddOnFlag = 'temporary_add_on_flag',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Listing_Var_Pop_Fields = {
  __typename?: 'listing_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Var_Samp_Fields = {
  __typename?: 'listing_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Listing_Variance_Fields = {
  __typename?: 'listing_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Listing_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  delivery_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type ListingResponse = {
  __typename?: 'ListingResponse',
  updated?: Maybe<Scalars['Boolean']>,
};

export type Location_Auto_Complete = {
  __typename?: 'location_auto_complete',
  full_location: Scalars['String'],
  id: Scalars['String'],
  location_type: Scalars['String'],
  state_territory: Scalars['String'],
};

export type Location_Auto_Complete_Group = {
  __typename?: 'location_auto_complete_group',
  completions?: Maybe<Array<Maybe<Location_Auto_Complete>>>,
};

export type MailSentResponse = {
  __typename?: 'MailSentResponse',
  error?: Maybe<Scalars['String']>,
  message?: Maybe<Scalars['String']>,
  success?: Maybe<Scalars['Boolean']>,
};

export type Metro_Type = {
  __typename?: 'metro_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Metro_Type_Aggregate = {
  __typename?: 'metro_type_aggregate',
  aggregate?: Maybe<Metro_Type_Aggregate_Fields>,
  nodes: Array<Metro_Type>,
};

export type Metro_Type_Aggregate_Fields = {
  __typename?: 'metro_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Metro_Type_Max_Fields>,
  min?: Maybe<Metro_Type_Min_Fields>,
};


export type Metro_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Metro_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Metro_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Metro_Type_Max_Order_By>,
  min?: Maybe<Metro_Type_Min_Order_By>,
};

export type Metro_Type_Arr_Rel_Insert_Input = {
  data: Array<Metro_Type_Insert_Input>,
  on_conflict?: Maybe<Metro_Type_On_Conflict>,
};

export type Metro_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Metro_Type_Bool_Exp>>>,
  _not?: Maybe<Metro_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Metro_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Metro_Type_Constraint {
  MetroTypePkey = 'MetroType_pkey'
}

export enum Metro_Type_Enum {
  Melbourne = 'Melbourne',
  Sydney = 'Sydney'
}

export type Metro_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Metro_Type_Enum>,
  _in?: Maybe<Array<Metro_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Metro_Type_Enum>,
  _nin?: Maybe<Array<Metro_Type_Enum>>,
};

export type Metro_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Metro_Type_Max_Fields = {
  __typename?: 'metro_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Metro_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Metro_Type_Min_Fields = {
  __typename?: 'metro_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Metro_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Metro_Type_Mutation_Response = {
  __typename?: 'metro_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Metro_Type>,
};

export type Metro_Type_Obj_Rel_Insert_Input = {
  data: Metro_Type_Insert_Input,
  on_conflict?: Maybe<Metro_Type_On_Conflict>,
};

export type Metro_Type_On_Conflict = {
  constraint: Metro_Type_Constraint,
  update_columns: Array<Metro_Type_Update_Column>,
  where?: Maybe<Metro_Type_Bool_Exp>,
};

export type Metro_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Metro_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Metro_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Metro_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Metro_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type MobileCodeVerification = {
  __typename?: 'mobileCodeVerification',
  error?: Maybe<Scalars['String']>,
  jwt: Scalars['String'],
  status: Scalars['String'],
};

export type Modify_Order_Item_Addon_Response = {
  __typename?: 'modify_order_item_addon_response',
  affected_rows: Scalars['numeric'],
};

export type Mutation = {
  __typename?: 'Mutation',
  add_campaign_to_order?: Maybe<Add_Campaign_To_Order_Response>,
  apply_coupon?: Maybe<Coupon_Update_Order_Response>,
  cancel_order?: Maybe<Cancel_Order_Response>,
  checkout_order?: Maybe<Checkout_Order_Response>,
  clear_addons_from_order?: Maybe<Clear_Addons_From_Order_Response>,
  clear_normal_addons_from_order?: Maybe<Clear_Normal_Addons_From_Order_Response>,
  create_order?: Maybe<Create_Order_Response>,
  delist_from_all_portals?: Maybe<Delist_Response>,
  doc_verification_email?: Maybe<MailSentResponse>,
  fail_publish_listing?: Maybe<ListingResponse>,
  list_listing?: Maybe<ListingResponse>,
  modify_order_item_addon?: Maybe<Modify_Order_Item_Addon_Response>,
  on_hold_listing?: Maybe<ListingResponse>,
  openpay_check_transaction?: Maybe<Check_Transaction_Response>,
  openpay_pay?: Maybe<Pay_Response>,
  pay_order?: Maybe<Paid_Order_Response>,
  paypal_check_transaction?: Maybe<Check_Transaction_Response>,
  paypal_pay?: Maybe<Pay_Response>,
  pending_publish_listing?: Maybe<ListingResponse>,
  poli_check_transaction?: Maybe<Check_Transaction_Response>,
  poli_pay?: Maybe<Pay_Response>,
  reactivate_listing?: Maybe<ListingResponse>,
  recalculate_coupon_discounts_listing?: Maybe<Coupon_Update_Order_Response>,
  recalculate_coupon_discounts_order?: Maybe<Coupon_Update_Order_Response>,
  remove_order?: Maybe<Remove_Order_Response>,
  remove_user?: Maybe<Remove_User_Response>,
  rent_listing?: Maybe<ListingResponse>,
  request_cancel_order?: Maybe<Request_Cancel_Order_Response>,
  reset_password?: Maybe<MailSentResponse>,
  sell_listing?: Maybe<ListingResponse>,
  send_bulk_onboarding_email?: Maybe<Array<Maybe<BulkOnBoardingEmailResponse>>>,
  set_password?: Maybe<Auth_Response>,
  sign_up?: Maybe<Signup_Auth_Response>,
  stripe_check_transaction?: Maybe<Check_Transaction_Response>,
  stripe_pay?: Maybe<Pay_Response>,
  under_offer_listing?: Maybe<ListingResponse>,
  under_review_listing?: Maybe<ListingResponse>,
  update_order_total?: Maybe<Update_Order_Total_Response>,
  update_user_email_verification?: Maybe<Update_User_Email_Verification_Response>,
  update_user_password_phone?: Maybe<Update_User_Password_Phone_Response>,
  verify_user_email?: Maybe<Json_Response>,
  withdraw_listing?: Maybe<ListingResponse>,
};


export type MutationAdd_Campaign_To_OrderArgs = {
  campaignId: Scalars['uuid'],
  orderId: Scalars['uuid']
};


export type MutationApply_CouponArgs = {
  couponCode: Scalars['String'],
  orderId: Scalars['uuid']
};


export type MutationCancel_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationCheckout_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationClear_Addons_From_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationClear_Normal_Addons_From_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationCreate_OrderArgs = {
  campaignId?: Maybe<Scalars['uuid']>,
  createdFromTemplate?: Maybe<Scalars['Boolean']>,
  listingId: Scalars['uuid']
};


export type MutationDelist_From_All_PortalsArgs = {
  listingId: Scalars['uuid']
};


export type MutationDoc_Verification_EmailArgs = {
  listingId: Scalars['uuid']
};


export type MutationFail_Publish_ListingArgs = {
  emailSend?: Maybe<Scalars['Boolean']>,
  listingId: Scalars['uuid'],
  message?: Maybe<Scalars['String']>
};


export type MutationList_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationModify_Order_Item_AddonArgs = {
  addonId: Scalars['uuid'],
  orderId: Scalars['uuid'],
  qty: Scalars['Int']
};


export type MutationOn_Hold_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationOpenpay_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type MutationOpenpay_PayArgs = {
  cancelUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type MutationPay_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationPaypal_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type MutationPaypal_PayArgs = {
  cancelUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type MutationPending_Publish_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationPoli_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type MutationPoli_PayArgs = {
  cancelUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  homePageUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type MutationReactivate_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationRecalculate_Coupon_Discounts_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationRecalculate_Coupon_Discounts_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationRemove_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationRemove_UserArgs = {
  userId: Scalars['uuid']
};


export type MutationRent_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationRequest_Cancel_OrderArgs = {
  orderId: Scalars['uuid']
};


export type MutationReset_PasswordArgs = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type MutationSell_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationSend_Bulk_Onboarding_EmailArgs = {
  agentPointIds?: Maybe<Array<Maybe<Scalars['numeric']>>>
};


export type MutationSet_PasswordArgs = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type MutationSign_UpArgs = {
  email: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  gaClientId?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  submittedVia?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmSource?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>
};


export type MutationStripe_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type MutationStripe_PayArgs = {
  orderId: Scalars['uuid']
};


export type MutationUnder_Offer_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationUnder_Review_ListingArgs = {
  listingId: Scalars['uuid']
};


export type MutationUpdate_Order_TotalArgs = {
  newOrderTotal?: Maybe<Scalars['numeric']>,
  orderId: Scalars['uuid']
};


export type MutationUpdate_User_Email_VerificationArgs = {
  email_verified?: Maybe<Scalars['Boolean']>,
  userId: Scalars['uuid']
};


export type MutationUpdate_User_Password_PhoneArgs = {
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  userId: Scalars['String']
};


export type MutationVerify_User_EmailArgs = {
  hash: Scalars['String']
};


export type MutationWithdraw_ListingArgs = {
  listingId: Scalars['uuid']
};

export type Mutation_Root = {
  __typename?: 'mutation_root',
  add_campaign_to_order?: Maybe<Add_Campaign_To_Order_Response>,
  apply_coupon?: Maybe<Coupon_Update_Order_Response>,
  assign_experiments?: Maybe<Array<Maybe<AssignExperimentOutput>>>,
  cancel_experiments?: Maybe<CancelExperimentsOutput>,
  cancel_order?: Maybe<Cancel_Order_Response>,
  checkout_order?: Maybe<Checkout_Order_Response>,
  clear_addons_from_order?: Maybe<Clear_Addons_From_Order_Response>,
  clear_normal_addons_from_order?: Maybe<Clear_Normal_Addons_From_Order_Response>,
  create_account_and_pay?: Maybe<CreateAccountPayOutput>,
  create_order?: Maybe<Create_Order_Response>,
  delete_addon?: Maybe<Addon_Mutation_Response>,
  delete_addon_addon_group?: Maybe<Addon_Addon_Group_Mutation_Response>,
  delete_addon_addon_group_by_pk?: Maybe<Addon_Addon_Group>,
  delete_addon_by_pk?: Maybe<Addon>,
  delete_addon_group?: Maybe<Addon_Group_Mutation_Response>,
  delete_addon_group_by_pk?: Maybe<Addon_Group>,
  delete_addon_group_type?: Maybe<Addon_Group_Type_Mutation_Response>,
  delete_addon_group_type_by_pk?: Maybe<Addon_Group_Type>,
  delete_addon_price?: Maybe<Addon_Price_Mutation_Response>,
  delete_addon_price_by_pk?: Maybe<Addon_Price>,
  delete_attachment?: Maybe<Attachment_Mutation_Response>,
  delete_attachment_by_pk?: Maybe<Attachment>,
  delete_attachment_parent_type?: Maybe<Attachment_Parent_Type_Mutation_Response>,
  delete_attachment_parent_type_by_pk?: Maybe<Attachment_Parent_Type>,
  delete_attachment_status?: Maybe<Attachment_Status_Mutation_Response>,
  delete_attachment_status_by_pk?: Maybe<Attachment_Status>,
  delete_attachment_type?: Maybe<Attachment_Type_Mutation_Response>,
  delete_attachment_type_by_pk?: Maybe<Attachment_Type>,
  delete_benefit?: Maybe<Benefit_Mutation_Response>,
  delete_benefit_by_pk?: Maybe<Benefit>,
  delete_bmp_listing?: Maybe<Bmp_Listing_Mutation_Response>,
  delete_bmp_listing_by_pk?: Maybe<Bmp_Listing>,
  delete_bmp_listing_contact?: Maybe<Bmp_Listing_Contact_Mutation_Response>,
  delete_bmp_listing_inspection?: Maybe<Bmp_Listing_Inspection_Mutation_Response>,
  delete_bmp_listing_media?: Maybe<Bmp_Listing_Media_Mutation_Response>,
  delete_cache?: Maybe<Cache_Mutation_Response>,
  delete_cache_by_pk?: Maybe<Cache>,
  delete_campaign?: Maybe<Campaign_Mutation_Response>,
  delete_campaign_addon_group?: Maybe<Campaign_Addon_Group_Mutation_Response>,
  delete_campaign_addon_group_by_pk?: Maybe<Campaign_Addon_Group>,
  delete_campaign_by_pk?: Maybe<Campaign>,
  delete_campaign_inclusion_group?: Maybe<Campaign_Inclusion_Group_Mutation_Response>,
  delete_campaign_inclusion_group_by_pk?: Maybe<Campaign_Inclusion_Group>,
  delete_campaign_selling_point?: Maybe<Campaign_Selling_Point_Mutation_Response>,
  delete_campaign_selling_point_by_pk?: Maybe<Campaign_Selling_Point>,
  delete_commercial_status_type?: Maybe<Commercial_Status_Type_Mutation_Response>,
  delete_commercial_status_type_by_pk?: Maybe<Commercial_Status_Type>,
  delete_coupon?: Maybe<Coupon_Mutation_Response>,
  delete_coupon_by_pk?: Maybe<Coupon>,
  delete_coupon_type?: Maybe<Coupon_Type_Mutation_Response>,
  delete_coupon_type_by_pk?: Maybe<Coupon_Type>,
  delete_enquiry?: Maybe<Enquiry_Mutation_Response>,
  delete_enquiry_by_pk?: Maybe<Enquiry>,
  delete_enquiry_call_result?: Maybe<Enquiry_Call_Result_Mutation_Response>,
  delete_enquiry_call_result_by_pk?: Maybe<Enquiry_Call_Result>,
  delete_enquiry_medium_type?: Maybe<Enquiry_Medium_Type_Mutation_Response>,
  delete_enquiry_medium_type_by_pk?: Maybe<Enquiry_Medium_Type>,
  delete_experiment?: Maybe<Experiment_Mutation_Response>,
  delete_experiment_by_pk?: Maybe<Experiment>,
  delete_experiment_name?: Maybe<Experiment_Name_Mutation_Response>,
  delete_experiment_name_by_pk?: Maybe<Experiment_Name>,
  delete_external_auth?: Maybe<External_Auth_Mutation_Response>,
  delete_external_auth_by_pk?: Maybe<External_Auth>,
  delete_feedback?: Maybe<Feedback_Mutation_Response>,
  delete_feedback_by_pk?: Maybe<Feedback>,
  delete_inclusion?: Maybe<Inclusion_Mutation_Response>,
  delete_inclusion_addon?: Maybe<Inclusion_Addon_Mutation_Response>,
  delete_inclusion_addon_by_pk?: Maybe<Inclusion_Addon>,
  delete_inclusion_by_pk?: Maybe<Inclusion>,
  delete_inclusion_group?: Maybe<Inclusion_Group_Mutation_Response>,
  delete_inclusion_group_by_pk?: Maybe<Inclusion_Group>,
  delete_listing?: Maybe<Listing_Mutation_Response>,
  delete_listing_by_pk?: Maybe<Listing>,
  delete_listing_contact?: Maybe<Listing_Contact_Mutation_Response>,
  delete_listing_contact_by_pk?: Maybe<Listing_Contact>,
  delete_listing_document?: Maybe<Listing_Document_Mutation_Response>,
  delete_listing_document_by_pk?: Maybe<Listing_Document>,
  delete_listing_document_status?: Maybe<Listing_Document_Status_Mutation_Response>,
  delete_listing_document_status_by_pk?: Maybe<Listing_Document_Status>,
  delete_listing_document_type?: Maybe<Listing_Document_Type_Mutation_Response>,
  delete_listing_document_type_by_pk?: Maybe<Listing_Document_Type>,
  delete_listing_event?: Maybe<Listing_Event_Mutation_Response>,
  delete_listing_event_by_pk?: Maybe<Listing_Event>,
  delete_listing_event_type?: Maybe<Listing_Event_Type_Mutation_Response>,
  delete_listing_event_type_by_pk?: Maybe<Listing_Event_Type>,
  delete_listing_inspection?: Maybe<Listing_Inspection_Mutation_Response>,
  delete_listing_inspection_by_pk?: Maybe<Listing_Inspection>,
  delete_listing_media?: Maybe<Listing_Media_Mutation_Response>,
  delete_listing_media_by_pk?: Maybe<Listing_Media>,
  delete_listing_media_type?: Maybe<Listing_Media_Type_Mutation_Response>,
  delete_listing_media_type_by_pk?: Maybe<Listing_Media_Type>,
  delete_listing_metadata?: Maybe<Listing_Metadata_Mutation_Response>,
  delete_listing_metadata_by_pk?: Maybe<Listing_Metadata>,
  delete_listing_onboarding?: Maybe<Listing_Onboarding_Mutation_Response>,
  delete_listing_onboarding_by_pk?: Maybe<Listing_Onboarding>,
  delete_listing_parking?: Maybe<Listing_Parking_Mutation_Response>,
  delete_listing_parking_by_pk?: Maybe<Listing_Parking>,
  delete_listing_publish_errors?: Maybe<Listing_Publish_Errors_Mutation_Response>,
  delete_listing_publish_errors_by_pk?: Maybe<Listing_Publish_Errors>,
  delete_listing_publish_portal_source?: Maybe<Listing_Publish_Portal_Source_Mutation_Response>,
  delete_listing_publish_portal_source_by_pk?: Maybe<Listing_Publish_Portal_Source>,
  delete_listing_publish_status?: Maybe<Listing_Publish_Status_Mutation_Response>,
  delete_listing_publish_status_by_pk?: Maybe<Listing_Publish_Status>,
  delete_listing_publish_status_type?: Maybe<Listing_Publish_Status_Type_Mutation_Response>,
  delete_listing_publish_status_type_by_pk?: Maybe<Listing_Publish_Status_Type>,
  delete_listing_soi_comparable_property?: Maybe<Listing_Soi_Comparable_Property_Mutation_Response>,
  delete_listing_soi_comparable_property_by_pk?: Maybe<Listing_Soi_Comparable_Property>,
  delete_metro_type?: Maybe<Metro_Type_Mutation_Response>,
  delete_metro_type_by_pk?: Maybe<Metro_Type>,
  delete_onboarding_budget_size?: Maybe<Onboarding_Budget_Size_Mutation_Response>,
  delete_onboarding_budget_size_by_pk?: Maybe<Onboarding_Budget_Size>,
  delete_onboarding_reason_selling?: Maybe<Onboarding_Reason_Selling_Mutation_Response>,
  delete_onboarding_reason_selling_by_pk?: Maybe<Onboarding_Reason_Selling>,
  delete_onboarding_timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Mutation_Response>,
  delete_onboarding_timeframe_selling_by_pk?: Maybe<Onboarding_Timeframe_Selling>,
  delete_order?: Maybe<Order_Mutation_Response>,
  delete_order_by_pk?: Maybe<Order>,
  delete_order_fulfilment?: Maybe<Order_Fulfilment_Mutation_Response>,
  delete_order_fulfilment_by_pk?: Maybe<Order_Fulfilment>,
  delete_order_item?: Maybe<Order_Item_Mutation_Response>,
  delete_order_item_by_pk?: Maybe<Order_Item>,
  delete_order_item_type?: Maybe<Order_Item_Type_Mutation_Response>,
  delete_order_item_type_by_pk?: Maybe<Order_Item_Type>,
  delete_order_status?: Maybe<Order_Status_Mutation_Response>,
  delete_order_status_by_pk?: Maybe<Order_Status>,
  delete_publishing_status_type?: Maybe<Publishing_Status_Type_Mutation_Response>,
  delete_publishing_status_type_by_pk?: Maybe<Publishing_Status_Type>,
  delete_raw_bordering_postcode?: Maybe<Raw_Bordering_Postcode_Mutation_Response>,
  delete_raw_bordering_postcode_by_pk?: Maybe<Raw_Bordering_Postcode>,
  delete_rea_price?: Maybe<Rea_Price_Mutation_Response>,
  delete_rea_price_by_pk?: Maybe<Rea_Price>,
  delete_salesforce_bulksync_records?: Maybe<Salesforce_Bulksync_Records_Mutation_Response>,
  delete_salesforce_bulksync_records_by_pk?: Maybe<Salesforce_Bulksync_Records>,
  delete_salesforce_connection_token?: Maybe<Salesforce_Connection_Token_Mutation_Response>,
  delete_salesforce_connection_token_by_pk?: Maybe<Salesforce_Connection_Token>,
  delete_salesforce_sync_status?: Maybe<Salesforce_Sync_Status_Mutation_Response>,
  delete_salesforce_sync_status_by_pk?: Maybe<Salesforce_Sync_Status>,
  delete_selling_point?: Maybe<Selling_Point_Mutation_Response>,
  delete_selling_point_by_pk?: Maybe<Selling_Point>,
  delete_stock_photo?: Maybe<Stock_Photo_Mutation_Response>,
  delete_stock_photo_by_pk?: Maybe<Stock_Photo>,
  delete_surrounding_suburb?: Maybe<Surrounding_Suburb_Mutation_Response>,
  delete_surrounding_suburb_by_pk?: Maybe<Surrounding_Suburb>,
  delete_surrounding_suburb_listing?: Maybe<Surrounding_Suburb_Listing_Mutation_Response>,
  delete_transaction?: Maybe<Transaction_Mutation_Response>,
  delete_transaction_by_pk?: Maybe<Transaction>,
  delete_transaction_status?: Maybe<Transaction_Status_Mutation_Response>,
  delete_transaction_status_by_pk?: Maybe<Transaction_Status>,
  delete_user?: Maybe<User_Mutation_Response>,
  delete_user_by_pk?: Maybe<User>,
  delete_user_detail?: Maybe<User_Detail_Mutation_Response>,
  delete_zone_type?: Maybe<Zone_Type_Mutation_Response>,
  delete_zone_type_by_pk?: Maybe<Zone_Type>,
  delist_from_all_portals?: Maybe<Delist_Response>,
  doc_verification_email?: Maybe<MailSentResponse>,
  fail_publish_listing?: Maybe<ListingResponse>,
  insert_addon?: Maybe<Addon_Mutation_Response>,
  insert_addon_addon_group?: Maybe<Addon_Addon_Group_Mutation_Response>,
  insert_addon_addon_group_one?: Maybe<Addon_Addon_Group>,
  insert_addon_group?: Maybe<Addon_Group_Mutation_Response>,
  insert_addon_group_one?: Maybe<Addon_Group>,
  insert_addon_group_type?: Maybe<Addon_Group_Type_Mutation_Response>,
  insert_addon_group_type_one?: Maybe<Addon_Group_Type>,
  insert_addon_one?: Maybe<Addon>,
  insert_addon_price?: Maybe<Addon_Price_Mutation_Response>,
  insert_addon_price_one?: Maybe<Addon_Price>,
  insert_attachment?: Maybe<Attachment_Mutation_Response>,
  insert_attachment_one?: Maybe<Attachment>,
  insert_attachment_parent_type?: Maybe<Attachment_Parent_Type_Mutation_Response>,
  insert_attachment_parent_type_one?: Maybe<Attachment_Parent_Type>,
  insert_attachment_status?: Maybe<Attachment_Status_Mutation_Response>,
  insert_attachment_status_one?: Maybe<Attachment_Status>,
  insert_attachment_type?: Maybe<Attachment_Type_Mutation_Response>,
  insert_attachment_type_one?: Maybe<Attachment_Type>,
  insert_benefit?: Maybe<Benefit_Mutation_Response>,
  insert_benefit_one?: Maybe<Benefit>,
  insert_bmp_listing?: Maybe<Bmp_Listing_Mutation_Response>,
  insert_bmp_listing_contact?: Maybe<Bmp_Listing_Contact_Mutation_Response>,
  insert_bmp_listing_contact_one?: Maybe<Bmp_Listing_Contact>,
  insert_bmp_listing_inspection?: Maybe<Bmp_Listing_Inspection_Mutation_Response>,
  insert_bmp_listing_inspection_one?: Maybe<Bmp_Listing_Inspection>,
  insert_bmp_listing_media?: Maybe<Bmp_Listing_Media_Mutation_Response>,
  insert_bmp_listing_media_one?: Maybe<Bmp_Listing_Media>,
  insert_bmp_listing_one?: Maybe<Bmp_Listing>,
  insert_cache?: Maybe<Cache_Mutation_Response>,
  insert_cache_one?: Maybe<Cache>,
  insert_campaign?: Maybe<Campaign_Mutation_Response>,
  insert_campaign_addon_group?: Maybe<Campaign_Addon_Group_Mutation_Response>,
  insert_campaign_addon_group_one?: Maybe<Campaign_Addon_Group>,
  insert_campaign_inclusion_group?: Maybe<Campaign_Inclusion_Group_Mutation_Response>,
  insert_campaign_inclusion_group_one?: Maybe<Campaign_Inclusion_Group>,
  insert_campaign_one?: Maybe<Campaign>,
  insert_campaign_selling_point?: Maybe<Campaign_Selling_Point_Mutation_Response>,
  insert_campaign_selling_point_one?: Maybe<Campaign_Selling_Point>,
  insert_commercial_status_type?: Maybe<Commercial_Status_Type_Mutation_Response>,
  insert_commercial_status_type_one?: Maybe<Commercial_Status_Type>,
  insert_coupon?: Maybe<Coupon_Mutation_Response>,
  insert_coupon_one?: Maybe<Coupon>,
  insert_coupon_type?: Maybe<Coupon_Type_Mutation_Response>,
  insert_coupon_type_one?: Maybe<Coupon_Type>,
  insert_enquiry?: Maybe<Enquiry_Mutation_Response>,
  insert_enquiry_call_result?: Maybe<Enquiry_Call_Result_Mutation_Response>,
  insert_enquiry_call_result_one?: Maybe<Enquiry_Call_Result>,
  insert_enquiry_medium_type?: Maybe<Enquiry_Medium_Type_Mutation_Response>,
  insert_enquiry_medium_type_one?: Maybe<Enquiry_Medium_Type>,
  insert_enquiry_one?: Maybe<Enquiry>,
  insert_experiment?: Maybe<Experiment_Mutation_Response>,
  insert_experiment_name?: Maybe<Experiment_Name_Mutation_Response>,
  insert_experiment_name_one?: Maybe<Experiment_Name>,
  insert_experiment_one?: Maybe<Experiment>,
  insert_external_auth?: Maybe<External_Auth_Mutation_Response>,
  insert_external_auth_one?: Maybe<External_Auth>,
  insert_feedback?: Maybe<Feedback_Mutation_Response>,
  insert_feedback_one?: Maybe<Feedback>,
  insert_inclusion?: Maybe<Inclusion_Mutation_Response>,
  insert_inclusion_addon?: Maybe<Inclusion_Addon_Mutation_Response>,
  insert_inclusion_addon_one?: Maybe<Inclusion_Addon>,
  insert_inclusion_group?: Maybe<Inclusion_Group_Mutation_Response>,
  insert_inclusion_group_one?: Maybe<Inclusion_Group>,
  insert_inclusion_one?: Maybe<Inclusion>,
  insert_listing?: Maybe<Listing_Mutation_Response>,
  insert_listing_contact?: Maybe<Listing_Contact_Mutation_Response>,
  insert_listing_contact_one?: Maybe<Listing_Contact>,
  insert_listing_document?: Maybe<Listing_Document_Mutation_Response>,
  insert_listing_document_one?: Maybe<Listing_Document>,
  insert_listing_document_status?: Maybe<Listing_Document_Status_Mutation_Response>,
  insert_listing_document_status_one?: Maybe<Listing_Document_Status>,
  insert_listing_document_type?: Maybe<Listing_Document_Type_Mutation_Response>,
  insert_listing_document_type_one?: Maybe<Listing_Document_Type>,
  insert_listing_event?: Maybe<Listing_Event_Mutation_Response>,
  insert_listing_event_one?: Maybe<Listing_Event>,
  insert_listing_event_type?: Maybe<Listing_Event_Type_Mutation_Response>,
  insert_listing_event_type_one?: Maybe<Listing_Event_Type>,
  insert_listing_inspection?: Maybe<Listing_Inspection_Mutation_Response>,
  insert_listing_inspection_one?: Maybe<Listing_Inspection>,
  insert_listing_media?: Maybe<Listing_Media_Mutation_Response>,
  insert_listing_media_one?: Maybe<Listing_Media>,
  insert_listing_media_type?: Maybe<Listing_Media_Type_Mutation_Response>,
  insert_listing_media_type_one?: Maybe<Listing_Media_Type>,
  insert_listing_metadata?: Maybe<Listing_Metadata_Mutation_Response>,
  insert_listing_metadata_one?: Maybe<Listing_Metadata>,
  insert_listing_onboarding?: Maybe<Listing_Onboarding_Mutation_Response>,
  insert_listing_onboarding_one?: Maybe<Listing_Onboarding>,
  insert_listing_one?: Maybe<Listing>,
  insert_listing_parking?: Maybe<Listing_Parking_Mutation_Response>,
  insert_listing_parking_one?: Maybe<Listing_Parking>,
  insert_listing_publish_errors?: Maybe<Listing_Publish_Errors_Mutation_Response>,
  insert_listing_publish_errors_one?: Maybe<Listing_Publish_Errors>,
  insert_listing_publish_portal_source?: Maybe<Listing_Publish_Portal_Source_Mutation_Response>,
  insert_listing_publish_portal_source_one?: Maybe<Listing_Publish_Portal_Source>,
  insert_listing_publish_status?: Maybe<Listing_Publish_Status_Mutation_Response>,
  insert_listing_publish_status_one?: Maybe<Listing_Publish_Status>,
  insert_listing_publish_status_type?: Maybe<Listing_Publish_Status_Type_Mutation_Response>,
  insert_listing_publish_status_type_one?: Maybe<Listing_Publish_Status_Type>,
  insert_listing_soi_comparable_property?: Maybe<Listing_Soi_Comparable_Property_Mutation_Response>,
  insert_listing_soi_comparable_property_one?: Maybe<Listing_Soi_Comparable_Property>,
  insert_metro_type?: Maybe<Metro_Type_Mutation_Response>,
  insert_metro_type_one?: Maybe<Metro_Type>,
  insert_onboarding_budget_size?: Maybe<Onboarding_Budget_Size_Mutation_Response>,
  insert_onboarding_budget_size_one?: Maybe<Onboarding_Budget_Size>,
  insert_onboarding_reason_selling?: Maybe<Onboarding_Reason_Selling_Mutation_Response>,
  insert_onboarding_reason_selling_one?: Maybe<Onboarding_Reason_Selling>,
  insert_onboarding_timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Mutation_Response>,
  insert_onboarding_timeframe_selling_one?: Maybe<Onboarding_Timeframe_Selling>,
  insert_order?: Maybe<Order_Mutation_Response>,
  insert_order_fulfilment?: Maybe<Order_Fulfilment_Mutation_Response>,
  insert_order_fulfilment_one?: Maybe<Order_Fulfilment>,
  insert_order_item?: Maybe<Order_Item_Mutation_Response>,
  insert_order_item_one?: Maybe<Order_Item>,
  insert_order_item_type?: Maybe<Order_Item_Type_Mutation_Response>,
  insert_order_item_type_one?: Maybe<Order_Item_Type>,
  insert_order_one?: Maybe<Order>,
  insert_order_status?: Maybe<Order_Status_Mutation_Response>,
  insert_order_status_one?: Maybe<Order_Status>,
  insert_publishing_status_type?: Maybe<Publishing_Status_Type_Mutation_Response>,
  insert_publishing_status_type_one?: Maybe<Publishing_Status_Type>,
  insert_raw_bordering_postcode?: Maybe<Raw_Bordering_Postcode_Mutation_Response>,
  insert_raw_bordering_postcode_one?: Maybe<Raw_Bordering_Postcode>,
  insert_rea_price?: Maybe<Rea_Price_Mutation_Response>,
  insert_rea_price_one?: Maybe<Rea_Price>,
  insert_salesforce_bulksync_records?: Maybe<Salesforce_Bulksync_Records_Mutation_Response>,
  insert_salesforce_bulksync_records_one?: Maybe<Salesforce_Bulksync_Records>,
  insert_salesforce_connection_token?: Maybe<Salesforce_Connection_Token_Mutation_Response>,
  insert_salesforce_connection_token_one?: Maybe<Salesforce_Connection_Token>,
  insert_salesforce_sync_status?: Maybe<Salesforce_Sync_Status_Mutation_Response>,
  insert_salesforce_sync_status_one?: Maybe<Salesforce_Sync_Status>,
  insert_selling_point?: Maybe<Selling_Point_Mutation_Response>,
  insert_selling_point_one?: Maybe<Selling_Point>,
  insert_stock_photo?: Maybe<Stock_Photo_Mutation_Response>,
  insert_stock_photo_one?: Maybe<Stock_Photo>,
  insert_surrounding_suburb?: Maybe<Surrounding_Suburb_Mutation_Response>,
  insert_surrounding_suburb_listing?: Maybe<Surrounding_Suburb_Listing_Mutation_Response>,
  insert_surrounding_suburb_listing_one?: Maybe<Surrounding_Suburb_Listing>,
  insert_surrounding_suburb_one?: Maybe<Surrounding_Suburb>,
  insert_transaction?: Maybe<Transaction_Mutation_Response>,
  insert_transaction_one?: Maybe<Transaction>,
  insert_transaction_status?: Maybe<Transaction_Status_Mutation_Response>,
  insert_transaction_status_one?: Maybe<Transaction_Status>,
  insert_user?: Maybe<User_Mutation_Response>,
  insert_user_detail?: Maybe<User_Detail_Mutation_Response>,
  insert_user_detail_one?: Maybe<User_Detail>,
  insert_user_one?: Maybe<User>,
  insert_zone_type?: Maybe<Zone_Type_Mutation_Response>,
  insert_zone_type_one?: Maybe<Zone_Type>,
  list_listing?: Maybe<ListingResponse>,
  modify_order_item_addon?: Maybe<Modify_Order_Item_Addon_Response>,
  on_hold_listing?: Maybe<ListingResponse>,
  openpay_check_transaction?: Maybe<Check_Transaction_Response>,
  openpay_pay?: Maybe<Pay_Response>,
  pay_order?: Maybe<Paid_Order_Response>,
  paypal_check_transaction?: Maybe<Check_Transaction_Response>,
  paypal_pay?: Maybe<Pay_Response>,
  pending_publish_listing?: Maybe<ListingResponse>,
  poli_check_transaction?: Maybe<Check_Transaction_Response>,
  poli_pay?: Maybe<Pay_Response>,
  reactivate_listing?: Maybe<ListingResponse>,
  recalculate_coupon_discounts_listing?: Maybe<Coupon_Update_Order_Response>,
  recalculate_coupon_discounts_order?: Maybe<Coupon_Update_Order_Response>,
  remove_order?: Maybe<Remove_Order_Response>,
  remove_user?: Maybe<Remove_User_Response>,
  rent_listing?: Maybe<ListingResponse>,
  request_cancel_order?: Maybe<Request_Cancel_Order_Response>,
  reset_password?: Maybe<MailSentResponse>,
  save_rea_prices?: Maybe<ReaPriceOutput>,
  sell_listing?: Maybe<ListingResponse>,
  send_bulk_onboarding_email?: Maybe<Array<Maybe<BulkOnBoardingEmailResponse>>>,
  set_password?: Maybe<Auth_Response>,
  sign_up?: Maybe<Signup_Auth_Response>,
  stripe_check_transaction?: Maybe<Check_Transaction_Response>,
  stripe_pay?: Maybe<Pay_Response>,
  under_offer_listing?: Maybe<ListingResponse>,
  under_review_listing?: Maybe<ListingResponse>,
  update_addon?: Maybe<Addon_Mutation_Response>,
  update_addon_addon_group?: Maybe<Addon_Addon_Group_Mutation_Response>,
  update_addon_addon_group_by_pk?: Maybe<Addon_Addon_Group>,
  update_addon_by_pk?: Maybe<Addon>,
  update_addon_group?: Maybe<Addon_Group_Mutation_Response>,
  update_addon_group_by_pk?: Maybe<Addon_Group>,
  update_addon_group_type?: Maybe<Addon_Group_Type_Mutation_Response>,
  update_addon_group_type_by_pk?: Maybe<Addon_Group_Type>,
  update_addon_price?: Maybe<Addon_Price_Mutation_Response>,
  update_addon_price_by_pk?: Maybe<Addon_Price>,
  update_attachment?: Maybe<Attachment_Mutation_Response>,
  update_attachment_by_pk?: Maybe<Attachment>,
  update_attachment_parent_type?: Maybe<Attachment_Parent_Type_Mutation_Response>,
  update_attachment_parent_type_by_pk?: Maybe<Attachment_Parent_Type>,
  update_attachment_status?: Maybe<Attachment_Status_Mutation_Response>,
  update_attachment_status_by_pk?: Maybe<Attachment_Status>,
  update_attachment_type?: Maybe<Attachment_Type_Mutation_Response>,
  update_attachment_type_by_pk?: Maybe<Attachment_Type>,
  update_benefit?: Maybe<Benefit_Mutation_Response>,
  update_benefit_by_pk?: Maybe<Benefit>,
  update_bmp_listing?: Maybe<Bmp_Listing_Mutation_Response>,
  update_bmp_listing_by_pk?: Maybe<Bmp_Listing>,
  update_bmp_listing_contact?: Maybe<Bmp_Listing_Contact_Mutation_Response>,
  update_bmp_listing_inspection?: Maybe<Bmp_Listing_Inspection_Mutation_Response>,
  update_bmp_listing_media?: Maybe<Bmp_Listing_Media_Mutation_Response>,
  update_cache?: Maybe<Cache_Mutation_Response>,
  update_cache_by_pk?: Maybe<Cache>,
  update_campaign?: Maybe<Campaign_Mutation_Response>,
  update_campaign_addon_group?: Maybe<Campaign_Addon_Group_Mutation_Response>,
  update_campaign_addon_group_by_pk?: Maybe<Campaign_Addon_Group>,
  update_campaign_by_pk?: Maybe<Campaign>,
  update_campaign_inclusion_group?: Maybe<Campaign_Inclusion_Group_Mutation_Response>,
  update_campaign_inclusion_group_by_pk?: Maybe<Campaign_Inclusion_Group>,
  update_campaign_selling_point?: Maybe<Campaign_Selling_Point_Mutation_Response>,
  update_campaign_selling_point_by_pk?: Maybe<Campaign_Selling_Point>,
  update_commercial_status_type?: Maybe<Commercial_Status_Type_Mutation_Response>,
  update_commercial_status_type_by_pk?: Maybe<Commercial_Status_Type>,
  update_coupon?: Maybe<Coupon_Mutation_Response>,
  update_coupon_by_pk?: Maybe<Coupon>,
  update_coupon_type?: Maybe<Coupon_Type_Mutation_Response>,
  update_coupon_type_by_pk?: Maybe<Coupon_Type>,
  update_enquiry?: Maybe<Enquiry_Mutation_Response>,
  update_enquiry_by_pk?: Maybe<Enquiry>,
  update_enquiry_call_result?: Maybe<Enquiry_Call_Result_Mutation_Response>,
  update_enquiry_call_result_by_pk?: Maybe<Enquiry_Call_Result>,
  update_enquiry_medium_type?: Maybe<Enquiry_Medium_Type_Mutation_Response>,
  update_enquiry_medium_type_by_pk?: Maybe<Enquiry_Medium_Type>,
  update_experiment?: Maybe<Experiment_Mutation_Response>,
  update_experiment_by_pk?: Maybe<Experiment>,
  update_experiment_name?: Maybe<Experiment_Name_Mutation_Response>,
  update_experiment_name_by_pk?: Maybe<Experiment_Name>,
  update_external_auth?: Maybe<External_Auth_Mutation_Response>,
  update_external_auth_by_pk?: Maybe<External_Auth>,
  update_feedback?: Maybe<Feedback_Mutation_Response>,
  update_feedback_by_pk?: Maybe<Feedback>,
  update_inclusion?: Maybe<Inclusion_Mutation_Response>,
  update_inclusion_addon?: Maybe<Inclusion_Addon_Mutation_Response>,
  update_inclusion_addon_by_pk?: Maybe<Inclusion_Addon>,
  update_inclusion_by_pk?: Maybe<Inclusion>,
  update_inclusion_group?: Maybe<Inclusion_Group_Mutation_Response>,
  update_inclusion_group_by_pk?: Maybe<Inclusion_Group>,
  update_listing?: Maybe<Listing_Mutation_Response>,
  update_listing_by_pk?: Maybe<Listing>,
  update_listing_contact?: Maybe<Listing_Contact_Mutation_Response>,
  update_listing_contact_by_pk?: Maybe<Listing_Contact>,
  update_listing_document?: Maybe<Listing_Document_Mutation_Response>,
  update_listing_document_by_pk?: Maybe<Listing_Document>,
  update_listing_document_status?: Maybe<Listing_Document_Status_Mutation_Response>,
  update_listing_document_status_by_pk?: Maybe<Listing_Document_Status>,
  update_listing_document_type?: Maybe<Listing_Document_Type_Mutation_Response>,
  update_listing_document_type_by_pk?: Maybe<Listing_Document_Type>,
  update_listing_event?: Maybe<Listing_Event_Mutation_Response>,
  update_listing_event_by_pk?: Maybe<Listing_Event>,
  update_listing_event_type?: Maybe<Listing_Event_Type_Mutation_Response>,
  update_listing_event_type_by_pk?: Maybe<Listing_Event_Type>,
  update_listing_inspection?: Maybe<Listing_Inspection_Mutation_Response>,
  update_listing_inspection_by_pk?: Maybe<Listing_Inspection>,
  update_listing_media?: Maybe<Listing_Media_Mutation_Response>,
  update_listing_media_by_pk?: Maybe<Listing_Media>,
  update_listing_media_type?: Maybe<Listing_Media_Type_Mutation_Response>,
  update_listing_media_type_by_pk?: Maybe<Listing_Media_Type>,
  update_listing_metadata?: Maybe<Listing_Metadata_Mutation_Response>,
  update_listing_metadata_by_pk?: Maybe<Listing_Metadata>,
  update_listing_onboarding?: Maybe<Listing_Onboarding_Mutation_Response>,
  update_listing_onboarding_by_pk?: Maybe<Listing_Onboarding>,
  update_listing_parking?: Maybe<Listing_Parking_Mutation_Response>,
  update_listing_parking_by_pk?: Maybe<Listing_Parking>,
  update_listing_publish_errors?: Maybe<Listing_Publish_Errors_Mutation_Response>,
  update_listing_publish_errors_by_pk?: Maybe<Listing_Publish_Errors>,
  update_listing_publish_portal_source?: Maybe<Listing_Publish_Portal_Source_Mutation_Response>,
  update_listing_publish_portal_source_by_pk?: Maybe<Listing_Publish_Portal_Source>,
  update_listing_publish_status?: Maybe<Listing_Publish_Status_Mutation_Response>,
  update_listing_publish_status_by_pk?: Maybe<Listing_Publish_Status>,
  update_listing_publish_status_type?: Maybe<Listing_Publish_Status_Type_Mutation_Response>,
  update_listing_publish_status_type_by_pk?: Maybe<Listing_Publish_Status_Type>,
  update_listing_soi_comparable_property?: Maybe<Listing_Soi_Comparable_Property_Mutation_Response>,
  update_listing_soi_comparable_property_by_pk?: Maybe<Listing_Soi_Comparable_Property>,
  update_metro_type?: Maybe<Metro_Type_Mutation_Response>,
  update_metro_type_by_pk?: Maybe<Metro_Type>,
  update_onboarding_budget_size?: Maybe<Onboarding_Budget_Size_Mutation_Response>,
  update_onboarding_budget_size_by_pk?: Maybe<Onboarding_Budget_Size>,
  update_onboarding_reason_selling?: Maybe<Onboarding_Reason_Selling_Mutation_Response>,
  update_onboarding_reason_selling_by_pk?: Maybe<Onboarding_Reason_Selling>,
  update_onboarding_timeframe_selling?: Maybe<Onboarding_Timeframe_Selling_Mutation_Response>,
  update_onboarding_timeframe_selling_by_pk?: Maybe<Onboarding_Timeframe_Selling>,
  update_order?: Maybe<Order_Mutation_Response>,
  update_order_by_pk?: Maybe<Order>,
  update_order_fulfilment?: Maybe<Order_Fulfilment_Mutation_Response>,
  update_order_fulfilment_by_pk?: Maybe<Order_Fulfilment>,
  update_order_item?: Maybe<Order_Item_Mutation_Response>,
  update_order_item_by_pk?: Maybe<Order_Item>,
  update_order_item_type?: Maybe<Order_Item_Type_Mutation_Response>,
  update_order_item_type_by_pk?: Maybe<Order_Item_Type>,
  update_order_status?: Maybe<Order_Status_Mutation_Response>,
  update_order_status_by_pk?: Maybe<Order_Status>,
  update_order_total?: Maybe<Update_Order_Total_Response>,
  update_publishing_status_type?: Maybe<Publishing_Status_Type_Mutation_Response>,
  update_publishing_status_type_by_pk?: Maybe<Publishing_Status_Type>,
  update_raw_bordering_postcode?: Maybe<Raw_Bordering_Postcode_Mutation_Response>,
  update_raw_bordering_postcode_by_pk?: Maybe<Raw_Bordering_Postcode>,
  update_rea_price?: Maybe<Rea_Price_Mutation_Response>,
  update_rea_price_by_pk?: Maybe<Rea_Price>,
  update_salesforce_bulksync_records?: Maybe<Salesforce_Bulksync_Records_Mutation_Response>,
  update_salesforce_bulksync_records_by_pk?: Maybe<Salesforce_Bulksync_Records>,
  update_salesforce_connection_token?: Maybe<Salesforce_Connection_Token_Mutation_Response>,
  update_salesforce_connection_token_by_pk?: Maybe<Salesforce_Connection_Token>,
  update_salesforce_sync_status?: Maybe<Salesforce_Sync_Status_Mutation_Response>,
  update_salesforce_sync_status_by_pk?: Maybe<Salesforce_Sync_Status>,
  update_selling_point?: Maybe<Selling_Point_Mutation_Response>,
  update_selling_point_by_pk?: Maybe<Selling_Point>,
  update_stock_photo?: Maybe<Stock_Photo_Mutation_Response>,
  update_stock_photo_by_pk?: Maybe<Stock_Photo>,
  update_surrounding_suburb?: Maybe<Surrounding_Suburb_Mutation_Response>,
  update_surrounding_suburb_by_pk?: Maybe<Surrounding_Suburb>,
  update_surrounding_suburb_listing?: Maybe<Surrounding_Suburb_Listing_Mutation_Response>,
  update_transaction?: Maybe<Transaction_Mutation_Response>,
  update_transaction_by_pk?: Maybe<Transaction>,
  update_transaction_status?: Maybe<Transaction_Status_Mutation_Response>,
  update_transaction_status_by_pk?: Maybe<Transaction_Status>,
  update_user?: Maybe<User_Mutation_Response>,
  update_user_by_pk?: Maybe<User>,
  update_user_detail?: Maybe<User_Detail_Mutation_Response>,
  update_user_email_verification?: Maybe<Update_User_Email_Verification_Response>,
  update_user_password_phone?: Maybe<Update_User_Password_Phone_Response>,
  update_zone_type?: Maybe<Zone_Type_Mutation_Response>,
  update_zone_type_by_pk?: Maybe<Zone_Type>,
  verify_user_email?: Maybe<Json_Response>,
  withdraw_listing?: Maybe<ListingResponse>,
};


export type Mutation_RootAdd_Campaign_To_OrderArgs = {
  campaignId: Scalars['uuid'],
  orderId: Scalars['uuid']
};


export type Mutation_RootApply_CouponArgs = {
  couponCode: Scalars['String'],
  orderId: Scalars['uuid']
};


export type Mutation_RootAssign_ExperimentsArgs = {
  experimentNames?: Maybe<Array<Maybe<Scalars['String']>>>
};


export type Mutation_RootCancel_ExperimentsArgs = {
  experimentNames?: Maybe<Array<Maybe<Scalars['String']>>>
};


export type Mutation_RootCancel_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootCheckout_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootClear_Addons_From_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootClear_Normal_Addons_From_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootCreate_Account_And_PayArgs = {
  input: CreateAccountPayInput
};


export type Mutation_RootCreate_OrderArgs = {
  campaignId?: Maybe<Scalars['uuid']>,
  createdFromTemplate?: Maybe<Scalars['Boolean']>,
  listingId: Scalars['uuid']
};


export type Mutation_RootDelete_AddonArgs = {
  where: Addon_Bool_Exp
};


export type Mutation_RootDelete_Addon_Addon_GroupArgs = {
  where: Addon_Addon_Group_Bool_Exp
};


export type Mutation_RootDelete_Addon_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Addon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Addon_GroupArgs = {
  where: Addon_Group_Bool_Exp
};


export type Mutation_RootDelete_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Addon_Group_TypeArgs = {
  where: Addon_Group_Type_Bool_Exp
};


export type Mutation_RootDelete_Addon_Group_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Addon_PriceArgs = {
  where: Addon_Price_Bool_Exp
};


export type Mutation_RootDelete_Addon_Price_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_AttachmentArgs = {
  where: Attachment_Bool_Exp
};


export type Mutation_RootDelete_Attachment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Attachment_Parent_TypeArgs = {
  where: Attachment_Parent_Type_Bool_Exp
};


export type Mutation_RootDelete_Attachment_Parent_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Attachment_StatusArgs = {
  where: Attachment_Status_Bool_Exp
};


export type Mutation_RootDelete_Attachment_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Attachment_TypeArgs = {
  where: Attachment_Type_Bool_Exp
};


export type Mutation_RootDelete_Attachment_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_BenefitArgs = {
  where: Benefit_Bool_Exp
};


export type Mutation_RootDelete_Benefit_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Bmp_ListingArgs = {
  where: Bmp_Listing_Bool_Exp
};


export type Mutation_RootDelete_Bmp_Listing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Bmp_Listing_ContactArgs = {
  where: Bmp_Listing_Contact_Bool_Exp
};


export type Mutation_RootDelete_Bmp_Listing_InspectionArgs = {
  where: Bmp_Listing_Inspection_Bool_Exp
};


export type Mutation_RootDelete_Bmp_Listing_MediaArgs = {
  where: Bmp_Listing_Media_Bool_Exp
};


export type Mutation_RootDelete_CacheArgs = {
  where: Cache_Bool_Exp
};


export type Mutation_RootDelete_Cache_By_PkArgs = {
  key: Scalars['String']
};


export type Mutation_RootDelete_CampaignArgs = {
  where: Campaign_Bool_Exp
};


export type Mutation_RootDelete_Campaign_Addon_GroupArgs = {
  where: Campaign_Addon_Group_Bool_Exp
};


export type Mutation_RootDelete_Campaign_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Campaign_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Campaign_Inclusion_GroupArgs = {
  where: Campaign_Inclusion_Group_Bool_Exp
};


export type Mutation_RootDelete_Campaign_Inclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Campaign_Selling_PointArgs = {
  where: Campaign_Selling_Point_Bool_Exp
};


export type Mutation_RootDelete_Campaign_Selling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Commercial_Status_TypeArgs = {
  where: Commercial_Status_Type_Bool_Exp
};


export type Mutation_RootDelete_Commercial_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_CouponArgs = {
  where: Coupon_Bool_Exp
};


export type Mutation_RootDelete_Coupon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Coupon_TypeArgs = {
  where: Coupon_Type_Bool_Exp
};


export type Mutation_RootDelete_Coupon_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_EnquiryArgs = {
  where: Enquiry_Bool_Exp
};


export type Mutation_RootDelete_Enquiry_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Enquiry_Call_ResultArgs = {
  where: Enquiry_Call_Result_Bool_Exp
};


export type Mutation_RootDelete_Enquiry_Call_Result_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Enquiry_Medium_TypeArgs = {
  where: Enquiry_Medium_Type_Bool_Exp
};


export type Mutation_RootDelete_Enquiry_Medium_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_ExperimentArgs = {
  where: Experiment_Bool_Exp
};


export type Mutation_RootDelete_Experiment_By_PkArgs = {
  name: Experiment_Name_Enum
};


export type Mutation_RootDelete_Experiment_NameArgs = {
  where: Experiment_Name_Bool_Exp
};


export type Mutation_RootDelete_Experiment_Name_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_External_AuthArgs = {
  where: External_Auth_Bool_Exp
};


export type Mutation_RootDelete_External_Auth_By_PkArgs = {
  user_id: Scalars['uuid']
};


export type Mutation_RootDelete_FeedbackArgs = {
  where: Feedback_Bool_Exp
};


export type Mutation_RootDelete_Feedback_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_InclusionArgs = {
  where: Inclusion_Bool_Exp
};


export type Mutation_RootDelete_Inclusion_AddonArgs = {
  where: Inclusion_Addon_Bool_Exp
};


export type Mutation_RootDelete_Inclusion_Addon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Inclusion_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Inclusion_GroupArgs = {
  where: Inclusion_Group_Bool_Exp
};


export type Mutation_RootDelete_Inclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_ListingArgs = {
  where: Listing_Bool_Exp
};


export type Mutation_RootDelete_Listing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_ContactArgs = {
  where: Listing_Contact_Bool_Exp
};


export type Mutation_RootDelete_Listing_Contact_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_DocumentArgs = {
  where: Listing_Document_Bool_Exp
};


export type Mutation_RootDelete_Listing_Document_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Document_StatusArgs = {
  where: Listing_Document_Status_Bool_Exp
};


export type Mutation_RootDelete_Listing_Document_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_Document_TypeArgs = {
  where: Listing_Document_Type_Bool_Exp
};


export type Mutation_RootDelete_Listing_Document_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_EventArgs = {
  where: Listing_Event_Bool_Exp
};


export type Mutation_RootDelete_Listing_Event_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Event_TypeArgs = {
  where: Listing_Event_Type_Bool_Exp
};


export type Mutation_RootDelete_Listing_Event_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_InspectionArgs = {
  where: Listing_Inspection_Bool_Exp
};


export type Mutation_RootDelete_Listing_Inspection_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_MediaArgs = {
  where: Listing_Media_Bool_Exp
};


export type Mutation_RootDelete_Listing_Media_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Media_TypeArgs = {
  where: Listing_Media_Type_Bool_Exp
};


export type Mutation_RootDelete_Listing_Media_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_MetadataArgs = {
  where: Listing_Metadata_Bool_Exp
};


export type Mutation_RootDelete_Listing_Metadata_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_OnboardingArgs = {
  where: Listing_Onboarding_Bool_Exp
};


export type Mutation_RootDelete_Listing_Onboarding_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_ParkingArgs = {
  where: Listing_Parking_Bool_Exp
};


export type Mutation_RootDelete_Listing_Parking_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Publish_ErrorsArgs = {
  where: Listing_Publish_Errors_Bool_Exp
};


export type Mutation_RootDelete_Listing_Publish_Errors_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Publish_Portal_SourceArgs = {
  where: Listing_Publish_Portal_Source_Bool_Exp
};


export type Mutation_RootDelete_Listing_Publish_Portal_Source_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_Publish_StatusArgs = {
  where: Listing_Publish_Status_Bool_Exp
};


export type Mutation_RootDelete_Listing_Publish_Status_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Mutation_RootDelete_Listing_Publish_Status_TypeArgs = {
  where: Listing_Publish_Status_Type_Bool_Exp
};


export type Mutation_RootDelete_Listing_Publish_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Listing_Soi_Comparable_PropertyArgs = {
  where: Listing_Soi_Comparable_Property_Bool_Exp
};


export type Mutation_RootDelete_Listing_Soi_Comparable_Property_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Metro_TypeArgs = {
  where: Metro_Type_Bool_Exp
};


export type Mutation_RootDelete_Metro_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Onboarding_Budget_SizeArgs = {
  where: Onboarding_Budget_Size_Bool_Exp
};


export type Mutation_RootDelete_Onboarding_Budget_Size_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Onboarding_Reason_SellingArgs = {
  where: Onboarding_Reason_Selling_Bool_Exp
};


export type Mutation_RootDelete_Onboarding_Reason_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Onboarding_Timeframe_SellingArgs = {
  where: Onboarding_Timeframe_Selling_Bool_Exp
};


export type Mutation_RootDelete_Onboarding_Timeframe_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_OrderArgs = {
  where: Order_Bool_Exp
};


export type Mutation_RootDelete_Order_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Order_FulfilmentArgs = {
  where: Order_Fulfilment_Bool_Exp
};


export type Mutation_RootDelete_Order_Fulfilment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Order_ItemArgs = {
  where: Order_Item_Bool_Exp
};


export type Mutation_RootDelete_Order_Item_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Order_Item_TypeArgs = {
  where: Order_Item_Type_Bool_Exp
};


export type Mutation_RootDelete_Order_Item_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Order_StatusArgs = {
  where: Order_Status_Bool_Exp
};


export type Mutation_RootDelete_Order_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Publishing_Status_TypeArgs = {
  where: Publishing_Status_Type_Bool_Exp
};


export type Mutation_RootDelete_Publishing_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Raw_Bordering_PostcodeArgs = {
  where: Raw_Bordering_Postcode_Bool_Exp
};


export type Mutation_RootDelete_Raw_Bordering_Postcode_By_PkArgs = {
  id: Scalars['Int']
};


export type Mutation_RootDelete_Rea_PriceArgs = {
  where: Rea_Price_Bool_Exp
};


export type Mutation_RootDelete_Rea_Price_By_PkArgs = {
  key: Scalars['String']
};


export type Mutation_RootDelete_Salesforce_Bulksync_RecordsArgs = {
  where: Salesforce_Bulksync_Records_Bool_Exp
};


export type Mutation_RootDelete_Salesforce_Bulksync_Records_By_PkArgs = {
  operation_id: Scalars['uuid']
};


export type Mutation_RootDelete_Salesforce_Connection_TokenArgs = {
  where: Salesforce_Connection_Token_Bool_Exp
};


export type Mutation_RootDelete_Salesforce_Connection_Token_By_PkArgs = {
  access_token: Scalars['String']
};


export type Mutation_RootDelete_Salesforce_Sync_StatusArgs = {
  where: Salesforce_Sync_Status_Bool_Exp
};


export type Mutation_RootDelete_Salesforce_Sync_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_Selling_PointArgs = {
  where: Selling_Point_Bool_Exp
};


export type Mutation_RootDelete_Selling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Stock_PhotoArgs = {
  where: Stock_Photo_Bool_Exp
};


export type Mutation_RootDelete_Stock_Photo_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Surrounding_SuburbArgs = {
  where: Surrounding_Suburb_Bool_Exp
};


export type Mutation_RootDelete_Surrounding_Suburb_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Surrounding_Suburb_ListingArgs = {
  where: Surrounding_Suburb_Listing_Bool_Exp
};


export type Mutation_RootDelete_TransactionArgs = {
  where: Transaction_Bool_Exp
};


export type Mutation_RootDelete_Transaction_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_Transaction_StatusArgs = {
  where: Transaction_Status_Bool_Exp
};


export type Mutation_RootDelete_Transaction_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp
};


export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid']
};


export type Mutation_RootDelete_User_DetailArgs = {
  where: User_Detail_Bool_Exp
};


export type Mutation_RootDelete_Zone_TypeArgs = {
  where: Zone_Type_Bool_Exp
};


export type Mutation_RootDelete_Zone_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Mutation_RootDelist_From_All_PortalsArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootDoc_Verification_EmailArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootFail_Publish_ListingArgs = {
  emailSend?: Maybe<Scalars['Boolean']>,
  listingId: Scalars['uuid'],
  message?: Maybe<Scalars['String']>
};


export type Mutation_RootInsert_AddonArgs = {
  objects: Array<Addon_Insert_Input>,
  on_conflict?: Maybe<Addon_On_Conflict>
};


export type Mutation_RootInsert_Addon_Addon_GroupArgs = {
  objects: Array<Addon_Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Addon_Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Addon_Addon_Group_OneArgs = {
  object: Addon_Addon_Group_Insert_Input,
  on_conflict?: Maybe<Addon_Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Addon_GroupArgs = {
  objects: Array<Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Addon_Group_OneArgs = {
  object: Addon_Group_Insert_Input,
  on_conflict?: Maybe<Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Addon_Group_TypeArgs = {
  objects: Array<Addon_Group_Type_Insert_Input>,
  on_conflict?: Maybe<Addon_Group_Type_On_Conflict>
};


export type Mutation_RootInsert_Addon_Group_Type_OneArgs = {
  object: Addon_Group_Type_Insert_Input,
  on_conflict?: Maybe<Addon_Group_Type_On_Conflict>
};


export type Mutation_RootInsert_Addon_OneArgs = {
  object: Addon_Insert_Input,
  on_conflict?: Maybe<Addon_On_Conflict>
};


export type Mutation_RootInsert_Addon_PriceArgs = {
  objects: Array<Addon_Price_Insert_Input>,
  on_conflict?: Maybe<Addon_Price_On_Conflict>
};


export type Mutation_RootInsert_Addon_Price_OneArgs = {
  object: Addon_Price_Insert_Input,
  on_conflict?: Maybe<Addon_Price_On_Conflict>
};


export type Mutation_RootInsert_AttachmentArgs = {
  objects: Array<Attachment_Insert_Input>,
  on_conflict?: Maybe<Attachment_On_Conflict>
};


export type Mutation_RootInsert_Attachment_OneArgs = {
  object: Attachment_Insert_Input,
  on_conflict?: Maybe<Attachment_On_Conflict>
};


export type Mutation_RootInsert_Attachment_Parent_TypeArgs = {
  objects: Array<Attachment_Parent_Type_Insert_Input>,
  on_conflict?: Maybe<Attachment_Parent_Type_On_Conflict>
};


export type Mutation_RootInsert_Attachment_Parent_Type_OneArgs = {
  object: Attachment_Parent_Type_Insert_Input,
  on_conflict?: Maybe<Attachment_Parent_Type_On_Conflict>
};


export type Mutation_RootInsert_Attachment_StatusArgs = {
  objects: Array<Attachment_Status_Insert_Input>,
  on_conflict?: Maybe<Attachment_Status_On_Conflict>
};


export type Mutation_RootInsert_Attachment_Status_OneArgs = {
  object: Attachment_Status_Insert_Input,
  on_conflict?: Maybe<Attachment_Status_On_Conflict>
};


export type Mutation_RootInsert_Attachment_TypeArgs = {
  objects: Array<Attachment_Type_Insert_Input>,
  on_conflict?: Maybe<Attachment_Type_On_Conflict>
};


export type Mutation_RootInsert_Attachment_Type_OneArgs = {
  object: Attachment_Type_Insert_Input,
  on_conflict?: Maybe<Attachment_Type_On_Conflict>
};


export type Mutation_RootInsert_BenefitArgs = {
  objects: Array<Benefit_Insert_Input>,
  on_conflict?: Maybe<Benefit_On_Conflict>
};


export type Mutation_RootInsert_Benefit_OneArgs = {
  object: Benefit_Insert_Input,
  on_conflict?: Maybe<Benefit_On_Conflict>
};


export type Mutation_RootInsert_Bmp_ListingArgs = {
  objects: Array<Bmp_Listing_Insert_Input>,
  on_conflict?: Maybe<Bmp_Listing_On_Conflict>
};


export type Mutation_RootInsert_Bmp_Listing_ContactArgs = {
  objects: Array<Bmp_Listing_Contact_Insert_Input>
};


export type Mutation_RootInsert_Bmp_Listing_Contact_OneArgs = {
  object: Bmp_Listing_Contact_Insert_Input
};


export type Mutation_RootInsert_Bmp_Listing_InspectionArgs = {
  objects: Array<Bmp_Listing_Inspection_Insert_Input>
};


export type Mutation_RootInsert_Bmp_Listing_Inspection_OneArgs = {
  object: Bmp_Listing_Inspection_Insert_Input
};


export type Mutation_RootInsert_Bmp_Listing_MediaArgs = {
  objects: Array<Bmp_Listing_Media_Insert_Input>
};


export type Mutation_RootInsert_Bmp_Listing_Media_OneArgs = {
  object: Bmp_Listing_Media_Insert_Input
};


export type Mutation_RootInsert_Bmp_Listing_OneArgs = {
  object: Bmp_Listing_Insert_Input,
  on_conflict?: Maybe<Bmp_Listing_On_Conflict>
};


export type Mutation_RootInsert_CacheArgs = {
  objects: Array<Cache_Insert_Input>,
  on_conflict?: Maybe<Cache_On_Conflict>
};


export type Mutation_RootInsert_Cache_OneArgs = {
  object: Cache_Insert_Input,
  on_conflict?: Maybe<Cache_On_Conflict>
};


export type Mutation_RootInsert_CampaignArgs = {
  objects: Array<Campaign_Insert_Input>,
  on_conflict?: Maybe<Campaign_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Addon_GroupArgs = {
  objects: Array<Campaign_Addon_Group_Insert_Input>,
  on_conflict?: Maybe<Campaign_Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Addon_Group_OneArgs = {
  object: Campaign_Addon_Group_Insert_Input,
  on_conflict?: Maybe<Campaign_Addon_Group_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Inclusion_GroupArgs = {
  objects: Array<Campaign_Inclusion_Group_Insert_Input>,
  on_conflict?: Maybe<Campaign_Inclusion_Group_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Inclusion_Group_OneArgs = {
  object: Campaign_Inclusion_Group_Insert_Input,
  on_conflict?: Maybe<Campaign_Inclusion_Group_On_Conflict>
};


export type Mutation_RootInsert_Campaign_OneArgs = {
  object: Campaign_Insert_Input,
  on_conflict?: Maybe<Campaign_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Selling_PointArgs = {
  objects: Array<Campaign_Selling_Point_Insert_Input>,
  on_conflict?: Maybe<Campaign_Selling_Point_On_Conflict>
};


export type Mutation_RootInsert_Campaign_Selling_Point_OneArgs = {
  object: Campaign_Selling_Point_Insert_Input,
  on_conflict?: Maybe<Campaign_Selling_Point_On_Conflict>
};


export type Mutation_RootInsert_Commercial_Status_TypeArgs = {
  objects: Array<Commercial_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Commercial_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_Commercial_Status_Type_OneArgs = {
  object: Commercial_Status_Type_Insert_Input,
  on_conflict?: Maybe<Commercial_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_CouponArgs = {
  objects: Array<Coupon_Insert_Input>,
  on_conflict?: Maybe<Coupon_On_Conflict>
};


export type Mutation_RootInsert_Coupon_OneArgs = {
  object: Coupon_Insert_Input,
  on_conflict?: Maybe<Coupon_On_Conflict>
};


export type Mutation_RootInsert_Coupon_TypeArgs = {
  objects: Array<Coupon_Type_Insert_Input>,
  on_conflict?: Maybe<Coupon_Type_On_Conflict>
};


export type Mutation_RootInsert_Coupon_Type_OneArgs = {
  object: Coupon_Type_Insert_Input,
  on_conflict?: Maybe<Coupon_Type_On_Conflict>
};


export type Mutation_RootInsert_EnquiryArgs = {
  objects: Array<Enquiry_Insert_Input>,
  on_conflict?: Maybe<Enquiry_On_Conflict>
};


export type Mutation_RootInsert_Enquiry_Call_ResultArgs = {
  objects: Array<Enquiry_Call_Result_Insert_Input>,
  on_conflict?: Maybe<Enquiry_Call_Result_On_Conflict>
};


export type Mutation_RootInsert_Enquiry_Call_Result_OneArgs = {
  object: Enquiry_Call_Result_Insert_Input,
  on_conflict?: Maybe<Enquiry_Call_Result_On_Conflict>
};


export type Mutation_RootInsert_Enquiry_Medium_TypeArgs = {
  objects: Array<Enquiry_Medium_Type_Insert_Input>,
  on_conflict?: Maybe<Enquiry_Medium_Type_On_Conflict>
};


export type Mutation_RootInsert_Enquiry_Medium_Type_OneArgs = {
  object: Enquiry_Medium_Type_Insert_Input,
  on_conflict?: Maybe<Enquiry_Medium_Type_On_Conflict>
};


export type Mutation_RootInsert_Enquiry_OneArgs = {
  object: Enquiry_Insert_Input,
  on_conflict?: Maybe<Enquiry_On_Conflict>
};


export type Mutation_RootInsert_ExperimentArgs = {
  objects: Array<Experiment_Insert_Input>,
  on_conflict?: Maybe<Experiment_On_Conflict>
};


export type Mutation_RootInsert_Experiment_NameArgs = {
  objects: Array<Experiment_Name_Insert_Input>,
  on_conflict?: Maybe<Experiment_Name_On_Conflict>
};


export type Mutation_RootInsert_Experiment_Name_OneArgs = {
  object: Experiment_Name_Insert_Input,
  on_conflict?: Maybe<Experiment_Name_On_Conflict>
};


export type Mutation_RootInsert_Experiment_OneArgs = {
  object: Experiment_Insert_Input,
  on_conflict?: Maybe<Experiment_On_Conflict>
};


export type Mutation_RootInsert_External_AuthArgs = {
  objects: Array<External_Auth_Insert_Input>,
  on_conflict?: Maybe<External_Auth_On_Conflict>
};


export type Mutation_RootInsert_External_Auth_OneArgs = {
  object: External_Auth_Insert_Input,
  on_conflict?: Maybe<External_Auth_On_Conflict>
};


export type Mutation_RootInsert_FeedbackArgs = {
  objects: Array<Feedback_Insert_Input>,
  on_conflict?: Maybe<Feedback_On_Conflict>
};


export type Mutation_RootInsert_Feedback_OneArgs = {
  object: Feedback_Insert_Input,
  on_conflict?: Maybe<Feedback_On_Conflict>
};


export type Mutation_RootInsert_InclusionArgs = {
  objects: Array<Inclusion_Insert_Input>,
  on_conflict?: Maybe<Inclusion_On_Conflict>
};


export type Mutation_RootInsert_Inclusion_AddonArgs = {
  objects: Array<Inclusion_Addon_Insert_Input>,
  on_conflict?: Maybe<Inclusion_Addon_On_Conflict>
};


export type Mutation_RootInsert_Inclusion_Addon_OneArgs = {
  object: Inclusion_Addon_Insert_Input,
  on_conflict?: Maybe<Inclusion_Addon_On_Conflict>
};


export type Mutation_RootInsert_Inclusion_GroupArgs = {
  objects: Array<Inclusion_Group_Insert_Input>,
  on_conflict?: Maybe<Inclusion_Group_On_Conflict>
};


export type Mutation_RootInsert_Inclusion_Group_OneArgs = {
  object: Inclusion_Group_Insert_Input,
  on_conflict?: Maybe<Inclusion_Group_On_Conflict>
};


export type Mutation_RootInsert_Inclusion_OneArgs = {
  object: Inclusion_Insert_Input,
  on_conflict?: Maybe<Inclusion_On_Conflict>
};


export type Mutation_RootInsert_ListingArgs = {
  objects: Array<Listing_Insert_Input>,
  on_conflict?: Maybe<Listing_On_Conflict>
};


export type Mutation_RootInsert_Listing_ContactArgs = {
  objects: Array<Listing_Contact_Insert_Input>,
  on_conflict?: Maybe<Listing_Contact_On_Conflict>
};


export type Mutation_RootInsert_Listing_Contact_OneArgs = {
  object: Listing_Contact_Insert_Input,
  on_conflict?: Maybe<Listing_Contact_On_Conflict>
};


export type Mutation_RootInsert_Listing_DocumentArgs = {
  objects: Array<Listing_Document_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_On_Conflict>
};


export type Mutation_RootInsert_Listing_Document_OneArgs = {
  object: Listing_Document_Insert_Input,
  on_conflict?: Maybe<Listing_Document_On_Conflict>
};


export type Mutation_RootInsert_Listing_Document_StatusArgs = {
  objects: Array<Listing_Document_Status_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_Status_On_Conflict>
};


export type Mutation_RootInsert_Listing_Document_Status_OneArgs = {
  object: Listing_Document_Status_Insert_Input,
  on_conflict?: Maybe<Listing_Document_Status_On_Conflict>
};


export type Mutation_RootInsert_Listing_Document_TypeArgs = {
  objects: Array<Listing_Document_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Document_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_Document_Type_OneArgs = {
  object: Listing_Document_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Document_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_EventArgs = {
  objects: Array<Listing_Event_Insert_Input>,
  on_conflict?: Maybe<Listing_Event_On_Conflict>
};


export type Mutation_RootInsert_Listing_Event_OneArgs = {
  object: Listing_Event_Insert_Input,
  on_conflict?: Maybe<Listing_Event_On_Conflict>
};


export type Mutation_RootInsert_Listing_Event_TypeArgs = {
  objects: Array<Listing_Event_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Event_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_Event_Type_OneArgs = {
  object: Listing_Event_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Event_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_InspectionArgs = {
  objects: Array<Listing_Inspection_Insert_Input>,
  on_conflict?: Maybe<Listing_Inspection_On_Conflict>
};


export type Mutation_RootInsert_Listing_Inspection_OneArgs = {
  object: Listing_Inspection_Insert_Input,
  on_conflict?: Maybe<Listing_Inspection_On_Conflict>
};


export type Mutation_RootInsert_Listing_MediaArgs = {
  objects: Array<Listing_Media_Insert_Input>,
  on_conflict?: Maybe<Listing_Media_On_Conflict>
};


export type Mutation_RootInsert_Listing_Media_OneArgs = {
  object: Listing_Media_Insert_Input,
  on_conflict?: Maybe<Listing_Media_On_Conflict>
};


export type Mutation_RootInsert_Listing_Media_TypeArgs = {
  objects: Array<Listing_Media_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Media_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_Media_Type_OneArgs = {
  object: Listing_Media_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Media_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_MetadataArgs = {
  objects: Array<Listing_Metadata_Insert_Input>,
  on_conflict?: Maybe<Listing_Metadata_On_Conflict>
};


export type Mutation_RootInsert_Listing_Metadata_OneArgs = {
  object: Listing_Metadata_Insert_Input,
  on_conflict?: Maybe<Listing_Metadata_On_Conflict>
};


export type Mutation_RootInsert_Listing_OnboardingArgs = {
  objects: Array<Listing_Onboarding_Insert_Input>,
  on_conflict?: Maybe<Listing_Onboarding_On_Conflict>
};


export type Mutation_RootInsert_Listing_Onboarding_OneArgs = {
  object: Listing_Onboarding_Insert_Input,
  on_conflict?: Maybe<Listing_Onboarding_On_Conflict>
};


export type Mutation_RootInsert_Listing_OneArgs = {
  object: Listing_Insert_Input,
  on_conflict?: Maybe<Listing_On_Conflict>
};


export type Mutation_RootInsert_Listing_ParkingArgs = {
  objects: Array<Listing_Parking_Insert_Input>,
  on_conflict?: Maybe<Listing_Parking_On_Conflict>
};


export type Mutation_RootInsert_Listing_Parking_OneArgs = {
  object: Listing_Parking_Insert_Input,
  on_conflict?: Maybe<Listing_Parking_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_ErrorsArgs = {
  objects: Array<Listing_Publish_Errors_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Errors_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Errors_OneArgs = {
  object: Listing_Publish_Errors_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Errors_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Portal_SourceArgs = {
  objects: Array<Listing_Publish_Portal_Source_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Portal_Source_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Portal_Source_OneArgs = {
  object: Listing_Publish_Portal_Source_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Portal_Source_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_StatusArgs = {
  objects: Array<Listing_Publish_Status_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Status_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Status_OneArgs = {
  object: Listing_Publish_Status_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Status_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Status_TypeArgs = {
  objects: Array<Listing_Publish_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Listing_Publish_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_Publish_Status_Type_OneArgs = {
  object: Listing_Publish_Status_Type_Insert_Input,
  on_conflict?: Maybe<Listing_Publish_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_Listing_Soi_Comparable_PropertyArgs = {
  objects: Array<Listing_Soi_Comparable_Property_Insert_Input>,
  on_conflict?: Maybe<Listing_Soi_Comparable_Property_On_Conflict>
};


export type Mutation_RootInsert_Listing_Soi_Comparable_Property_OneArgs = {
  object: Listing_Soi_Comparable_Property_Insert_Input,
  on_conflict?: Maybe<Listing_Soi_Comparable_Property_On_Conflict>
};


export type Mutation_RootInsert_Metro_TypeArgs = {
  objects: Array<Metro_Type_Insert_Input>,
  on_conflict?: Maybe<Metro_Type_On_Conflict>
};


export type Mutation_RootInsert_Metro_Type_OneArgs = {
  object: Metro_Type_Insert_Input,
  on_conflict?: Maybe<Metro_Type_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Budget_SizeArgs = {
  objects: Array<Onboarding_Budget_Size_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Budget_Size_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Budget_Size_OneArgs = {
  object: Onboarding_Budget_Size_Insert_Input,
  on_conflict?: Maybe<Onboarding_Budget_Size_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Reason_SellingArgs = {
  objects: Array<Onboarding_Reason_Selling_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Reason_Selling_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Reason_Selling_OneArgs = {
  object: Onboarding_Reason_Selling_Insert_Input,
  on_conflict?: Maybe<Onboarding_Reason_Selling_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Timeframe_SellingArgs = {
  objects: Array<Onboarding_Timeframe_Selling_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Timeframe_Selling_On_Conflict>
};


export type Mutation_RootInsert_Onboarding_Timeframe_Selling_OneArgs = {
  object: Onboarding_Timeframe_Selling_Insert_Input,
  on_conflict?: Maybe<Onboarding_Timeframe_Selling_On_Conflict>
};


export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>,
  on_conflict?: Maybe<Order_On_Conflict>
};


export type Mutation_RootInsert_Order_FulfilmentArgs = {
  objects: Array<Order_Fulfilment_Insert_Input>,
  on_conflict?: Maybe<Order_Fulfilment_On_Conflict>
};


export type Mutation_RootInsert_Order_Fulfilment_OneArgs = {
  object: Order_Fulfilment_Insert_Input,
  on_conflict?: Maybe<Order_Fulfilment_On_Conflict>
};


export type Mutation_RootInsert_Order_ItemArgs = {
  objects: Array<Order_Item_Insert_Input>,
  on_conflict?: Maybe<Order_Item_On_Conflict>
};


export type Mutation_RootInsert_Order_Item_OneArgs = {
  object: Order_Item_Insert_Input,
  on_conflict?: Maybe<Order_Item_On_Conflict>
};


export type Mutation_RootInsert_Order_Item_TypeArgs = {
  objects: Array<Order_Item_Type_Insert_Input>,
  on_conflict?: Maybe<Order_Item_Type_On_Conflict>
};


export type Mutation_RootInsert_Order_Item_Type_OneArgs = {
  object: Order_Item_Type_Insert_Input,
  on_conflict?: Maybe<Order_Item_Type_On_Conflict>
};


export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input,
  on_conflict?: Maybe<Order_On_Conflict>
};


export type Mutation_RootInsert_Order_StatusArgs = {
  objects: Array<Order_Status_Insert_Input>,
  on_conflict?: Maybe<Order_Status_On_Conflict>
};


export type Mutation_RootInsert_Order_Status_OneArgs = {
  object: Order_Status_Insert_Input,
  on_conflict?: Maybe<Order_Status_On_Conflict>
};


export type Mutation_RootInsert_Publishing_Status_TypeArgs = {
  objects: Array<Publishing_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Publishing_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_Publishing_Status_Type_OneArgs = {
  object: Publishing_Status_Type_Insert_Input,
  on_conflict?: Maybe<Publishing_Status_Type_On_Conflict>
};


export type Mutation_RootInsert_Raw_Bordering_PostcodeArgs = {
  objects: Array<Raw_Bordering_Postcode_Insert_Input>,
  on_conflict?: Maybe<Raw_Bordering_Postcode_On_Conflict>
};


export type Mutation_RootInsert_Raw_Bordering_Postcode_OneArgs = {
  object: Raw_Bordering_Postcode_Insert_Input,
  on_conflict?: Maybe<Raw_Bordering_Postcode_On_Conflict>
};


export type Mutation_RootInsert_Rea_PriceArgs = {
  objects: Array<Rea_Price_Insert_Input>,
  on_conflict?: Maybe<Rea_Price_On_Conflict>
};


export type Mutation_RootInsert_Rea_Price_OneArgs = {
  object: Rea_Price_Insert_Input,
  on_conflict?: Maybe<Rea_Price_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Bulksync_RecordsArgs = {
  objects: Array<Salesforce_Bulksync_Records_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Bulksync_Records_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Bulksync_Records_OneArgs = {
  object: Salesforce_Bulksync_Records_Insert_Input,
  on_conflict?: Maybe<Salesforce_Bulksync_Records_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Connection_TokenArgs = {
  objects: Array<Salesforce_Connection_Token_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Connection_Token_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Connection_Token_OneArgs = {
  object: Salesforce_Connection_Token_Insert_Input,
  on_conflict?: Maybe<Salesforce_Connection_Token_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Sync_StatusArgs = {
  objects: Array<Salesforce_Sync_Status_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Sync_Status_On_Conflict>
};


export type Mutation_RootInsert_Salesforce_Sync_Status_OneArgs = {
  object: Salesforce_Sync_Status_Insert_Input,
  on_conflict?: Maybe<Salesforce_Sync_Status_On_Conflict>
};


export type Mutation_RootInsert_Selling_PointArgs = {
  objects: Array<Selling_Point_Insert_Input>,
  on_conflict?: Maybe<Selling_Point_On_Conflict>
};


export type Mutation_RootInsert_Selling_Point_OneArgs = {
  object: Selling_Point_Insert_Input,
  on_conflict?: Maybe<Selling_Point_On_Conflict>
};


export type Mutation_RootInsert_Stock_PhotoArgs = {
  objects: Array<Stock_Photo_Insert_Input>,
  on_conflict?: Maybe<Stock_Photo_On_Conflict>
};


export type Mutation_RootInsert_Stock_Photo_OneArgs = {
  object: Stock_Photo_Insert_Input,
  on_conflict?: Maybe<Stock_Photo_On_Conflict>
};


export type Mutation_RootInsert_Surrounding_SuburbArgs = {
  objects: Array<Surrounding_Suburb_Insert_Input>,
  on_conflict?: Maybe<Surrounding_Suburb_On_Conflict>
};


export type Mutation_RootInsert_Surrounding_Suburb_ListingArgs = {
  objects: Array<Surrounding_Suburb_Listing_Insert_Input>
};


export type Mutation_RootInsert_Surrounding_Suburb_Listing_OneArgs = {
  object: Surrounding_Suburb_Listing_Insert_Input
};


export type Mutation_RootInsert_Surrounding_Suburb_OneArgs = {
  object: Surrounding_Suburb_Insert_Input,
  on_conflict?: Maybe<Surrounding_Suburb_On_Conflict>
};


export type Mutation_RootInsert_TransactionArgs = {
  objects: Array<Transaction_Insert_Input>,
  on_conflict?: Maybe<Transaction_On_Conflict>
};


export type Mutation_RootInsert_Transaction_OneArgs = {
  object: Transaction_Insert_Input,
  on_conflict?: Maybe<Transaction_On_Conflict>
};


export type Mutation_RootInsert_Transaction_StatusArgs = {
  objects: Array<Transaction_Status_Insert_Input>,
  on_conflict?: Maybe<Transaction_Status_On_Conflict>
};


export type Mutation_RootInsert_Transaction_Status_OneArgs = {
  object: Transaction_Status_Insert_Input,
  on_conflict?: Maybe<Transaction_Status_On_Conflict>
};


export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>,
  on_conflict?: Maybe<User_On_Conflict>
};


export type Mutation_RootInsert_User_DetailArgs = {
  objects: Array<User_Detail_Insert_Input>
};


export type Mutation_RootInsert_User_Detail_OneArgs = {
  object: User_Detail_Insert_Input
};


export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input,
  on_conflict?: Maybe<User_On_Conflict>
};


export type Mutation_RootInsert_Zone_TypeArgs = {
  objects: Array<Zone_Type_Insert_Input>,
  on_conflict?: Maybe<Zone_Type_On_Conflict>
};


export type Mutation_RootInsert_Zone_Type_OneArgs = {
  object: Zone_Type_Insert_Input,
  on_conflict?: Maybe<Zone_Type_On_Conflict>
};


export type Mutation_RootList_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootModify_Order_Item_AddonArgs = {
  addonId: Scalars['uuid'],
  orderId: Scalars['uuid'],
  qty: Scalars['Int']
};


export type Mutation_RootOn_Hold_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootOpenpay_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type Mutation_RootOpenpay_PayArgs = {
  cancelUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type Mutation_RootPay_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootPaypal_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type Mutation_RootPaypal_PayArgs = {
  cancelUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type Mutation_RootPending_Publish_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootPoli_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type Mutation_RootPoli_PayArgs = {
  cancelUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  homePageUrl: Scalars['String'],
  orderId: Scalars['uuid'],
  successUrl: Scalars['String']
};


export type Mutation_RootReactivate_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootRecalculate_Coupon_Discounts_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootRecalculate_Coupon_Discounts_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootRemove_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootRemove_UserArgs = {
  userId: Scalars['uuid']
};


export type Mutation_RootRent_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootRequest_Cancel_OrderArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootReset_PasswordArgs = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type Mutation_RootSave_Rea_PricesArgs = {
  prices?: Maybe<Array<ReaPriceInput>>
};


export type Mutation_RootSell_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootSend_Bulk_Onboarding_EmailArgs = {
  agentPointIds?: Maybe<Array<Maybe<Scalars['numeric']>>>
};


export type Mutation_RootSet_PasswordArgs = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type Mutation_RootSign_UpArgs = {
  email: Scalars['String'],
  firstName?: Maybe<Scalars['String']>,
  gaClientId?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  lastName?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  submittedVia?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmSource?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>
};


export type Mutation_RootStripe_Check_TransactionArgs = {
  originId: Scalars['String']
};


export type Mutation_RootStripe_PayArgs = {
  orderId: Scalars['uuid']
};


export type Mutation_RootUnder_Offer_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootUnder_Review_ListingArgs = {
  listingId: Scalars['uuid']
};


export type Mutation_RootUpdate_AddonArgs = {
  _append?: Maybe<Addon_Append_Input>,
  _delete_at_path?: Maybe<Addon_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Addon_Delete_Elem_Input>,
  _delete_key?: Maybe<Addon_Delete_Key_Input>,
  _inc?: Maybe<Addon_Inc_Input>,
  _prepend?: Maybe<Addon_Prepend_Input>,
  _set?: Maybe<Addon_Set_Input>,
  where: Addon_Bool_Exp
};


export type Mutation_RootUpdate_Addon_Addon_GroupArgs = {
  _set?: Maybe<Addon_Addon_Group_Set_Input>,
  where: Addon_Addon_Group_Bool_Exp
};


export type Mutation_RootUpdate_Addon_Addon_Group_By_PkArgs = {
  _set?: Maybe<Addon_Addon_Group_Set_Input>,
  pk_columns: Addon_Addon_Group_Pk_Columns_Input
};


export type Mutation_RootUpdate_Addon_By_PkArgs = {
  _append?: Maybe<Addon_Append_Input>,
  _delete_at_path?: Maybe<Addon_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Addon_Delete_Elem_Input>,
  _delete_key?: Maybe<Addon_Delete_Key_Input>,
  _inc?: Maybe<Addon_Inc_Input>,
  _prepend?: Maybe<Addon_Prepend_Input>,
  _set?: Maybe<Addon_Set_Input>,
  pk_columns: Addon_Pk_Columns_Input
};


export type Mutation_RootUpdate_Addon_GroupArgs = {
  _inc?: Maybe<Addon_Group_Inc_Input>,
  _set?: Maybe<Addon_Group_Set_Input>,
  where: Addon_Group_Bool_Exp
};


export type Mutation_RootUpdate_Addon_Group_By_PkArgs = {
  _inc?: Maybe<Addon_Group_Inc_Input>,
  _set?: Maybe<Addon_Group_Set_Input>,
  pk_columns: Addon_Group_Pk_Columns_Input
};


export type Mutation_RootUpdate_Addon_Group_TypeArgs = {
  _set?: Maybe<Addon_Group_Type_Set_Input>,
  where: Addon_Group_Type_Bool_Exp
};


export type Mutation_RootUpdate_Addon_Group_Type_By_PkArgs = {
  _set?: Maybe<Addon_Group_Type_Set_Input>,
  pk_columns: Addon_Group_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Addon_PriceArgs = {
  _inc?: Maybe<Addon_Price_Inc_Input>,
  _set?: Maybe<Addon_Price_Set_Input>,
  where: Addon_Price_Bool_Exp
};


export type Mutation_RootUpdate_Addon_Price_By_PkArgs = {
  _inc?: Maybe<Addon_Price_Inc_Input>,
  _set?: Maybe<Addon_Price_Set_Input>,
  pk_columns: Addon_Price_Pk_Columns_Input
};


export type Mutation_RootUpdate_AttachmentArgs = {
  _set?: Maybe<Attachment_Set_Input>,
  where: Attachment_Bool_Exp
};


export type Mutation_RootUpdate_Attachment_By_PkArgs = {
  _set?: Maybe<Attachment_Set_Input>,
  pk_columns: Attachment_Pk_Columns_Input
};


export type Mutation_RootUpdate_Attachment_Parent_TypeArgs = {
  _set?: Maybe<Attachment_Parent_Type_Set_Input>,
  where: Attachment_Parent_Type_Bool_Exp
};


export type Mutation_RootUpdate_Attachment_Parent_Type_By_PkArgs = {
  _set?: Maybe<Attachment_Parent_Type_Set_Input>,
  pk_columns: Attachment_Parent_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Attachment_StatusArgs = {
  _set?: Maybe<Attachment_Status_Set_Input>,
  where: Attachment_Status_Bool_Exp
};


export type Mutation_RootUpdate_Attachment_Status_By_PkArgs = {
  _set?: Maybe<Attachment_Status_Set_Input>,
  pk_columns: Attachment_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_Attachment_TypeArgs = {
  _set?: Maybe<Attachment_Type_Set_Input>,
  where: Attachment_Type_Bool_Exp
};


export type Mutation_RootUpdate_Attachment_Type_By_PkArgs = {
  _set?: Maybe<Attachment_Type_Set_Input>,
  pk_columns: Attachment_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_BenefitArgs = {
  _inc?: Maybe<Benefit_Inc_Input>,
  _set?: Maybe<Benefit_Set_Input>,
  where: Benefit_Bool_Exp
};


export type Mutation_RootUpdate_Benefit_By_PkArgs = {
  _inc?: Maybe<Benefit_Inc_Input>,
  _set?: Maybe<Benefit_Set_Input>,
  pk_columns: Benefit_Pk_Columns_Input
};


export type Mutation_RootUpdate_Bmp_ListingArgs = {
  _append?: Maybe<Bmp_Listing_Append_Input>,
  _delete_at_path?: Maybe<Bmp_Listing_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Bmp_Listing_Delete_Elem_Input>,
  _delete_key?: Maybe<Bmp_Listing_Delete_Key_Input>,
  _inc?: Maybe<Bmp_Listing_Inc_Input>,
  _prepend?: Maybe<Bmp_Listing_Prepend_Input>,
  _set?: Maybe<Bmp_Listing_Set_Input>,
  where: Bmp_Listing_Bool_Exp
};


export type Mutation_RootUpdate_Bmp_Listing_By_PkArgs = {
  _append?: Maybe<Bmp_Listing_Append_Input>,
  _delete_at_path?: Maybe<Bmp_Listing_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Bmp_Listing_Delete_Elem_Input>,
  _delete_key?: Maybe<Bmp_Listing_Delete_Key_Input>,
  _inc?: Maybe<Bmp_Listing_Inc_Input>,
  _prepend?: Maybe<Bmp_Listing_Prepend_Input>,
  _set?: Maybe<Bmp_Listing_Set_Input>,
  pk_columns: Bmp_Listing_Pk_Columns_Input
};


export type Mutation_RootUpdate_Bmp_Listing_ContactArgs = {
  _inc?: Maybe<Bmp_Listing_Contact_Inc_Input>,
  _set?: Maybe<Bmp_Listing_Contact_Set_Input>,
  where: Bmp_Listing_Contact_Bool_Exp
};


export type Mutation_RootUpdate_Bmp_Listing_InspectionArgs = {
  _inc?: Maybe<Bmp_Listing_Inspection_Inc_Input>,
  _set?: Maybe<Bmp_Listing_Inspection_Set_Input>,
  where: Bmp_Listing_Inspection_Bool_Exp
};


export type Mutation_RootUpdate_Bmp_Listing_MediaArgs = {
  _inc?: Maybe<Bmp_Listing_Media_Inc_Input>,
  _set?: Maybe<Bmp_Listing_Media_Set_Input>,
  where: Bmp_Listing_Media_Bool_Exp
};


export type Mutation_RootUpdate_CacheArgs = {
  _set?: Maybe<Cache_Set_Input>,
  where: Cache_Bool_Exp
};


export type Mutation_RootUpdate_Cache_By_PkArgs = {
  _set?: Maybe<Cache_Set_Input>,
  pk_columns: Cache_Pk_Columns_Input
};


export type Mutation_RootUpdate_CampaignArgs = {
  _inc?: Maybe<Campaign_Inc_Input>,
  _set?: Maybe<Campaign_Set_Input>,
  where: Campaign_Bool_Exp
};


export type Mutation_RootUpdate_Campaign_Addon_GroupArgs = {
  _set?: Maybe<Campaign_Addon_Group_Set_Input>,
  where: Campaign_Addon_Group_Bool_Exp
};


export type Mutation_RootUpdate_Campaign_Addon_Group_By_PkArgs = {
  _set?: Maybe<Campaign_Addon_Group_Set_Input>,
  pk_columns: Campaign_Addon_Group_Pk_Columns_Input
};


export type Mutation_RootUpdate_Campaign_By_PkArgs = {
  _inc?: Maybe<Campaign_Inc_Input>,
  _set?: Maybe<Campaign_Set_Input>,
  pk_columns: Campaign_Pk_Columns_Input
};


export type Mutation_RootUpdate_Campaign_Inclusion_GroupArgs = {
  _set?: Maybe<Campaign_Inclusion_Group_Set_Input>,
  where: Campaign_Inclusion_Group_Bool_Exp
};


export type Mutation_RootUpdate_Campaign_Inclusion_Group_By_PkArgs = {
  _set?: Maybe<Campaign_Inclusion_Group_Set_Input>,
  pk_columns: Campaign_Inclusion_Group_Pk_Columns_Input
};


export type Mutation_RootUpdate_Campaign_Selling_PointArgs = {
  _set?: Maybe<Campaign_Selling_Point_Set_Input>,
  where: Campaign_Selling_Point_Bool_Exp
};


export type Mutation_RootUpdate_Campaign_Selling_Point_By_PkArgs = {
  _set?: Maybe<Campaign_Selling_Point_Set_Input>,
  pk_columns: Campaign_Selling_Point_Pk_Columns_Input
};


export type Mutation_RootUpdate_Commercial_Status_TypeArgs = {
  _set?: Maybe<Commercial_Status_Type_Set_Input>,
  where: Commercial_Status_Type_Bool_Exp
};


export type Mutation_RootUpdate_Commercial_Status_Type_By_PkArgs = {
  _set?: Maybe<Commercial_Status_Type_Set_Input>,
  pk_columns: Commercial_Status_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_CouponArgs = {
  _inc?: Maybe<Coupon_Inc_Input>,
  _set?: Maybe<Coupon_Set_Input>,
  where: Coupon_Bool_Exp
};


export type Mutation_RootUpdate_Coupon_By_PkArgs = {
  _inc?: Maybe<Coupon_Inc_Input>,
  _set?: Maybe<Coupon_Set_Input>,
  pk_columns: Coupon_Pk_Columns_Input
};


export type Mutation_RootUpdate_Coupon_TypeArgs = {
  _set?: Maybe<Coupon_Type_Set_Input>,
  where: Coupon_Type_Bool_Exp
};


export type Mutation_RootUpdate_Coupon_Type_By_PkArgs = {
  _set?: Maybe<Coupon_Type_Set_Input>,
  pk_columns: Coupon_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_EnquiryArgs = {
  _append?: Maybe<Enquiry_Append_Input>,
  _delete_at_path?: Maybe<Enquiry_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Enquiry_Delete_Elem_Input>,
  _delete_key?: Maybe<Enquiry_Delete_Key_Input>,
  _prepend?: Maybe<Enquiry_Prepend_Input>,
  _set?: Maybe<Enquiry_Set_Input>,
  where: Enquiry_Bool_Exp
};


export type Mutation_RootUpdate_Enquiry_By_PkArgs = {
  _append?: Maybe<Enquiry_Append_Input>,
  _delete_at_path?: Maybe<Enquiry_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Enquiry_Delete_Elem_Input>,
  _delete_key?: Maybe<Enquiry_Delete_Key_Input>,
  _prepend?: Maybe<Enquiry_Prepend_Input>,
  _set?: Maybe<Enquiry_Set_Input>,
  pk_columns: Enquiry_Pk_Columns_Input
};


export type Mutation_RootUpdate_Enquiry_Call_ResultArgs = {
  _set?: Maybe<Enquiry_Call_Result_Set_Input>,
  where: Enquiry_Call_Result_Bool_Exp
};


export type Mutation_RootUpdate_Enquiry_Call_Result_By_PkArgs = {
  _set?: Maybe<Enquiry_Call_Result_Set_Input>,
  pk_columns: Enquiry_Call_Result_Pk_Columns_Input
};


export type Mutation_RootUpdate_Enquiry_Medium_TypeArgs = {
  _set?: Maybe<Enquiry_Medium_Type_Set_Input>,
  where: Enquiry_Medium_Type_Bool_Exp
};


export type Mutation_RootUpdate_Enquiry_Medium_Type_By_PkArgs = {
  _set?: Maybe<Enquiry_Medium_Type_Set_Input>,
  pk_columns: Enquiry_Medium_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_ExperimentArgs = {
  _append?: Maybe<Experiment_Append_Input>,
  _delete_at_path?: Maybe<Experiment_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Experiment_Delete_Elem_Input>,
  _delete_key?: Maybe<Experiment_Delete_Key_Input>,
  _prepend?: Maybe<Experiment_Prepend_Input>,
  _set?: Maybe<Experiment_Set_Input>,
  where: Experiment_Bool_Exp
};


export type Mutation_RootUpdate_Experiment_By_PkArgs = {
  _append?: Maybe<Experiment_Append_Input>,
  _delete_at_path?: Maybe<Experiment_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Experiment_Delete_Elem_Input>,
  _delete_key?: Maybe<Experiment_Delete_Key_Input>,
  _prepend?: Maybe<Experiment_Prepend_Input>,
  _set?: Maybe<Experiment_Set_Input>,
  pk_columns: Experiment_Pk_Columns_Input
};


export type Mutation_RootUpdate_Experiment_NameArgs = {
  _set?: Maybe<Experiment_Name_Set_Input>,
  where: Experiment_Name_Bool_Exp
};


export type Mutation_RootUpdate_Experiment_Name_By_PkArgs = {
  _set?: Maybe<Experiment_Name_Set_Input>,
  pk_columns: Experiment_Name_Pk_Columns_Input
};


export type Mutation_RootUpdate_External_AuthArgs = {
  _set?: Maybe<External_Auth_Set_Input>,
  where: External_Auth_Bool_Exp
};


export type Mutation_RootUpdate_External_Auth_By_PkArgs = {
  _set?: Maybe<External_Auth_Set_Input>,
  pk_columns: External_Auth_Pk_Columns_Input
};


export type Mutation_RootUpdate_FeedbackArgs = {
  _append?: Maybe<Feedback_Append_Input>,
  _delete_at_path?: Maybe<Feedback_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Feedback_Delete_Elem_Input>,
  _delete_key?: Maybe<Feedback_Delete_Key_Input>,
  _inc?: Maybe<Feedback_Inc_Input>,
  _prepend?: Maybe<Feedback_Prepend_Input>,
  _set?: Maybe<Feedback_Set_Input>,
  where: Feedback_Bool_Exp
};


export type Mutation_RootUpdate_Feedback_By_PkArgs = {
  _append?: Maybe<Feedback_Append_Input>,
  _delete_at_path?: Maybe<Feedback_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Feedback_Delete_Elem_Input>,
  _delete_key?: Maybe<Feedback_Delete_Key_Input>,
  _inc?: Maybe<Feedback_Inc_Input>,
  _prepend?: Maybe<Feedback_Prepend_Input>,
  _set?: Maybe<Feedback_Set_Input>,
  pk_columns: Feedback_Pk_Columns_Input
};


export type Mutation_RootUpdate_InclusionArgs = {
  _inc?: Maybe<Inclusion_Inc_Input>,
  _set?: Maybe<Inclusion_Set_Input>,
  where: Inclusion_Bool_Exp
};


export type Mutation_RootUpdate_Inclusion_AddonArgs = {
  _set?: Maybe<Inclusion_Addon_Set_Input>,
  where: Inclusion_Addon_Bool_Exp
};


export type Mutation_RootUpdate_Inclusion_Addon_By_PkArgs = {
  _set?: Maybe<Inclusion_Addon_Set_Input>,
  pk_columns: Inclusion_Addon_Pk_Columns_Input
};


export type Mutation_RootUpdate_Inclusion_By_PkArgs = {
  _inc?: Maybe<Inclusion_Inc_Input>,
  _set?: Maybe<Inclusion_Set_Input>,
  pk_columns: Inclusion_Pk_Columns_Input
};


export type Mutation_RootUpdate_Inclusion_GroupArgs = {
  _inc?: Maybe<Inclusion_Group_Inc_Input>,
  _set?: Maybe<Inclusion_Group_Set_Input>,
  where: Inclusion_Group_Bool_Exp
};


export type Mutation_RootUpdate_Inclusion_Group_By_PkArgs = {
  _inc?: Maybe<Inclusion_Group_Inc_Input>,
  _set?: Maybe<Inclusion_Group_Set_Input>,
  pk_columns: Inclusion_Group_Pk_Columns_Input
};


export type Mutation_RootUpdate_ListingArgs = {
  _append?: Maybe<Listing_Append_Input>,
  _delete_at_path?: Maybe<Listing_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Listing_Delete_Elem_Input>,
  _delete_key?: Maybe<Listing_Delete_Key_Input>,
  _inc?: Maybe<Listing_Inc_Input>,
  _prepend?: Maybe<Listing_Prepend_Input>,
  _set?: Maybe<Listing_Set_Input>,
  where: Listing_Bool_Exp
};


export type Mutation_RootUpdate_Listing_By_PkArgs = {
  _append?: Maybe<Listing_Append_Input>,
  _delete_at_path?: Maybe<Listing_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Listing_Delete_Elem_Input>,
  _delete_key?: Maybe<Listing_Delete_Key_Input>,
  _inc?: Maybe<Listing_Inc_Input>,
  _prepend?: Maybe<Listing_Prepend_Input>,
  _set?: Maybe<Listing_Set_Input>,
  pk_columns: Listing_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_ContactArgs = {
  _inc?: Maybe<Listing_Contact_Inc_Input>,
  _set?: Maybe<Listing_Contact_Set_Input>,
  where: Listing_Contact_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Contact_By_PkArgs = {
  _inc?: Maybe<Listing_Contact_Inc_Input>,
  _set?: Maybe<Listing_Contact_Set_Input>,
  pk_columns: Listing_Contact_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_DocumentArgs = {
  _set?: Maybe<Listing_Document_Set_Input>,
  where: Listing_Document_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Document_By_PkArgs = {
  _set?: Maybe<Listing_Document_Set_Input>,
  pk_columns: Listing_Document_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Document_StatusArgs = {
  _set?: Maybe<Listing_Document_Status_Set_Input>,
  where: Listing_Document_Status_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Document_Status_By_PkArgs = {
  _set?: Maybe<Listing_Document_Status_Set_Input>,
  pk_columns: Listing_Document_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Document_TypeArgs = {
  _set?: Maybe<Listing_Document_Type_Set_Input>,
  where: Listing_Document_Type_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Document_Type_By_PkArgs = {
  _set?: Maybe<Listing_Document_Type_Set_Input>,
  pk_columns: Listing_Document_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_EventArgs = {
  _append?: Maybe<Listing_Event_Append_Input>,
  _delete_at_path?: Maybe<Listing_Event_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Listing_Event_Delete_Elem_Input>,
  _delete_key?: Maybe<Listing_Event_Delete_Key_Input>,
  _prepend?: Maybe<Listing_Event_Prepend_Input>,
  _set?: Maybe<Listing_Event_Set_Input>,
  where: Listing_Event_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Event_By_PkArgs = {
  _append?: Maybe<Listing_Event_Append_Input>,
  _delete_at_path?: Maybe<Listing_Event_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Listing_Event_Delete_Elem_Input>,
  _delete_key?: Maybe<Listing_Event_Delete_Key_Input>,
  _prepend?: Maybe<Listing_Event_Prepend_Input>,
  _set?: Maybe<Listing_Event_Set_Input>,
  pk_columns: Listing_Event_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Event_TypeArgs = {
  _set?: Maybe<Listing_Event_Type_Set_Input>,
  where: Listing_Event_Type_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Event_Type_By_PkArgs = {
  _set?: Maybe<Listing_Event_Type_Set_Input>,
  pk_columns: Listing_Event_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_InspectionArgs = {
  _inc?: Maybe<Listing_Inspection_Inc_Input>,
  _set?: Maybe<Listing_Inspection_Set_Input>,
  where: Listing_Inspection_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Inspection_By_PkArgs = {
  _inc?: Maybe<Listing_Inspection_Inc_Input>,
  _set?: Maybe<Listing_Inspection_Set_Input>,
  pk_columns: Listing_Inspection_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_MediaArgs = {
  _inc?: Maybe<Listing_Media_Inc_Input>,
  _set?: Maybe<Listing_Media_Set_Input>,
  where: Listing_Media_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Media_By_PkArgs = {
  _inc?: Maybe<Listing_Media_Inc_Input>,
  _set?: Maybe<Listing_Media_Set_Input>,
  pk_columns: Listing_Media_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Media_TypeArgs = {
  _set?: Maybe<Listing_Media_Type_Set_Input>,
  where: Listing_Media_Type_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Media_Type_By_PkArgs = {
  _set?: Maybe<Listing_Media_Type_Set_Input>,
  pk_columns: Listing_Media_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_MetadataArgs = {
  _set?: Maybe<Listing_Metadata_Set_Input>,
  where: Listing_Metadata_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Metadata_By_PkArgs = {
  _set?: Maybe<Listing_Metadata_Set_Input>,
  pk_columns: Listing_Metadata_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_OnboardingArgs = {
  _inc?: Maybe<Listing_Onboarding_Inc_Input>,
  _set?: Maybe<Listing_Onboarding_Set_Input>,
  where: Listing_Onboarding_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Onboarding_By_PkArgs = {
  _inc?: Maybe<Listing_Onboarding_Inc_Input>,
  _set?: Maybe<Listing_Onboarding_Set_Input>,
  pk_columns: Listing_Onboarding_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_ParkingArgs = {
  _inc?: Maybe<Listing_Parking_Inc_Input>,
  _set?: Maybe<Listing_Parking_Set_Input>,
  where: Listing_Parking_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Parking_By_PkArgs = {
  _inc?: Maybe<Listing_Parking_Inc_Input>,
  _set?: Maybe<Listing_Parking_Set_Input>,
  pk_columns: Listing_Parking_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Publish_ErrorsArgs = {
  _set?: Maybe<Listing_Publish_Errors_Set_Input>,
  where: Listing_Publish_Errors_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Publish_Errors_By_PkArgs = {
  _set?: Maybe<Listing_Publish_Errors_Set_Input>,
  pk_columns: Listing_Publish_Errors_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Publish_Portal_SourceArgs = {
  _set?: Maybe<Listing_Publish_Portal_Source_Set_Input>,
  where: Listing_Publish_Portal_Source_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Publish_Portal_Source_By_PkArgs = {
  _set?: Maybe<Listing_Publish_Portal_Source_Set_Input>,
  pk_columns: Listing_Publish_Portal_Source_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Publish_StatusArgs = {
  _set?: Maybe<Listing_Publish_Status_Set_Input>,
  where: Listing_Publish_Status_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Publish_Status_By_PkArgs = {
  _set?: Maybe<Listing_Publish_Status_Set_Input>,
  pk_columns: Listing_Publish_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Publish_Status_TypeArgs = {
  _set?: Maybe<Listing_Publish_Status_Type_Set_Input>,
  where: Listing_Publish_Status_Type_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Publish_Status_Type_By_PkArgs = {
  _set?: Maybe<Listing_Publish_Status_Type_Set_Input>,
  pk_columns: Listing_Publish_Status_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Listing_Soi_Comparable_PropertyArgs = {
  _inc?: Maybe<Listing_Soi_Comparable_Property_Inc_Input>,
  _set?: Maybe<Listing_Soi_Comparable_Property_Set_Input>,
  where: Listing_Soi_Comparable_Property_Bool_Exp
};


export type Mutation_RootUpdate_Listing_Soi_Comparable_Property_By_PkArgs = {
  _inc?: Maybe<Listing_Soi_Comparable_Property_Inc_Input>,
  _set?: Maybe<Listing_Soi_Comparable_Property_Set_Input>,
  pk_columns: Listing_Soi_Comparable_Property_Pk_Columns_Input
};


export type Mutation_RootUpdate_Metro_TypeArgs = {
  _set?: Maybe<Metro_Type_Set_Input>,
  where: Metro_Type_Bool_Exp
};


export type Mutation_RootUpdate_Metro_Type_By_PkArgs = {
  _set?: Maybe<Metro_Type_Set_Input>,
  pk_columns: Metro_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Onboarding_Budget_SizeArgs = {
  _set?: Maybe<Onboarding_Budget_Size_Set_Input>,
  where: Onboarding_Budget_Size_Bool_Exp
};


export type Mutation_RootUpdate_Onboarding_Budget_Size_By_PkArgs = {
  _set?: Maybe<Onboarding_Budget_Size_Set_Input>,
  pk_columns: Onboarding_Budget_Size_Pk_Columns_Input
};


export type Mutation_RootUpdate_Onboarding_Reason_SellingArgs = {
  _set?: Maybe<Onboarding_Reason_Selling_Set_Input>,
  where: Onboarding_Reason_Selling_Bool_Exp
};


export type Mutation_RootUpdate_Onboarding_Reason_Selling_By_PkArgs = {
  _set?: Maybe<Onboarding_Reason_Selling_Set_Input>,
  pk_columns: Onboarding_Reason_Selling_Pk_Columns_Input
};


export type Mutation_RootUpdate_Onboarding_Timeframe_SellingArgs = {
  _set?: Maybe<Onboarding_Timeframe_Selling_Set_Input>,
  where: Onboarding_Timeframe_Selling_Bool_Exp
};


export type Mutation_RootUpdate_Onboarding_Timeframe_Selling_By_PkArgs = {
  _set?: Maybe<Onboarding_Timeframe_Selling_Set_Input>,
  pk_columns: Onboarding_Timeframe_Selling_Pk_Columns_Input
};


export type Mutation_RootUpdate_OrderArgs = {
  _append?: Maybe<Order_Append_Input>,
  _delete_at_path?: Maybe<Order_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Order_Delete_Elem_Input>,
  _delete_key?: Maybe<Order_Delete_Key_Input>,
  _inc?: Maybe<Order_Inc_Input>,
  _prepend?: Maybe<Order_Prepend_Input>,
  _set?: Maybe<Order_Set_Input>,
  where: Order_Bool_Exp
};


export type Mutation_RootUpdate_Order_By_PkArgs = {
  _append?: Maybe<Order_Append_Input>,
  _delete_at_path?: Maybe<Order_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Order_Delete_Elem_Input>,
  _delete_key?: Maybe<Order_Delete_Key_Input>,
  _inc?: Maybe<Order_Inc_Input>,
  _prepend?: Maybe<Order_Prepend_Input>,
  _set?: Maybe<Order_Set_Input>,
  pk_columns: Order_Pk_Columns_Input
};


export type Mutation_RootUpdate_Order_FulfilmentArgs = {
  _append?: Maybe<Order_Fulfilment_Append_Input>,
  _delete_at_path?: Maybe<Order_Fulfilment_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Order_Fulfilment_Delete_Elem_Input>,
  _delete_key?: Maybe<Order_Fulfilment_Delete_Key_Input>,
  _prepend?: Maybe<Order_Fulfilment_Prepend_Input>,
  _set?: Maybe<Order_Fulfilment_Set_Input>,
  where: Order_Fulfilment_Bool_Exp
};


export type Mutation_RootUpdate_Order_Fulfilment_By_PkArgs = {
  _append?: Maybe<Order_Fulfilment_Append_Input>,
  _delete_at_path?: Maybe<Order_Fulfilment_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Order_Fulfilment_Delete_Elem_Input>,
  _delete_key?: Maybe<Order_Fulfilment_Delete_Key_Input>,
  _prepend?: Maybe<Order_Fulfilment_Prepend_Input>,
  _set?: Maybe<Order_Fulfilment_Set_Input>,
  pk_columns: Order_Fulfilment_Pk_Columns_Input
};


export type Mutation_RootUpdate_Order_ItemArgs = {
  _inc?: Maybe<Order_Item_Inc_Input>,
  _set?: Maybe<Order_Item_Set_Input>,
  where: Order_Item_Bool_Exp
};


export type Mutation_RootUpdate_Order_Item_By_PkArgs = {
  _inc?: Maybe<Order_Item_Inc_Input>,
  _set?: Maybe<Order_Item_Set_Input>,
  pk_columns: Order_Item_Pk_Columns_Input
};


export type Mutation_RootUpdate_Order_Item_TypeArgs = {
  _set?: Maybe<Order_Item_Type_Set_Input>,
  where: Order_Item_Type_Bool_Exp
};


export type Mutation_RootUpdate_Order_Item_Type_By_PkArgs = {
  _set?: Maybe<Order_Item_Type_Set_Input>,
  pk_columns: Order_Item_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Order_StatusArgs = {
  _set?: Maybe<Order_Status_Set_Input>,
  where: Order_Status_Bool_Exp
};


export type Mutation_RootUpdate_Order_Status_By_PkArgs = {
  _set?: Maybe<Order_Status_Set_Input>,
  pk_columns: Order_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_Order_TotalArgs = {
  newOrderTotal?: Maybe<Scalars['numeric']>,
  orderId: Scalars['uuid']
};


export type Mutation_RootUpdate_Publishing_Status_TypeArgs = {
  _set?: Maybe<Publishing_Status_Type_Set_Input>,
  where: Publishing_Status_Type_Bool_Exp
};


export type Mutation_RootUpdate_Publishing_Status_Type_By_PkArgs = {
  _set?: Maybe<Publishing_Status_Type_Set_Input>,
  pk_columns: Publishing_Status_Type_Pk_Columns_Input
};


export type Mutation_RootUpdate_Raw_Bordering_PostcodeArgs = {
  _inc?: Maybe<Raw_Bordering_Postcode_Inc_Input>,
  _set?: Maybe<Raw_Bordering_Postcode_Set_Input>,
  where: Raw_Bordering_Postcode_Bool_Exp
};


export type Mutation_RootUpdate_Raw_Bordering_Postcode_By_PkArgs = {
  _inc?: Maybe<Raw_Bordering_Postcode_Inc_Input>,
  _set?: Maybe<Raw_Bordering_Postcode_Set_Input>,
  pk_columns: Raw_Bordering_Postcode_Pk_Columns_Input
};


export type Mutation_RootUpdate_Rea_PriceArgs = {
  _append?: Maybe<Rea_Price_Append_Input>,
  _delete_at_path?: Maybe<Rea_Price_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Rea_Price_Delete_Elem_Input>,
  _delete_key?: Maybe<Rea_Price_Delete_Key_Input>,
  _prepend?: Maybe<Rea_Price_Prepend_Input>,
  _set?: Maybe<Rea_Price_Set_Input>,
  where: Rea_Price_Bool_Exp
};


export type Mutation_RootUpdate_Rea_Price_By_PkArgs = {
  _append?: Maybe<Rea_Price_Append_Input>,
  _delete_at_path?: Maybe<Rea_Price_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Rea_Price_Delete_Elem_Input>,
  _delete_key?: Maybe<Rea_Price_Delete_Key_Input>,
  _prepend?: Maybe<Rea_Price_Prepend_Input>,
  _set?: Maybe<Rea_Price_Set_Input>,
  pk_columns: Rea_Price_Pk_Columns_Input
};


export type Mutation_RootUpdate_Salesforce_Bulksync_RecordsArgs = {
  _append?: Maybe<Salesforce_Bulksync_Records_Append_Input>,
  _delete_at_path?: Maybe<Salesforce_Bulksync_Records_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Salesforce_Bulksync_Records_Delete_Elem_Input>,
  _delete_key?: Maybe<Salesforce_Bulksync_Records_Delete_Key_Input>,
  _inc?: Maybe<Salesforce_Bulksync_Records_Inc_Input>,
  _prepend?: Maybe<Salesforce_Bulksync_Records_Prepend_Input>,
  _set?: Maybe<Salesforce_Bulksync_Records_Set_Input>,
  where: Salesforce_Bulksync_Records_Bool_Exp
};


export type Mutation_RootUpdate_Salesforce_Bulksync_Records_By_PkArgs = {
  _append?: Maybe<Salesforce_Bulksync_Records_Append_Input>,
  _delete_at_path?: Maybe<Salesforce_Bulksync_Records_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Salesforce_Bulksync_Records_Delete_Elem_Input>,
  _delete_key?: Maybe<Salesforce_Bulksync_Records_Delete_Key_Input>,
  _inc?: Maybe<Salesforce_Bulksync_Records_Inc_Input>,
  _prepend?: Maybe<Salesforce_Bulksync_Records_Prepend_Input>,
  _set?: Maybe<Salesforce_Bulksync_Records_Set_Input>,
  pk_columns: Salesforce_Bulksync_Records_Pk_Columns_Input
};


export type Mutation_RootUpdate_Salesforce_Connection_TokenArgs = {
  _set?: Maybe<Salesforce_Connection_Token_Set_Input>,
  where: Salesforce_Connection_Token_Bool_Exp
};


export type Mutation_RootUpdate_Salesforce_Connection_Token_By_PkArgs = {
  _set?: Maybe<Salesforce_Connection_Token_Set_Input>,
  pk_columns: Salesforce_Connection_Token_Pk_Columns_Input
};


export type Mutation_RootUpdate_Salesforce_Sync_StatusArgs = {
  _set?: Maybe<Salesforce_Sync_Status_Set_Input>,
  where: Salesforce_Sync_Status_Bool_Exp
};


export type Mutation_RootUpdate_Salesforce_Sync_Status_By_PkArgs = {
  _set?: Maybe<Salesforce_Sync_Status_Set_Input>,
  pk_columns: Salesforce_Sync_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_Selling_PointArgs = {
  _inc?: Maybe<Selling_Point_Inc_Input>,
  _set?: Maybe<Selling_Point_Set_Input>,
  where: Selling_Point_Bool_Exp
};


export type Mutation_RootUpdate_Selling_Point_By_PkArgs = {
  _inc?: Maybe<Selling_Point_Inc_Input>,
  _set?: Maybe<Selling_Point_Set_Input>,
  pk_columns: Selling_Point_Pk_Columns_Input
};


export type Mutation_RootUpdate_Stock_PhotoArgs = {
  _set?: Maybe<Stock_Photo_Set_Input>,
  where: Stock_Photo_Bool_Exp
};


export type Mutation_RootUpdate_Stock_Photo_By_PkArgs = {
  _set?: Maybe<Stock_Photo_Set_Input>,
  pk_columns: Stock_Photo_Pk_Columns_Input
};


export type Mutation_RootUpdate_Surrounding_SuburbArgs = {
  _inc?: Maybe<Surrounding_Suburb_Inc_Input>,
  _set?: Maybe<Surrounding_Suburb_Set_Input>,
  where: Surrounding_Suburb_Bool_Exp
};


export type Mutation_RootUpdate_Surrounding_Suburb_By_PkArgs = {
  _inc?: Maybe<Surrounding_Suburb_Inc_Input>,
  _set?: Maybe<Surrounding_Suburb_Set_Input>,
  pk_columns: Surrounding_Suburb_Pk_Columns_Input
};


export type Mutation_RootUpdate_Surrounding_Suburb_ListingArgs = {
  _inc?: Maybe<Surrounding_Suburb_Listing_Inc_Input>,
  _set?: Maybe<Surrounding_Suburb_Listing_Set_Input>,
  where: Surrounding_Suburb_Listing_Bool_Exp
};


export type Mutation_RootUpdate_TransactionArgs = {
  _append?: Maybe<Transaction_Append_Input>,
  _delete_at_path?: Maybe<Transaction_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Transaction_Delete_Elem_Input>,
  _delete_key?: Maybe<Transaction_Delete_Key_Input>,
  _inc?: Maybe<Transaction_Inc_Input>,
  _prepend?: Maybe<Transaction_Prepend_Input>,
  _set?: Maybe<Transaction_Set_Input>,
  where: Transaction_Bool_Exp
};


export type Mutation_RootUpdate_Transaction_By_PkArgs = {
  _append?: Maybe<Transaction_Append_Input>,
  _delete_at_path?: Maybe<Transaction_Delete_At_Path_Input>,
  _delete_elem?: Maybe<Transaction_Delete_Elem_Input>,
  _delete_key?: Maybe<Transaction_Delete_Key_Input>,
  _inc?: Maybe<Transaction_Inc_Input>,
  _prepend?: Maybe<Transaction_Prepend_Input>,
  _set?: Maybe<Transaction_Set_Input>,
  pk_columns: Transaction_Pk_Columns_Input
};


export type Mutation_RootUpdate_Transaction_StatusArgs = {
  _set?: Maybe<Transaction_Status_Set_Input>,
  where: Transaction_Status_Bool_Exp
};


export type Mutation_RootUpdate_Transaction_Status_By_PkArgs = {
  _set?: Maybe<Transaction_Status_Set_Input>,
  pk_columns: Transaction_Status_Pk_Columns_Input
};


export type Mutation_RootUpdate_UserArgs = {
  _append?: Maybe<User_Append_Input>,
  _delete_at_path?: Maybe<User_Delete_At_Path_Input>,
  _delete_elem?: Maybe<User_Delete_Elem_Input>,
  _delete_key?: Maybe<User_Delete_Key_Input>,
  _inc?: Maybe<User_Inc_Input>,
  _prepend?: Maybe<User_Prepend_Input>,
  _set?: Maybe<User_Set_Input>,
  where: User_Bool_Exp
};


export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: Maybe<User_Append_Input>,
  _delete_at_path?: Maybe<User_Delete_At_Path_Input>,
  _delete_elem?: Maybe<User_Delete_Elem_Input>,
  _delete_key?: Maybe<User_Delete_Key_Input>,
  _inc?: Maybe<User_Inc_Input>,
  _prepend?: Maybe<User_Prepend_Input>,
  _set?: Maybe<User_Set_Input>,
  pk_columns: User_Pk_Columns_Input
};


export type Mutation_RootUpdate_User_DetailArgs = {
  _inc?: Maybe<User_Detail_Inc_Input>,
  _set?: Maybe<User_Detail_Set_Input>,
  where: User_Detail_Bool_Exp
};


export type Mutation_RootUpdate_User_Email_VerificationArgs = {
  email_verified?: Maybe<Scalars['Boolean']>,
  userId: Scalars['uuid']
};


export type Mutation_RootUpdate_User_Password_PhoneArgs = {
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  userId: Scalars['String']
};


export type Mutation_RootUpdate_Zone_TypeArgs = {
  _set?: Maybe<Zone_Type_Set_Input>,
  where: Zone_Type_Bool_Exp
};


export type Mutation_RootUpdate_Zone_Type_By_PkArgs = {
  _set?: Maybe<Zone_Type_Set_Input>,
  pk_columns: Zone_Type_Pk_Columns_Input
};


export type Mutation_RootVerify_User_EmailArgs = {
  hash: Scalars['String']
};


export type Mutation_RootWithdraw_ListingArgs = {
  listingId: Scalars['uuid']
};

export type NationalIdRequestCn = {
  cardNumber: Scalars['String'],
  dob: Scalars['String'],
  fullName: Scalars['String'],
};

export type NationalIdResponseCn = {
  __typename?: 'NationalIDResponseCN',
  Message?: Maybe<Scalars['String']>,
  Results?: Maybe<Results_Nicn>,
  SafeHarbour?: Maybe<Scalars['String']>,
  Status?: Maybe<Scalars['String']>,
  pdfLink?: Maybe<Scalars['String']>,
  rapidID?: Maybe<Scalars['String']>,
};


export type Numeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>,
  _gt?: Maybe<Scalars['numeric']>,
  _gte?: Maybe<Scalars['numeric']>,
  _in?: Maybe<Array<Scalars['numeric']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['numeric']>,
  _lte?: Maybe<Scalars['numeric']>,
  _neq?: Maybe<Scalars['numeric']>,
  _nin?: Maybe<Array<Scalars['numeric']>>,
};

export type Onboarding_Budget_Size = {
  __typename?: 'onboarding_budget_size',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Onboarding_Budget_Size_Aggregate = {
  __typename?: 'onboarding_budget_size_aggregate',
  aggregate?: Maybe<Onboarding_Budget_Size_Aggregate_Fields>,
  nodes: Array<Onboarding_Budget_Size>,
};

export type Onboarding_Budget_Size_Aggregate_Fields = {
  __typename?: 'onboarding_budget_size_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Onboarding_Budget_Size_Max_Fields>,
  min?: Maybe<Onboarding_Budget_Size_Min_Fields>,
};


export type Onboarding_Budget_Size_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Onboarding_Budget_Size_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Onboarding_Budget_Size_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Onboarding_Budget_Size_Max_Order_By>,
  min?: Maybe<Onboarding_Budget_Size_Min_Order_By>,
};

export type Onboarding_Budget_Size_Arr_Rel_Insert_Input = {
  data: Array<Onboarding_Budget_Size_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Budget_Size_On_Conflict>,
};

export type Onboarding_Budget_Size_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Onboarding_Budget_Size_Bool_Exp>>>,
  _not?: Maybe<Onboarding_Budget_Size_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Onboarding_Budget_Size_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Onboarding_Budget_Size_Constraint {
  OnboardingBudgetSizePkey = 'onboarding_budget_size_pkey'
}

export enum Onboarding_Budget_Size_Enum {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type Onboarding_Budget_Size_Enum_Comparison_Exp = {
  _eq?: Maybe<Onboarding_Budget_Size_Enum>,
  _in?: Maybe<Array<Onboarding_Budget_Size_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Onboarding_Budget_Size_Enum>,
  _nin?: Maybe<Array<Onboarding_Budget_Size_Enum>>,
};

export type Onboarding_Budget_Size_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Budget_Size_Max_Fields = {
  __typename?: 'onboarding_budget_size_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Budget_Size_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Budget_Size_Min_Fields = {
  __typename?: 'onboarding_budget_size_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Budget_Size_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Budget_Size_Mutation_Response = {
  __typename?: 'onboarding_budget_size_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Onboarding_Budget_Size>,
};

export type Onboarding_Budget_Size_Obj_Rel_Insert_Input = {
  data: Onboarding_Budget_Size_Insert_Input,
  on_conflict?: Maybe<Onboarding_Budget_Size_On_Conflict>,
};

export type Onboarding_Budget_Size_On_Conflict = {
  constraint: Onboarding_Budget_Size_Constraint,
  update_columns: Array<Onboarding_Budget_Size_Update_Column>,
  where?: Maybe<Onboarding_Budget_Size_Bool_Exp>,
};

export type Onboarding_Budget_Size_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Budget_Size_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Onboarding_Budget_Size_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Onboarding_Budget_Size_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Onboarding_Budget_Size_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Onboarding_Reason_Selling = {
  __typename?: 'onboarding_reason_selling',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Onboarding_Reason_Selling_Aggregate = {
  __typename?: 'onboarding_reason_selling_aggregate',
  aggregate?: Maybe<Onboarding_Reason_Selling_Aggregate_Fields>,
  nodes: Array<Onboarding_Reason_Selling>,
};

export type Onboarding_Reason_Selling_Aggregate_Fields = {
  __typename?: 'onboarding_reason_selling_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Onboarding_Reason_Selling_Max_Fields>,
  min?: Maybe<Onboarding_Reason_Selling_Min_Fields>,
};


export type Onboarding_Reason_Selling_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Onboarding_Reason_Selling_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Onboarding_Reason_Selling_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Onboarding_Reason_Selling_Max_Order_By>,
  min?: Maybe<Onboarding_Reason_Selling_Min_Order_By>,
};

export type Onboarding_Reason_Selling_Arr_Rel_Insert_Input = {
  data: Array<Onboarding_Reason_Selling_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Reason_Selling_On_Conflict>,
};

export type Onboarding_Reason_Selling_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Onboarding_Reason_Selling_Bool_Exp>>>,
  _not?: Maybe<Onboarding_Reason_Selling_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Onboarding_Reason_Selling_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Onboarding_Reason_Selling_Constraint {
  OnboardingReasonSellingPkey = 'onboarding_reason_selling_pkey'
}

export enum Onboarding_Reason_Selling_Enum {
  Downsizing = 'DOWNSIZING',
  Money = 'MONEY',
  Other = 'OTHER',
  Relocating = 'RELOCATING',
  Upsizing = 'UPSIZING'
}

export type Onboarding_Reason_Selling_Enum_Comparison_Exp = {
  _eq?: Maybe<Onboarding_Reason_Selling_Enum>,
  _in?: Maybe<Array<Onboarding_Reason_Selling_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Onboarding_Reason_Selling_Enum>,
  _nin?: Maybe<Array<Onboarding_Reason_Selling_Enum>>,
};

export type Onboarding_Reason_Selling_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Reason_Selling_Max_Fields = {
  __typename?: 'onboarding_reason_selling_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Reason_Selling_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Reason_Selling_Min_Fields = {
  __typename?: 'onboarding_reason_selling_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Reason_Selling_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Reason_Selling_Mutation_Response = {
  __typename?: 'onboarding_reason_selling_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Onboarding_Reason_Selling>,
};

export type Onboarding_Reason_Selling_Obj_Rel_Insert_Input = {
  data: Onboarding_Reason_Selling_Insert_Input,
  on_conflict?: Maybe<Onboarding_Reason_Selling_On_Conflict>,
};

export type Onboarding_Reason_Selling_On_Conflict = {
  constraint: Onboarding_Reason_Selling_Constraint,
  update_columns: Array<Onboarding_Reason_Selling_Update_Column>,
  where?: Maybe<Onboarding_Reason_Selling_Bool_Exp>,
};

export type Onboarding_Reason_Selling_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Reason_Selling_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Onboarding_Reason_Selling_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Onboarding_Reason_Selling_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Onboarding_Reason_Selling_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Onboarding_Timeframe_Selling = {
  __typename?: 'onboarding_timeframe_selling',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Onboarding_Timeframe_Selling_Aggregate = {
  __typename?: 'onboarding_timeframe_selling_aggregate',
  aggregate?: Maybe<Onboarding_Timeframe_Selling_Aggregate_Fields>,
  nodes: Array<Onboarding_Timeframe_Selling>,
};

export type Onboarding_Timeframe_Selling_Aggregate_Fields = {
  __typename?: 'onboarding_timeframe_selling_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Onboarding_Timeframe_Selling_Max_Fields>,
  min?: Maybe<Onboarding_Timeframe_Selling_Min_Fields>,
};


export type Onboarding_Timeframe_Selling_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Onboarding_Timeframe_Selling_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Onboarding_Timeframe_Selling_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Onboarding_Timeframe_Selling_Max_Order_By>,
  min?: Maybe<Onboarding_Timeframe_Selling_Min_Order_By>,
};

export type Onboarding_Timeframe_Selling_Arr_Rel_Insert_Input = {
  data: Array<Onboarding_Timeframe_Selling_Insert_Input>,
  on_conflict?: Maybe<Onboarding_Timeframe_Selling_On_Conflict>,
};

export type Onboarding_Timeframe_Selling_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Onboarding_Timeframe_Selling_Bool_Exp>>>,
  _not?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Onboarding_Timeframe_Selling_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Onboarding_Timeframe_Selling_Constraint {
  OnboardingTimeframeSellingPkey = 'onboarding_timeframe_selling_pkey'
}

export enum Onboarding_Timeframe_Selling_Enum {
  In_3Months = 'IN_3_MONTHS',
  In_4_6Months = 'IN_4_6_MONTHS',
  In_4Weeks = 'IN_4_WEEKS',
  In_6PlusMonths = 'IN_6_PLUS_MONTHS'
}

export type Onboarding_Timeframe_Selling_Enum_Comparison_Exp = {
  _eq?: Maybe<Onboarding_Timeframe_Selling_Enum>,
  _in?: Maybe<Array<Onboarding_Timeframe_Selling_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Onboarding_Timeframe_Selling_Enum>,
  _nin?: Maybe<Array<Onboarding_Timeframe_Selling_Enum>>,
};

export type Onboarding_Timeframe_Selling_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Timeframe_Selling_Max_Fields = {
  __typename?: 'onboarding_timeframe_selling_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Timeframe_Selling_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Timeframe_Selling_Min_Fields = {
  __typename?: 'onboarding_timeframe_selling_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Onboarding_Timeframe_Selling_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Timeframe_Selling_Mutation_Response = {
  __typename?: 'onboarding_timeframe_selling_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Onboarding_Timeframe_Selling>,
};

export type Onboarding_Timeframe_Selling_Obj_Rel_Insert_Input = {
  data: Onboarding_Timeframe_Selling_Insert_Input,
  on_conflict?: Maybe<Onboarding_Timeframe_Selling_On_Conflict>,
};

export type Onboarding_Timeframe_Selling_On_Conflict = {
  constraint: Onboarding_Timeframe_Selling_Constraint,
  update_columns: Array<Onboarding_Timeframe_Selling_Update_Column>,
  where?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>,
};

export type Onboarding_Timeframe_Selling_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Onboarding_Timeframe_Selling_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Onboarding_Timeframe_Selling_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Onboarding_Timeframe_Selling_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Onboarding_Timeframe_Selling_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Order = {
  __typename?: 'order',
  created_at: Scalars['timestamptz'],
  created_from_template: Scalars['Boolean'],
  experiments?: Maybe<Scalars['jsonb']>,
  id: Scalars['uuid'],
  listing: Listing,
  listing_id: Scalars['uuid'],
  order_items: Array<Order_Item>,
  order_items_aggregate: Order_Item_Aggregate,
  order_status: Order_Status,
  order_total: Scalars['numeric'],
  order_total_without_discount: Scalars['numeric'],
  processed_by_id?: Maybe<Scalars['uuid']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status: Order_Status_Enum,
  transactions: Array<Transaction>,
  transactions_aggregate: Transaction_Aggregate,
  updated_at: Scalars['timestamptz'],
  user?: Maybe<User>,
};


export type OrderExperimentsArgs = {
  path?: Maybe<Scalars['String']>
};


export type OrderOrder_ItemsArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type OrderOrder_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type OrderTransactionsArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type OrderTransactions_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};

export type Order_Aggregate = {
  __typename?: 'order_aggregate',
  aggregate?: Maybe<Order_Aggregate_Fields>,
  nodes: Array<Order>,
};

export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields',
  avg?: Maybe<Order_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Max_Fields>,
  min?: Maybe<Order_Min_Fields>,
  stddev?: Maybe<Order_Stddev_Fields>,
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>,
  sum?: Maybe<Order_Sum_Fields>,
  var_pop?: Maybe<Order_Var_Pop_Fields>,
  var_samp?: Maybe<Order_Var_Samp_Fields>,
  variance?: Maybe<Order_Variance_Fields>,
};


export type Order_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Aggregate_Order_By = {
  avg?: Maybe<Order_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Max_Order_By>,
  min?: Maybe<Order_Min_Order_By>,
  stddev?: Maybe<Order_Stddev_Order_By>,
  stddev_pop?: Maybe<Order_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Order_Stddev_Samp_Order_By>,
  sum?: Maybe<Order_Sum_Order_By>,
  var_pop?: Maybe<Order_Var_Pop_Order_By>,
  var_samp?: Maybe<Order_Var_Samp_Order_By>,
  variance?: Maybe<Order_Variance_Order_By>,
};

export type Order_Append_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>,
  on_conflict?: Maybe<Order_On_Conflict>,
};

export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Avg_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Bool_Exp>>>,
  _not?: Maybe<Order_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  created_from_template?: Maybe<Boolean_Comparison_Exp>,
  experiments?: Maybe<Jsonb_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  order_items?: Maybe<Order_Item_Bool_Exp>,
  order_status?: Maybe<Order_Status_Bool_Exp>,
  order_total?: Maybe<Numeric_Comparison_Exp>,
  order_total_without_discount?: Maybe<Numeric_Comparison_Exp>,
  processed_by_id?: Maybe<Uuid_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  status?: Maybe<Order_Status_Enum_Comparison_Exp>,
  transactions?: Maybe<Transaction_Bool_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  user?: Maybe<User_Bool_Exp>,
};

export enum Order_By {
  Asc = 'asc',
  AscNullsFirst = 'asc_nulls_first',
  AscNullsLast = 'asc_nulls_last',
  Desc = 'desc',
  DescNullsFirst = 'desc_nulls_first',
  DescNullsLast = 'desc_nulls_last'
}

export enum Order_Constraint {
  OrderPkey = 'order_pkey'
}

export type Order_Delete_At_Path_Input = {
  experiments?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Order_Delete_Elem_Input = {
  experiments?: Maybe<Scalars['Int']>,
};

export type Order_Delete_Key_Input = {
  experiments?: Maybe<Scalars['String']>,
};

export type Order_Detail = {
  __typename?: 'order_detail',
  created_at?: Maybe<Scalars['timestamptz']>,
  created_from_template?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  listing?: Maybe<Listing>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_items: Array<Order_Item>,
  order_items_aggregate: Order_Item_Aggregate,
  order_total?: Maybe<Scalars['bigint']>,
  order_total_static?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['bigint']>,
  order_total_without_discount_static?: Maybe<Scalars['numeric']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_name?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  transactions: Array<Transaction>,
  transactions_aggregate: Transaction_Aggregate,
  updated_at?: Maybe<Scalars['timestamptz']>,
};


export type Order_DetailOrder_ItemsArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Order_DetailOrder_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Order_DetailTransactionsArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type Order_DetailTransactions_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};

export type Order_Detail_Aggregate = {
  __typename?: 'order_detail_aggregate',
  aggregate?: Maybe<Order_Detail_Aggregate_Fields>,
  nodes: Array<Order_Detail>,
};

export type Order_Detail_Aggregate_Fields = {
  __typename?: 'order_detail_aggregate_fields',
  avg?: Maybe<Order_Detail_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Detail_Max_Fields>,
  min?: Maybe<Order_Detail_Min_Fields>,
  stddev?: Maybe<Order_Detail_Stddev_Fields>,
  stddev_pop?: Maybe<Order_Detail_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Order_Detail_Stddev_Samp_Fields>,
  sum?: Maybe<Order_Detail_Sum_Fields>,
  var_pop?: Maybe<Order_Detail_Var_Pop_Fields>,
  var_samp?: Maybe<Order_Detail_Var_Samp_Fields>,
  variance?: Maybe<Order_Detail_Variance_Fields>,
};


export type Order_Detail_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Detail_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Detail_Aggregate_Order_By = {
  avg?: Maybe<Order_Detail_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Detail_Max_Order_By>,
  min?: Maybe<Order_Detail_Min_Order_By>,
  stddev?: Maybe<Order_Detail_Stddev_Order_By>,
  stddev_pop?: Maybe<Order_Detail_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Order_Detail_Stddev_Samp_Order_By>,
  sum?: Maybe<Order_Detail_Sum_Order_By>,
  var_pop?: Maybe<Order_Detail_Var_Pop_Order_By>,
  var_samp?: Maybe<Order_Detail_Var_Samp_Order_By>,
  variance?: Maybe<Order_Detail_Variance_Order_By>,
};

export type Order_Detail_Avg_Fields = {
  __typename?: 'order_detail_avg_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Avg_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Detail_Bool_Exp>>>,
  _not?: Maybe<Order_Detail_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Detail_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  created_from_template?: Maybe<Boolean_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  enquiry_code?: Maybe<Int_Comparison_Exp>,
  first_name?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  last_name?: Maybe<String_Comparison_Exp>,
  listing?: Maybe<Listing_Bool_Exp>,
  listing_id?: Maybe<Uuid_Comparison_Exp>,
  order_items?: Maybe<Order_Item_Bool_Exp>,
  order_total?: Maybe<Bigint_Comparison_Exp>,
  order_total_static?: Maybe<Numeric_Comparison_Exp>,
  order_total_without_discount?: Maybe<Bigint_Comparison_Exp>,
  order_total_without_discount_static?: Maybe<Numeric_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  processed_name?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_displayOption?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_street?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_unitNumber?: Maybe<String_Comparison_Exp>,
  status?: Maybe<String_Comparison_Exp>,
  transactions?: Maybe<Transaction_Bool_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export type Order_Detail_Max_Fields = {
  __typename?: 'order_detail_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_total?: Maybe<Scalars['bigint']>,
  order_total_static?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['bigint']>,
  order_total_without_discount_static?: Maybe<Scalars['numeric']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_name?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Detail_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_name?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Detail_Min_Fields = {
  __typename?: 'order_detail_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  email?: Maybe<Scalars['String']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  first_name?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_total?: Maybe<Scalars['bigint']>,
  order_total_static?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['bigint']>,
  order_total_without_discount_static?: Maybe<Scalars['numeric']>,
  owner_id?: Maybe<Scalars['uuid']>,
  processed_name?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Detail_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_name?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Detail_Order_By = {
  created_at?: Maybe<Order_By>,
  created_from_template?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  order_items_aggregate?: Maybe<Order_Item_Aggregate_Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  processed_name?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  transactions_aggregate?: Maybe<Transaction_Aggregate_Order_By>,
  updated_at?: Maybe<Order_By>,
};

export enum Order_Detail_Select_Column {
  CreatedAt = 'created_at',
  CreatedFromTemplate = 'created_from_template',
  Email = 'email',
  EnquiryCode = 'enquiry_code',
  FirstName = 'first_name',
  Id = 'id',
  LastName = 'last_name',
  ListingId = 'listing_id',
  OrderTotal = 'order_total',
  OrderTotalStatic = 'order_total_static',
  OrderTotalWithoutDiscount = 'order_total_without_discount',
  OrderTotalWithoutDiscountStatic = 'order_total_without_discount_static',
  OwnerId = 'owner_id',
  ProcessedName = 'processed_name',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type Order_Detail_Stddev_Fields = {
  __typename?: 'order_detail_stddev_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Stddev_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Stddev_Pop_Fields = {
  __typename?: 'order_detail_stddev_pop_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Stddev_Pop_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Stddev_Samp_Fields = {
  __typename?: 'order_detail_stddev_samp_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Stddev_Samp_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Sum_Fields = {
  __typename?: 'order_detail_sum_fields',
  enquiry_code?: Maybe<Scalars['Int']>,
  order_total?: Maybe<Scalars['bigint']>,
  order_total_static?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['bigint']>,
  order_total_without_discount_static?: Maybe<Scalars['numeric']>,
};

export type Order_Detail_Sum_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Var_Pop_Fields = {
  __typename?: 'order_detail_var_pop_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Var_Pop_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Var_Samp_Fields = {
  __typename?: 'order_detail_var_samp_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Var_Samp_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Detail_Variance_Fields = {
  __typename?: 'order_detail_variance_fields',
  enquiry_code?: Maybe<Scalars['Float']>,
  order_total?: Maybe<Scalars['Float']>,
  order_total_static?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
  order_total_without_discount_static?: Maybe<Scalars['Float']>,
};

export type Order_Detail_Variance_Order_By = {
  enquiry_code?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_static?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  order_total_without_discount_static?: Maybe<Order_By>,
};

export type Order_Fulfilment = {
  __typename?: 'order_fulfilment',
  abc_order_id: Scalars['String'],
  abc_photo_order_id?: Maybe<Scalars['String']>,
  abc_property_id?: Maybe<Scalars['String']>,
  abc_request?: Maybe<Scalars['jsonb']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id: Scalars['uuid'],
  order: Order,
  order_id: Scalars['uuid'],
  order_status: Scalars['String'],
  updated_at?: Maybe<Scalars['timestamptz']>,
};


export type Order_FulfilmentAbc_RequestArgs = {
  path?: Maybe<Scalars['String']>
};

export type Order_Fulfilment_Aggregate = {
  __typename?: 'order_fulfilment_aggregate',
  aggregate?: Maybe<Order_Fulfilment_Aggregate_Fields>,
  nodes: Array<Order_Fulfilment>,
};

export type Order_Fulfilment_Aggregate_Fields = {
  __typename?: 'order_fulfilment_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Fulfilment_Max_Fields>,
  min?: Maybe<Order_Fulfilment_Min_Fields>,
};


export type Order_Fulfilment_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Fulfilment_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Fulfilment_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Fulfilment_Max_Order_By>,
  min?: Maybe<Order_Fulfilment_Min_Order_By>,
};

export type Order_Fulfilment_Append_Input = {
  abc_request?: Maybe<Scalars['jsonb']>,
};

export type Order_Fulfilment_Arr_Rel_Insert_Input = {
  data: Array<Order_Fulfilment_Insert_Input>,
  on_conflict?: Maybe<Order_Fulfilment_On_Conflict>,
};

export type Order_Fulfilment_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Fulfilment_Bool_Exp>>>,
  _not?: Maybe<Order_Fulfilment_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Fulfilment_Bool_Exp>>>,
  abc_order_id?: Maybe<String_Comparison_Exp>,
  abc_photo_order_id?: Maybe<String_Comparison_Exp>,
  abc_property_id?: Maybe<String_Comparison_Exp>,
  abc_request?: Maybe<Jsonb_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  order?: Maybe<Order_Bool_Exp>,
  order_id?: Maybe<Uuid_Comparison_Exp>,
  order_status?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Order_Fulfilment_Constraint {
  OrderFulfilmentAbcPhotoOrderIdKey = 'order_fulfilment_abc_photo_order_id_key',
  OrderFulfilmentPkey = 'order_fulfilment_pkey'
}

export type Order_Fulfilment_Delete_At_Path_Input = {
  abc_request?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Order_Fulfilment_Delete_Elem_Input = {
  abc_request?: Maybe<Scalars['Int']>,
};

export type Order_Fulfilment_Delete_Key_Input = {
  abc_request?: Maybe<Scalars['String']>,
};

export type Order_Fulfilment_Insert_Input = {
  abc_order_id?: Maybe<Scalars['String']>,
  abc_photo_order_id?: Maybe<Scalars['String']>,
  abc_property_id?: Maybe<Scalars['String']>,
  abc_request?: Maybe<Scalars['jsonb']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order?: Maybe<Order_Obj_Rel_Insert_Input>,
  order_id?: Maybe<Scalars['uuid']>,
  order_status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Fulfilment_Max_Fields = {
  __typename?: 'order_fulfilment_max_fields',
  abc_order_id?: Maybe<Scalars['String']>,
  abc_photo_order_id?: Maybe<Scalars['String']>,
  abc_property_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order_id?: Maybe<Scalars['uuid']>,
  order_status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Fulfilment_Max_Order_By = {
  abc_order_id?: Maybe<Order_By>,
  abc_photo_order_id?: Maybe<Order_By>,
  abc_property_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  order_status?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Fulfilment_Min_Fields = {
  __typename?: 'order_fulfilment_min_fields',
  abc_order_id?: Maybe<Scalars['String']>,
  abc_photo_order_id?: Maybe<Scalars['String']>,
  abc_property_id?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order_id?: Maybe<Scalars['uuid']>,
  order_status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Fulfilment_Min_Order_By = {
  abc_order_id?: Maybe<Order_By>,
  abc_photo_order_id?: Maybe<Order_By>,
  abc_property_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  order_status?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Fulfilment_Mutation_Response = {
  __typename?: 'order_fulfilment_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Order_Fulfilment>,
};

export type Order_Fulfilment_Obj_Rel_Insert_Input = {
  data: Order_Fulfilment_Insert_Input,
  on_conflict?: Maybe<Order_Fulfilment_On_Conflict>,
};

export type Order_Fulfilment_On_Conflict = {
  constraint: Order_Fulfilment_Constraint,
  update_columns: Array<Order_Fulfilment_Update_Column>,
  where?: Maybe<Order_Fulfilment_Bool_Exp>,
};

export type Order_Fulfilment_Order_By = {
  abc_order_id?: Maybe<Order_By>,
  abc_photo_order_id?: Maybe<Order_By>,
  abc_property_id?: Maybe<Order_By>,
  abc_request?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order?: Maybe<Order_Order_By>,
  order_id?: Maybe<Order_By>,
  order_status?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Fulfilment_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Order_Fulfilment_Prepend_Input = {
  abc_request?: Maybe<Scalars['jsonb']>,
};

export enum Order_Fulfilment_Select_Column {
  AbcOrderId = 'abc_order_id',
  AbcPhotoOrderId = 'abc_photo_order_id',
  AbcPropertyId = 'abc_property_id',
  AbcRequest = 'abc_request',
  CreatedAt = 'created_at',
  Id = 'id',
  OrderId = 'order_id',
  OrderStatus = 'order_status',
  UpdatedAt = 'updated_at'
}

export type Order_Fulfilment_Set_Input = {
  abc_order_id?: Maybe<Scalars['String']>,
  abc_photo_order_id?: Maybe<Scalars['String']>,
  abc_property_id?: Maybe<Scalars['String']>,
  abc_request?: Maybe<Scalars['jsonb']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order_id?: Maybe<Scalars['uuid']>,
  order_status?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Order_Fulfilment_Update_Column {
  AbcOrderId = 'abc_order_id',
  AbcPhotoOrderId = 'abc_photo_order_id',
  AbcPropertyId = 'abc_property_id',
  AbcRequest = 'abc_request',
  CreatedAt = 'created_at',
  Id = 'id',
  OrderId = 'order_id',
  OrderStatus = 'order_status',
  UpdatedAt = 'updated_at'
}

export type Order_Inc_Input = {
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
};

export type Order_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  created_from_template?: Maybe<Scalars['Boolean']>,
  experiments?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  listing?: Maybe<Listing_Obj_Rel_Insert_Input>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_items?: Maybe<Order_Item_Arr_Rel_Insert_Input>,
  order_status?: Maybe<Order_Status_Obj_Rel_Insert_Input>,
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status?: Maybe<Order_Status_Enum>,
  transactions?: Maybe<Transaction_Arr_Rel_Insert_Input>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  user?: Maybe<User_Obj_Rel_Insert_Input>,
};

export type Order_Item = {
  __typename?: 'order_item',
  addon?: Maybe<Addon>,
  addon_id?: Maybe<Scalars['uuid']>,
  campaign?: Maybe<Campaign>,
  campaign_id?: Maybe<Scalars['uuid']>,
  coupon?: Maybe<Coupon>,
  coupon_id?: Maybe<Scalars['uuid']>,
  created_at: Scalars['timestamptz'],
  fulfillment_status?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  item_qty: Scalars['Int'],
  name?: Maybe<Scalars['String']>,
  order: Order,
  order_id: Scalars['uuid'],
  price: Scalars['Int'],
  processed_by_id?: Maybe<Scalars['uuid']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
  refund_status?: Maybe<Scalars['String']>,
  removed: Scalars['Boolean'],
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status?: Maybe<Order_Status_Enum>,
  type?: Maybe<Order_Item_Type_Enum>,
  updated_at: Scalars['timestamptz'],
};

export type Order_Item_Aggregate = {
  __typename?: 'order_item_aggregate',
  aggregate?: Maybe<Order_Item_Aggregate_Fields>,
  nodes: Array<Order_Item>,
};

export type Order_Item_Aggregate_Fields = {
  __typename?: 'order_item_aggregate_fields',
  avg?: Maybe<Order_Item_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Item_Max_Fields>,
  min?: Maybe<Order_Item_Min_Fields>,
  stddev?: Maybe<Order_Item_Stddev_Fields>,
  stddev_pop?: Maybe<Order_Item_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Order_Item_Stddev_Samp_Fields>,
  sum?: Maybe<Order_Item_Sum_Fields>,
  var_pop?: Maybe<Order_Item_Var_Pop_Fields>,
  var_samp?: Maybe<Order_Item_Var_Samp_Fields>,
  variance?: Maybe<Order_Item_Variance_Fields>,
};


export type Order_Item_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Item_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Item_Aggregate_Order_By = {
  avg?: Maybe<Order_Item_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Item_Max_Order_By>,
  min?: Maybe<Order_Item_Min_Order_By>,
  stddev?: Maybe<Order_Item_Stddev_Order_By>,
  stddev_pop?: Maybe<Order_Item_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Order_Item_Stddev_Samp_Order_By>,
  sum?: Maybe<Order_Item_Sum_Order_By>,
  var_pop?: Maybe<Order_Item_Var_Pop_Order_By>,
  var_samp?: Maybe<Order_Item_Var_Samp_Order_By>,
  variance?: Maybe<Order_Item_Variance_Order_By>,
};

export type Order_Item_Arr_Rel_Insert_Input = {
  data: Array<Order_Item_Insert_Input>,
  on_conflict?: Maybe<Order_Item_On_Conflict>,
};

export type Order_Item_Avg_Fields = {
  __typename?: 'order_item_avg_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Avg_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Item_Bool_Exp>>>,
  _not?: Maybe<Order_Item_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Item_Bool_Exp>>>,
  addon?: Maybe<Addon_Bool_Exp>,
  addon_id?: Maybe<Uuid_Comparison_Exp>,
  campaign?: Maybe<Campaign_Bool_Exp>,
  campaign_id?: Maybe<Uuid_Comparison_Exp>,
  coupon?: Maybe<Coupon_Bool_Exp>,
  coupon_id?: Maybe<Uuid_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  fulfillment_status?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  item_qty?: Maybe<Int_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Order_Bool_Exp>,
  order_id?: Maybe<Uuid_Comparison_Exp>,
  price?: Maybe<Int_Comparison_Exp>,
  processed_by_id?: Maybe<Uuid_Comparison_Exp>,
  qty_processed_by_admin?: Maybe<Int_Comparison_Exp>,
  refund_status?: Maybe<String_Comparison_Exp>,
  removed?: Maybe<Boolean_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  status?: Maybe<Order_Status_Enum_Comparison_Exp>,
  type?: Maybe<Order_Item_Type_Enum_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Order_Item_Constraint {
  OrderItemPkey = 'order_item_pkey'
}

export type Order_Item_Inc_Input = {
  item_qty?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
};

export type Order_Item_Insert_Input = {
  addon?: Maybe<Addon_Obj_Rel_Insert_Input>,
  addon_id?: Maybe<Scalars['uuid']>,
  campaign?: Maybe<Campaign_Obj_Rel_Insert_Input>,
  campaign_id?: Maybe<Scalars['uuid']>,
  coupon?: Maybe<Coupon_Obj_Rel_Insert_Input>,
  coupon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  fulfillment_status?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  item_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Order_Obj_Rel_Insert_Input>,
  order_id?: Maybe<Scalars['uuid']>,
  price?: Maybe<Scalars['Int']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
  refund_status?: Maybe<Scalars['String']>,
  removed?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status?: Maybe<Order_Status_Enum>,
  type?: Maybe<Order_Item_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Item_Max_Fields = {
  __typename?: 'order_item_max_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  coupon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  fulfillment_status?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  item_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  order_id?: Maybe<Scalars['uuid']>,
  price?: Maybe<Scalars['Int']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
  refund_status?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Item_Max_Order_By = {
  addon_id?: Maybe<Order_By>,
  campaign_id?: Maybe<Order_By>,
  coupon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  fulfillment_status?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  item_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
  refund_status?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Item_Min_Fields = {
  __typename?: 'order_item_min_fields',
  addon_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  coupon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  fulfillment_status?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  item_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  order_id?: Maybe<Scalars['uuid']>,
  price?: Maybe<Scalars['Int']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
  refund_status?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Item_Min_Order_By = {
  addon_id?: Maybe<Order_By>,
  campaign_id?: Maybe<Order_By>,
  coupon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  fulfillment_status?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  item_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
  refund_status?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Item_Mutation_Response = {
  __typename?: 'order_item_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Order_Item>,
};

export type Order_Item_Obj_Rel_Insert_Input = {
  data: Order_Item_Insert_Input,
  on_conflict?: Maybe<Order_Item_On_Conflict>,
};

export type Order_Item_On_Conflict = {
  constraint: Order_Item_Constraint,
  update_columns: Array<Order_Item_Update_Column>,
  where?: Maybe<Order_Item_Bool_Exp>,
};

export type Order_Item_Order_By = {
  addon?: Maybe<Addon_Order_By>,
  addon_id?: Maybe<Order_By>,
  campaign?: Maybe<Campaign_Order_By>,
  campaign_id?: Maybe<Order_By>,
  coupon?: Maybe<Coupon_Order_By>,
  coupon_id?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  fulfillment_status?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  item_qty?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_Order_By>,
  order_id?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
  refund_status?: Maybe<Order_By>,
  removed?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  type?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Item_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Order_Item_Select_Column {
  AddonId = 'addon_id',
  CampaignId = 'campaign_id',
  CouponId = 'coupon_id',
  CreatedAt = 'created_at',
  FulfillmentStatus = 'fulfillment_status',
  Id = 'id',
  ItemQty = 'item_qty',
  Name = 'name',
  OrderId = 'order_id',
  Price = 'price',
  ProcessedById = 'processed_by_id',
  QtyProcessedByAdmin = 'qty_processed_by_admin',
  RefundStatus = 'refund_status',
  Removed = 'removed',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Order_Item_Set_Input = {
  addon_id?: Maybe<Scalars['uuid']>,
  campaign_id?: Maybe<Scalars['uuid']>,
  coupon_id?: Maybe<Scalars['uuid']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  fulfillment_status?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  item_qty?: Maybe<Scalars['Int']>,
  name?: Maybe<Scalars['String']>,
  order_id?: Maybe<Scalars['uuid']>,
  price?: Maybe<Scalars['Int']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
  refund_status?: Maybe<Scalars['String']>,
  removed?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status?: Maybe<Order_Status_Enum>,
  type?: Maybe<Order_Item_Type_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Item_Stddev_Fields = {
  __typename?: 'order_item_stddev_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Stddev_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Stddev_Pop_Fields = {
  __typename?: 'order_item_stddev_pop_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Stddev_Pop_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Stddev_Samp_Fields = {
  __typename?: 'order_item_stddev_samp_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Stddev_Samp_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Sum_Fields = {
  __typename?: 'order_item_sum_fields',
  item_qty?: Maybe<Scalars['Int']>,
  price?: Maybe<Scalars['Int']>,
  qty_processed_by_admin?: Maybe<Scalars['Int']>,
};

export type Order_Item_Sum_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Type = {
  __typename?: 'order_item_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Order_Item_Type_Aggregate = {
  __typename?: 'order_item_type_aggregate',
  aggregate?: Maybe<Order_Item_Type_Aggregate_Fields>,
  nodes: Array<Order_Item_Type>,
};

export type Order_Item_Type_Aggregate_Fields = {
  __typename?: 'order_item_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Item_Type_Max_Fields>,
  min?: Maybe<Order_Item_Type_Min_Fields>,
};


export type Order_Item_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Item_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Item_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Item_Type_Max_Order_By>,
  min?: Maybe<Order_Item_Type_Min_Order_By>,
};

export type Order_Item_Type_Arr_Rel_Insert_Input = {
  data: Array<Order_Item_Type_Insert_Input>,
  on_conflict?: Maybe<Order_Item_Type_On_Conflict>,
};

export type Order_Item_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Item_Type_Bool_Exp>>>,
  _not?: Maybe<Order_Item_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Item_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Order_Item_Type_Constraint {
  OrderItemTypePkey = 'order_item_type_pkey'
}

export enum Order_Item_Type_Enum {
  Addon = 'ADDON',
  Campaign = 'CAMPAIGN',
  Coupon = 'COUPON',
  PriceAdjustment = 'PRICE_ADJUSTMENT',
  RemovedInclusion = 'REMOVED_INCLUSION'
}

export type Order_Item_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Order_Item_Type_Enum>,
  _in?: Maybe<Array<Order_Item_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Order_Item_Type_Enum>,
  _nin?: Maybe<Array<Order_Item_Type_Enum>>,
};

export type Order_Item_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Item_Type_Max_Fields = {
  __typename?: 'order_item_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Item_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Item_Type_Min_Fields = {
  __typename?: 'order_item_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Item_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Item_Type_Mutation_Response = {
  __typename?: 'order_item_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Order_Item_Type>,
};

export type Order_Item_Type_Obj_Rel_Insert_Input = {
  data: Order_Item_Type_Insert_Input,
  on_conflict?: Maybe<Order_Item_Type_On_Conflict>,
};

export type Order_Item_Type_On_Conflict = {
  constraint: Order_Item_Type_Constraint,
  update_columns: Array<Order_Item_Type_Update_Column>,
  where?: Maybe<Order_Item_Type_Bool_Exp>,
};

export type Order_Item_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Item_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Order_Item_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Order_Item_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Order_Item_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export enum Order_Item_Update_Column {
  AddonId = 'addon_id',
  CampaignId = 'campaign_id',
  CouponId = 'coupon_id',
  CreatedAt = 'created_at',
  FulfillmentStatus = 'fulfillment_status',
  Id = 'id',
  ItemQty = 'item_qty',
  Name = 'name',
  OrderId = 'order_id',
  Price = 'price',
  ProcessedById = 'processed_by_id',
  QtyProcessedByAdmin = 'qty_processed_by_admin',
  RefundStatus = 'refund_status',
  Removed = 'removed',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updated_at'
}

export type Order_Item_Var_Pop_Fields = {
  __typename?: 'order_item_var_pop_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Var_Pop_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Var_Samp_Fields = {
  __typename?: 'order_item_var_samp_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Var_Samp_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Item_Variance_Fields = {
  __typename?: 'order_item_variance_fields',
  item_qty?: Maybe<Scalars['Float']>,
  price?: Maybe<Scalars['Float']>,
  qty_processed_by_admin?: Maybe<Scalars['Float']>,
};

export type Order_Item_Variance_Order_By = {
  item_qty?: Maybe<Order_By>,
  price?: Maybe<Order_By>,
  qty_processed_by_admin?: Maybe<Order_By>,
};

export type Order_Max_Fields = {
  __typename?: 'order_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Min_Fields = {
  __typename?: 'order_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing_id?: Maybe<Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Order>,
};

export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input,
  on_conflict?: Maybe<Order_On_Conflict>,
};

export type Order_On_Conflict = {
  constraint: Order_Constraint,
  update_columns: Array<Order_Update_Column>,
  where?: Maybe<Order_Bool_Exp>,
};

export type Order_Order_By = {
  created_at?: Maybe<Order_By>,
  created_from_template?: Maybe<Order_By>,
  experiments?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  listing?: Maybe<Listing_Order_By>,
  listing_id?: Maybe<Order_By>,
  order_items_aggregate?: Maybe<Order_Item_Aggregate_Order_By>,
  order_status?: Maybe<Order_Status_Order_By>,
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
  processed_by_id?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  transactions_aggregate?: Maybe<Transaction_Aggregate_Order_By>,
  updated_at?: Maybe<Order_By>,
  user?: Maybe<User_Order_By>,
};

export type Order_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Order_Prepend_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export enum Order_Select_Column {
  CreatedAt = 'created_at',
  CreatedFromTemplate = 'created_from_template',
  Experiments = 'experiments',
  Id = 'id',
  ListingId = 'listing_id',
  OrderTotal = 'order_total',
  OrderTotalWithoutDiscount = 'order_total_without_discount',
  ProcessedById = 'processed_by_id',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type Order_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  created_from_template?: Maybe<Scalars['Boolean']>,
  experiments?: Maybe<Scalars['jsonb']>,
  id?: Maybe<Scalars['uuid']>,
  listing_id?: Maybe<Scalars['uuid']>,
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
  processed_by_id?: Maybe<Scalars['uuid']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  status?: Maybe<Order_Status_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Order_Status = {
  __typename?: 'order_status',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Order_Status_Aggregate = {
  __typename?: 'order_status_aggregate',
  aggregate?: Maybe<Order_Status_Aggregate_Fields>,
  nodes: Array<Order_Status>,
};

export type Order_Status_Aggregate_Fields = {
  __typename?: 'order_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Order_Status_Max_Fields>,
  min?: Maybe<Order_Status_Min_Fields>,
};


export type Order_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Order_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Order_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Order_Status_Max_Order_By>,
  min?: Maybe<Order_Status_Min_Order_By>,
};

export type Order_Status_Arr_Rel_Insert_Input = {
  data: Array<Order_Status_Insert_Input>,
  on_conflict?: Maybe<Order_Status_On_Conflict>,
};

export type Order_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Order_Status_Bool_Exp>>>,
  _not?: Maybe<Order_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Order_Status_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Order_Status_Constraint {
  OrderStatusPkey = 'order_status_pkey'
}

export enum Order_Status_Enum {
  CancellationPending = 'Cancellation_Pending',
  Cancelled = 'Cancelled',
  Open = 'Open',
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type Order_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Order_Status_Enum>,
  _in?: Maybe<Array<Order_Status_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Order_Status_Enum>,
  _nin?: Maybe<Array<Order_Status_Enum>>,
};

export type Order_Status_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Status_Max_Fields = {
  __typename?: 'order_status_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Status_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Status_Min_Fields = {
  __typename?: 'order_status_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Order_Status_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Status_Mutation_Response = {
  __typename?: 'order_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Order_Status>,
};

export type Order_Status_Obj_Rel_Insert_Input = {
  data: Order_Status_Insert_Input,
  on_conflict?: Maybe<Order_Status_On_Conflict>,
};

export type Order_Status_On_Conflict = {
  constraint: Order_Status_Constraint,
  update_columns: Array<Order_Status_Update_Column>,
  where?: Maybe<Order_Status_Bool_Exp>,
};

export type Order_Status_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Order_Status_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Order_Status_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Order_Status_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Order_Status_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Order_Status_Update_Response = {
  __typename?: 'order_status_update_response',
  affected_rows: Scalars['numeric'],
};

export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Stddev_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Stddev_Pop_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Stddev_Samp_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields',
  order_total?: Maybe<Scalars['numeric']>,
  order_total_without_discount?: Maybe<Scalars['numeric']>,
};

export type Order_Sum_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export enum Order_Update_Column {
  CreatedAt = 'created_at',
  CreatedFromTemplate = 'created_from_template',
  Experiments = 'experiments',
  Id = 'id',
  ListingId = 'listing_id',
  OrderTotal = 'order_total',
  OrderTotalWithoutDiscount = 'order_total_without_discount',
  ProcessedById = 'processed_by_id',
  SalesforceId = 'salesforce_id',
  SfUpdatedAt = 'sf_updated_at',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Var_Pop_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Var_Samp_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields',
  order_total?: Maybe<Scalars['Float']>,
  order_total_without_discount?: Maybe<Scalars['Float']>,
};

export type Order_Variance_Order_By = {
  order_total?: Maybe<Order_By>,
  order_total_without_discount?: Maybe<Order_By>,
};

export type Paid_Order_Response = {
  __typename?: 'paid_order_response',
  affected_rows: Scalars['numeric'],
};

export type PassportRequestAu = {
  BirthDate: Scalars['Date'],
  ExpiryDate?: Maybe<Scalars['Date']>,
  FamilyName: Scalars['String'],
  Gender: Scalars['String'],
  GivenName: Scalars['String'],
  MiddleName?: Maybe<Scalars['String']>,
  TravelDocumentNumber: Scalars['String'],
};

export type PassportRequestNz = {
  dob: Scalars['Date'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  passportExpiry: Scalars['Date'],
  passportNumber: Scalars['String'],
};

export type PassportResponseAu = {
  __typename?: 'PassportResponseAu',
  VerifyDocumentResult?: Maybe<VerifyDocumentResult_Ppau>,
  fieldDetails?: Maybe<FieldDetails_Ppau>,
  pdfLink?: Maybe<Scalars['String']>,
  rapidID?: Maybe<Scalars['String']>,
};

export type PassportResponseNz = {
  __typename?: 'PassportResponseNz',
  Message?: Maybe<Scalars['String']>,
  Results?: Maybe<Results_Ppnz>,
  SafeHarbour?: Maybe<Scalars['String']>,
  Status?: Maybe<Scalars['String']>,
  pdfLink?: Maybe<Scalars['String']>,
  rapidID?: Maybe<Scalars['String']>,
};

export type Pay_Response = {
  __typename?: 'pay_response',
  url: Scalars['String'],
};

export type Poli_Get_Transaction_Response = {
  __typename?: 'poli_get_transaction_response',
  AmountPaid?: Maybe<Scalars['Float']>,
  BankReceipt?: Maybe<Scalars['String']>,
  BankReceiptDateTime?: Maybe<Scalars['String']>,
  CountryCode?: Maybe<Scalars['String']>,
  CountryName?: Maybe<Scalars['String']>,
  CurrencyCode?: Maybe<Scalars['String']>,
  CurrencyName?: Maybe<Scalars['String']>,
  EndDateTime?: Maybe<Scalars['String']>,
  ErrorCode?: Maybe<Scalars['String']>,
  ErrorMessage?: Maybe<Scalars['String']>,
  EstablishedDateTime?: Maybe<Scalars['String']>,
  FinancialInstitutionCode?: Maybe<Scalars['String']>,
  FinancialInstitutionCountryCode?: Maybe<Scalars['String']>,
  FinancialInstitutionName?: Maybe<Scalars['String']>,
  IsExpired?: Maybe<Scalars['Boolean']>,
  MerchantAccountName?: Maybe<Scalars['String']>,
  MerchantAccountNumber?: Maybe<Scalars['String']>,
  MerchantAccountSortCode?: Maybe<Scalars['String']>,
  MerchantAccountSuffix?: Maybe<Scalars['String']>,
  MerchantData?: Maybe<Scalars['String']>,
  MerchantEntityID?: Maybe<Scalars['String']>,
  MerchantEstablishedDateTime?: Maybe<Scalars['String']>,
  MerchantName?: Maybe<Scalars['String']>,
  MerchantReference?: Maybe<Scalars['String']>,
  POLiVersionCode?: Maybe<Scalars['String']>,
  PayerAccountNumber?: Maybe<Scalars['String']>,
  PayerAccountSortCode?: Maybe<Scalars['String']>,
  PayerAccountSuffix?: Maybe<Scalars['String']>,
  PayerFamilyName?: Maybe<Scalars['String']>,
  PayerFirstName?: Maybe<Scalars['String']>,
  PaymentAmount?: Maybe<Scalars['Float']>,
  StartDateTime?: Maybe<Scalars['String']>,
  TransactionID?: Maybe<Scalars['String']>,
  TransactionRefNo?: Maybe<Scalars['String']>,
  TransactionStatus?: Maybe<Scalars['String']>,
  TransactionStatusCode?: Maybe<Scalars['String']>,
  UserIPAddress?: Maybe<Scalars['String']>,
};

export type Poli_Init_Transaction_Response = {
  __typename?: 'poli_init_transaction_response',
  ErrorCode?: Maybe<Scalars['Int']>,
  ErrorMessage?: Maybe<Scalars['String']>,
  NavigateURL?: Maybe<Scalars['String']>,
  Success?: Maybe<Scalars['Boolean']>,
  TransactionRefNo?: Maybe<Scalars['String']>,
};

export type Publishing_Status_Type = {
  __typename?: 'publishing_status_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Publishing_Status_Type_Aggregate = {
  __typename?: 'publishing_status_type_aggregate',
  aggregate?: Maybe<Publishing_Status_Type_Aggregate_Fields>,
  nodes: Array<Publishing_Status_Type>,
};

export type Publishing_Status_Type_Aggregate_Fields = {
  __typename?: 'publishing_status_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Publishing_Status_Type_Max_Fields>,
  min?: Maybe<Publishing_Status_Type_Min_Fields>,
};


export type Publishing_Status_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Publishing_Status_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Publishing_Status_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Publishing_Status_Type_Max_Order_By>,
  min?: Maybe<Publishing_Status_Type_Min_Order_By>,
};

export type Publishing_Status_Type_Arr_Rel_Insert_Input = {
  data: Array<Publishing_Status_Type_Insert_Input>,
  on_conflict?: Maybe<Publishing_Status_Type_On_Conflict>,
};

export type Publishing_Status_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Publishing_Status_Type_Bool_Exp>>>,
  _not?: Maybe<Publishing_Status_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Publishing_Status_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Publishing_Status_Type_Constraint {
  PublishingStatusTypePkey = 'publishing_status_type_pkey'
}

export enum Publishing_Status_Type_Enum {
  Draft = 'DRAFT',
  FailedPublishing = 'FAILED_PUBLISHING',
  PendingPublishing = 'PENDING_PUBLISHING',
  Published = 'PUBLISHED',
  UnderReview = 'UNDER_REVIEW'
}

export type Publishing_Status_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Publishing_Status_Type_Enum>,
  _in?: Maybe<Array<Publishing_Status_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Publishing_Status_Type_Enum>,
  _nin?: Maybe<Array<Publishing_Status_Type_Enum>>,
};

export type Publishing_Status_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Publishing_Status_Type_Max_Fields = {
  __typename?: 'publishing_status_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Publishing_Status_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Publishing_Status_Type_Min_Fields = {
  __typename?: 'publishing_status_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Publishing_Status_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Publishing_Status_Type_Mutation_Response = {
  __typename?: 'publishing_status_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Publishing_Status_Type>,
};

export type Publishing_Status_Type_Obj_Rel_Insert_Input = {
  data: Publishing_Status_Type_Insert_Input,
  on_conflict?: Maybe<Publishing_Status_Type_On_Conflict>,
};

export type Publishing_Status_Type_On_Conflict = {
  constraint: Publishing_Status_Type_Constraint,
  update_columns: Array<Publishing_Status_Type_Update_Column>,
  where?: Maybe<Publishing_Status_Type_Bool_Exp>,
};

export type Publishing_Status_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Publishing_Status_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Publishing_Status_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Publishing_Status_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Publishing_Status_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Query = {
  __typename?: 'Query',
  address_auto_complete?: Maybe<Address_Auto_Complete_Group>,
  attachment_upload_credential?: Maybe<Upload_Credential>,
  check_driver_licence_au?: Maybe<DriverLicenceResponseAu>,
  check_driver_licence_nz?: Maybe<DriverLicenceResponseNz>,
  check_duplicate_listing_for_address?: Maybe<Check_Duplicate_Listing_For_Address>,
  check_national_id_cn?: Maybe<NationalIdResponseCn>,
  check_passport_au?: Maybe<PassportResponseAu>,
  check_passport_nz?: Maybe<PassportResponseNz>,
  frontend_config?: Maybe<Frontend_Config_Response>,
  get_address_detail?: Maybe<Address_Detail>,
  get_listing_advisor_context?: Maybe<Listing_Advisor_Context_Response>,
  get_relisting_addon?: Maybe<AddonResponse>,
  google_auth_url?: Maybe<Google_Auth_Url_Response>,
  impersonate_logout?: Maybe<Auth_Response>,
  impersonate_sign_in?: Maybe<Auth_Response>,
  location_auto_complete?: Maybe<Location_Auto_Complete_Group>,
  mobile_code_verification?: Maybe<MobileCodeVerification>,
  resend_email_verification_link?: Maybe<MailSentResponse>,
  send_email?: Maybe<MailSentResponse>,
  send_onboarding_email?: Maybe<MailSentResponse>,
  send_purchase_email?: Maybe<MailSentResponse>,
  sign_in?: Maybe<Auth_Response>,
  verify_hash?: Maybe<Json_Response>,
  verify_mobile_number?: Maybe<VerifyMobileResponse>,
};


export type QueryAddress_Auto_CompleteArgs = {
  addressInput: Scalars['String']
};


export type QueryAttachment_Upload_CredentialArgs = {
  extension?: Maybe<Scalars['String']>,
  id: Scalars['uuid']
};


export type QueryCheck_Driver_Licence_AuArgs = {
  driverLicenceAu: DriverLicenceRequestAu
};


export type QueryCheck_Driver_Licence_NzArgs = {
  diverLicenceNz: DriverLicenceRequestNz
};


export type QueryCheck_Duplicate_Listing_For_AddressArgs = {
  listingId: Scalars['String']
};


export type QueryCheck_National_Id_CnArgs = {
  nationalId: NationalIdRequestCn
};


export type QueryCheck_Passport_AuArgs = {
  passportAu: PassportRequestAu
};


export type QueryCheck_Passport_NzArgs = {
  passportNz: PassportRequestNz
};


export type QueryGet_Address_DetailArgs = {
  addressId: Scalars['String']
};


export type QueryGet_Listing_Advisor_ContextArgs = {
  listingId: Scalars['uuid']
};


export type QueryGet_Relisting_AddonArgs = {
  listingId: Scalars['String']
};


export type QueryGoogle_Auth_UrlArgs = {
  webAppUrl: Scalars['String']
};


export type QueryImpersonate_Sign_InArgs = {
  userId: Scalars['uuid']
};


export type QueryLocation_Auto_CompleteArgs = {
  locationInput: Scalars['String'],
  locationType: Scalars['String']
};


export type QueryMobile_Code_VerificationArgs = {
  code: Scalars['String'],
  mobileNumber: Scalars['String'],
  sid: Scalars['String']
};


export type QueryResend_Email_Verification_LinkArgs = {
  redirectUrl?: Maybe<Scalars['String']>
};


export type QuerySend_EmailArgs = {
  email: Scalars['String'],
  type: Scalars['String']
};


export type QuerySend_Onboarding_EmailArgs = {
  userId: Scalars['String']
};


export type QuerySend_Purchase_EmailArgs = {
  orderId: Scalars['String']
};


export type QuerySign_InArgs = {
  email: Scalars['String'],
  password: Scalars['String'],
  rememberLogin?: Maybe<Scalars['Boolean']>
};


export type QueryVerify_HashArgs = {
  hash: Scalars['String']
};


export type QueryVerify_Mobile_NumberArgs = {
  channel: Scalars['String'],
  mobileNumber: Scalars['String'],
  type: Scalars['String']
};

export type Query_Root = {
  __typename?: 'query_root',
  addon: Array<Addon>,
  addon_addon_group: Array<Addon_Addon_Group>,
  addon_addon_group_aggregate: Addon_Addon_Group_Aggregate,
  addon_addon_group_by_pk?: Maybe<Addon_Addon_Group>,
  addon_aggregate: Addon_Aggregate,
  addon_by_pk?: Maybe<Addon>,
  addon_group: Array<Addon_Group>,
  addon_group_aggregate: Addon_Group_Aggregate,
  addon_group_by_pk?: Maybe<Addon_Group>,
  addon_group_type: Array<Addon_Group_Type>,
  addon_group_type_aggregate: Addon_Group_Type_Aggregate,
  addon_group_type_by_pk?: Maybe<Addon_Group_Type>,
  addon_price: Array<Addon_Price>,
  addon_price_aggregate: Addon_Price_Aggregate,
  addon_price_by_pk?: Maybe<Addon_Price>,
  address_auto_complete?: Maybe<Address_Auto_Complete_Group>,
  attachment: Array<Attachment>,
  attachment_aggregate: Attachment_Aggregate,
  attachment_by_pk?: Maybe<Attachment>,
  attachment_parent_type: Array<Attachment_Parent_Type>,
  attachment_parent_type_aggregate: Attachment_Parent_Type_Aggregate,
  attachment_parent_type_by_pk?: Maybe<Attachment_Parent_Type>,
  attachment_status: Array<Attachment_Status>,
  attachment_status_aggregate: Attachment_Status_Aggregate,
  attachment_status_by_pk?: Maybe<Attachment_Status>,
  attachment_type: Array<Attachment_Type>,
  attachment_type_aggregate: Attachment_Type_Aggregate,
  attachment_type_by_pk?: Maybe<Attachment_Type>,
  attachment_upload_credential?: Maybe<Upload_Credential>,
  benefit: Array<Benefit>,
  benefit_aggregate: Benefit_Aggregate,
  benefit_by_pk?: Maybe<Benefit>,
  bmp_listing: Array<Bmp_Listing>,
  bmp_listing_aggregate: Bmp_Listing_Aggregate,
  bmp_listing_by_pk?: Maybe<Bmp_Listing>,
  bmp_listing_contact: Array<Bmp_Listing_Contact>,
  bmp_listing_contact_aggregate: Bmp_Listing_Contact_Aggregate,
  bmp_listing_inspection: Array<Bmp_Listing_Inspection>,
  bmp_listing_inspection_aggregate: Bmp_Listing_Inspection_Aggregate,
  bmp_listing_media: Array<Bmp_Listing_Media>,
  bmp_listing_media_aggregate: Bmp_Listing_Media_Aggregate,
  bmp_listing_search: Array<Bmp_Listing_Search>,
  bmp_listing_search_aggregate: Bmp_Listing_Search_Aggregate,
  cache: Array<Cache>,
  cache_aggregate: Cache_Aggregate,
  cache_by_pk?: Maybe<Cache>,
  campaign: Array<Campaign>,
  campaign_addon_group: Array<Campaign_Addon_Group>,
  campaign_addon_group_aggregate: Campaign_Addon_Group_Aggregate,
  campaign_addon_group_by_pk?: Maybe<Campaign_Addon_Group>,
  campaign_aggregate: Campaign_Aggregate,
  campaign_by_pk?: Maybe<Campaign>,
  campaign_inclusion_group: Array<Campaign_Inclusion_Group>,
  campaign_inclusion_group_aggregate: Campaign_Inclusion_Group_Aggregate,
  campaign_inclusion_group_by_pk?: Maybe<Campaign_Inclusion_Group>,
  campaign_selling_point: Array<Campaign_Selling_Point>,
  campaign_selling_point_aggregate: Campaign_Selling_Point_Aggregate,
  campaign_selling_point_by_pk?: Maybe<Campaign_Selling_Point>,
  check_driver_licence_au?: Maybe<DriverLicenceResponseAu>,
  check_driver_licence_nz?: Maybe<DriverLicenceResponseNz>,
  check_duplicate_listing_for_address?: Maybe<Check_Duplicate_Listing_For_Address>,
  check_national_id_cn?: Maybe<NationalIdResponseCn>,
  check_passport_au?: Maybe<PassportResponseAu>,
  check_passport_nz?: Maybe<PassportResponseNz>,
  commercial_status_type: Array<Commercial_Status_Type>,
  commercial_status_type_aggregate: Commercial_Status_Type_Aggregate,
  commercial_status_type_by_pk?: Maybe<Commercial_Status_Type>,
  coupon: Array<Coupon>,
  coupon_aggregate: Coupon_Aggregate,
  coupon_by_pk?: Maybe<Coupon>,
  coupon_type: Array<Coupon_Type>,
  coupon_type_aggregate: Coupon_Type_Aggregate,
  coupon_type_by_pk?: Maybe<Coupon_Type>,
  enquiry: Array<Enquiry>,
  enquiry_aggregate: Enquiry_Aggregate,
  enquiry_by_pk?: Maybe<Enquiry>,
  enquiry_call_result: Array<Enquiry_Call_Result>,
  enquiry_call_result_aggregate: Enquiry_Call_Result_Aggregate,
  enquiry_call_result_by_pk?: Maybe<Enquiry_Call_Result>,
  enquiry_medium_type: Array<Enquiry_Medium_Type>,
  enquiry_medium_type_aggregate: Enquiry_Medium_Type_Aggregate,
  enquiry_medium_type_by_pk?: Maybe<Enquiry_Medium_Type>,
  experiment: Array<Experiment>,
  experiment_aggregate: Experiment_Aggregate,
  experiment_by_pk?: Maybe<Experiment>,
  experiment_name: Array<Experiment_Name>,
  experiment_name_aggregate: Experiment_Name_Aggregate,
  experiment_name_by_pk?: Maybe<Experiment_Name>,
  experiment_stat: Array<Experiment_Stat>,
  experiment_stat_aggregate: Experiment_Stat_Aggregate,
  external_auth: Array<External_Auth>,
  external_auth_aggregate: External_Auth_Aggregate,
  external_auth_by_pk?: Maybe<External_Auth>,
  feedback: Array<Feedback>,
  feedback_aggregate: Feedback_Aggregate,
  feedback_by_pk?: Maybe<Feedback>,
  frontend_config?: Maybe<Frontend_Config_Response>,
  get_address_detail?: Maybe<Address_Detail>,
  get_listing_advisor_context?: Maybe<Listing_Advisor_Context_Response>,
  get_relisting_addon?: Maybe<AddonResponse>,
  google_auth_url?: Maybe<Google_Auth_Url_Response>,
  impersonate_logout?: Maybe<Auth_Response>,
  impersonate_sign_in?: Maybe<Auth_Response>,
  inclusion: Array<Inclusion>,
  inclusion_addon: Array<Inclusion_Addon>,
  inclusion_addon_aggregate: Inclusion_Addon_Aggregate,
  inclusion_addon_by_pk?: Maybe<Inclusion_Addon>,
  inclusion_aggregate: Inclusion_Aggregate,
  inclusion_by_pk?: Maybe<Inclusion>,
  inclusion_group: Array<Inclusion_Group>,
  inclusion_group_aggregate: Inclusion_Group_Aggregate,
  inclusion_group_by_pk?: Maybe<Inclusion_Group>,
  listing: Array<Listing>,
  listing_aggregate: Listing_Aggregate,
  listing_by_pk?: Maybe<Listing>,
  listing_contact: Array<Listing_Contact>,
  listing_contact_aggregate: Listing_Contact_Aggregate,
  listing_contact_by_pk?: Maybe<Listing_Contact>,
  listing_detail: Array<Listing_Detail>,
  listing_detail_aggregate: Listing_Detail_Aggregate,
  listing_document: Array<Listing_Document>,
  listing_document_aggregate: Listing_Document_Aggregate,
  listing_document_by_pk?: Maybe<Listing_Document>,
  listing_document_status: Array<Listing_Document_Status>,
  listing_document_status_aggregate: Listing_Document_Status_Aggregate,
  listing_document_status_by_pk?: Maybe<Listing_Document_Status>,
  listing_document_type: Array<Listing_Document_Type>,
  listing_document_type_aggregate: Listing_Document_Type_Aggregate,
  listing_document_type_by_pk?: Maybe<Listing_Document_Type>,
  listing_event: Array<Listing_Event>,
  listing_event_aggregate: Listing_Event_Aggregate,
  listing_event_by_pk?: Maybe<Listing_Event>,
  listing_event_type: Array<Listing_Event_Type>,
  listing_event_type_aggregate: Listing_Event_Type_Aggregate,
  listing_event_type_by_pk?: Maybe<Listing_Event_Type>,
  listing_inspection: Array<Listing_Inspection>,
  listing_inspection_aggregate: Listing_Inspection_Aggregate,
  listing_inspection_by_pk?: Maybe<Listing_Inspection>,
  listing_media: Array<Listing_Media>,
  listing_media_aggregate: Listing_Media_Aggregate,
  listing_media_by_pk?: Maybe<Listing_Media>,
  listing_media_type: Array<Listing_Media_Type>,
  listing_media_type_aggregate: Listing_Media_Type_Aggregate,
  listing_media_type_by_pk?: Maybe<Listing_Media_Type>,
  listing_metadata: Array<Listing_Metadata>,
  listing_metadata_aggregate: Listing_Metadata_Aggregate,
  listing_metadata_by_pk?: Maybe<Listing_Metadata>,
  listing_onboarding: Array<Listing_Onboarding>,
  listing_onboarding_aggregate: Listing_Onboarding_Aggregate,
  listing_onboarding_by_pk?: Maybe<Listing_Onboarding>,
  listing_parking: Array<Listing_Parking>,
  listing_parking_aggregate: Listing_Parking_Aggregate,
  listing_parking_by_pk?: Maybe<Listing_Parking>,
  listing_publish_errors: Array<Listing_Publish_Errors>,
  listing_publish_errors_aggregate: Listing_Publish_Errors_Aggregate,
  listing_publish_errors_by_pk?: Maybe<Listing_Publish_Errors>,
  listing_publish_portal_source: Array<Listing_Publish_Portal_Source>,
  listing_publish_portal_source_aggregate: Listing_Publish_Portal_Source_Aggregate,
  listing_publish_portal_source_by_pk?: Maybe<Listing_Publish_Portal_Source>,
  listing_publish_status: Array<Listing_Publish_Status>,
  listing_publish_status_aggregate: Listing_Publish_Status_Aggregate,
  listing_publish_status_by_pk?: Maybe<Listing_Publish_Status>,
  listing_publish_status_type: Array<Listing_Publish_Status_Type>,
  listing_publish_status_type_aggregate: Listing_Publish_Status_Type_Aggregate,
  listing_publish_status_type_by_pk?: Maybe<Listing_Publish_Status_Type>,
  listing_search: Array<Listing_Search>,
  listing_search_aggregate: Listing_Search_Aggregate,
  listing_soi_comparable_property: Array<Listing_Soi_Comparable_Property>,
  listing_soi_comparable_property_aggregate: Listing_Soi_Comparable_Property_Aggregate,
  listing_soi_comparable_property_by_pk?: Maybe<Listing_Soi_Comparable_Property>,
  location_auto_complete?: Maybe<Location_Auto_Complete_Group>,
  metro_type: Array<Metro_Type>,
  metro_type_aggregate: Metro_Type_Aggregate,
  metro_type_by_pk?: Maybe<Metro_Type>,
  mobile_code_verification?: Maybe<MobileCodeVerification>,
  onboarding_budget_size: Array<Onboarding_Budget_Size>,
  onboarding_budget_size_aggregate: Onboarding_Budget_Size_Aggregate,
  onboarding_budget_size_by_pk?: Maybe<Onboarding_Budget_Size>,
  onboarding_reason_selling: Array<Onboarding_Reason_Selling>,
  onboarding_reason_selling_aggregate: Onboarding_Reason_Selling_Aggregate,
  onboarding_reason_selling_by_pk?: Maybe<Onboarding_Reason_Selling>,
  onboarding_timeframe_selling: Array<Onboarding_Timeframe_Selling>,
  onboarding_timeframe_selling_aggregate: Onboarding_Timeframe_Selling_Aggregate,
  onboarding_timeframe_selling_by_pk?: Maybe<Onboarding_Timeframe_Selling>,
  order: Array<Order>,
  order_aggregate: Order_Aggregate,
  order_by_pk?: Maybe<Order>,
  order_detail: Array<Order_Detail>,
  order_detail_aggregate: Order_Detail_Aggregate,
  order_fulfilment: Array<Order_Fulfilment>,
  order_fulfilment_aggregate: Order_Fulfilment_Aggregate,
  order_fulfilment_by_pk?: Maybe<Order_Fulfilment>,
  order_item: Array<Order_Item>,
  order_item_aggregate: Order_Item_Aggregate,
  order_item_by_pk?: Maybe<Order_Item>,
  order_item_type: Array<Order_Item_Type>,
  order_item_type_aggregate: Order_Item_Type_Aggregate,
  order_item_type_by_pk?: Maybe<Order_Item_Type>,
  order_status: Array<Order_Status>,
  order_status_aggregate: Order_Status_Aggregate,
  order_status_by_pk?: Maybe<Order_Status>,
  publishing_status_type: Array<Publishing_Status_Type>,
  publishing_status_type_aggregate: Publishing_Status_Type_Aggregate,
  publishing_status_type_by_pk?: Maybe<Publishing_Status_Type>,
  raw_bordering_postcode: Array<Raw_Bordering_Postcode>,
  raw_bordering_postcode_aggregate: Raw_Bordering_Postcode_Aggregate,
  raw_bordering_postcode_by_pk?: Maybe<Raw_Bordering_Postcode>,
  rea_price: Array<Rea_Price>,
  rea_price_aggregate: Rea_Price_Aggregate,
  rea_price_by_pk?: Maybe<Rea_Price>,
  recommended_addons?: Maybe<Array<Maybe<RecommendedAddonOutput>>>,
  recommended_campaigns?: Maybe<Array<Maybe<RecommendedCampaignOutput>>>,
  resend_email_verification_link?: Maybe<MailSentResponse>,
  salesforce_bulksync_records: Array<Salesforce_Bulksync_Records>,
  salesforce_bulksync_records_aggregate: Salesforce_Bulksync_Records_Aggregate,
  salesforce_bulksync_records_by_pk?: Maybe<Salesforce_Bulksync_Records>,
  salesforce_connection_token: Array<Salesforce_Connection_Token>,
  salesforce_connection_token_aggregate: Salesforce_Connection_Token_Aggregate,
  salesforce_connection_token_by_pk?: Maybe<Salesforce_Connection_Token>,
  salesforce_sync_status: Array<Salesforce_Sync_Status>,
  salesforce_sync_status_aggregate: Salesforce_Sync_Status_Aggregate,
  salesforce_sync_status_by_pk?: Maybe<Salesforce_Sync_Status>,
  search_listing: Array<Surrounding_Suburb_Listing>,
  search_listing_aggregate: Surrounding_Suburb_Listing_Aggregate,
  selling_point: Array<Selling_Point>,
  selling_point_aggregate: Selling_Point_Aggregate,
  selling_point_by_pk?: Maybe<Selling_Point>,
  send_email?: Maybe<MailSentResponse>,
  send_onboarding_email?: Maybe<MailSentResponse>,
  send_purchase_email?: Maybe<MailSentResponse>,
  sign_in?: Maybe<Auth_Response>,
  stock_photo: Array<Stock_Photo>,
  stock_photo_aggregate: Stock_Photo_Aggregate,
  stock_photo_by_pk?: Maybe<Stock_Photo>,
  surrounding_suburb: Array<Surrounding_Suburb>,
  surrounding_suburb_aggregate: Surrounding_Suburb_Aggregate,
  surrounding_suburb_by_pk?: Maybe<Surrounding_Suburb>,
  surrounding_suburb_listing: Array<Surrounding_Suburb_Listing>,
  surrounding_suburb_listing_aggregate: Surrounding_Suburb_Listing_Aggregate,
  transaction: Array<Transaction>,
  transaction_aggregate: Transaction_Aggregate,
  transaction_by_pk?: Maybe<Transaction>,
  transaction_status: Array<Transaction_Status>,
  transaction_status_aggregate: Transaction_Status_Aggregate,
  transaction_status_by_pk?: Maybe<Transaction_Status>,
  user: Array<User>,
  user_aggregate: User_Aggregate,
  user_by_pk?: Maybe<User>,
  user_detail: Array<User_Detail>,
  user_detail_aggregate: User_Detail_Aggregate,
  verify_hash?: Maybe<Json_Response>,
  verify_mobile_number?: Maybe<VerifyMobileResponse>,
  zone_type: Array<Zone_Type>,
  zone_type_aggregate: Zone_Type_Aggregate,
  zone_type_by_pk?: Maybe<Zone_Type>,
};


export type Query_RootAddonArgs = {
  distinct_on?: Maybe<Array<Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Order_By>>,
  where?: Maybe<Addon_Bool_Exp>
};


export type Query_RootAddon_Addon_GroupArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Query_RootAddon_Addon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Query_RootAddon_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootAddon_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Order_By>>,
  where?: Maybe<Addon_Bool_Exp>
};


export type Query_RootAddon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootAddon_GroupArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Order_By>>,
  where?: Maybe<Addon_Group_Bool_Exp>
};


export type Query_RootAddon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Order_By>>,
  where?: Maybe<Addon_Group_Bool_Exp>
};


export type Query_RootAddon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootAddon_Group_TypeArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Type_Order_By>>,
  where?: Maybe<Addon_Group_Type_Bool_Exp>
};


export type Query_RootAddon_Group_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Type_Order_By>>,
  where?: Maybe<Addon_Group_Type_Bool_Exp>
};


export type Query_RootAddon_Group_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootAddon_PriceArgs = {
  distinct_on?: Maybe<Array<Addon_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Price_Order_By>>,
  where?: Maybe<Addon_Price_Bool_Exp>
};


export type Query_RootAddon_Price_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Price_Order_By>>,
  where?: Maybe<Addon_Price_Bool_Exp>
};


export type Query_RootAddon_Price_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootAddress_Auto_CompleteArgs = {
  addressInput: Scalars['String']
};


export type Query_RootAttachmentArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Query_RootAttachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Query_RootAttachment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootAttachment_Parent_TypeArgs = {
  distinct_on?: Maybe<Array<Attachment_Parent_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Parent_Type_Order_By>>,
  where?: Maybe<Attachment_Parent_Type_Bool_Exp>
};


export type Query_RootAttachment_Parent_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Parent_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Parent_Type_Order_By>>,
  where?: Maybe<Attachment_Parent_Type_Bool_Exp>
};


export type Query_RootAttachment_Parent_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootAttachment_StatusArgs = {
  distinct_on?: Maybe<Array<Attachment_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Status_Order_By>>,
  where?: Maybe<Attachment_Status_Bool_Exp>
};


export type Query_RootAttachment_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Status_Order_By>>,
  where?: Maybe<Attachment_Status_Bool_Exp>
};


export type Query_RootAttachment_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootAttachment_TypeArgs = {
  distinct_on?: Maybe<Array<Attachment_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Type_Order_By>>,
  where?: Maybe<Attachment_Type_Bool_Exp>
};


export type Query_RootAttachment_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Type_Order_By>>,
  where?: Maybe<Attachment_Type_Bool_Exp>
};


export type Query_RootAttachment_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootAttachment_Upload_CredentialArgs = {
  extension?: Maybe<Scalars['String']>,
  id: Scalars['uuid']
};


export type Query_RootBenefitArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type Query_RootBenefit_AggregateArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type Query_RootBenefit_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootBmp_ListingArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Order_By>>,
  where?: Maybe<Bmp_Listing_Bool_Exp>
};


export type Query_RootBmp_Listing_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Order_By>>,
  where?: Maybe<Bmp_Listing_Bool_Exp>
};


export type Query_RootBmp_Listing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootBmp_Listing_ContactArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Query_RootBmp_Listing_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Query_RootBmp_Listing_InspectionArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Query_RootBmp_Listing_Inspection_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Query_RootBmp_Listing_MediaArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Query_RootBmp_Listing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Query_RootBmp_Listing_SearchArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Search_Order_By>>,
  where?: Maybe<Bmp_Listing_Search_Bool_Exp>
};


export type Query_RootBmp_Listing_Search_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Search_Order_By>>,
  where?: Maybe<Bmp_Listing_Search_Bool_Exp>
};


export type Query_RootCacheArgs = {
  distinct_on?: Maybe<Array<Cache_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Cache_Order_By>>,
  where?: Maybe<Cache_Bool_Exp>
};


export type Query_RootCache_AggregateArgs = {
  distinct_on?: Maybe<Array<Cache_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Cache_Order_By>>,
  where?: Maybe<Cache_Bool_Exp>
};


export type Query_RootCache_By_PkArgs = {
  key: Scalars['String']
};


export type Query_RootCampaignArgs = {
  distinct_on?: Maybe<Array<Campaign_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Order_By>>,
  where?: Maybe<Campaign_Bool_Exp>
};


export type Query_RootCampaign_Addon_GroupArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type Query_RootCampaign_Addon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type Query_RootCampaign_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootCampaign_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Order_By>>,
  where?: Maybe<Campaign_Bool_Exp>
};


export type Query_RootCampaign_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootCampaign_Inclusion_GroupArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Query_RootCampaign_Inclusion_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Query_RootCampaign_Inclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootCampaign_Selling_PointArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type Query_RootCampaign_Selling_Point_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type Query_RootCampaign_Selling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootCheck_Driver_Licence_AuArgs = {
  driverLicenceAu: DriverLicenceRequestAu
};


export type Query_RootCheck_Driver_Licence_NzArgs = {
  diverLicenceNz: DriverLicenceRequestNz
};


export type Query_RootCheck_Duplicate_Listing_For_AddressArgs = {
  listingId: Scalars['String']
};


export type Query_RootCheck_National_Id_CnArgs = {
  nationalId: NationalIdRequestCn
};


export type Query_RootCheck_Passport_AuArgs = {
  passportAu: PassportRequestAu
};


export type Query_RootCheck_Passport_NzArgs = {
  passportNz: PassportRequestNz
};


export type Query_RootCommercial_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Commercial_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Commercial_Status_Type_Order_By>>,
  where?: Maybe<Commercial_Status_Type_Bool_Exp>
};


export type Query_RootCommercial_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Commercial_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Commercial_Status_Type_Order_By>>,
  where?: Maybe<Commercial_Status_Type_Bool_Exp>
};


export type Query_RootCommercial_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootCouponArgs = {
  distinct_on?: Maybe<Array<Coupon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Order_By>>,
  where?: Maybe<Coupon_Bool_Exp>
};


export type Query_RootCoupon_AggregateArgs = {
  distinct_on?: Maybe<Array<Coupon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Order_By>>,
  where?: Maybe<Coupon_Bool_Exp>
};


export type Query_RootCoupon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootCoupon_TypeArgs = {
  distinct_on?: Maybe<Array<Coupon_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Type_Order_By>>,
  where?: Maybe<Coupon_Type_Bool_Exp>
};


export type Query_RootCoupon_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Coupon_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Type_Order_By>>,
  where?: Maybe<Coupon_Type_Bool_Exp>
};


export type Query_RootCoupon_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootEnquiryArgs = {
  distinct_on?: Maybe<Array<Enquiry_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Order_By>>,
  where?: Maybe<Enquiry_Bool_Exp>
};


export type Query_RootEnquiry_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Order_By>>,
  where?: Maybe<Enquiry_Bool_Exp>
};


export type Query_RootEnquiry_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootEnquiry_Call_ResultArgs = {
  distinct_on?: Maybe<Array<Enquiry_Call_Result_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Call_Result_Order_By>>,
  where?: Maybe<Enquiry_Call_Result_Bool_Exp>
};


export type Query_RootEnquiry_Call_Result_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Call_Result_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Call_Result_Order_By>>,
  where?: Maybe<Enquiry_Call_Result_Bool_Exp>
};


export type Query_RootEnquiry_Call_Result_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootEnquiry_Medium_TypeArgs = {
  distinct_on?: Maybe<Array<Enquiry_Medium_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Medium_Type_Order_By>>,
  where?: Maybe<Enquiry_Medium_Type_Bool_Exp>
};


export type Query_RootEnquiry_Medium_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Medium_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Medium_Type_Order_By>>,
  where?: Maybe<Enquiry_Medium_Type_Bool_Exp>
};


export type Query_RootEnquiry_Medium_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootExperimentArgs = {
  distinct_on?: Maybe<Array<Experiment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Order_By>>,
  where?: Maybe<Experiment_Bool_Exp>
};


export type Query_RootExperiment_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Order_By>>,
  where?: Maybe<Experiment_Bool_Exp>
};


export type Query_RootExperiment_By_PkArgs = {
  name: Experiment_Name_Enum
};


export type Query_RootExperiment_NameArgs = {
  distinct_on?: Maybe<Array<Experiment_Name_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Name_Order_By>>,
  where?: Maybe<Experiment_Name_Bool_Exp>
};


export type Query_RootExperiment_Name_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Name_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Name_Order_By>>,
  where?: Maybe<Experiment_Name_Bool_Exp>
};


export type Query_RootExperiment_Name_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootExperiment_StatArgs = {
  distinct_on?: Maybe<Array<Experiment_Stat_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Stat_Order_By>>,
  where?: Maybe<Experiment_Stat_Bool_Exp>
};


export type Query_RootExperiment_Stat_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Stat_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Stat_Order_By>>,
  where?: Maybe<Experiment_Stat_Bool_Exp>
};


export type Query_RootExternal_AuthArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type Query_RootExternal_Auth_AggregateArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type Query_RootExternal_Auth_By_PkArgs = {
  user_id: Scalars['uuid']
};


export type Query_RootFeedbackArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type Query_RootFeedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type Query_RootFeedback_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootGet_Address_DetailArgs = {
  addressId: Scalars['String']
};


export type Query_RootGet_Listing_Advisor_ContextArgs = {
  listingId: Scalars['uuid']
};


export type Query_RootGet_Relisting_AddonArgs = {
  listingId: Scalars['String']
};


export type Query_RootGoogle_Auth_UrlArgs = {
  webAppUrl: Scalars['String']
};


export type Query_RootImpersonate_Sign_InArgs = {
  userId: Scalars['uuid']
};


export type Query_RootInclusionArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};


export type Query_RootInclusion_AddonArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type Query_RootInclusion_Addon_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type Query_RootInclusion_Addon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootInclusion_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};


export type Query_RootInclusion_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootInclusion_GroupArgs = {
  distinct_on?: Maybe<Array<Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Group_Order_By>>,
  where?: Maybe<Inclusion_Group_Bool_Exp>
};


export type Query_RootInclusion_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Group_Order_By>>,
  where?: Maybe<Inclusion_Group_Bool_Exp>
};


export type Query_RootInclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListingArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type Query_RootListing_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type Query_RootListing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_ContactArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type Query_RootListing_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type Query_RootListing_Contact_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_DetailArgs = {
  distinct_on?: Maybe<Array<Listing_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Detail_Order_By>>,
  where?: Maybe<Listing_Detail_Bool_Exp>
};


export type Query_RootListing_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Detail_Order_By>>,
  where?: Maybe<Listing_Detail_Bool_Exp>
};


export type Query_RootListing_DocumentArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type Query_RootListing_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type Query_RootListing_Document_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_Document_StatusArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Status_Order_By>>,
  where?: Maybe<Listing_Document_Status_Bool_Exp>
};


export type Query_RootListing_Document_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Status_Order_By>>,
  where?: Maybe<Listing_Document_Status_Bool_Exp>
};


export type Query_RootListing_Document_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_Document_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Type_Order_By>>,
  where?: Maybe<Listing_Document_Type_Bool_Exp>
};


export type Query_RootListing_Document_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Type_Order_By>>,
  where?: Maybe<Listing_Document_Type_Bool_Exp>
};


export type Query_RootListing_Document_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_EventArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type Query_RootListing_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type Query_RootListing_Event_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_Event_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Type_Order_By>>,
  where?: Maybe<Listing_Event_Type_Bool_Exp>
};


export type Query_RootListing_Event_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Type_Order_By>>,
  where?: Maybe<Listing_Event_Type_Bool_Exp>
};


export type Query_RootListing_Event_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_InspectionArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type Query_RootListing_Inspection_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type Query_RootListing_Inspection_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_MediaArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type Query_RootListing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type Query_RootListing_Media_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_Media_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Type_Order_By>>,
  where?: Maybe<Listing_Media_Type_Bool_Exp>
};


export type Query_RootListing_Media_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Type_Order_By>>,
  where?: Maybe<Listing_Media_Type_Bool_Exp>
};


export type Query_RootListing_Media_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_MetadataArgs = {
  distinct_on?: Maybe<Array<Listing_Metadata_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Metadata_Order_By>>,
  where?: Maybe<Listing_Metadata_Bool_Exp>
};


export type Query_RootListing_Metadata_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Metadata_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Metadata_Order_By>>,
  where?: Maybe<Listing_Metadata_Bool_Exp>
};


export type Query_RootListing_Metadata_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_OnboardingArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type Query_RootListing_Onboarding_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type Query_RootListing_Onboarding_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_ParkingArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type Query_RootListing_Parking_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type Query_RootListing_Parking_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootListing_Publish_ErrorsArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type Query_RootListing_Publish_Errors_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type Query_RootListing_Publish_Errors_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Query_RootListing_Publish_Portal_SourceArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Portal_Source_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Portal_Source_Order_By>>,
  where?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>
};


export type Query_RootListing_Publish_Portal_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Portal_Source_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Portal_Source_Order_By>>,
  where?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>
};


export type Query_RootListing_Publish_Portal_Source_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_Publish_StatusArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type Query_RootListing_Publish_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type Query_RootListing_Publish_Status_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Query_RootListing_Publish_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Type_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Type_Bool_Exp>
};


export type Query_RootListing_Publish_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Type_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Type_Bool_Exp>
};


export type Query_RootListing_Publish_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootListing_SearchArgs = {
  distinct_on?: Maybe<Array<Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Search_Order_By>>,
  where?: Maybe<Listing_Search_Bool_Exp>
};


export type Query_RootListing_Search_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Search_Order_By>>,
  where?: Maybe<Listing_Search_Bool_Exp>
};


export type Query_RootListing_Soi_Comparable_PropertyArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type Query_RootListing_Soi_Comparable_Property_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type Query_RootListing_Soi_Comparable_Property_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootLocation_Auto_CompleteArgs = {
  locationInput: Scalars['String'],
  locationType: Scalars['String']
};


export type Query_RootMetro_TypeArgs = {
  distinct_on?: Maybe<Array<Metro_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Metro_Type_Order_By>>,
  where?: Maybe<Metro_Type_Bool_Exp>
};


export type Query_RootMetro_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Metro_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Metro_Type_Order_By>>,
  where?: Maybe<Metro_Type_Bool_Exp>
};


export type Query_RootMetro_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootMobile_Code_VerificationArgs = {
  code: Scalars['String'],
  mobileNumber: Scalars['String'],
  sid: Scalars['String']
};


export type Query_RootOnboarding_Budget_SizeArgs = {
  distinct_on?: Maybe<Array<Onboarding_Budget_Size_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Budget_Size_Order_By>>,
  where?: Maybe<Onboarding_Budget_Size_Bool_Exp>
};


export type Query_RootOnboarding_Budget_Size_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Budget_Size_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Budget_Size_Order_By>>,
  where?: Maybe<Onboarding_Budget_Size_Bool_Exp>
};


export type Query_RootOnboarding_Budget_Size_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootOnboarding_Reason_SellingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Reason_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Reason_Selling_Order_By>>,
  where?: Maybe<Onboarding_Reason_Selling_Bool_Exp>
};


export type Query_RootOnboarding_Reason_Selling_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Reason_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Reason_Selling_Order_By>>,
  where?: Maybe<Onboarding_Reason_Selling_Bool_Exp>
};


export type Query_RootOnboarding_Reason_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootOnboarding_Timeframe_SellingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Timeframe_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Timeframe_Selling_Order_By>>,
  where?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>
};


export type Query_RootOnboarding_Timeframe_Selling_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Timeframe_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Timeframe_Selling_Order_By>>,
  where?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>
};


export type Query_RootOnboarding_Timeframe_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootOrderArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootOrder_DetailArgs = {
  distinct_on?: Maybe<Array<Order_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Detail_Order_By>>,
  where?: Maybe<Order_Detail_Bool_Exp>
};


export type Query_RootOrder_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Detail_Order_By>>,
  where?: Maybe<Order_Detail_Bool_Exp>
};


export type Query_RootOrder_FulfilmentArgs = {
  distinct_on?: Maybe<Array<Order_Fulfilment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Fulfilment_Order_By>>,
  where?: Maybe<Order_Fulfilment_Bool_Exp>
};


export type Query_RootOrder_Fulfilment_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Fulfilment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Fulfilment_Order_By>>,
  where?: Maybe<Order_Fulfilment_Bool_Exp>
};


export type Query_RootOrder_Fulfilment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootOrder_ItemArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Query_RootOrder_Item_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Query_RootOrder_Item_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootOrder_Item_TypeArgs = {
  distinct_on?: Maybe<Array<Order_Item_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Type_Order_By>>,
  where?: Maybe<Order_Item_Type_Bool_Exp>
};


export type Query_RootOrder_Item_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Type_Order_By>>,
  where?: Maybe<Order_Item_Type_Bool_Exp>
};


export type Query_RootOrder_Item_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootOrder_StatusArgs = {
  distinct_on?: Maybe<Array<Order_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Status_Order_By>>,
  where?: Maybe<Order_Status_Bool_Exp>
};


export type Query_RootOrder_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Status_Order_By>>,
  where?: Maybe<Order_Status_Bool_Exp>
};


export type Query_RootOrder_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootPublishing_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Publishing_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Publishing_Status_Type_Order_By>>,
  where?: Maybe<Publishing_Status_Type_Bool_Exp>
};


export type Query_RootPublishing_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Publishing_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Publishing_Status_Type_Order_By>>,
  where?: Maybe<Publishing_Status_Type_Bool_Exp>
};


export type Query_RootPublishing_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootRaw_Bordering_PostcodeArgs = {
  distinct_on?: Maybe<Array<Raw_Bordering_Postcode_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Raw_Bordering_Postcode_Order_By>>,
  where?: Maybe<Raw_Bordering_Postcode_Bool_Exp>
};


export type Query_RootRaw_Bordering_Postcode_AggregateArgs = {
  distinct_on?: Maybe<Array<Raw_Bordering_Postcode_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Raw_Bordering_Postcode_Order_By>>,
  where?: Maybe<Raw_Bordering_Postcode_Bool_Exp>
};


export type Query_RootRaw_Bordering_Postcode_By_PkArgs = {
  id: Scalars['Int']
};


export type Query_RootRea_PriceArgs = {
  distinct_on?: Maybe<Array<Rea_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Rea_Price_Order_By>>,
  where?: Maybe<Rea_Price_Bool_Exp>
};


export type Query_RootRea_Price_AggregateArgs = {
  distinct_on?: Maybe<Array<Rea_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Rea_Price_Order_By>>,
  where?: Maybe<Rea_Price_Bool_Exp>
};


export type Query_RootRea_Price_By_PkArgs = {
  key: Scalars['String']
};


export type Query_RootRecommended_AddonsArgs = {
  campaign_code?: Maybe<Scalars['String']>,
  listingId: Scalars['uuid']
};


export type Query_RootRecommended_CampaignsArgs = {
  listingId: Scalars['uuid']
};


export type Query_RootResend_Email_Verification_LinkArgs = {
  redirectUrl?: Maybe<Scalars['String']>
};


export type Query_RootSalesforce_Bulksync_RecordsArgs = {
  distinct_on?: Maybe<Array<Salesforce_Bulksync_Records_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Bulksync_Records_Order_By>>,
  where?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>
};


export type Query_RootSalesforce_Bulksync_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Bulksync_Records_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Bulksync_Records_Order_By>>,
  where?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>
};


export type Query_RootSalesforce_Bulksync_Records_By_PkArgs = {
  operation_id: Scalars['uuid']
};


export type Query_RootSalesforce_Connection_TokenArgs = {
  distinct_on?: Maybe<Array<Salesforce_Connection_Token_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Connection_Token_Order_By>>,
  where?: Maybe<Salesforce_Connection_Token_Bool_Exp>
};


export type Query_RootSalesforce_Connection_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Connection_Token_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Connection_Token_Order_By>>,
  where?: Maybe<Salesforce_Connection_Token_Bool_Exp>
};


export type Query_RootSalesforce_Connection_Token_By_PkArgs = {
  access_token: Scalars['String']
};


export type Query_RootSalesforce_Sync_StatusArgs = {
  distinct_on?: Maybe<Array<Salesforce_Sync_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Sync_Status_Order_By>>,
  where?: Maybe<Salesforce_Sync_Status_Bool_Exp>
};


export type Query_RootSalesforce_Sync_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Sync_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Sync_Status_Order_By>>,
  where?: Maybe<Salesforce_Sync_Status_Bool_Exp>
};


export type Query_RootSalesforce_Sync_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootSearch_ListingArgs = {
  args: Search_Listing_Args,
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Query_RootSearch_Listing_AggregateArgs = {
  args: Search_Listing_Args,
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Query_RootSelling_PointArgs = {
  distinct_on?: Maybe<Array<Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Selling_Point_Order_By>>,
  where?: Maybe<Selling_Point_Bool_Exp>
};


export type Query_RootSelling_Point_AggregateArgs = {
  distinct_on?: Maybe<Array<Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Selling_Point_Order_By>>,
  where?: Maybe<Selling_Point_Bool_Exp>
};


export type Query_RootSelling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootSend_EmailArgs = {
  email: Scalars['String'],
  type: Scalars['String']
};


export type Query_RootSend_Onboarding_EmailArgs = {
  userId: Scalars['String']
};


export type Query_RootSend_Purchase_EmailArgs = {
  orderId: Scalars['String']
};


export type Query_RootSign_InArgs = {
  email: Scalars['String'],
  password: Scalars['String'],
  rememberLogin?: Maybe<Scalars['Boolean']>
};


export type Query_RootStock_PhotoArgs = {
  distinct_on?: Maybe<Array<Stock_Photo_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Stock_Photo_Order_By>>,
  where?: Maybe<Stock_Photo_Bool_Exp>
};


export type Query_RootStock_Photo_AggregateArgs = {
  distinct_on?: Maybe<Array<Stock_Photo_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Stock_Photo_Order_By>>,
  where?: Maybe<Stock_Photo_Bool_Exp>
};


export type Query_RootStock_Photo_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootSurrounding_SuburbArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Bool_Exp>
};


export type Query_RootSurrounding_Suburb_AggregateArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Bool_Exp>
};


export type Query_RootSurrounding_Suburb_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootSurrounding_Suburb_ListingArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Query_RootSurrounding_Suburb_Listing_AggregateArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Query_RootTransactionArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type Query_RootTransaction_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type Query_RootTransaction_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootTransaction_StatusArgs = {
  distinct_on?: Maybe<Array<Transaction_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Status_Order_By>>,
  where?: Maybe<Transaction_Status_Bool_Exp>
};


export type Query_RootTransaction_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Status_Order_By>>,
  where?: Maybe<Transaction_Status_Bool_Exp>
};


export type Query_RootTransaction_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Query_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Order_By>>,
  where?: Maybe<User_Bool_Exp>
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Order_By>>,
  where?: Maybe<User_Bool_Exp>
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid']
};


export type Query_RootUser_DetailArgs = {
  distinct_on?: Maybe<Array<User_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Detail_Order_By>>,
  where?: Maybe<User_Detail_Bool_Exp>
};


export type Query_RootUser_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Detail_Order_By>>,
  where?: Maybe<User_Detail_Bool_Exp>
};


export type Query_RootVerify_HashArgs = {
  hash: Scalars['String']
};


export type Query_RootVerify_Mobile_NumberArgs = {
  channel: Scalars['String'],
  mobileNumber: Scalars['String'],
  type: Scalars['String']
};


export type Query_RootZone_TypeArgs = {
  distinct_on?: Maybe<Array<Zone_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Zone_Type_Order_By>>,
  where?: Maybe<Zone_Type_Bool_Exp>
};


export type Query_RootZone_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Zone_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Zone_Type_Order_By>>,
  where?: Maybe<Zone_Type_Bool_Exp>
};


export type Query_RootZone_Type_By_PkArgs = {
  value: Scalars['String']
};

export type Raw_Bordering_Postcode = {
  __typename?: 'raw_bordering_postcode',
  Border_Locality?: Maybe<Scalars['String']>,
  Border_Pcode?: Maybe<Scalars['String']>,
  Border_State?: Maybe<Scalars['String']>,
  Category?: Maybe<Scalars['String']>,
  Comments?: Maybe<Scalars['String']>,
  Locality?: Maybe<Scalars['String']>,
  Pcode?: Maybe<Scalars['String']>,
  State?: Maybe<Scalars['String']>,
  id: Scalars['Int'],
};

export type Raw_Bordering_Postcode_Aggregate = {
  __typename?: 'raw_bordering_postcode_aggregate',
  aggregate?: Maybe<Raw_Bordering_Postcode_Aggregate_Fields>,
  nodes: Array<Raw_Bordering_Postcode>,
};

export type Raw_Bordering_Postcode_Aggregate_Fields = {
  __typename?: 'raw_bordering_postcode_aggregate_fields',
  avg?: Maybe<Raw_Bordering_Postcode_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Raw_Bordering_Postcode_Max_Fields>,
  min?: Maybe<Raw_Bordering_Postcode_Min_Fields>,
  stddev?: Maybe<Raw_Bordering_Postcode_Stddev_Fields>,
  stddev_pop?: Maybe<Raw_Bordering_Postcode_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Raw_Bordering_Postcode_Stddev_Samp_Fields>,
  sum?: Maybe<Raw_Bordering_Postcode_Sum_Fields>,
  var_pop?: Maybe<Raw_Bordering_Postcode_Var_Pop_Fields>,
  var_samp?: Maybe<Raw_Bordering_Postcode_Var_Samp_Fields>,
  variance?: Maybe<Raw_Bordering_Postcode_Variance_Fields>,
};


export type Raw_Bordering_Postcode_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Raw_Bordering_Postcode_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Raw_Bordering_Postcode_Aggregate_Order_By = {
  avg?: Maybe<Raw_Bordering_Postcode_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Raw_Bordering_Postcode_Max_Order_By>,
  min?: Maybe<Raw_Bordering_Postcode_Min_Order_By>,
  stddev?: Maybe<Raw_Bordering_Postcode_Stddev_Order_By>,
  stddev_pop?: Maybe<Raw_Bordering_Postcode_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Raw_Bordering_Postcode_Stddev_Samp_Order_By>,
  sum?: Maybe<Raw_Bordering_Postcode_Sum_Order_By>,
  var_pop?: Maybe<Raw_Bordering_Postcode_Var_Pop_Order_By>,
  var_samp?: Maybe<Raw_Bordering_Postcode_Var_Samp_Order_By>,
  variance?: Maybe<Raw_Bordering_Postcode_Variance_Order_By>,
};

export type Raw_Bordering_Postcode_Arr_Rel_Insert_Input = {
  data: Array<Raw_Bordering_Postcode_Insert_Input>,
  on_conflict?: Maybe<Raw_Bordering_Postcode_On_Conflict>,
};

export type Raw_Bordering_Postcode_Avg_Fields = {
  __typename?: 'raw_bordering_postcode_avg_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Avg_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Bool_Exp = {
  Border_Locality?: Maybe<String_Comparison_Exp>,
  Border_Pcode?: Maybe<String_Comparison_Exp>,
  Border_State?: Maybe<String_Comparison_Exp>,
  Category?: Maybe<String_Comparison_Exp>,
  Comments?: Maybe<String_Comparison_Exp>,
  Locality?: Maybe<String_Comparison_Exp>,
  Pcode?: Maybe<String_Comparison_Exp>,
  State?: Maybe<String_Comparison_Exp>,
  _and?: Maybe<Array<Maybe<Raw_Bordering_Postcode_Bool_Exp>>>,
  _not?: Maybe<Raw_Bordering_Postcode_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Raw_Bordering_Postcode_Bool_Exp>>>,
  id?: Maybe<Int_Comparison_Exp>,
};

export enum Raw_Bordering_Postcode_Constraint {
  RawBorderingPostcodePkey = 'raw_bordering_postcode_pkey'
}

export type Raw_Bordering_Postcode_Inc_Input = {
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Insert_Input = {
  Border_Locality?: Maybe<Scalars['String']>,
  Border_Pcode?: Maybe<Scalars['String']>,
  Border_State?: Maybe<Scalars['String']>,
  Category?: Maybe<Scalars['String']>,
  Comments?: Maybe<Scalars['String']>,
  Locality?: Maybe<Scalars['String']>,
  Pcode?: Maybe<Scalars['String']>,
  State?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Max_Fields = {
  __typename?: 'raw_bordering_postcode_max_fields',
  Border_Locality?: Maybe<Scalars['String']>,
  Border_Pcode?: Maybe<Scalars['String']>,
  Border_State?: Maybe<Scalars['String']>,
  Category?: Maybe<Scalars['String']>,
  Comments?: Maybe<Scalars['String']>,
  Locality?: Maybe<Scalars['String']>,
  Pcode?: Maybe<Scalars['String']>,
  State?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Max_Order_By = {
  Border_Locality?: Maybe<Order_By>,
  Border_Pcode?: Maybe<Order_By>,
  Border_State?: Maybe<Order_By>,
  Category?: Maybe<Order_By>,
  Comments?: Maybe<Order_By>,
  Locality?: Maybe<Order_By>,
  Pcode?: Maybe<Order_By>,
  State?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Min_Fields = {
  __typename?: 'raw_bordering_postcode_min_fields',
  Border_Locality?: Maybe<Scalars['String']>,
  Border_Pcode?: Maybe<Scalars['String']>,
  Border_State?: Maybe<Scalars['String']>,
  Category?: Maybe<Scalars['String']>,
  Comments?: Maybe<Scalars['String']>,
  Locality?: Maybe<Scalars['String']>,
  Pcode?: Maybe<Scalars['String']>,
  State?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Min_Order_By = {
  Border_Locality?: Maybe<Order_By>,
  Border_Pcode?: Maybe<Order_By>,
  Border_State?: Maybe<Order_By>,
  Category?: Maybe<Order_By>,
  Comments?: Maybe<Order_By>,
  Locality?: Maybe<Order_By>,
  Pcode?: Maybe<Order_By>,
  State?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Mutation_Response = {
  __typename?: 'raw_bordering_postcode_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Raw_Bordering_Postcode>,
};

export type Raw_Bordering_Postcode_Obj_Rel_Insert_Input = {
  data: Raw_Bordering_Postcode_Insert_Input,
  on_conflict?: Maybe<Raw_Bordering_Postcode_On_Conflict>,
};

export type Raw_Bordering_Postcode_On_Conflict = {
  constraint: Raw_Bordering_Postcode_Constraint,
  update_columns: Array<Raw_Bordering_Postcode_Update_Column>,
  where?: Maybe<Raw_Bordering_Postcode_Bool_Exp>,
};

export type Raw_Bordering_Postcode_Order_By = {
  Border_Locality?: Maybe<Order_By>,
  Border_Pcode?: Maybe<Order_By>,
  Border_State?: Maybe<Order_By>,
  Category?: Maybe<Order_By>,
  Comments?: Maybe<Order_By>,
  Locality?: Maybe<Order_By>,
  Pcode?: Maybe<Order_By>,
  State?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Pk_Columns_Input = {
  id: Scalars['Int'],
};

export enum Raw_Bordering_Postcode_Select_Column {
  BorderLocality = 'Border_Locality',
  BorderPcode = 'Border_Pcode',
  BorderState = 'Border_State',
  Category = 'Category',
  Comments = 'Comments',
  Locality = 'Locality',
  Pcode = 'Pcode',
  State = 'State',
  Id = 'id'
}

export type Raw_Bordering_Postcode_Set_Input = {
  Border_Locality?: Maybe<Scalars['String']>,
  Border_Pcode?: Maybe<Scalars['String']>,
  Border_State?: Maybe<Scalars['String']>,
  Category?: Maybe<Scalars['String']>,
  Comments?: Maybe<Scalars['String']>,
  Locality?: Maybe<Scalars['String']>,
  Pcode?: Maybe<Scalars['String']>,
  State?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Stddev_Fields = {
  __typename?: 'raw_bordering_postcode_stddev_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Stddev_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Stddev_Pop_Fields = {
  __typename?: 'raw_bordering_postcode_stddev_pop_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Stddev_Samp_Fields = {
  __typename?: 'raw_bordering_postcode_stddev_samp_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Sum_Fields = {
  __typename?: 'raw_bordering_postcode_sum_fields',
  id?: Maybe<Scalars['Int']>,
};

export type Raw_Bordering_Postcode_Sum_Order_By = {
  id?: Maybe<Order_By>,
};

export enum Raw_Bordering_Postcode_Update_Column {
  BorderLocality = 'Border_Locality',
  BorderPcode = 'Border_Pcode',
  BorderState = 'Border_State',
  Category = 'Category',
  Comments = 'Comments',
  Locality = 'Locality',
  Pcode = 'Pcode',
  State = 'State',
  Id = 'id'
}

export type Raw_Bordering_Postcode_Var_Pop_Fields = {
  __typename?: 'raw_bordering_postcode_var_pop_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Var_Pop_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Var_Samp_Fields = {
  __typename?: 'raw_bordering_postcode_var_samp_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Var_Samp_Order_By = {
  id?: Maybe<Order_By>,
};

export type Raw_Bordering_Postcode_Variance_Fields = {
  __typename?: 'raw_bordering_postcode_variance_fields',
  id?: Maybe<Scalars['Float']>,
};

export type Raw_Bordering_Postcode_Variance_Order_By = {
  id?: Maybe<Order_By>,
};

export type Rea_Price = {
  __typename?: 'rea_price',
  key: Scalars['String'],
  postcode: Scalars['String'],
  prices?: Maybe<Scalars['jsonb']>,
  response?: Maybe<Scalars['jsonb']>,
  state: Scalars['String'],
  suburb: Scalars['String'],
  updated_at?: Maybe<Scalars['timestamptz']>,
};


export type Rea_PricePricesArgs = {
  path?: Maybe<Scalars['String']>
};


export type Rea_PriceResponseArgs = {
  path?: Maybe<Scalars['String']>
};

export type Rea_Price_Aggregate = {
  __typename?: 'rea_price_aggregate',
  aggregate?: Maybe<Rea_Price_Aggregate_Fields>,
  nodes: Array<Rea_Price>,
};

export type Rea_Price_Aggregate_Fields = {
  __typename?: 'rea_price_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Rea_Price_Max_Fields>,
  min?: Maybe<Rea_Price_Min_Fields>,
};


export type Rea_Price_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Rea_Price_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Rea_Price_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Rea_Price_Max_Order_By>,
  min?: Maybe<Rea_Price_Min_Order_By>,
};

export type Rea_Price_Append_Input = {
  prices?: Maybe<Scalars['jsonb']>,
  response?: Maybe<Scalars['jsonb']>,
};

export type Rea_Price_Arr_Rel_Insert_Input = {
  data: Array<Rea_Price_Insert_Input>,
  on_conflict?: Maybe<Rea_Price_On_Conflict>,
};

export type Rea_Price_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Rea_Price_Bool_Exp>>>,
  _not?: Maybe<Rea_Price_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Rea_Price_Bool_Exp>>>,
  key?: Maybe<String_Comparison_Exp>,
  postcode?: Maybe<String_Comparison_Exp>,
  prices?: Maybe<Jsonb_Comparison_Exp>,
  response?: Maybe<Jsonb_Comparison_Exp>,
  state?: Maybe<String_Comparison_Exp>,
  suburb?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Rea_Price_Constraint {
  ReaPricePkey = 'rea_price_pkey'
}

export type Rea_Price_Delete_At_Path_Input = {
  prices?: Maybe<Array<Maybe<Scalars['String']>>>,
  response?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Rea_Price_Delete_Elem_Input = {
  prices?: Maybe<Scalars['Int']>,
  response?: Maybe<Scalars['Int']>,
};

export type Rea_Price_Delete_Key_Input = {
  prices?: Maybe<Scalars['String']>,
  response?: Maybe<Scalars['String']>,
};

export type Rea_Price_Insert_Input = {
  key?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  prices?: Maybe<Scalars['jsonb']>,
  response?: Maybe<Scalars['jsonb']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Rea_Price_Max_Fields = {
  __typename?: 'rea_price_max_fields',
  key?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Rea_Price_Max_Order_By = {
  key?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Rea_Price_Min_Fields = {
  __typename?: 'rea_price_min_fields',
  key?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Rea_Price_Min_Order_By = {
  key?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Rea_Price_Mutation_Response = {
  __typename?: 'rea_price_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Rea_Price>,
};

export type Rea_Price_Obj_Rel_Insert_Input = {
  data: Rea_Price_Insert_Input,
  on_conflict?: Maybe<Rea_Price_On_Conflict>,
};

export type Rea_Price_On_Conflict = {
  constraint: Rea_Price_Constraint,
  update_columns: Array<Rea_Price_Update_Column>,
  where?: Maybe<Rea_Price_Bool_Exp>,
};

export type Rea_Price_Order_By = {
  key?: Maybe<Order_By>,
  postcode?: Maybe<Order_By>,
  prices?: Maybe<Order_By>,
  response?: Maybe<Order_By>,
  state?: Maybe<Order_By>,
  suburb?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Rea_Price_Pk_Columns_Input = {
  key: Scalars['String'],
};

export type Rea_Price_Prepend_Input = {
  prices?: Maybe<Scalars['jsonb']>,
  response?: Maybe<Scalars['jsonb']>,
};

export enum Rea_Price_Select_Column {
  Key = 'key',
  Postcode = 'postcode',
  Prices = 'prices',
  Response = 'response',
  State = 'state',
  Suburb = 'suburb',
  UpdatedAt = 'updated_at'
}

export type Rea_Price_Set_Input = {
  key?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  prices?: Maybe<Scalars['jsonb']>,
  response?: Maybe<Scalars['jsonb']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export enum Rea_Price_Update_Column {
  Key = 'key',
  Postcode = 'postcode',
  Prices = 'prices',
  Response = 'response',
  State = 'state',
  Suburb = 'suburb',
  UpdatedAt = 'updated_at'
}

export type ReaPriceInput = {
  postcode: Scalars['String'],
  prices?: Maybe<Scalars['String']>,
  state: Scalars['String'],
  suburb: Scalars['String'],
};

export type ReaPriceOutput = {
  __typename?: 'ReaPriceOutput',
  success: Scalars['Boolean'],
};

export type RecommendedAddonOutput = {
  __typename?: 'RecommendedAddonOutput',
  addon?: Maybe<Addon>,
  addon_code: Scalars['String'],
  all_homes_allowed?: Maybe<Scalars['Boolean']>,
  campaign_code: Scalars['String'],
  index: Scalars['Int'],
  land_size?: Maybe<Scalars['String']>,
  metro?: Maybe<Scalars['String']>,
  persona?: Maybe<Scalars['String']>,
  property_type?: Maybe<Scalars['String']>,
  rule_id?: Maybe<Scalars['String']>,
  sale_type?: Maybe<Scalars['String']>,
  special_price?: Maybe<Scalars['Float']>,
  suburb?: Maybe<Scalars['String']>,
  use_special_price?: Maybe<Scalars['Boolean']>,
  zone?: Maybe<Scalars['String']>,
};

export type RecommendedCampaignOutput = {
  __typename?: 'RecommendedCampaignOutput',
  campaign?: Maybe<Campaign>,
  campaign_code: Scalars['String'],
  index: Scalars['Int'],
  metro?: Maybe<Scalars['String']>,
  persona?: Maybe<Scalars['String']>,
  property_type?: Maybe<Scalars['String']>,
  rule_id?: Maybe<Scalars['String']>,
  sale_type?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  zone?: Maybe<Scalars['String']>,
};

export type Remove_Order_Response = {
  __typename?: 'remove_order_response',
  affected_rows: Scalars['numeric'],
};

export type Remove_User_Response = {
  __typename?: 'remove_user_response',
  affected_rows: Scalars['numeric'],
};

export type Request_Cancel_Order_Response = {
  __typename?: 'request_cancel_order_response',
  affected_rows: Scalars['numeric'],
};

export type Results_Dlnz = {
  __typename?: 'Results_dlnz',
  VerifyResult_v22?: Maybe<VerifyResultV22_Dlnz>,
};

export type Results_Nicn = {
  __typename?: 'Results_nicn',
  VerifyResult_v22?: Maybe<VerifyResultV22_Nicn>,
};

export type Results_Ppnz = {
  __typename?: 'Results_ppnz',
  VerifyResult_v22?: Maybe<VerifyResultV22_Ppnz>,
};

export type Salesforce_Bulksync_Records = {
  __typename?: 'salesforce_bulksync_records',
  created_at: Scalars['timestamptz'],
  hasura_id: Scalars['String'],
  hasura_obj_new?: Maybe<Scalars['jsonb']>,
  hasura_obj_old?: Maybe<Scalars['jsonb']>,
  hasura_table_name: Scalars['String'],
  operation: Scalars['String'],
  operation_id: Scalars['uuid'],
  retries: Scalars['Int'],
  salesforce_id?: Maybe<Scalars['String']>,
  status: Salesforce_Sync_Status_Enum,
  sync_error?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};


export type Salesforce_Bulksync_RecordsHasura_Obj_NewArgs = {
  path?: Maybe<Scalars['String']>
};


export type Salesforce_Bulksync_RecordsHasura_Obj_OldArgs = {
  path?: Maybe<Scalars['String']>
};

export type Salesforce_Bulksync_Records_Aggregate = {
  __typename?: 'salesforce_bulksync_records_aggregate',
  aggregate?: Maybe<Salesforce_Bulksync_Records_Aggregate_Fields>,
  nodes: Array<Salesforce_Bulksync_Records>,
};

export type Salesforce_Bulksync_Records_Aggregate_Fields = {
  __typename?: 'salesforce_bulksync_records_aggregate_fields',
  avg?: Maybe<Salesforce_Bulksync_Records_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Salesforce_Bulksync_Records_Max_Fields>,
  min?: Maybe<Salesforce_Bulksync_Records_Min_Fields>,
  stddev?: Maybe<Salesforce_Bulksync_Records_Stddev_Fields>,
  stddev_pop?: Maybe<Salesforce_Bulksync_Records_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Salesforce_Bulksync_Records_Stddev_Samp_Fields>,
  sum?: Maybe<Salesforce_Bulksync_Records_Sum_Fields>,
  var_pop?: Maybe<Salesforce_Bulksync_Records_Var_Pop_Fields>,
  var_samp?: Maybe<Salesforce_Bulksync_Records_Var_Samp_Fields>,
  variance?: Maybe<Salesforce_Bulksync_Records_Variance_Fields>,
};


export type Salesforce_Bulksync_Records_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salesforce_Bulksync_Records_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Salesforce_Bulksync_Records_Aggregate_Order_By = {
  avg?: Maybe<Salesforce_Bulksync_Records_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Salesforce_Bulksync_Records_Max_Order_By>,
  min?: Maybe<Salesforce_Bulksync_Records_Min_Order_By>,
  stddev?: Maybe<Salesforce_Bulksync_Records_Stddev_Order_By>,
  stddev_pop?: Maybe<Salesforce_Bulksync_Records_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Salesforce_Bulksync_Records_Stddev_Samp_Order_By>,
  sum?: Maybe<Salesforce_Bulksync_Records_Sum_Order_By>,
  var_pop?: Maybe<Salesforce_Bulksync_Records_Var_Pop_Order_By>,
  var_samp?: Maybe<Salesforce_Bulksync_Records_Var_Samp_Order_By>,
  variance?: Maybe<Salesforce_Bulksync_Records_Variance_Order_By>,
};

export type Salesforce_Bulksync_Records_Append_Input = {
  hasura_obj_new?: Maybe<Scalars['jsonb']>,
  hasura_obj_old?: Maybe<Scalars['jsonb']>,
};

export type Salesforce_Bulksync_Records_Arr_Rel_Insert_Input = {
  data: Array<Salesforce_Bulksync_Records_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Bulksync_Records_On_Conflict>,
};

export type Salesforce_Bulksync_Records_Avg_Fields = {
  __typename?: 'salesforce_bulksync_records_avg_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Avg_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Salesforce_Bulksync_Records_Bool_Exp>>>,
  _not?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Salesforce_Bulksync_Records_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  hasura_id?: Maybe<String_Comparison_Exp>,
  hasura_obj_new?: Maybe<Jsonb_Comparison_Exp>,
  hasura_obj_old?: Maybe<Jsonb_Comparison_Exp>,
  hasura_table_name?: Maybe<String_Comparison_Exp>,
  operation?: Maybe<String_Comparison_Exp>,
  operation_id?: Maybe<Uuid_Comparison_Exp>,
  retries?: Maybe<Int_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  status?: Maybe<Salesforce_Sync_Status_Enum_Comparison_Exp>,
  sync_error?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Salesforce_Bulksync_Records_Constraint {
  SalesforceBulksyncRecordsOperationIdKey = 'salesforce_bulksync_records_operation_id_key',
  SalesforceBulksyncRecordsPkey = 'salesforce_bulksync_records_pkey'
}

export type Salesforce_Bulksync_Records_Delete_At_Path_Input = {
  hasura_obj_new?: Maybe<Array<Maybe<Scalars['String']>>>,
  hasura_obj_old?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Salesforce_Bulksync_Records_Delete_Elem_Input = {
  hasura_obj_new?: Maybe<Scalars['Int']>,
  hasura_obj_old?: Maybe<Scalars['Int']>,
};

export type Salesforce_Bulksync_Records_Delete_Key_Input = {
  hasura_obj_new?: Maybe<Scalars['String']>,
  hasura_obj_old?: Maybe<Scalars['String']>,
};

export type Salesforce_Bulksync_Records_Inc_Input = {
  retries?: Maybe<Scalars['Int']>,
};

export type Salesforce_Bulksync_Records_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  hasura_id?: Maybe<Scalars['String']>,
  hasura_obj_new?: Maybe<Scalars['jsonb']>,
  hasura_obj_old?: Maybe<Scalars['jsonb']>,
  hasura_table_name?: Maybe<Scalars['String']>,
  operation?: Maybe<Scalars['String']>,
  operation_id?: Maybe<Scalars['uuid']>,
  retries?: Maybe<Scalars['Int']>,
  salesforce_id?: Maybe<Scalars['String']>,
  status?: Maybe<Salesforce_Sync_Status_Enum>,
  sync_error?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Bulksync_Records_Max_Fields = {
  __typename?: 'salesforce_bulksync_records_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  hasura_id?: Maybe<Scalars['String']>,
  hasura_table_name?: Maybe<Scalars['String']>,
  operation?: Maybe<Scalars['String']>,
  operation_id?: Maybe<Scalars['uuid']>,
  retries?: Maybe<Scalars['Int']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sync_error?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Bulksync_Records_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  hasura_id?: Maybe<Order_By>,
  hasura_table_name?: Maybe<Order_By>,
  operation?: Maybe<Order_By>,
  operation_id?: Maybe<Order_By>,
  retries?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sync_error?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Min_Fields = {
  __typename?: 'salesforce_bulksync_records_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  hasura_id?: Maybe<Scalars['String']>,
  hasura_table_name?: Maybe<Scalars['String']>,
  operation?: Maybe<Scalars['String']>,
  operation_id?: Maybe<Scalars['uuid']>,
  retries?: Maybe<Scalars['Int']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sync_error?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Bulksync_Records_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  hasura_id?: Maybe<Order_By>,
  hasura_table_name?: Maybe<Order_By>,
  operation?: Maybe<Order_By>,
  operation_id?: Maybe<Order_By>,
  retries?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sync_error?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Mutation_Response = {
  __typename?: 'salesforce_bulksync_records_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Salesforce_Bulksync_Records>,
};

export type Salesforce_Bulksync_Records_Obj_Rel_Insert_Input = {
  data: Salesforce_Bulksync_Records_Insert_Input,
  on_conflict?: Maybe<Salesforce_Bulksync_Records_On_Conflict>,
};

export type Salesforce_Bulksync_Records_On_Conflict = {
  constraint: Salesforce_Bulksync_Records_Constraint,
  update_columns: Array<Salesforce_Bulksync_Records_Update_Column>,
  where?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>,
};

export type Salesforce_Bulksync_Records_Order_By = {
  created_at?: Maybe<Order_By>,
  hasura_id?: Maybe<Order_By>,
  hasura_obj_new?: Maybe<Order_By>,
  hasura_obj_old?: Maybe<Order_By>,
  hasura_table_name?: Maybe<Order_By>,
  operation?: Maybe<Order_By>,
  operation_id?: Maybe<Order_By>,
  retries?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  sync_error?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Pk_Columns_Input = {
  operation_id: Scalars['uuid'],
};

export type Salesforce_Bulksync_Records_Prepend_Input = {
  hasura_obj_new?: Maybe<Scalars['jsonb']>,
  hasura_obj_old?: Maybe<Scalars['jsonb']>,
};

export enum Salesforce_Bulksync_Records_Select_Column {
  CreatedAt = 'created_at',
  HasuraId = 'hasura_id',
  HasuraObjNew = 'hasura_obj_new',
  HasuraObjOld = 'hasura_obj_old',
  HasuraTableName = 'hasura_table_name',
  Operation = 'operation',
  OperationId = 'operation_id',
  Retries = 'retries',
  SalesforceId = 'salesforce_id',
  Status = 'status',
  SyncError = 'sync_error',
  UpdatedAt = 'updated_at'
}

export type Salesforce_Bulksync_Records_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  hasura_id?: Maybe<Scalars['String']>,
  hasura_obj_new?: Maybe<Scalars['jsonb']>,
  hasura_obj_old?: Maybe<Scalars['jsonb']>,
  hasura_table_name?: Maybe<Scalars['String']>,
  operation?: Maybe<Scalars['String']>,
  operation_id?: Maybe<Scalars['uuid']>,
  retries?: Maybe<Scalars['Int']>,
  salesforce_id?: Maybe<Scalars['String']>,
  status?: Maybe<Salesforce_Sync_Status_Enum>,
  sync_error?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Bulksync_Records_Stddev_Fields = {
  __typename?: 'salesforce_bulksync_records_stddev_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Stddev_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Stddev_Pop_Fields = {
  __typename?: 'salesforce_bulksync_records_stddev_pop_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Stddev_Pop_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Stddev_Samp_Fields = {
  __typename?: 'salesforce_bulksync_records_stddev_samp_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Stddev_Samp_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Sum_Fields = {
  __typename?: 'salesforce_bulksync_records_sum_fields',
  retries?: Maybe<Scalars['Int']>,
};

export type Salesforce_Bulksync_Records_Sum_Order_By = {
  retries?: Maybe<Order_By>,
};

export enum Salesforce_Bulksync_Records_Update_Column {
  CreatedAt = 'created_at',
  HasuraId = 'hasura_id',
  HasuraObjNew = 'hasura_obj_new',
  HasuraObjOld = 'hasura_obj_old',
  HasuraTableName = 'hasura_table_name',
  Operation = 'operation',
  OperationId = 'operation_id',
  Retries = 'retries',
  SalesforceId = 'salesforce_id',
  Status = 'status',
  SyncError = 'sync_error',
  UpdatedAt = 'updated_at'
}

export type Salesforce_Bulksync_Records_Var_Pop_Fields = {
  __typename?: 'salesforce_bulksync_records_var_pop_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Var_Pop_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Var_Samp_Fields = {
  __typename?: 'salesforce_bulksync_records_var_samp_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Var_Samp_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Bulksync_Records_Variance_Fields = {
  __typename?: 'salesforce_bulksync_records_variance_fields',
  retries?: Maybe<Scalars['Float']>,
};

export type Salesforce_Bulksync_Records_Variance_Order_By = {
  retries?: Maybe<Order_By>,
};

export type Salesforce_Connection_Token = {
  __typename?: 'salesforce_connection_token',
  access_token: Scalars['String'],
  instance_url?: Maybe<Scalars['String']>,
  last_ran_time?: Maybe<Scalars['timestamptz']>,
  refresh_token?: Maybe<Scalars['String']>,
  start_time?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Connection_Token_Aggregate = {
  __typename?: 'salesforce_connection_token_aggregate',
  aggregate?: Maybe<Salesforce_Connection_Token_Aggregate_Fields>,
  nodes: Array<Salesforce_Connection_Token>,
};

export type Salesforce_Connection_Token_Aggregate_Fields = {
  __typename?: 'salesforce_connection_token_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Salesforce_Connection_Token_Max_Fields>,
  min?: Maybe<Salesforce_Connection_Token_Min_Fields>,
};


export type Salesforce_Connection_Token_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salesforce_Connection_Token_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Salesforce_Connection_Token_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Salesforce_Connection_Token_Max_Order_By>,
  min?: Maybe<Salesforce_Connection_Token_Min_Order_By>,
};

export type Salesforce_Connection_Token_Arr_Rel_Insert_Input = {
  data: Array<Salesforce_Connection_Token_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Connection_Token_On_Conflict>,
};

export type Salesforce_Connection_Token_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Salesforce_Connection_Token_Bool_Exp>>>,
  _not?: Maybe<Salesforce_Connection_Token_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Salesforce_Connection_Token_Bool_Exp>>>,
  access_token?: Maybe<String_Comparison_Exp>,
  instance_url?: Maybe<String_Comparison_Exp>,
  last_ran_time?: Maybe<Timestamptz_Comparison_Exp>,
  refresh_token?: Maybe<String_Comparison_Exp>,
  start_time?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Salesforce_Connection_Token_Constraint {
  SalesforceConnectionTokenInstanceUrlKey = 'salesforce_connection_token_instance_url_key',
  SalesforceConnectionTokenPkey = 'salesforce_connection_token_pkey',
  SalesforceConnectionTokenRefreshTokenKey = 'salesforce_connection_token_refresh_token_key'
}

export type Salesforce_Connection_Token_Insert_Input = {
  access_token?: Maybe<Scalars['String']>,
  instance_url?: Maybe<Scalars['String']>,
  last_ran_time?: Maybe<Scalars['timestamptz']>,
  refresh_token?: Maybe<Scalars['String']>,
  start_time?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Connection_Token_Max_Fields = {
  __typename?: 'salesforce_connection_token_max_fields',
  access_token?: Maybe<Scalars['String']>,
  instance_url?: Maybe<Scalars['String']>,
  last_ran_time?: Maybe<Scalars['timestamptz']>,
  refresh_token?: Maybe<Scalars['String']>,
  start_time?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Connection_Token_Max_Order_By = {
  access_token?: Maybe<Order_By>,
  instance_url?: Maybe<Order_By>,
  last_ran_time?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  start_time?: Maybe<Order_By>,
};

export type Salesforce_Connection_Token_Min_Fields = {
  __typename?: 'salesforce_connection_token_min_fields',
  access_token?: Maybe<Scalars['String']>,
  instance_url?: Maybe<Scalars['String']>,
  last_ran_time?: Maybe<Scalars['timestamptz']>,
  refresh_token?: Maybe<Scalars['String']>,
  start_time?: Maybe<Scalars['timestamptz']>,
};

export type Salesforce_Connection_Token_Min_Order_By = {
  access_token?: Maybe<Order_By>,
  instance_url?: Maybe<Order_By>,
  last_ran_time?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  start_time?: Maybe<Order_By>,
};

export type Salesforce_Connection_Token_Mutation_Response = {
  __typename?: 'salesforce_connection_token_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Salesforce_Connection_Token>,
};

export type Salesforce_Connection_Token_Obj_Rel_Insert_Input = {
  data: Salesforce_Connection_Token_Insert_Input,
  on_conflict?: Maybe<Salesforce_Connection_Token_On_Conflict>,
};

export type Salesforce_Connection_Token_On_Conflict = {
  constraint: Salesforce_Connection_Token_Constraint,
  update_columns: Array<Salesforce_Connection_Token_Update_Column>,
  where?: Maybe<Salesforce_Connection_Token_Bool_Exp>,
};

export type Salesforce_Connection_Token_Order_By = {
  access_token?: Maybe<Order_By>,
  instance_url?: Maybe<Order_By>,
  last_ran_time?: Maybe<Order_By>,
  refresh_token?: Maybe<Order_By>,
  start_time?: Maybe<Order_By>,
};

export type Salesforce_Connection_Token_Pk_Columns_Input = {
  access_token: Scalars['String'],
};

export enum Salesforce_Connection_Token_Select_Column {
  AccessToken = 'access_token',
  InstanceUrl = 'instance_url',
  LastRanTime = 'last_ran_time',
  RefreshToken = 'refresh_token',
  StartTime = 'start_time'
}

export type Salesforce_Connection_Token_Set_Input = {
  access_token?: Maybe<Scalars['String']>,
  instance_url?: Maybe<Scalars['String']>,
  last_ran_time?: Maybe<Scalars['timestamptz']>,
  refresh_token?: Maybe<Scalars['String']>,
  start_time?: Maybe<Scalars['timestamptz']>,
};

export enum Salesforce_Connection_Token_Update_Column {
  AccessToken = 'access_token',
  InstanceUrl = 'instance_url',
  LastRanTime = 'last_ran_time',
  RefreshToken = 'refresh_token',
  StartTime = 'start_time'
}

export type Salesforce_Sync_Status = {
  __typename?: 'salesforce_sync_status',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Salesforce_Sync_Status_Aggregate = {
  __typename?: 'salesforce_sync_status_aggregate',
  aggregate?: Maybe<Salesforce_Sync_Status_Aggregate_Fields>,
  nodes: Array<Salesforce_Sync_Status>,
};

export type Salesforce_Sync_Status_Aggregate_Fields = {
  __typename?: 'salesforce_sync_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Salesforce_Sync_Status_Max_Fields>,
  min?: Maybe<Salesforce_Sync_Status_Min_Fields>,
};


export type Salesforce_Sync_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Salesforce_Sync_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Salesforce_Sync_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Salesforce_Sync_Status_Max_Order_By>,
  min?: Maybe<Salesforce_Sync_Status_Min_Order_By>,
};

export type Salesforce_Sync_Status_Arr_Rel_Insert_Input = {
  data: Array<Salesforce_Sync_Status_Insert_Input>,
  on_conflict?: Maybe<Salesforce_Sync_Status_On_Conflict>,
};

export type Salesforce_Sync_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Salesforce_Sync_Status_Bool_Exp>>>,
  _not?: Maybe<Salesforce_Sync_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Salesforce_Sync_Status_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Salesforce_Sync_Status_Constraint {
  SalesforceSyncStatusPkey = 'salesforce_sync_status_pkey'
}

export enum Salesforce_Sync_Status_Enum {
  Failed = 'FAILED',
  InProcess = 'IN_PROCESS',
  Queued = 'QUEUED',
  Synced = 'SYNCED'
}

export type Salesforce_Sync_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Salesforce_Sync_Status_Enum>,
  _in?: Maybe<Array<Salesforce_Sync_Status_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Salesforce_Sync_Status_Enum>,
  _nin?: Maybe<Array<Salesforce_Sync_Status_Enum>>,
};

export type Salesforce_Sync_Status_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Salesforce_Sync_Status_Max_Fields = {
  __typename?: 'salesforce_sync_status_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Salesforce_Sync_Status_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Salesforce_Sync_Status_Min_Fields = {
  __typename?: 'salesforce_sync_status_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Salesforce_Sync_Status_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Salesforce_Sync_Status_Mutation_Response = {
  __typename?: 'salesforce_sync_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Salesforce_Sync_Status>,
};

export type Salesforce_Sync_Status_Obj_Rel_Insert_Input = {
  data: Salesforce_Sync_Status_Insert_Input,
  on_conflict?: Maybe<Salesforce_Sync_Status_On_Conflict>,
};

export type Salesforce_Sync_Status_On_Conflict = {
  constraint: Salesforce_Sync_Status_Constraint,
  update_columns: Array<Salesforce_Sync_Status_Update_Column>,
  where?: Maybe<Salesforce_Sync_Status_Bool_Exp>,
};

export type Salesforce_Sync_Status_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Salesforce_Sync_Status_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Salesforce_Sync_Status_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Salesforce_Sync_Status_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Salesforce_Sync_Status_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Search_Listing_Args = {
  show_surrounding?: Maybe<Scalars['Boolean']>,
  suburbname?: Maybe<Scalars['String']>,
};

export type Selling_Point = {
  __typename?: 'selling_point',
  campaign_selling_points: Array<Campaign_Selling_Point>,
  campaign_selling_points_aggregate: Campaign_Selling_Point_Aggregate,
  created_at: Scalars['timestamptz'],
  description: Scalars['String'],
  id: Scalars['uuid'],
  image: Scalars['String'],
  name: Scalars['String'],
  order: Scalars['Int'],
  updated_at: Scalars['timestamptz'],
};


export type Selling_PointCampaign_Selling_PointsArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type Selling_PointCampaign_Selling_Points_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};

export type Selling_Point_Aggregate = {
  __typename?: 'selling_point_aggregate',
  aggregate?: Maybe<Selling_Point_Aggregate_Fields>,
  nodes: Array<Selling_Point>,
};

export type Selling_Point_Aggregate_Fields = {
  __typename?: 'selling_point_aggregate_fields',
  avg?: Maybe<Selling_Point_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Selling_Point_Max_Fields>,
  min?: Maybe<Selling_Point_Min_Fields>,
  stddev?: Maybe<Selling_Point_Stddev_Fields>,
  stddev_pop?: Maybe<Selling_Point_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Selling_Point_Stddev_Samp_Fields>,
  sum?: Maybe<Selling_Point_Sum_Fields>,
  var_pop?: Maybe<Selling_Point_Var_Pop_Fields>,
  var_samp?: Maybe<Selling_Point_Var_Samp_Fields>,
  variance?: Maybe<Selling_Point_Variance_Fields>,
};


export type Selling_Point_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Selling_Point_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Selling_Point_Aggregate_Order_By = {
  avg?: Maybe<Selling_Point_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Selling_Point_Max_Order_By>,
  min?: Maybe<Selling_Point_Min_Order_By>,
  stddev?: Maybe<Selling_Point_Stddev_Order_By>,
  stddev_pop?: Maybe<Selling_Point_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Selling_Point_Stddev_Samp_Order_By>,
  sum?: Maybe<Selling_Point_Sum_Order_By>,
  var_pop?: Maybe<Selling_Point_Var_Pop_Order_By>,
  var_samp?: Maybe<Selling_Point_Var_Samp_Order_By>,
  variance?: Maybe<Selling_Point_Variance_Order_By>,
};

export type Selling_Point_Arr_Rel_Insert_Input = {
  data: Array<Selling_Point_Insert_Input>,
  on_conflict?: Maybe<Selling_Point_On_Conflict>,
};

export type Selling_Point_Avg_Fields = {
  __typename?: 'selling_point_avg_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Avg_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Selling_Point_Bool_Exp>>>,
  _not?: Maybe<Selling_Point_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Selling_Point_Bool_Exp>>>,
  campaign_selling_points?: Maybe<Campaign_Selling_Point_Bool_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  image?: Maybe<String_Comparison_Exp>,
  name?: Maybe<String_Comparison_Exp>,
  order?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Selling_Point_Constraint {
  SellingPointPkey = 'selling_point_pkey'
}

export type Selling_Point_Inc_Input = {
  order?: Maybe<Scalars['Int']>,
};

export type Selling_Point_Insert_Input = {
  campaign_selling_points?: Maybe<Campaign_Selling_Point_Arr_Rel_Insert_Input>,
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Selling_Point_Max_Fields = {
  __typename?: 'selling_point_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Selling_Point_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Selling_Point_Min_Fields = {
  __typename?: 'selling_point_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Selling_Point_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Selling_Point_Mutation_Response = {
  __typename?: 'selling_point_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Selling_Point>,
};

export type Selling_Point_Obj_Rel_Insert_Input = {
  data: Selling_Point_Insert_Input,
  on_conflict?: Maybe<Selling_Point_On_Conflict>,
};

export type Selling_Point_On_Conflict = {
  constraint: Selling_Point_Constraint,
  update_columns: Array<Selling_Point_Update_Column>,
  where?: Maybe<Selling_Point_Bool_Exp>,
};

export type Selling_Point_Order_By = {
  campaign_selling_points_aggregate?: Maybe<Campaign_Selling_Point_Aggregate_Order_By>,
  created_at?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  image?: Maybe<Order_By>,
  name?: Maybe<Order_By>,
  order?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Selling_Point_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Selling_Point_Select_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Image = 'image',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Selling_Point_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  description?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  image?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  order?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Selling_Point_Stddev_Fields = {
  __typename?: 'selling_point_stddev_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Stddev_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Stddev_Pop_Fields = {
  __typename?: 'selling_point_stddev_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Stddev_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Stddev_Samp_Fields = {
  __typename?: 'selling_point_stddev_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Stddev_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Sum_Fields = {
  __typename?: 'selling_point_sum_fields',
  order?: Maybe<Scalars['Int']>,
};

export type Selling_Point_Sum_Order_By = {
  order?: Maybe<Order_By>,
};

export enum Selling_Point_Update_Column {
  CreatedAt = 'created_at',
  Description = 'description',
  Id = 'id',
  Image = 'image',
  Name = 'name',
  Order = 'order',
  UpdatedAt = 'updated_at'
}

export type Selling_Point_Var_Pop_Fields = {
  __typename?: 'selling_point_var_pop_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Var_Pop_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Var_Samp_Fields = {
  __typename?: 'selling_point_var_samp_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Var_Samp_Order_By = {
  order?: Maybe<Order_By>,
};

export type Selling_Point_Variance_Fields = {
  __typename?: 'selling_point_variance_fields',
  order?: Maybe<Scalars['Float']>,
};

export type Selling_Point_Variance_Order_By = {
  order?: Maybe<Order_By>,
};

export type Signup_Auth_Response = {
  __typename?: 'signup_auth_response',
  jwt: Scalars['String'],
  listingId: Scalars['uuid'],
  redirectUrl: Scalars['String'],
  userId: Scalars['uuid'],
};


export type Smallint_Comparison_Exp = {
  _eq?: Maybe<Scalars['smallint']>,
  _gt?: Maybe<Scalars['smallint']>,
  _gte?: Maybe<Scalars['smallint']>,
  _in?: Maybe<Array<Scalars['smallint']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['smallint']>,
  _lte?: Maybe<Scalars['smallint']>,
  _neq?: Maybe<Scalars['smallint']>,
  _nin?: Maybe<Array<Scalars['smallint']>>,
};

export type Stock_Photo = {
  __typename?: 'stock_photo',
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  url: Scalars['String'],
};

export type Stock_Photo_Aggregate = {
  __typename?: 'stock_photo_aggregate',
  aggregate?: Maybe<Stock_Photo_Aggregate_Fields>,
  nodes: Array<Stock_Photo>,
};

export type Stock_Photo_Aggregate_Fields = {
  __typename?: 'stock_photo_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Stock_Photo_Max_Fields>,
  min?: Maybe<Stock_Photo_Min_Fields>,
};


export type Stock_Photo_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Stock_Photo_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Stock_Photo_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Stock_Photo_Max_Order_By>,
  min?: Maybe<Stock_Photo_Min_Order_By>,
};

export type Stock_Photo_Arr_Rel_Insert_Input = {
  data: Array<Stock_Photo_Insert_Input>,
  on_conflict?: Maybe<Stock_Photo_On_Conflict>,
};

export type Stock_Photo_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Stock_Photo_Bool_Exp>>>,
  _not?: Maybe<Stock_Photo_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Stock_Photo_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  thumbnail_1212?: Maybe<String_Comparison_Exp>,
  thumbnail_1818?: Maybe<String_Comparison_Exp>,
  thumbnail_185?: Maybe<String_Comparison_Exp>,
  thumbnail_284?: Maybe<String_Comparison_Exp>,
  thumbnail_370?: Maybe<String_Comparison_Exp>,
  thumbnail_555?: Maybe<String_Comparison_Exp>,
  thumbnail_568?: Maybe<String_Comparison_Exp>,
  thumbnail_606?: Maybe<String_Comparison_Exp>,
  thumbnail_852?: Maybe<String_Comparison_Exp>,
  url?: Maybe<String_Comparison_Exp>,
};

export enum Stock_Photo_Constraint {
  StockPhotoPkey = 'stock_photo_pkey'
}

export type Stock_Photo_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Stock_Photo_Max_Fields = {
  __typename?: 'stock_photo_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Stock_Photo_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Stock_Photo_Min_Fields = {
  __typename?: 'stock_photo_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export type Stock_Photo_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Stock_Photo_Mutation_Response = {
  __typename?: 'stock_photo_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Stock_Photo>,
};

export type Stock_Photo_Obj_Rel_Insert_Input = {
  data: Stock_Photo_Insert_Input,
  on_conflict?: Maybe<Stock_Photo_On_Conflict>,
};

export type Stock_Photo_On_Conflict = {
  constraint: Stock_Photo_Constraint,
  update_columns: Array<Stock_Photo_Update_Column>,
  where?: Maybe<Stock_Photo_Bool_Exp>,
};

export type Stock_Photo_Order_By = {
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  url?: Maybe<Order_By>,
};

export type Stock_Photo_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Stock_Photo_Select_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  Url = 'url'
}

export type Stock_Photo_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  url?: Maybe<Scalars['String']>,
};

export enum Stock_Photo_Update_Column {
  CreatedAt = 'created_at',
  Id = 'id',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  Url = 'url'
}

export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>,
  _gt?: Maybe<Scalars['String']>,
  _gte?: Maybe<Scalars['String']>,
  _ilike?: Maybe<Scalars['String']>,
  _in?: Maybe<Array<Scalars['String']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _like?: Maybe<Scalars['String']>,
  _lt?: Maybe<Scalars['String']>,
  _lte?: Maybe<Scalars['String']>,
  _neq?: Maybe<Scalars['String']>,
  _nilike?: Maybe<Scalars['String']>,
  _nin?: Maybe<Array<Scalars['String']>>,
  _nlike?: Maybe<Scalars['String']>,
  _nsimilar?: Maybe<Scalars['String']>,
  _similar?: Maybe<Scalars['String']>,
};

export type Subscription_Root = {
  __typename?: 'subscription_root',
  addon: Array<Addon>,
  addon_addon_group: Array<Addon_Addon_Group>,
  addon_addon_group_aggregate: Addon_Addon_Group_Aggregate,
  addon_addon_group_by_pk?: Maybe<Addon_Addon_Group>,
  addon_aggregate: Addon_Aggregate,
  addon_by_pk?: Maybe<Addon>,
  addon_group: Array<Addon_Group>,
  addon_group_aggregate: Addon_Group_Aggregate,
  addon_group_by_pk?: Maybe<Addon_Group>,
  addon_group_type: Array<Addon_Group_Type>,
  addon_group_type_aggregate: Addon_Group_Type_Aggregate,
  addon_group_type_by_pk?: Maybe<Addon_Group_Type>,
  addon_price: Array<Addon_Price>,
  addon_price_aggregate: Addon_Price_Aggregate,
  addon_price_by_pk?: Maybe<Addon_Price>,
  attachment: Array<Attachment>,
  attachment_aggregate: Attachment_Aggregate,
  attachment_by_pk?: Maybe<Attachment>,
  attachment_parent_type: Array<Attachment_Parent_Type>,
  attachment_parent_type_aggregate: Attachment_Parent_Type_Aggregate,
  attachment_parent_type_by_pk?: Maybe<Attachment_Parent_Type>,
  attachment_status: Array<Attachment_Status>,
  attachment_status_aggregate: Attachment_Status_Aggregate,
  attachment_status_by_pk?: Maybe<Attachment_Status>,
  attachment_type: Array<Attachment_Type>,
  attachment_type_aggregate: Attachment_Type_Aggregate,
  attachment_type_by_pk?: Maybe<Attachment_Type>,
  benefit: Array<Benefit>,
  benefit_aggregate: Benefit_Aggregate,
  benefit_by_pk?: Maybe<Benefit>,
  bmp_listing: Array<Bmp_Listing>,
  bmp_listing_aggregate: Bmp_Listing_Aggregate,
  bmp_listing_by_pk?: Maybe<Bmp_Listing>,
  bmp_listing_contact: Array<Bmp_Listing_Contact>,
  bmp_listing_contact_aggregate: Bmp_Listing_Contact_Aggregate,
  bmp_listing_inspection: Array<Bmp_Listing_Inspection>,
  bmp_listing_inspection_aggregate: Bmp_Listing_Inspection_Aggregate,
  bmp_listing_media: Array<Bmp_Listing_Media>,
  bmp_listing_media_aggregate: Bmp_Listing_Media_Aggregate,
  bmp_listing_search: Array<Bmp_Listing_Search>,
  bmp_listing_search_aggregate: Bmp_Listing_Search_Aggregate,
  cache: Array<Cache>,
  cache_aggregate: Cache_Aggregate,
  cache_by_pk?: Maybe<Cache>,
  campaign: Array<Campaign>,
  campaign_addon_group: Array<Campaign_Addon_Group>,
  campaign_addon_group_aggregate: Campaign_Addon_Group_Aggregate,
  campaign_addon_group_by_pk?: Maybe<Campaign_Addon_Group>,
  campaign_aggregate: Campaign_Aggregate,
  campaign_by_pk?: Maybe<Campaign>,
  campaign_inclusion_group: Array<Campaign_Inclusion_Group>,
  campaign_inclusion_group_aggregate: Campaign_Inclusion_Group_Aggregate,
  campaign_inclusion_group_by_pk?: Maybe<Campaign_Inclusion_Group>,
  campaign_selling_point: Array<Campaign_Selling_Point>,
  campaign_selling_point_aggregate: Campaign_Selling_Point_Aggregate,
  campaign_selling_point_by_pk?: Maybe<Campaign_Selling_Point>,
  commercial_status_type: Array<Commercial_Status_Type>,
  commercial_status_type_aggregate: Commercial_Status_Type_Aggregate,
  commercial_status_type_by_pk?: Maybe<Commercial_Status_Type>,
  coupon: Array<Coupon>,
  coupon_aggregate: Coupon_Aggregate,
  coupon_by_pk?: Maybe<Coupon>,
  coupon_type: Array<Coupon_Type>,
  coupon_type_aggregate: Coupon_Type_Aggregate,
  coupon_type_by_pk?: Maybe<Coupon_Type>,
  enquiry: Array<Enquiry>,
  enquiry_aggregate: Enquiry_Aggregate,
  enquiry_by_pk?: Maybe<Enquiry>,
  enquiry_call_result: Array<Enquiry_Call_Result>,
  enquiry_call_result_aggregate: Enquiry_Call_Result_Aggregate,
  enquiry_call_result_by_pk?: Maybe<Enquiry_Call_Result>,
  enquiry_medium_type: Array<Enquiry_Medium_Type>,
  enquiry_medium_type_aggregate: Enquiry_Medium_Type_Aggregate,
  enquiry_medium_type_by_pk?: Maybe<Enquiry_Medium_Type>,
  experiment: Array<Experiment>,
  experiment_aggregate: Experiment_Aggregate,
  experiment_by_pk?: Maybe<Experiment>,
  experiment_name: Array<Experiment_Name>,
  experiment_name_aggregate: Experiment_Name_Aggregate,
  experiment_name_by_pk?: Maybe<Experiment_Name>,
  experiment_stat: Array<Experiment_Stat>,
  experiment_stat_aggregate: Experiment_Stat_Aggregate,
  external_auth: Array<External_Auth>,
  external_auth_aggregate: External_Auth_Aggregate,
  external_auth_by_pk?: Maybe<External_Auth>,
  feedback: Array<Feedback>,
  feedback_aggregate: Feedback_Aggregate,
  feedback_by_pk?: Maybe<Feedback>,
  inclusion: Array<Inclusion>,
  inclusion_addon: Array<Inclusion_Addon>,
  inclusion_addon_aggregate: Inclusion_Addon_Aggregate,
  inclusion_addon_by_pk?: Maybe<Inclusion_Addon>,
  inclusion_aggregate: Inclusion_Aggregate,
  inclusion_by_pk?: Maybe<Inclusion>,
  inclusion_group: Array<Inclusion_Group>,
  inclusion_group_aggregate: Inclusion_Group_Aggregate,
  inclusion_group_by_pk?: Maybe<Inclusion_Group>,
  listing: Array<Listing>,
  listing_aggregate: Listing_Aggregate,
  listing_by_pk?: Maybe<Listing>,
  listing_contact: Array<Listing_Contact>,
  listing_contact_aggregate: Listing_Contact_Aggregate,
  listing_contact_by_pk?: Maybe<Listing_Contact>,
  listing_detail: Array<Listing_Detail>,
  listing_detail_aggregate: Listing_Detail_Aggregate,
  listing_document: Array<Listing_Document>,
  listing_document_aggregate: Listing_Document_Aggregate,
  listing_document_by_pk?: Maybe<Listing_Document>,
  listing_document_status: Array<Listing_Document_Status>,
  listing_document_status_aggregate: Listing_Document_Status_Aggregate,
  listing_document_status_by_pk?: Maybe<Listing_Document_Status>,
  listing_document_type: Array<Listing_Document_Type>,
  listing_document_type_aggregate: Listing_Document_Type_Aggregate,
  listing_document_type_by_pk?: Maybe<Listing_Document_Type>,
  listing_event: Array<Listing_Event>,
  listing_event_aggregate: Listing_Event_Aggregate,
  listing_event_by_pk?: Maybe<Listing_Event>,
  listing_event_type: Array<Listing_Event_Type>,
  listing_event_type_aggregate: Listing_Event_Type_Aggregate,
  listing_event_type_by_pk?: Maybe<Listing_Event_Type>,
  listing_inspection: Array<Listing_Inspection>,
  listing_inspection_aggregate: Listing_Inspection_Aggregate,
  listing_inspection_by_pk?: Maybe<Listing_Inspection>,
  listing_media: Array<Listing_Media>,
  listing_media_aggregate: Listing_Media_Aggregate,
  listing_media_by_pk?: Maybe<Listing_Media>,
  listing_media_type: Array<Listing_Media_Type>,
  listing_media_type_aggregate: Listing_Media_Type_Aggregate,
  listing_media_type_by_pk?: Maybe<Listing_Media_Type>,
  listing_metadata: Array<Listing_Metadata>,
  listing_metadata_aggregate: Listing_Metadata_Aggregate,
  listing_metadata_by_pk?: Maybe<Listing_Metadata>,
  listing_onboarding: Array<Listing_Onboarding>,
  listing_onboarding_aggregate: Listing_Onboarding_Aggregate,
  listing_onboarding_by_pk?: Maybe<Listing_Onboarding>,
  listing_parking: Array<Listing_Parking>,
  listing_parking_aggregate: Listing_Parking_Aggregate,
  listing_parking_by_pk?: Maybe<Listing_Parking>,
  listing_publish_errors: Array<Listing_Publish_Errors>,
  listing_publish_errors_aggregate: Listing_Publish_Errors_Aggregate,
  listing_publish_errors_by_pk?: Maybe<Listing_Publish_Errors>,
  listing_publish_portal_source: Array<Listing_Publish_Portal_Source>,
  listing_publish_portal_source_aggregate: Listing_Publish_Portal_Source_Aggregate,
  listing_publish_portal_source_by_pk?: Maybe<Listing_Publish_Portal_Source>,
  listing_publish_status: Array<Listing_Publish_Status>,
  listing_publish_status_aggregate: Listing_Publish_Status_Aggregate,
  listing_publish_status_by_pk?: Maybe<Listing_Publish_Status>,
  listing_publish_status_type: Array<Listing_Publish_Status_Type>,
  listing_publish_status_type_aggregate: Listing_Publish_Status_Type_Aggregate,
  listing_publish_status_type_by_pk?: Maybe<Listing_Publish_Status_Type>,
  listing_search: Array<Listing_Search>,
  listing_search_aggregate: Listing_Search_Aggregate,
  listing_soi_comparable_property: Array<Listing_Soi_Comparable_Property>,
  listing_soi_comparable_property_aggregate: Listing_Soi_Comparable_Property_Aggregate,
  listing_soi_comparable_property_by_pk?: Maybe<Listing_Soi_Comparable_Property>,
  metro_type: Array<Metro_Type>,
  metro_type_aggregate: Metro_Type_Aggregate,
  metro_type_by_pk?: Maybe<Metro_Type>,
  onboarding_budget_size: Array<Onboarding_Budget_Size>,
  onboarding_budget_size_aggregate: Onboarding_Budget_Size_Aggregate,
  onboarding_budget_size_by_pk?: Maybe<Onboarding_Budget_Size>,
  onboarding_reason_selling: Array<Onboarding_Reason_Selling>,
  onboarding_reason_selling_aggregate: Onboarding_Reason_Selling_Aggregate,
  onboarding_reason_selling_by_pk?: Maybe<Onboarding_Reason_Selling>,
  onboarding_timeframe_selling: Array<Onboarding_Timeframe_Selling>,
  onboarding_timeframe_selling_aggregate: Onboarding_Timeframe_Selling_Aggregate,
  onboarding_timeframe_selling_by_pk?: Maybe<Onboarding_Timeframe_Selling>,
  order: Array<Order>,
  order_aggregate: Order_Aggregate,
  order_by_pk?: Maybe<Order>,
  order_detail: Array<Order_Detail>,
  order_detail_aggregate: Order_Detail_Aggregate,
  order_fulfilment: Array<Order_Fulfilment>,
  order_fulfilment_aggregate: Order_Fulfilment_Aggregate,
  order_fulfilment_by_pk?: Maybe<Order_Fulfilment>,
  order_item: Array<Order_Item>,
  order_item_aggregate: Order_Item_Aggregate,
  order_item_by_pk?: Maybe<Order_Item>,
  order_item_type: Array<Order_Item_Type>,
  order_item_type_aggregate: Order_Item_Type_Aggregate,
  order_item_type_by_pk?: Maybe<Order_Item_Type>,
  order_status: Array<Order_Status>,
  order_status_aggregate: Order_Status_Aggregate,
  order_status_by_pk?: Maybe<Order_Status>,
  publishing_status_type: Array<Publishing_Status_Type>,
  publishing_status_type_aggregate: Publishing_Status_Type_Aggregate,
  publishing_status_type_by_pk?: Maybe<Publishing_Status_Type>,
  raw_bordering_postcode: Array<Raw_Bordering_Postcode>,
  raw_bordering_postcode_aggregate: Raw_Bordering_Postcode_Aggregate,
  raw_bordering_postcode_by_pk?: Maybe<Raw_Bordering_Postcode>,
  rea_price: Array<Rea_Price>,
  rea_price_aggregate: Rea_Price_Aggregate,
  rea_price_by_pk?: Maybe<Rea_Price>,
  recommended_addons?: Maybe<Array<Maybe<RecommendedAddonOutput>>>,
  recommended_campaigns?: Maybe<Array<Maybe<RecommendedCampaignOutput>>>,
  salesforce_bulksync_records: Array<Salesforce_Bulksync_Records>,
  salesforce_bulksync_records_aggregate: Salesforce_Bulksync_Records_Aggregate,
  salesforce_bulksync_records_by_pk?: Maybe<Salesforce_Bulksync_Records>,
  salesforce_connection_token: Array<Salesforce_Connection_Token>,
  salesforce_connection_token_aggregate: Salesforce_Connection_Token_Aggregate,
  salesforce_connection_token_by_pk?: Maybe<Salesforce_Connection_Token>,
  salesforce_sync_status: Array<Salesforce_Sync_Status>,
  salesforce_sync_status_aggregate: Salesforce_Sync_Status_Aggregate,
  salesforce_sync_status_by_pk?: Maybe<Salesforce_Sync_Status>,
  search_listing: Array<Surrounding_Suburb_Listing>,
  search_listing_aggregate: Surrounding_Suburb_Listing_Aggregate,
  selling_point: Array<Selling_Point>,
  selling_point_aggregate: Selling_Point_Aggregate,
  selling_point_by_pk?: Maybe<Selling_Point>,
  stock_photo: Array<Stock_Photo>,
  stock_photo_aggregate: Stock_Photo_Aggregate,
  stock_photo_by_pk?: Maybe<Stock_Photo>,
  surrounding_suburb: Array<Surrounding_Suburb>,
  surrounding_suburb_aggregate: Surrounding_Suburb_Aggregate,
  surrounding_suburb_by_pk?: Maybe<Surrounding_Suburb>,
  surrounding_suburb_listing: Array<Surrounding_Suburb_Listing>,
  surrounding_suburb_listing_aggregate: Surrounding_Suburb_Listing_Aggregate,
  transaction: Array<Transaction>,
  transaction_aggregate: Transaction_Aggregate,
  transaction_by_pk?: Maybe<Transaction>,
  transaction_status: Array<Transaction_Status>,
  transaction_status_aggregate: Transaction_Status_Aggregate,
  transaction_status_by_pk?: Maybe<Transaction_Status>,
  user: Array<User>,
  user_aggregate: User_Aggregate,
  user_by_pk?: Maybe<User>,
  user_detail: Array<User_Detail>,
  user_detail_aggregate: User_Detail_Aggregate,
  zone_type: Array<Zone_Type>,
  zone_type_aggregate: Zone_Type_Aggregate,
  zone_type_by_pk?: Maybe<Zone_Type>,
};


export type Subscription_RootAddonArgs = {
  distinct_on?: Maybe<Array<Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Order_By>>,
  where?: Maybe<Addon_Bool_Exp>
};


export type Subscription_RootAddon_Addon_GroupArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Subscription_RootAddon_Addon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Addon_Group_Order_By>>,
  where?: Maybe<Addon_Addon_Group_Bool_Exp>
};


export type Subscription_RootAddon_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootAddon_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Order_By>>,
  where?: Maybe<Addon_Bool_Exp>
};


export type Subscription_RootAddon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootAddon_GroupArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Order_By>>,
  where?: Maybe<Addon_Group_Bool_Exp>
};


export type Subscription_RootAddon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Order_By>>,
  where?: Maybe<Addon_Group_Bool_Exp>
};


export type Subscription_RootAddon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootAddon_Group_TypeArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Type_Order_By>>,
  where?: Maybe<Addon_Group_Type_Bool_Exp>
};


export type Subscription_RootAddon_Group_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Group_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Group_Type_Order_By>>,
  where?: Maybe<Addon_Group_Type_Bool_Exp>
};


export type Subscription_RootAddon_Group_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootAddon_PriceArgs = {
  distinct_on?: Maybe<Array<Addon_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Price_Order_By>>,
  where?: Maybe<Addon_Price_Bool_Exp>
};


export type Subscription_RootAddon_Price_AggregateArgs = {
  distinct_on?: Maybe<Array<Addon_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Addon_Price_Order_By>>,
  where?: Maybe<Addon_Price_Bool_Exp>
};


export type Subscription_RootAddon_Price_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootAttachmentArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Subscription_RootAttachment_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Order_By>>,
  where?: Maybe<Attachment_Bool_Exp>
};


export type Subscription_RootAttachment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootAttachment_Parent_TypeArgs = {
  distinct_on?: Maybe<Array<Attachment_Parent_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Parent_Type_Order_By>>,
  where?: Maybe<Attachment_Parent_Type_Bool_Exp>
};


export type Subscription_RootAttachment_Parent_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Parent_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Parent_Type_Order_By>>,
  where?: Maybe<Attachment_Parent_Type_Bool_Exp>
};


export type Subscription_RootAttachment_Parent_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootAttachment_StatusArgs = {
  distinct_on?: Maybe<Array<Attachment_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Status_Order_By>>,
  where?: Maybe<Attachment_Status_Bool_Exp>
};


export type Subscription_RootAttachment_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Status_Order_By>>,
  where?: Maybe<Attachment_Status_Bool_Exp>
};


export type Subscription_RootAttachment_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootAttachment_TypeArgs = {
  distinct_on?: Maybe<Array<Attachment_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Type_Order_By>>,
  where?: Maybe<Attachment_Type_Bool_Exp>
};


export type Subscription_RootAttachment_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Attachment_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Attachment_Type_Order_By>>,
  where?: Maybe<Attachment_Type_Bool_Exp>
};


export type Subscription_RootAttachment_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootBenefitArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type Subscription_RootBenefit_AggregateArgs = {
  distinct_on?: Maybe<Array<Benefit_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Benefit_Order_By>>,
  where?: Maybe<Benefit_Bool_Exp>
};


export type Subscription_RootBenefit_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootBmp_ListingArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Order_By>>,
  where?: Maybe<Bmp_Listing_Bool_Exp>
};


export type Subscription_RootBmp_Listing_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Order_By>>,
  where?: Maybe<Bmp_Listing_Bool_Exp>
};


export type Subscription_RootBmp_Listing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootBmp_Listing_ContactArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Subscription_RootBmp_Listing_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Contact_Order_By>>,
  where?: Maybe<Bmp_Listing_Contact_Bool_Exp>
};


export type Subscription_RootBmp_Listing_InspectionArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Subscription_RootBmp_Listing_Inspection_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Inspection_Order_By>>,
  where?: Maybe<Bmp_Listing_Inspection_Bool_Exp>
};


export type Subscription_RootBmp_Listing_MediaArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Subscription_RootBmp_Listing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Media_Order_By>>,
  where?: Maybe<Bmp_Listing_Media_Bool_Exp>
};


export type Subscription_RootBmp_Listing_SearchArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Search_Order_By>>,
  where?: Maybe<Bmp_Listing_Search_Bool_Exp>
};


export type Subscription_RootBmp_Listing_Search_AggregateArgs = {
  distinct_on?: Maybe<Array<Bmp_Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Bmp_Listing_Search_Order_By>>,
  where?: Maybe<Bmp_Listing_Search_Bool_Exp>
};


export type Subscription_RootCacheArgs = {
  distinct_on?: Maybe<Array<Cache_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Cache_Order_By>>,
  where?: Maybe<Cache_Bool_Exp>
};


export type Subscription_RootCache_AggregateArgs = {
  distinct_on?: Maybe<Array<Cache_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Cache_Order_By>>,
  where?: Maybe<Cache_Bool_Exp>
};


export type Subscription_RootCache_By_PkArgs = {
  key: Scalars['String']
};


export type Subscription_RootCampaignArgs = {
  distinct_on?: Maybe<Array<Campaign_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Order_By>>,
  where?: Maybe<Campaign_Bool_Exp>
};


export type Subscription_RootCampaign_Addon_GroupArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type Subscription_RootCampaign_Addon_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Addon_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Addon_Group_Order_By>>,
  where?: Maybe<Campaign_Addon_Group_Bool_Exp>
};


export type Subscription_RootCampaign_Addon_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootCampaign_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Order_By>>,
  where?: Maybe<Campaign_Bool_Exp>
};


export type Subscription_RootCampaign_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootCampaign_Inclusion_GroupArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Subscription_RootCampaign_Inclusion_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Inclusion_Group_Order_By>>,
  where?: Maybe<Campaign_Inclusion_Group_Bool_Exp>
};


export type Subscription_RootCampaign_Inclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootCampaign_Selling_PointArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type Subscription_RootCampaign_Selling_Point_AggregateArgs = {
  distinct_on?: Maybe<Array<Campaign_Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Campaign_Selling_Point_Order_By>>,
  where?: Maybe<Campaign_Selling_Point_Bool_Exp>
};


export type Subscription_RootCampaign_Selling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootCommercial_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Commercial_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Commercial_Status_Type_Order_By>>,
  where?: Maybe<Commercial_Status_Type_Bool_Exp>
};


export type Subscription_RootCommercial_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Commercial_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Commercial_Status_Type_Order_By>>,
  where?: Maybe<Commercial_Status_Type_Bool_Exp>
};


export type Subscription_RootCommercial_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootCouponArgs = {
  distinct_on?: Maybe<Array<Coupon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Order_By>>,
  where?: Maybe<Coupon_Bool_Exp>
};


export type Subscription_RootCoupon_AggregateArgs = {
  distinct_on?: Maybe<Array<Coupon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Order_By>>,
  where?: Maybe<Coupon_Bool_Exp>
};


export type Subscription_RootCoupon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootCoupon_TypeArgs = {
  distinct_on?: Maybe<Array<Coupon_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Type_Order_By>>,
  where?: Maybe<Coupon_Type_Bool_Exp>
};


export type Subscription_RootCoupon_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Coupon_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Coupon_Type_Order_By>>,
  where?: Maybe<Coupon_Type_Bool_Exp>
};


export type Subscription_RootCoupon_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootEnquiryArgs = {
  distinct_on?: Maybe<Array<Enquiry_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Order_By>>,
  where?: Maybe<Enquiry_Bool_Exp>
};


export type Subscription_RootEnquiry_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Order_By>>,
  where?: Maybe<Enquiry_Bool_Exp>
};


export type Subscription_RootEnquiry_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootEnquiry_Call_ResultArgs = {
  distinct_on?: Maybe<Array<Enquiry_Call_Result_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Call_Result_Order_By>>,
  where?: Maybe<Enquiry_Call_Result_Bool_Exp>
};


export type Subscription_RootEnquiry_Call_Result_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Call_Result_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Call_Result_Order_By>>,
  where?: Maybe<Enquiry_Call_Result_Bool_Exp>
};


export type Subscription_RootEnquiry_Call_Result_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootEnquiry_Medium_TypeArgs = {
  distinct_on?: Maybe<Array<Enquiry_Medium_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Medium_Type_Order_By>>,
  where?: Maybe<Enquiry_Medium_Type_Bool_Exp>
};


export type Subscription_RootEnquiry_Medium_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Enquiry_Medium_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Enquiry_Medium_Type_Order_By>>,
  where?: Maybe<Enquiry_Medium_Type_Bool_Exp>
};


export type Subscription_RootEnquiry_Medium_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootExperimentArgs = {
  distinct_on?: Maybe<Array<Experiment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Order_By>>,
  where?: Maybe<Experiment_Bool_Exp>
};


export type Subscription_RootExperiment_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Order_By>>,
  where?: Maybe<Experiment_Bool_Exp>
};


export type Subscription_RootExperiment_By_PkArgs = {
  name: Experiment_Name_Enum
};


export type Subscription_RootExperiment_NameArgs = {
  distinct_on?: Maybe<Array<Experiment_Name_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Name_Order_By>>,
  where?: Maybe<Experiment_Name_Bool_Exp>
};


export type Subscription_RootExperiment_Name_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Name_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Name_Order_By>>,
  where?: Maybe<Experiment_Name_Bool_Exp>
};


export type Subscription_RootExperiment_Name_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootExperiment_StatArgs = {
  distinct_on?: Maybe<Array<Experiment_Stat_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Stat_Order_By>>,
  where?: Maybe<Experiment_Stat_Bool_Exp>
};


export type Subscription_RootExperiment_Stat_AggregateArgs = {
  distinct_on?: Maybe<Array<Experiment_Stat_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Experiment_Stat_Order_By>>,
  where?: Maybe<Experiment_Stat_Bool_Exp>
};


export type Subscription_RootExternal_AuthArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type Subscription_RootExternal_Auth_AggregateArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type Subscription_RootExternal_Auth_By_PkArgs = {
  user_id: Scalars['uuid']
};


export type Subscription_RootFeedbackArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type Subscription_RootFeedback_AggregateArgs = {
  distinct_on?: Maybe<Array<Feedback_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Feedback_Order_By>>,
  where?: Maybe<Feedback_Bool_Exp>
};


export type Subscription_RootFeedback_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootInclusionArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};


export type Subscription_RootInclusion_AddonArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type Subscription_RootInclusion_Addon_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Addon_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Addon_Order_By>>,
  where?: Maybe<Inclusion_Addon_Bool_Exp>
};


export type Subscription_RootInclusion_Addon_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootInclusion_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Order_By>>,
  where?: Maybe<Inclusion_Bool_Exp>
};


export type Subscription_RootInclusion_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootInclusion_GroupArgs = {
  distinct_on?: Maybe<Array<Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Group_Order_By>>,
  where?: Maybe<Inclusion_Group_Bool_Exp>
};


export type Subscription_RootInclusion_Group_AggregateArgs = {
  distinct_on?: Maybe<Array<Inclusion_Group_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Inclusion_Group_Order_By>>,
  where?: Maybe<Inclusion_Group_Bool_Exp>
};


export type Subscription_RootInclusion_Group_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListingArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type Subscription_RootListing_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type Subscription_RootListing_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_ContactArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type Subscription_RootListing_Contact_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Contact_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Contact_Order_By>>,
  where?: Maybe<Listing_Contact_Bool_Exp>
};


export type Subscription_RootListing_Contact_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_DetailArgs = {
  distinct_on?: Maybe<Array<Listing_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Detail_Order_By>>,
  where?: Maybe<Listing_Detail_Bool_Exp>
};


export type Subscription_RootListing_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Detail_Order_By>>,
  where?: Maybe<Listing_Detail_Bool_Exp>
};


export type Subscription_RootListing_DocumentArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type Subscription_RootListing_Document_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Order_By>>,
  where?: Maybe<Listing_Document_Bool_Exp>
};


export type Subscription_RootListing_Document_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_Document_StatusArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Status_Order_By>>,
  where?: Maybe<Listing_Document_Status_Bool_Exp>
};


export type Subscription_RootListing_Document_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Status_Order_By>>,
  where?: Maybe<Listing_Document_Status_Bool_Exp>
};


export type Subscription_RootListing_Document_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_Document_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Type_Order_By>>,
  where?: Maybe<Listing_Document_Type_Bool_Exp>
};


export type Subscription_RootListing_Document_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Document_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Document_Type_Order_By>>,
  where?: Maybe<Listing_Document_Type_Bool_Exp>
};


export type Subscription_RootListing_Document_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_EventArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type Subscription_RootListing_Event_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Order_By>>,
  where?: Maybe<Listing_Event_Bool_Exp>
};


export type Subscription_RootListing_Event_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_Event_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Type_Order_By>>,
  where?: Maybe<Listing_Event_Type_Bool_Exp>
};


export type Subscription_RootListing_Event_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Event_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Event_Type_Order_By>>,
  where?: Maybe<Listing_Event_Type_Bool_Exp>
};


export type Subscription_RootListing_Event_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_InspectionArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type Subscription_RootListing_Inspection_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Inspection_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Inspection_Order_By>>,
  where?: Maybe<Listing_Inspection_Bool_Exp>
};


export type Subscription_RootListing_Inspection_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_MediaArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type Subscription_RootListing_Media_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Order_By>>,
  where?: Maybe<Listing_Media_Bool_Exp>
};


export type Subscription_RootListing_Media_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_Media_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Type_Order_By>>,
  where?: Maybe<Listing_Media_Type_Bool_Exp>
};


export type Subscription_RootListing_Media_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Media_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Media_Type_Order_By>>,
  where?: Maybe<Listing_Media_Type_Bool_Exp>
};


export type Subscription_RootListing_Media_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_MetadataArgs = {
  distinct_on?: Maybe<Array<Listing_Metadata_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Metadata_Order_By>>,
  where?: Maybe<Listing_Metadata_Bool_Exp>
};


export type Subscription_RootListing_Metadata_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Metadata_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Metadata_Order_By>>,
  where?: Maybe<Listing_Metadata_Bool_Exp>
};


export type Subscription_RootListing_Metadata_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_OnboardingArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type Subscription_RootListing_Onboarding_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Onboarding_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Onboarding_Order_By>>,
  where?: Maybe<Listing_Onboarding_Bool_Exp>
};


export type Subscription_RootListing_Onboarding_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_ParkingArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type Subscription_RootListing_Parking_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Parking_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Parking_Order_By>>,
  where?: Maybe<Listing_Parking_Bool_Exp>
};


export type Subscription_RootListing_Parking_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootListing_Publish_ErrorsArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type Subscription_RootListing_Publish_Errors_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Errors_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Errors_Order_By>>,
  where?: Maybe<Listing_Publish_Errors_Bool_Exp>
};


export type Subscription_RootListing_Publish_Errors_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Subscription_RootListing_Publish_Portal_SourceArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Portal_Source_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Portal_Source_Order_By>>,
  where?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>
};


export type Subscription_RootListing_Publish_Portal_Source_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Portal_Source_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Portal_Source_Order_By>>,
  where?: Maybe<Listing_Publish_Portal_Source_Bool_Exp>
};


export type Subscription_RootListing_Publish_Portal_Source_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_Publish_StatusArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type Subscription_RootListing_Publish_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Bool_Exp>
};


export type Subscription_RootListing_Publish_Status_By_PkArgs = {
  id: Scalars['uuid'],
  listing_id: Scalars['uuid']
};


export type Subscription_RootListing_Publish_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Type_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Type_Bool_Exp>
};


export type Subscription_RootListing_Publish_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Publish_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Publish_Status_Type_Order_By>>,
  where?: Maybe<Listing_Publish_Status_Type_Bool_Exp>
};


export type Subscription_RootListing_Publish_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootListing_SearchArgs = {
  distinct_on?: Maybe<Array<Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Search_Order_By>>,
  where?: Maybe<Listing_Search_Bool_Exp>
};


export type Subscription_RootListing_Search_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Search_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Search_Order_By>>,
  where?: Maybe<Listing_Search_Bool_Exp>
};


export type Subscription_RootListing_Soi_Comparable_PropertyArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type Subscription_RootListing_Soi_Comparable_Property_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Soi_Comparable_Property_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Soi_Comparable_Property_Order_By>>,
  where?: Maybe<Listing_Soi_Comparable_Property_Bool_Exp>
};


export type Subscription_RootListing_Soi_Comparable_Property_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootMetro_TypeArgs = {
  distinct_on?: Maybe<Array<Metro_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Metro_Type_Order_By>>,
  where?: Maybe<Metro_Type_Bool_Exp>
};


export type Subscription_RootMetro_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Metro_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Metro_Type_Order_By>>,
  where?: Maybe<Metro_Type_Bool_Exp>
};


export type Subscription_RootMetro_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootOnboarding_Budget_SizeArgs = {
  distinct_on?: Maybe<Array<Onboarding_Budget_Size_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Budget_Size_Order_By>>,
  where?: Maybe<Onboarding_Budget_Size_Bool_Exp>
};


export type Subscription_RootOnboarding_Budget_Size_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Budget_Size_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Budget_Size_Order_By>>,
  where?: Maybe<Onboarding_Budget_Size_Bool_Exp>
};


export type Subscription_RootOnboarding_Budget_Size_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootOnboarding_Reason_SellingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Reason_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Reason_Selling_Order_By>>,
  where?: Maybe<Onboarding_Reason_Selling_Bool_Exp>
};


export type Subscription_RootOnboarding_Reason_Selling_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Reason_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Reason_Selling_Order_By>>,
  where?: Maybe<Onboarding_Reason_Selling_Bool_Exp>
};


export type Subscription_RootOnboarding_Reason_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootOnboarding_Timeframe_SellingArgs = {
  distinct_on?: Maybe<Array<Onboarding_Timeframe_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Timeframe_Selling_Order_By>>,
  where?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>
};


export type Subscription_RootOnboarding_Timeframe_Selling_AggregateArgs = {
  distinct_on?: Maybe<Array<Onboarding_Timeframe_Selling_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Onboarding_Timeframe_Selling_Order_By>>,
  where?: Maybe<Onboarding_Timeframe_Selling_Bool_Exp>
};


export type Subscription_RootOnboarding_Timeframe_Selling_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootOrderArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Order_By>>,
  where?: Maybe<Order_Bool_Exp>
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootOrder_DetailArgs = {
  distinct_on?: Maybe<Array<Order_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Detail_Order_By>>,
  where?: Maybe<Order_Detail_Bool_Exp>
};


export type Subscription_RootOrder_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Detail_Order_By>>,
  where?: Maybe<Order_Detail_Bool_Exp>
};


export type Subscription_RootOrder_FulfilmentArgs = {
  distinct_on?: Maybe<Array<Order_Fulfilment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Fulfilment_Order_By>>,
  where?: Maybe<Order_Fulfilment_Bool_Exp>
};


export type Subscription_RootOrder_Fulfilment_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Fulfilment_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Fulfilment_Order_By>>,
  where?: Maybe<Order_Fulfilment_Bool_Exp>
};


export type Subscription_RootOrder_Fulfilment_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootOrder_ItemArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Subscription_RootOrder_Item_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Order_By>>,
  where?: Maybe<Order_Item_Bool_Exp>
};


export type Subscription_RootOrder_Item_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootOrder_Item_TypeArgs = {
  distinct_on?: Maybe<Array<Order_Item_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Type_Order_By>>,
  where?: Maybe<Order_Item_Type_Bool_Exp>
};


export type Subscription_RootOrder_Item_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Item_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Item_Type_Order_By>>,
  where?: Maybe<Order_Item_Type_Bool_Exp>
};


export type Subscription_RootOrder_Item_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootOrder_StatusArgs = {
  distinct_on?: Maybe<Array<Order_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Status_Order_By>>,
  where?: Maybe<Order_Status_Bool_Exp>
};


export type Subscription_RootOrder_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Order_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Order_Status_Order_By>>,
  where?: Maybe<Order_Status_Bool_Exp>
};


export type Subscription_RootOrder_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootPublishing_Status_TypeArgs = {
  distinct_on?: Maybe<Array<Publishing_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Publishing_Status_Type_Order_By>>,
  where?: Maybe<Publishing_Status_Type_Bool_Exp>
};


export type Subscription_RootPublishing_Status_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Publishing_Status_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Publishing_Status_Type_Order_By>>,
  where?: Maybe<Publishing_Status_Type_Bool_Exp>
};


export type Subscription_RootPublishing_Status_Type_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootRaw_Bordering_PostcodeArgs = {
  distinct_on?: Maybe<Array<Raw_Bordering_Postcode_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Raw_Bordering_Postcode_Order_By>>,
  where?: Maybe<Raw_Bordering_Postcode_Bool_Exp>
};


export type Subscription_RootRaw_Bordering_Postcode_AggregateArgs = {
  distinct_on?: Maybe<Array<Raw_Bordering_Postcode_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Raw_Bordering_Postcode_Order_By>>,
  where?: Maybe<Raw_Bordering_Postcode_Bool_Exp>
};


export type Subscription_RootRaw_Bordering_Postcode_By_PkArgs = {
  id: Scalars['Int']
};


export type Subscription_RootRea_PriceArgs = {
  distinct_on?: Maybe<Array<Rea_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Rea_Price_Order_By>>,
  where?: Maybe<Rea_Price_Bool_Exp>
};


export type Subscription_RootRea_Price_AggregateArgs = {
  distinct_on?: Maybe<Array<Rea_Price_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Rea_Price_Order_By>>,
  where?: Maybe<Rea_Price_Bool_Exp>
};


export type Subscription_RootRea_Price_By_PkArgs = {
  key: Scalars['String']
};


export type Subscription_RootRecommended_AddonsArgs = {
  campaign_code?: Maybe<Scalars['String']>,
  listingId: Scalars['uuid']
};


export type Subscription_RootRecommended_CampaignsArgs = {
  listingId: Scalars['uuid']
};


export type Subscription_RootSalesforce_Bulksync_RecordsArgs = {
  distinct_on?: Maybe<Array<Salesforce_Bulksync_Records_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Bulksync_Records_Order_By>>,
  where?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>
};


export type Subscription_RootSalesforce_Bulksync_Records_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Bulksync_Records_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Bulksync_Records_Order_By>>,
  where?: Maybe<Salesforce_Bulksync_Records_Bool_Exp>
};


export type Subscription_RootSalesforce_Bulksync_Records_By_PkArgs = {
  operation_id: Scalars['uuid']
};


export type Subscription_RootSalesforce_Connection_TokenArgs = {
  distinct_on?: Maybe<Array<Salesforce_Connection_Token_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Connection_Token_Order_By>>,
  where?: Maybe<Salesforce_Connection_Token_Bool_Exp>
};


export type Subscription_RootSalesforce_Connection_Token_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Connection_Token_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Connection_Token_Order_By>>,
  where?: Maybe<Salesforce_Connection_Token_Bool_Exp>
};


export type Subscription_RootSalesforce_Connection_Token_By_PkArgs = {
  access_token: Scalars['String']
};


export type Subscription_RootSalesforce_Sync_StatusArgs = {
  distinct_on?: Maybe<Array<Salesforce_Sync_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Sync_Status_Order_By>>,
  where?: Maybe<Salesforce_Sync_Status_Bool_Exp>
};


export type Subscription_RootSalesforce_Sync_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Salesforce_Sync_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Salesforce_Sync_Status_Order_By>>,
  where?: Maybe<Salesforce_Sync_Status_Bool_Exp>
};


export type Subscription_RootSalesforce_Sync_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootSearch_ListingArgs = {
  args: Search_Listing_Args,
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Subscription_RootSearch_Listing_AggregateArgs = {
  args: Search_Listing_Args,
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Subscription_RootSelling_PointArgs = {
  distinct_on?: Maybe<Array<Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Selling_Point_Order_By>>,
  where?: Maybe<Selling_Point_Bool_Exp>
};


export type Subscription_RootSelling_Point_AggregateArgs = {
  distinct_on?: Maybe<Array<Selling_Point_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Selling_Point_Order_By>>,
  where?: Maybe<Selling_Point_Bool_Exp>
};


export type Subscription_RootSelling_Point_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootStock_PhotoArgs = {
  distinct_on?: Maybe<Array<Stock_Photo_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Stock_Photo_Order_By>>,
  where?: Maybe<Stock_Photo_Bool_Exp>
};


export type Subscription_RootStock_Photo_AggregateArgs = {
  distinct_on?: Maybe<Array<Stock_Photo_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Stock_Photo_Order_By>>,
  where?: Maybe<Stock_Photo_Bool_Exp>
};


export type Subscription_RootStock_Photo_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootSurrounding_SuburbArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Bool_Exp>
};


export type Subscription_RootSurrounding_Suburb_AggregateArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Bool_Exp>
};


export type Subscription_RootSurrounding_Suburb_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootSurrounding_Suburb_ListingArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Subscription_RootSurrounding_Suburb_Listing_AggregateArgs = {
  distinct_on?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Surrounding_Suburb_Listing_Order_By>>,
  where?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>
};


export type Subscription_RootTransactionArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type Subscription_RootTransaction_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Order_By>>,
  where?: Maybe<Transaction_Bool_Exp>
};


export type Subscription_RootTransaction_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootTransaction_StatusArgs = {
  distinct_on?: Maybe<Array<Transaction_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Status_Order_By>>,
  where?: Maybe<Transaction_Status_Bool_Exp>
};


export type Subscription_RootTransaction_Status_AggregateArgs = {
  distinct_on?: Maybe<Array<Transaction_Status_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Transaction_Status_Order_By>>,
  where?: Maybe<Transaction_Status_Bool_Exp>
};


export type Subscription_RootTransaction_Status_By_PkArgs = {
  value: Scalars['String']
};


export type Subscription_RootUserArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Order_By>>,
  where?: Maybe<User_Bool_Exp>
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Order_By>>,
  where?: Maybe<User_Bool_Exp>
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']
};


export type Subscription_RootUser_DetailArgs = {
  distinct_on?: Maybe<Array<User_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Detail_Order_By>>,
  where?: Maybe<User_Detail_Bool_Exp>
};


export type Subscription_RootUser_Detail_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Detail_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<User_Detail_Order_By>>,
  where?: Maybe<User_Detail_Bool_Exp>
};


export type Subscription_RootZone_TypeArgs = {
  distinct_on?: Maybe<Array<Zone_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Zone_Type_Order_By>>,
  where?: Maybe<Zone_Type_Bool_Exp>
};


export type Subscription_RootZone_Type_AggregateArgs = {
  distinct_on?: Maybe<Array<Zone_Type_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Zone_Type_Order_By>>,
  where?: Maybe<Zone_Type_Bool_Exp>
};


export type Subscription_RootZone_Type_By_PkArgs = {
  value: Scalars['String']
};

export type Surrounding_Suburb = {
  __typename?: 'surrounding_suburb',
  created_at: Scalars['timestamptz'],
  distance: Scalars['Int'],
  endLocality: Scalars['String'],
  endPCode: Scalars['String'],
  endSuburbName: Scalars['String'],
  id: Scalars['uuid'],
  startLocality: Scalars['String'],
  startPCode: Scalars['String'],
  startSuburbName: Scalars['String'],
  updated_at: Scalars['timestamptz'],
};

export type Surrounding_Suburb_Aggregate = {
  __typename?: 'surrounding_suburb_aggregate',
  aggregate?: Maybe<Surrounding_Suburb_Aggregate_Fields>,
  nodes: Array<Surrounding_Suburb>,
};

export type Surrounding_Suburb_Aggregate_Fields = {
  __typename?: 'surrounding_suburb_aggregate_fields',
  avg?: Maybe<Surrounding_Suburb_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Surrounding_Suburb_Max_Fields>,
  min?: Maybe<Surrounding_Suburb_Min_Fields>,
  stddev?: Maybe<Surrounding_Suburb_Stddev_Fields>,
  stddev_pop?: Maybe<Surrounding_Suburb_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Surrounding_Suburb_Stddev_Samp_Fields>,
  sum?: Maybe<Surrounding_Suburb_Sum_Fields>,
  var_pop?: Maybe<Surrounding_Suburb_Var_Pop_Fields>,
  var_samp?: Maybe<Surrounding_Suburb_Var_Samp_Fields>,
  variance?: Maybe<Surrounding_Suburb_Variance_Fields>,
};


export type Surrounding_Suburb_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Surrounding_Suburb_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Surrounding_Suburb_Aggregate_Order_By = {
  avg?: Maybe<Surrounding_Suburb_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Surrounding_Suburb_Max_Order_By>,
  min?: Maybe<Surrounding_Suburb_Min_Order_By>,
  stddev?: Maybe<Surrounding_Suburb_Stddev_Order_By>,
  stddev_pop?: Maybe<Surrounding_Suburb_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Surrounding_Suburb_Stddev_Samp_Order_By>,
  sum?: Maybe<Surrounding_Suburb_Sum_Order_By>,
  var_pop?: Maybe<Surrounding_Suburb_Var_Pop_Order_By>,
  var_samp?: Maybe<Surrounding_Suburb_Var_Samp_Order_By>,
  variance?: Maybe<Surrounding_Suburb_Variance_Order_By>,
};

export type Surrounding_Suburb_Arr_Rel_Insert_Input = {
  data: Array<Surrounding_Suburb_Insert_Input>,
  on_conflict?: Maybe<Surrounding_Suburb_On_Conflict>,
};

export type Surrounding_Suburb_Avg_Fields = {
  __typename?: 'surrounding_suburb_avg_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Avg_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Surrounding_Suburb_Bool_Exp>>>,
  _not?: Maybe<Surrounding_Suburb_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Surrounding_Suburb_Bool_Exp>>>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  distance?: Maybe<Int_Comparison_Exp>,
  endLocality?: Maybe<String_Comparison_Exp>,
  endPCode?: Maybe<String_Comparison_Exp>,
  endSuburbName?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  startLocality?: Maybe<String_Comparison_Exp>,
  startPCode?: Maybe<String_Comparison_Exp>,
  startSuburbName?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Surrounding_Suburb_Constraint {
  SurroundingSuburbPkey = 'surrounding_suburb_pkey'
}

export type Surrounding_Suburb_Inc_Input = {
  distance?: Maybe<Scalars['Int']>,
};

export type Surrounding_Suburb_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  distance?: Maybe<Scalars['Int']>,
  endLocality?: Maybe<Scalars['String']>,
  endPCode?: Maybe<Scalars['String']>,
  endSuburbName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  startLocality?: Maybe<Scalars['String']>,
  startPCode?: Maybe<Scalars['String']>,
  startSuburbName?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Surrounding_Suburb_Listing = {
  __typename?: 'surrounding_suburb_listing',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  media_url?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Surrounding_Suburb_Listing_Aggregate = {
  __typename?: 'surrounding_suburb_listing_aggregate',
  aggregate?: Maybe<Surrounding_Suburb_Listing_Aggregate_Fields>,
  nodes: Array<Surrounding_Suburb_Listing>,
};

export type Surrounding_Suburb_Listing_Aggregate_Fields = {
  __typename?: 'surrounding_suburb_listing_aggregate_fields',
  avg?: Maybe<Surrounding_Suburb_Listing_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Surrounding_Suburb_Listing_Max_Fields>,
  min?: Maybe<Surrounding_Suburb_Listing_Min_Fields>,
  stddev?: Maybe<Surrounding_Suburb_Listing_Stddev_Fields>,
  stddev_pop?: Maybe<Surrounding_Suburb_Listing_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Surrounding_Suburb_Listing_Stddev_Samp_Fields>,
  sum?: Maybe<Surrounding_Suburb_Listing_Sum_Fields>,
  var_pop?: Maybe<Surrounding_Suburb_Listing_Var_Pop_Fields>,
  var_samp?: Maybe<Surrounding_Suburb_Listing_Var_Samp_Fields>,
  variance?: Maybe<Surrounding_Suburb_Listing_Variance_Fields>,
};


export type Surrounding_Suburb_Listing_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Surrounding_Suburb_Listing_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Surrounding_Suburb_Listing_Aggregate_Order_By = {
  avg?: Maybe<Surrounding_Suburb_Listing_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Surrounding_Suburb_Listing_Max_Order_By>,
  min?: Maybe<Surrounding_Suburb_Listing_Min_Order_By>,
  stddev?: Maybe<Surrounding_Suburb_Listing_Stddev_Order_By>,
  stddev_pop?: Maybe<Surrounding_Suburb_Listing_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Surrounding_Suburb_Listing_Stddev_Samp_Order_By>,
  sum?: Maybe<Surrounding_Suburb_Listing_Sum_Order_By>,
  var_pop?: Maybe<Surrounding_Suburb_Listing_Var_Pop_Order_By>,
  var_samp?: Maybe<Surrounding_Suburb_Listing_Var_Samp_Order_By>,
  variance?: Maybe<Surrounding_Suburb_Listing_Variance_Order_By>,
};

export type Surrounding_Suburb_Listing_Arr_Rel_Insert_Input = {
  data: Array<Surrounding_Suburb_Listing_Insert_Input>,
};

export type Surrounding_Suburb_Listing_Avg_Fields = {
  __typename?: 'surrounding_suburb_listing_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Surrounding_Suburb_Listing_Bool_Exp>>>,
  _not?: Maybe<Surrounding_Suburb_Listing_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Surrounding_Suburb_Listing_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  auction_dateTime?: Maybe<Timestamptz_Comparison_Exp>,
  auction_location?: Maybe<String_Comparison_Exp>,
  auction_online?: Maybe<Boolean_Comparison_Exp>,
  authority?: Maybe<String_Comparison_Exp>,
  availableFrom?: Maybe<Timestamptz_Comparison_Exp>,
  bond?: Maybe<Int_Comparison_Exp>,
  commercial_status?: Maybe<String_Comparison_Exp>,
  contactPreference?: Maybe<String_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  crossOver?: Maybe<String_Comparison_Exp>,
  description?: Maybe<String_Comparison_Exp>,
  distance?: Maybe<Int_Comparison_Exp>,
  domainAdId?: Maybe<Int_Comparison_Exp>,
  enquiry_code?: Maybe<Int_Comparison_Exp>,
  externalLink?: Maybe<String_Comparison_Exp>,
  features?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  inspectionDetails_inspectionDescription?: Maybe<String_Comparison_Exp>,
  isNewDevelopment?: Maybe<Boolean_Comparison_Exp>,
  isRural?: Maybe<Boolean_Comparison_Exp>,
  lifeStyleType?: Maybe<String_Comparison_Exp>,
  listingAction?: Maybe<String_Comparison_Exp>,
  media_url?: Maybe<String_Comparison_Exp>,
  otherEnquiryEmail?: Maybe<String_Comparison_Exp>,
  owner_id?: Maybe<Uuid_Comparison_Exp>,
  price_asking?: Maybe<Int_Comparison_Exp>,
  price_displayOption?: Maybe<String_Comparison_Exp>,
  price_displayText?: Maybe<String_Comparison_Exp>,
  price_from?: Maybe<Int_Comparison_Exp>,
  price_single?: Maybe<Int_Comparison_Exp>,
  price_textOption?: Maybe<String_Comparison_Exp>,
  price_to?: Maybe<Int_Comparison_Exp>,
  price_view?: Maybe<String_Comparison_Exp>,
  proof_of_ownership_status?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_1?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_2?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_displayOption?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_municipality?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_postcode_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_state_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_street?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_page?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_reference?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetDirectory_type?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_streetNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suburb_before_checkout?: Maybe<String_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_address_unitNumber?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_area_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_area_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_bathRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_bedRooms?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_carportSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_energyEfficiencyRating?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_garageSpaces?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_left?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_rear?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_right?: Maybe<Int_Comparison_Exp>,
  propertyDetails_landArea_depth_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_from?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_frontage_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_to?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_landArea_unit?: Maybe<String_Comparison_Exp>,
  propertyDetails_landArea_value?: Maybe<Numeric_Comparison_Exp>,
  propertyDetails_parkingInfo_information?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType?: Maybe<String_Comparison_Exp>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<String_Comparison_Exp>,
  propertyDetails_yearBuilt?: Maybe<Int_Comparison_Exp>,
  providerAdId?: Maybe<String_Comparison_Exp>,
  publishing_status?: Maybe<String_Comparison_Exp>,
  saleType?: Maybe<String_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  search_price?: Maybe<Int_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData?: Maybe<String_Comparison_Exp>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Timestamptz_Comparison_Exp>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Int_Comparison_Exp>,
  soi_comparableData_declarationText?: Maybe<String_Comparison_Exp>,
  soi_documentationUrl?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice?: Maybe<String_Comparison_Exp>,
  soi_estimatedPrice_from?: Maybe<Int_Comparison_Exp>,
  soi_estimatedPrice_to?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_declarationText?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Int_Comparison_Exp>,
  soi_suburbMedianPrice_postcode?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_priceType?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_source?: Maybe<String_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Timestamptz_Comparison_Exp>,
  soi_suburbMedianPrice_suburb?: Maybe<String_Comparison_Exp>,
  status?: Maybe<String_Comparison_Exp>,
  summary?: Maybe<String_Comparison_Exp>,
  supplementary_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_description?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_measurement?: Maybe<Numeric_Comparison_Exp>,
  supplementary_metadata_measurementUnit?: Maybe<String_Comparison_Exp>,
  supplementary_metadata_name?: Maybe<String_Comparison_Exp>,
  supplementary_name?: Maybe<String_Comparison_Exp>,
  supplementary_types?: Maybe<String_Comparison_Exp>,
  temporary_add_on_flag?: Maybe<Boolean_Comparison_Exp>,
  thumbnail_1212?: Maybe<String_Comparison_Exp>,
  thumbnail_1818?: Maybe<String_Comparison_Exp>,
  thumbnail_185?: Maybe<String_Comparison_Exp>,
  thumbnail_284?: Maybe<String_Comparison_Exp>,
  thumbnail_370?: Maybe<String_Comparison_Exp>,
  thumbnail_555?: Maybe<String_Comparison_Exp>,
  thumbnail_568?: Maybe<String_Comparison_Exp>,
  thumbnail_606?: Maybe<String_Comparison_Exp>,
  thumbnail_852?: Maybe<String_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  zone?: Maybe<String_Comparison_Exp>,
};

export type Surrounding_Suburb_Listing_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Surrounding_Suburb_Listing_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  media_url?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Surrounding_Suburb_Listing_Max_Fields = {
  __typename?: 'surrounding_suburb_listing_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  media_url?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Surrounding_Suburb_Listing_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  media_url?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Min_Fields = {
  __typename?: 'surrounding_suburb_listing_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  media_url?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Surrounding_Suburb_Listing_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  media_url?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Mutation_Response = {
  __typename?: 'surrounding_suburb_listing_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Surrounding_Suburb_Listing>,
};

export type Surrounding_Suburb_Listing_Obj_Rel_Insert_Input = {
  data: Surrounding_Suburb_Listing_Insert_Input,
};

export type Surrounding_Suburb_Listing_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  auction_dateTime?: Maybe<Order_By>,
  auction_location?: Maybe<Order_By>,
  auction_online?: Maybe<Order_By>,
  authority?: Maybe<Order_By>,
  availableFrom?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  commercial_status?: Maybe<Order_By>,
  contactPreference?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  crossOver?: Maybe<Order_By>,
  description?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  externalLink?: Maybe<Order_By>,
  features?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  inspectionDetails_inspectionDescription?: Maybe<Order_By>,
  isNewDevelopment?: Maybe<Order_By>,
  isRural?: Maybe<Order_By>,
  lifeStyleType?: Maybe<Order_By>,
  listingAction?: Maybe<Order_By>,
  media_url?: Maybe<Order_By>,
  otherEnquiryEmail?: Maybe<Order_By>,
  owner_id?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_displayOption?: Maybe<Order_By>,
  price_displayText?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_textOption?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  price_view?: Maybe<Order_By>,
  proof_of_ownership_status?: Maybe<Order_By>,
  propertyDetails_address_1?: Maybe<Order_By>,
  propertyDetails_address_2?: Maybe<Order_By>,
  propertyDetails_address_displayOption?: Maybe<Order_By>,
  propertyDetails_address_municipality?: Maybe<Order_By>,
  propertyDetails_address_postcode?: Maybe<Order_By>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_state?: Maybe<Order_By>,
  propertyDetails_address_state_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_street?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_page?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Order_By>,
  propertyDetails_address_streetDirectory_type?: Maybe<Order_By>,
  propertyDetails_address_streetNumber?: Maybe<Order_By>,
  propertyDetails_address_suburb?: Maybe<Order_By>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_address_unitNumber?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_unit?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_depth_unit?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_frontage_unit?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_unit?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_parkingInfo_information?: Maybe<Order_By>,
  propertyDetails_propertyType?: Maybe<Order_By>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  providerAdId?: Maybe<Order_By>,
  publishing_status?: Maybe<Order_By>,
  saleType?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  soi_comparableData?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_comparableData_declarationText?: Maybe<Order_By>,
  soi_documentationUrl?: Maybe<Order_By>,
  soi_estimatedPrice?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_declarationText?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  soi_suburbMedianPrice_postcode?: Maybe<Order_By>,
  soi_suburbMedianPrice_priceType?: Maybe<Order_By>,
  soi_suburbMedianPrice_source?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Order_By>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Order_By>,
  soi_suburbMedianPrice_suburb?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  summary?: Maybe<Order_By>,
  supplementary_description?: Maybe<Order_By>,
  supplementary_metadata_description?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
  supplementary_metadata_measurementUnit?: Maybe<Order_By>,
  supplementary_metadata_name?: Maybe<Order_By>,
  supplementary_name?: Maybe<Order_By>,
  supplementary_types?: Maybe<Order_By>,
  temporary_add_on_flag?: Maybe<Order_By>,
  thumbnail_1212?: Maybe<Order_By>,
  thumbnail_1818?: Maybe<Order_By>,
  thumbnail_185?: Maybe<Order_By>,
  thumbnail_284?: Maybe<Order_By>,
  thumbnail_370?: Maybe<Order_By>,
  thumbnail_555?: Maybe<Order_By>,
  thumbnail_568?: Maybe<Order_By>,
  thumbnail_606?: Maybe<Order_By>,
  thumbnail_852?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  zone?: Maybe<Order_By>,
};

export enum Surrounding_Suburb_Listing_Select_Column {
  AgentPointId = 'agent_point_id',
  AuctionDateTime = 'auction_dateTime',
  AuctionLocation = 'auction_location',
  AuctionOnline = 'auction_online',
  Authority = 'authority',
  AvailableFrom = 'availableFrom',
  Bond = 'bond',
  CommercialStatus = 'commercial_status',
  ContactPreference = 'contactPreference',
  CreatedAt = 'created_at',
  CrossOver = 'crossOver',
  Description = 'description',
  Distance = 'distance',
  DomainAdId = 'domainAdId',
  EnquiryCode = 'enquiry_code',
  ExternalLink = 'externalLink',
  Features = 'features',
  Id = 'id',
  InspectionDetailsInspectionDescription = 'inspectionDetails_inspectionDescription',
  IsNewDevelopment = 'isNewDevelopment',
  IsRural = 'isRural',
  LifeStyleType = 'lifeStyleType',
  ListingAction = 'listingAction',
  MediaUrl = 'media_url',
  OtherEnquiryEmail = 'otherEnquiryEmail',
  OwnerId = 'owner_id',
  PriceAsking = 'price_asking',
  PriceDisplayOption = 'price_displayOption',
  PriceDisplayText = 'price_displayText',
  PriceFrom = 'price_from',
  PriceSingle = 'price_single',
  PriceTextOption = 'price_textOption',
  PriceTo = 'price_to',
  PriceView = 'price_view',
  ProofOfOwnershipStatus = 'proof_of_ownership_status',
  PropertyDetailsAddress_1 = 'propertyDetails_address_1',
  PropertyDetailsAddress_2 = 'propertyDetails_address_2',
  PropertyDetailsAddressDisplayOption = 'propertyDetails_address_displayOption',
  PropertyDetailsAddressMunicipality = 'propertyDetails_address_municipality',
  PropertyDetailsAddressPostcode = 'propertyDetails_address_postcode',
  PropertyDetailsAddressPostcodeBeforeCheckout = 'propertyDetails_address_postcode_before_checkout',
  PropertyDetailsAddressState = 'propertyDetails_address_state',
  PropertyDetailsAddressStateBeforeCheckout = 'propertyDetails_address_state_before_checkout',
  PropertyDetailsAddressStreet = 'propertyDetails_address_street',
  PropertyDetailsAddressStreetDirectoryPage = 'propertyDetails_address_streetDirectory_page',
  PropertyDetailsAddressStreetDirectoryReference = 'propertyDetails_address_streetDirectory_reference',
  PropertyDetailsAddressStreetDirectoryType = 'propertyDetails_address_streetDirectory_type',
  PropertyDetailsAddressStreetNumber = 'propertyDetails_address_streetNumber',
  PropertyDetailsAddressSuburb = 'propertyDetails_address_suburb',
  PropertyDetailsAddressSuburbBeforeCheckout = 'propertyDetails_address_suburb_before_checkout',
  PropertyDetailsAddressSuggestedGeoLocation = 'propertyDetails_address_suggestedGeoLocation',
  PropertyDetailsAddressSuggestedGeoLocationLatitude = 'propertyDetails_address_suggestedGeoLocation_latitude',
  PropertyDetailsAddressSuggestedGeoLocationLongitude = 'propertyDetails_address_suggestedGeoLocation_longitude',
  PropertyDetailsAddressUnitNumber = 'propertyDetails_address_unitNumber',
  PropertyDetailsAreaFrom = 'propertyDetails_area_from',
  PropertyDetailsAreaTo = 'propertyDetails_area_to',
  PropertyDetailsAreaUnit = 'propertyDetails_area_unit',
  PropertyDetailsAreaValue = 'propertyDetails_area_value',
  PropertyDetailsBathRooms = 'propertyDetails_bathRooms',
  PropertyDetailsBedRooms = 'propertyDetails_bedRooms',
  PropertyDetailsCarSpaces = 'propertyDetails_carSpaces',
  PropertyDetailsCarportSpaces = 'propertyDetails_carportSpaces',
  PropertyDetailsEnergyEfficiencyRating = 'propertyDetails_energyEfficiencyRating',
  PropertyDetailsGarageSpaces = 'propertyDetails_garageSpaces',
  PropertyDetailsLandAreaDepthLeft = 'propertyDetails_landArea_depth_left',
  PropertyDetailsLandAreaDepthRear = 'propertyDetails_landArea_depth_rear',
  PropertyDetailsLandAreaDepthRight = 'propertyDetails_landArea_depth_right',
  PropertyDetailsLandAreaDepthUnit = 'propertyDetails_landArea_depth_unit',
  PropertyDetailsLandAreaFrom = 'propertyDetails_landArea_from',
  PropertyDetailsLandAreaFrontage = 'propertyDetails_landArea_frontage',
  PropertyDetailsLandAreaFrontageUnit = 'propertyDetails_landArea_frontage_unit',
  PropertyDetailsLandAreaTo = 'propertyDetails_landArea_to',
  PropertyDetailsLandAreaUnit = 'propertyDetails_landArea_unit',
  PropertyDetailsLandAreaValue = 'propertyDetails_landArea_value',
  PropertyDetailsParkingInfoInformation = 'propertyDetails_parkingInfo_information',
  PropertyDetailsPropertyType = 'propertyDetails_propertyType',
  PropertyDetailsPropertyTypeHotWaterServiceType = 'propertyDetails_propertyType_hotWaterServiceType',
  PropertyDetailsYearBuilt = 'propertyDetails_yearBuilt',
  ProviderAdId = 'providerAdId',
  PublishingStatus = 'publishing_status',
  SaleType = 'saleType',
  SalesforceId = 'salesforce_id',
  SearchPrice = 'search_price',
  SfUpdatedAt = 'sf_updated_at',
  SoiComparableData = 'soi_comparableData',
  SoiComparableDataComparablePropertyDateOf = 'soi_comparableData_comparableProperty_dateOf',
  SoiComparableDataComparablePropertySoldPr = 'soi_comparableData_comparableProperty_soldPr',
  SoiComparableDataDeclarationText = 'soi_comparableData_declarationText',
  SoiDocumentationUrl = 'soi_documentationUrl',
  SoiEstimatedPrice = 'soi_estimatedPrice',
  SoiEstimatedPriceFrom = 'soi_estimatedPrice_from',
  SoiEstimatedPriceTo = 'soi_estimatedPrice_to',
  SoiSuburbMedianPrice = 'soi_suburbMedianPrice',
  SoiSuburbMedianPriceDeclarationText = 'soi_suburbMedianPrice_declarationText',
  SoiSuburbMedianPriceMedianPrice = 'soi_suburbMedianPrice_medianPrice',
  SoiSuburbMedianPricePostcode = 'soi_suburbMedianPrice_postcode',
  SoiSuburbMedianPricePriceType = 'soi_suburbMedianPrice_priceType',
  SoiSuburbMedianPriceSource = 'soi_suburbMedianPrice_source',
  SoiSuburbMedianPriceSourceDateFrom = 'soi_suburbMedianPrice_sourceDateFrom',
  SoiSuburbMedianPriceSourceDateTo = 'soi_suburbMedianPrice_sourceDateTo',
  SoiSuburbMedianPriceSuburb = 'soi_suburbMedianPrice_suburb',
  Status = 'status',
  Summary = 'summary',
  SupplementaryDescription = 'supplementary_description',
  SupplementaryMetadataDescription = 'supplementary_metadata_description',
  SupplementaryMetadataMeasurement = 'supplementary_metadata_measurement',
  SupplementaryMetadataMeasurementUnit = 'supplementary_metadata_measurementUnit',
  SupplementaryMetadataName = 'supplementary_metadata_name',
  SupplementaryName = 'supplementary_name',
  SupplementaryTypes = 'supplementary_types',
  TemporaryAddOnFlag = 'temporary_add_on_flag',
  Thumbnail_1212 = 'thumbnail_1212',
  Thumbnail_1818 = 'thumbnail_1818',
  Thumbnail_185 = 'thumbnail_185',
  Thumbnail_284 = 'thumbnail_284',
  Thumbnail_370 = 'thumbnail_370',
  Thumbnail_555 = 'thumbnail_555',
  Thumbnail_568 = 'thumbnail_568',
  Thumbnail_606 = 'thumbnail_606',
  Thumbnail_852 = 'thumbnail_852',
  UpdatedAt = 'updated_at',
  Zone = 'zone'
}

export type Surrounding_Suburb_Listing_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  auction_dateTime?: Maybe<Scalars['timestamptz']>,
  auction_location?: Maybe<Scalars['String']>,
  auction_online?: Maybe<Scalars['Boolean']>,
  authority?: Maybe<Scalars['String']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  bond?: Maybe<Scalars['Int']>,
  commercial_status?: Maybe<Scalars['String']>,
  contactPreference?: Maybe<Scalars['String']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  crossOver?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  externalLink?: Maybe<Scalars['String']>,
  features?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  inspectionDetails_inspectionDescription?: Maybe<Scalars['String']>,
  isNewDevelopment?: Maybe<Scalars['Boolean']>,
  isRural?: Maybe<Scalars['Boolean']>,
  lifeStyleType?: Maybe<Scalars['String']>,
  listingAction?: Maybe<Scalars['String']>,
  media_url?: Maybe<Scalars['String']>,
  otherEnquiryEmail?: Maybe<Scalars['String']>,
  owner_id?: Maybe<Scalars['uuid']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_displayOption?: Maybe<Scalars['String']>,
  price_displayText?: Maybe<Scalars['String']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_textOption?: Maybe<Scalars['String']>,
  price_to?: Maybe<Scalars['Int']>,
  price_view?: Maybe<Scalars['String']>,
  proof_of_ownership_status?: Maybe<Scalars['String']>,
  propertyDetails_address_1?: Maybe<Scalars['String']>,
  propertyDetails_address_2?: Maybe<Scalars['String']>,
  propertyDetails_address_displayOption?: Maybe<Scalars['String']>,
  propertyDetails_address_municipality?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode?: Maybe<Scalars['String']>,
  propertyDetails_address_postcode_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_state?: Maybe<Scalars['String']>,
  propertyDetails_address_state_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_street?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_page?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_reference?: Maybe<Scalars['String']>,
  propertyDetails_address_streetDirectory_type?: Maybe<Scalars['String']>,
  propertyDetails_address_streetNumber?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb?: Maybe<Scalars['String']>,
  propertyDetails_address_suburb_before_checkout?: Maybe<Scalars['String']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_unitNumber?: Maybe<Scalars['String']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_unit?: Maybe<Scalars['String']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_unit?: Maybe<Scalars['String']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_parkingInfo_information?: Maybe<Scalars['String']>,
  propertyDetails_propertyType?: Maybe<Scalars['String']>,
  propertyDetails_propertyType_hotWaterServiceType?: Maybe<Scalars['String']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  providerAdId?: Maybe<Scalars['String']>,
  publishing_status?: Maybe<Scalars['String']>,
  saleType?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  search_price?: Maybe<Scalars['Int']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  soi_comparableData?: Maybe<Scalars['String']>,
  soi_comparableData_comparableProperty_dateOf?: Maybe<Scalars['timestamptz']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_comparableData_declarationText?: Maybe<Scalars['String']>,
  soi_documentationUrl?: Maybe<Scalars['String']>,
  soi_estimatedPrice?: Maybe<Scalars['String']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_declarationText?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_postcode?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_priceType?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_source?: Maybe<Scalars['String']>,
  soi_suburbMedianPrice_sourceDateFrom?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_sourceDateTo?: Maybe<Scalars['timestamptz']>,
  soi_suburbMedianPrice_suburb?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  summary?: Maybe<Scalars['String']>,
  supplementary_description?: Maybe<Scalars['String']>,
  supplementary_metadata_description?: Maybe<Scalars['String']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
  supplementary_metadata_measurementUnit?: Maybe<Scalars['String']>,
  supplementary_metadata_name?: Maybe<Scalars['String']>,
  supplementary_name?: Maybe<Scalars['String']>,
  supplementary_types?: Maybe<Scalars['String']>,
  temporary_add_on_flag?: Maybe<Scalars['Boolean']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>,
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  zone?: Maybe<Scalars['String']>,
};

export type Surrounding_Suburb_Listing_Stddev_Fields = {
  __typename?: 'surrounding_suburb_listing_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Stddev_Pop_Fields = {
  __typename?: 'surrounding_suburb_listing_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Stddev_Samp_Fields = {
  __typename?: 'surrounding_suburb_listing_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Sum_Fields = {
  __typename?: 'surrounding_suburb_listing_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  bond?: Maybe<Scalars['Int']>,
  distance?: Maybe<Scalars['Int']>,
  domainAdId?: Maybe<Scalars['Int']>,
  enquiry_code?: Maybe<Scalars['Int']>,
  price_asking?: Maybe<Scalars['Int']>,
  price_from?: Maybe<Scalars['Int']>,
  price_single?: Maybe<Scalars['Int']>,
  price_to?: Maybe<Scalars['Int']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['numeric']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['numeric']>,
  propertyDetails_area_from?: Maybe<Scalars['numeric']>,
  propertyDetails_area_to?: Maybe<Scalars['numeric']>,
  propertyDetails_area_value?: Maybe<Scalars['numeric']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Int']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Int']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['numeric']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Int']>,
  propertyDetails_landArea_from?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_to?: Maybe<Scalars['numeric']>,
  propertyDetails_landArea_value?: Maybe<Scalars['numeric']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Int']>,
  search_price?: Maybe<Scalars['Int']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Int']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Int']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Int']>,
  supplementary_metadata_measurement?: Maybe<Scalars['numeric']>,
};

export type Surrounding_Suburb_Listing_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Var_Pop_Fields = {
  __typename?: 'surrounding_suburb_listing_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Var_Samp_Fields = {
  __typename?: 'surrounding_suburb_listing_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Listing_Variance_Fields = {
  __typename?: 'surrounding_suburb_listing_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  bond?: Maybe<Scalars['Float']>,
  distance?: Maybe<Scalars['Float']>,
  domainAdId?: Maybe<Scalars['Float']>,
  enquiry_code?: Maybe<Scalars['Float']>,
  price_asking?: Maybe<Scalars['Float']>,
  price_from?: Maybe<Scalars['Float']>,
  price_single?: Maybe<Scalars['Float']>,
  price_to?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Scalars['Float']>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Scalars['Float']>,
  propertyDetails_area_from?: Maybe<Scalars['Float']>,
  propertyDetails_area_to?: Maybe<Scalars['Float']>,
  propertyDetails_area_value?: Maybe<Scalars['Float']>,
  propertyDetails_bathRooms?: Maybe<Scalars['Float']>,
  propertyDetails_bedRooms?: Maybe<Scalars['Float']>,
  propertyDetails_carSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_carportSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_energyEfficiencyRating?: Maybe<Scalars['Float']>,
  propertyDetails_garageSpaces?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_left?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_rear?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_depth_right?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_from?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_frontage?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_to?: Maybe<Scalars['Float']>,
  propertyDetails_landArea_value?: Maybe<Scalars['Float']>,
  propertyDetails_yearBuilt?: Maybe<Scalars['Float']>,
  search_price?: Maybe<Scalars['Float']>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_from?: Maybe<Scalars['Float']>,
  soi_estimatedPrice_to?: Maybe<Scalars['Float']>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Scalars['Float']>,
  supplementary_metadata_measurement?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Listing_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  bond?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  domainAdId?: Maybe<Order_By>,
  enquiry_code?: Maybe<Order_By>,
  price_asking?: Maybe<Order_By>,
  price_from?: Maybe<Order_By>,
  price_single?: Maybe<Order_By>,
  price_to?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_latitude?: Maybe<Order_By>,
  propertyDetails_address_suggestedGeoLocation_longitude?: Maybe<Order_By>,
  propertyDetails_area_from?: Maybe<Order_By>,
  propertyDetails_area_to?: Maybe<Order_By>,
  propertyDetails_area_value?: Maybe<Order_By>,
  propertyDetails_bathRooms?: Maybe<Order_By>,
  propertyDetails_bedRooms?: Maybe<Order_By>,
  propertyDetails_carSpaces?: Maybe<Order_By>,
  propertyDetails_carportSpaces?: Maybe<Order_By>,
  propertyDetails_energyEfficiencyRating?: Maybe<Order_By>,
  propertyDetails_garageSpaces?: Maybe<Order_By>,
  propertyDetails_landArea_depth_left?: Maybe<Order_By>,
  propertyDetails_landArea_depth_rear?: Maybe<Order_By>,
  propertyDetails_landArea_depth_right?: Maybe<Order_By>,
  propertyDetails_landArea_from?: Maybe<Order_By>,
  propertyDetails_landArea_frontage?: Maybe<Order_By>,
  propertyDetails_landArea_to?: Maybe<Order_By>,
  propertyDetails_landArea_value?: Maybe<Order_By>,
  propertyDetails_yearBuilt?: Maybe<Order_By>,
  search_price?: Maybe<Order_By>,
  soi_comparableData_comparableProperty_soldPr?: Maybe<Order_By>,
  soi_estimatedPrice_from?: Maybe<Order_By>,
  soi_estimatedPrice_to?: Maybe<Order_By>,
  soi_suburbMedianPrice_medianPrice?: Maybe<Order_By>,
  supplementary_metadata_measurement?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Max_Fields = {
  __typename?: 'surrounding_suburb_max_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  distance?: Maybe<Scalars['Int']>,
  endLocality?: Maybe<Scalars['String']>,
  endPCode?: Maybe<Scalars['String']>,
  endSuburbName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  startLocality?: Maybe<Scalars['String']>,
  startPCode?: Maybe<Scalars['String']>,
  startSuburbName?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Surrounding_Suburb_Max_Order_By = {
  created_at?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  endLocality?: Maybe<Order_By>,
  endPCode?: Maybe<Order_By>,
  endSuburbName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  startLocality?: Maybe<Order_By>,
  startPCode?: Maybe<Order_By>,
  startSuburbName?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Min_Fields = {
  __typename?: 'surrounding_suburb_min_fields',
  created_at?: Maybe<Scalars['timestamptz']>,
  distance?: Maybe<Scalars['Int']>,
  endLocality?: Maybe<Scalars['String']>,
  endPCode?: Maybe<Scalars['String']>,
  endSuburbName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  startLocality?: Maybe<Scalars['String']>,
  startPCode?: Maybe<Scalars['String']>,
  startSuburbName?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Surrounding_Suburb_Min_Order_By = {
  created_at?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  endLocality?: Maybe<Order_By>,
  endPCode?: Maybe<Order_By>,
  endSuburbName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  startLocality?: Maybe<Order_By>,
  startPCode?: Maybe<Order_By>,
  startSuburbName?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Mutation_Response = {
  __typename?: 'surrounding_suburb_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Surrounding_Suburb>,
};

export type Surrounding_Suburb_Obj_Rel_Insert_Input = {
  data: Surrounding_Suburb_Insert_Input,
  on_conflict?: Maybe<Surrounding_Suburb_On_Conflict>,
};

export type Surrounding_Suburb_On_Conflict = {
  constraint: Surrounding_Suburb_Constraint,
  update_columns: Array<Surrounding_Suburb_Update_Column>,
  where?: Maybe<Surrounding_Suburb_Bool_Exp>,
};

export type Surrounding_Suburb_Order_By = {
  created_at?: Maybe<Order_By>,
  distance?: Maybe<Order_By>,
  endLocality?: Maybe<Order_By>,
  endPCode?: Maybe<Order_By>,
  endSuburbName?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  startLocality?: Maybe<Order_By>,
  startPCode?: Maybe<Order_By>,
  startSuburbName?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export enum Surrounding_Suburb_Select_Column {
  CreatedAt = 'created_at',
  Distance = 'distance',
  EndLocality = 'endLocality',
  EndPCode = 'endPCode',
  EndSuburbName = 'endSuburbName',
  Id = 'id',
  StartLocality = 'startLocality',
  StartPCode = 'startPCode',
  StartSuburbName = 'startSuburbName',
  UpdatedAt = 'updated_at'
}

export type Surrounding_Suburb_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>,
  distance?: Maybe<Scalars['Int']>,
  endLocality?: Maybe<Scalars['String']>,
  endPCode?: Maybe<Scalars['String']>,
  endSuburbName?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  startLocality?: Maybe<Scalars['String']>,
  startPCode?: Maybe<Scalars['String']>,
  startSuburbName?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Surrounding_Suburb_Stddev_Fields = {
  __typename?: 'surrounding_suburb_stddev_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Stddev_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Stddev_Pop_Fields = {
  __typename?: 'surrounding_suburb_stddev_pop_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Stddev_Pop_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Stddev_Samp_Fields = {
  __typename?: 'surrounding_suburb_stddev_samp_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Stddev_Samp_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Sum_Fields = {
  __typename?: 'surrounding_suburb_sum_fields',
  distance?: Maybe<Scalars['Int']>,
};

export type Surrounding_Suburb_Sum_Order_By = {
  distance?: Maybe<Order_By>,
};

export enum Surrounding_Suburb_Update_Column {
  CreatedAt = 'created_at',
  Distance = 'distance',
  EndLocality = 'endLocality',
  EndPCode = 'endPCode',
  EndSuburbName = 'endSuburbName',
  Id = 'id',
  StartLocality = 'startLocality',
  StartPCode = 'startPCode',
  StartSuburbName = 'startSuburbName',
  UpdatedAt = 'updated_at'
}

export type Surrounding_Suburb_Var_Pop_Fields = {
  __typename?: 'surrounding_suburb_var_pop_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Var_Pop_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Var_Samp_Fields = {
  __typename?: 'surrounding_suburb_var_samp_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Var_Samp_Order_By = {
  distance?: Maybe<Order_By>,
};

export type Surrounding_Suburb_Variance_Fields = {
  __typename?: 'surrounding_suburb_variance_fields',
  distance?: Maybe<Scalars['Float']>,
};

export type Surrounding_Suburb_Variance_Order_By = {
  distance?: Maybe<Order_By>,
};


export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>,
  _gt?: Maybe<Scalars['timestamptz']>,
  _gte?: Maybe<Scalars['timestamptz']>,
  _in?: Maybe<Array<Scalars['timestamptz']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['timestamptz']>,
  _lte?: Maybe<Scalars['timestamptz']>,
  _neq?: Maybe<Scalars['timestamptz']>,
  _nin?: Maybe<Array<Scalars['timestamptz']>>,
};

export type Transaction = {
  __typename?: 'transaction',
  amount: Scalars['Int'],
  created_at: Scalars['timestamptz'],
  id: Scalars['uuid'],
  json?: Maybe<Scalars['jsonb']>,
  order: Order,
  order_id: Scalars['uuid'],
  origin_id: Scalars['String'],
  origin_status?: Maybe<Scalars['String']>,
  origin_type: Scalars['String'],
  payment_url?: Maybe<Scalars['String']>,
  status: Transaction_Status_Enum,
  transaction_status: Transaction_Status,
  updated_at: Scalars['timestamptz'],
};


export type TransactionJsonArgs = {
  path?: Maybe<Scalars['String']>
};

export type Transaction_Aggregate = {
  __typename?: 'transaction_aggregate',
  aggregate?: Maybe<Transaction_Aggregate_Fields>,
  nodes: Array<Transaction>,
};

export type Transaction_Aggregate_Fields = {
  __typename?: 'transaction_aggregate_fields',
  avg?: Maybe<Transaction_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Transaction_Max_Fields>,
  min?: Maybe<Transaction_Min_Fields>,
  stddev?: Maybe<Transaction_Stddev_Fields>,
  stddev_pop?: Maybe<Transaction_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<Transaction_Stddev_Samp_Fields>,
  sum?: Maybe<Transaction_Sum_Fields>,
  var_pop?: Maybe<Transaction_Var_Pop_Fields>,
  var_samp?: Maybe<Transaction_Var_Samp_Fields>,
  variance?: Maybe<Transaction_Variance_Fields>,
};


export type Transaction_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Transaction_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Transaction_Aggregate_Order_By = {
  avg?: Maybe<Transaction_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<Transaction_Max_Order_By>,
  min?: Maybe<Transaction_Min_Order_By>,
  stddev?: Maybe<Transaction_Stddev_Order_By>,
  stddev_pop?: Maybe<Transaction_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<Transaction_Stddev_Samp_Order_By>,
  sum?: Maybe<Transaction_Sum_Order_By>,
  var_pop?: Maybe<Transaction_Var_Pop_Order_By>,
  var_samp?: Maybe<Transaction_Var_Samp_Order_By>,
  variance?: Maybe<Transaction_Variance_Order_By>,
};

export type Transaction_Append_Input = {
  json?: Maybe<Scalars['jsonb']>,
};

export type Transaction_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Insert_Input>,
  on_conflict?: Maybe<Transaction_On_Conflict>,
};

export type Transaction_Avg_Fields = {
  __typename?: 'transaction_avg_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Avg_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Transaction_Bool_Exp>>>,
  _not?: Maybe<Transaction_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Transaction_Bool_Exp>>>,
  amount?: Maybe<Int_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  json?: Maybe<Jsonb_Comparison_Exp>,
  order?: Maybe<Order_Bool_Exp>,
  order_id?: Maybe<Uuid_Comparison_Exp>,
  origin_id?: Maybe<String_Comparison_Exp>,
  origin_status?: Maybe<String_Comparison_Exp>,
  origin_type?: Maybe<String_Comparison_Exp>,
  payment_url?: Maybe<String_Comparison_Exp>,
  status?: Maybe<Transaction_Status_Enum_Comparison_Exp>,
  transaction_status?: Maybe<Transaction_Status_Bool_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
};

export enum Transaction_Constraint {
  TransactionOriginIdOriginTypeKey = 'transaction_origin_id_origin_type_key',
  TransactionPkey = 'transaction_pkey'
}

export type Transaction_Delete_At_Path_Input = {
  json?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Transaction_Delete_Elem_Input = {
  json?: Maybe<Scalars['Int']>,
};

export type Transaction_Delete_Key_Input = {
  json?: Maybe<Scalars['String']>,
};

export type Transaction_Inc_Input = {
  amount?: Maybe<Scalars['Int']>,
};

export type Transaction_Insert_Input = {
  amount?: Maybe<Scalars['Int']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  json?: Maybe<Scalars['jsonb']>,
  order?: Maybe<Order_Obj_Rel_Insert_Input>,
  order_id?: Maybe<Scalars['uuid']>,
  origin_id?: Maybe<Scalars['String']>,
  origin_status?: Maybe<Scalars['String']>,
  origin_type?: Maybe<Scalars['String']>,
  payment_url?: Maybe<Scalars['String']>,
  status?: Maybe<Transaction_Status_Enum>,
  transaction_status?: Maybe<Transaction_Status_Obj_Rel_Insert_Input>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Transaction_Max_Fields = {
  __typename?: 'transaction_max_fields',
  amount?: Maybe<Scalars['Int']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order_id?: Maybe<Scalars['uuid']>,
  origin_id?: Maybe<Scalars['String']>,
  origin_status?: Maybe<Scalars['String']>,
  origin_type?: Maybe<Scalars['String']>,
  payment_url?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Transaction_Max_Order_By = {
  amount?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  origin_id?: Maybe<Order_By>,
  origin_status?: Maybe<Order_By>,
  origin_type?: Maybe<Order_By>,
  payment_url?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Transaction_Min_Fields = {
  __typename?: 'transaction_min_fields',
  amount?: Maybe<Scalars['Int']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  order_id?: Maybe<Scalars['uuid']>,
  origin_id?: Maybe<Scalars['String']>,
  origin_status?: Maybe<Scalars['String']>,
  origin_type?: Maybe<Scalars['String']>,
  payment_url?: Maybe<Scalars['String']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Transaction_Min_Order_By = {
  amount?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  order_id?: Maybe<Order_By>,
  origin_id?: Maybe<Order_By>,
  origin_status?: Maybe<Order_By>,
  origin_type?: Maybe<Order_By>,
  payment_url?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Transaction_Mutation_Response = {
  __typename?: 'transaction_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Transaction>,
};

export type Transaction_Obj_Rel_Insert_Input = {
  data: Transaction_Insert_Input,
  on_conflict?: Maybe<Transaction_On_Conflict>,
};

export type Transaction_On_Conflict = {
  constraint: Transaction_Constraint,
  update_columns: Array<Transaction_Update_Column>,
  where?: Maybe<Transaction_Bool_Exp>,
};

export type Transaction_Order_By = {
  amount?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  json?: Maybe<Order_By>,
  order?: Maybe<Order_Order_By>,
  order_id?: Maybe<Order_By>,
  origin_id?: Maybe<Order_By>,
  origin_status?: Maybe<Order_By>,
  origin_type?: Maybe<Order_By>,
  payment_url?: Maybe<Order_By>,
  status?: Maybe<Order_By>,
  transaction_status?: Maybe<Transaction_Status_Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type Transaction_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type Transaction_Prepend_Input = {
  json?: Maybe<Scalars['jsonb']>,
};

export enum Transaction_Select_Column {
  Amount = 'amount',
  CreatedAt = 'created_at',
  Id = 'id',
  Json = 'json',
  OrderId = 'order_id',
  OriginId = 'origin_id',
  OriginStatus = 'origin_status',
  OriginType = 'origin_type',
  PaymentUrl = 'payment_url',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type Transaction_Set_Input = {
  amount?: Maybe<Scalars['Int']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  id?: Maybe<Scalars['uuid']>,
  json?: Maybe<Scalars['jsonb']>,
  order_id?: Maybe<Scalars['uuid']>,
  origin_id?: Maybe<Scalars['String']>,
  origin_status?: Maybe<Scalars['String']>,
  origin_type?: Maybe<Scalars['String']>,
  payment_url?: Maybe<Scalars['String']>,
  status?: Maybe<Transaction_Status_Enum>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type Transaction_Status = {
  __typename?: 'transaction_status',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Transaction_Status_Aggregate = {
  __typename?: 'transaction_status_aggregate',
  aggregate?: Maybe<Transaction_Status_Aggregate_Fields>,
  nodes: Array<Transaction_Status>,
};

export type Transaction_Status_Aggregate_Fields = {
  __typename?: 'transaction_status_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Transaction_Status_Max_Fields>,
  min?: Maybe<Transaction_Status_Min_Fields>,
};


export type Transaction_Status_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Transaction_Status_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Transaction_Status_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Transaction_Status_Max_Order_By>,
  min?: Maybe<Transaction_Status_Min_Order_By>,
};

export type Transaction_Status_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Status_Insert_Input>,
  on_conflict?: Maybe<Transaction_Status_On_Conflict>,
};

export type Transaction_Status_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Transaction_Status_Bool_Exp>>>,
  _not?: Maybe<Transaction_Status_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Transaction_Status_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Transaction_Status_Constraint {
  TransactionStatusPkey = 'transaction_status_pkey'
}

export enum Transaction_Status_Enum {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Created = 'Created',
  Paid = 'Paid'
}

export type Transaction_Status_Enum_Comparison_Exp = {
  _eq?: Maybe<Transaction_Status_Enum>,
  _in?: Maybe<Array<Transaction_Status_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Transaction_Status_Enum>,
  _nin?: Maybe<Array<Transaction_Status_Enum>>,
};

export type Transaction_Status_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Transaction_Status_Max_Fields = {
  __typename?: 'transaction_status_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Transaction_Status_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Transaction_Status_Min_Fields = {
  __typename?: 'transaction_status_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Transaction_Status_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Transaction_Status_Mutation_Response = {
  __typename?: 'transaction_status_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Transaction_Status>,
};

export type Transaction_Status_Obj_Rel_Insert_Input = {
  data: Transaction_Status_Insert_Input,
  on_conflict?: Maybe<Transaction_Status_On_Conflict>,
};

export type Transaction_Status_On_Conflict = {
  constraint: Transaction_Status_Constraint,
  update_columns: Array<Transaction_Status_Update_Column>,
  where?: Maybe<Transaction_Status_Bool_Exp>,
};

export type Transaction_Status_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Transaction_Status_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Transaction_Status_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Transaction_Status_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Transaction_Status_Update_Column {
  Description = 'description',
  Value = 'value'
}

export type Transaction_Stddev_Fields = {
  __typename?: 'transaction_stddev_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Stddev_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Stddev_Pop_Fields = {
  __typename?: 'transaction_stddev_pop_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Stddev_Pop_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Stddev_Samp_Fields = {
  __typename?: 'transaction_stddev_samp_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Stddev_Samp_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Sum_Fields = {
  __typename?: 'transaction_sum_fields',
  amount?: Maybe<Scalars['Int']>,
};

export type Transaction_Sum_Order_By = {
  amount?: Maybe<Order_By>,
};

export enum Transaction_Update_Column {
  Amount = 'amount',
  CreatedAt = 'created_at',
  Id = 'id',
  Json = 'json',
  OrderId = 'order_id',
  OriginId = 'origin_id',
  OriginStatus = 'origin_status',
  OriginType = 'origin_type',
  PaymentUrl = 'payment_url',
  Status = 'status',
  UpdatedAt = 'updated_at'
}

export type Transaction_Var_Pop_Fields = {
  __typename?: 'transaction_var_pop_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Var_Pop_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Var_Samp_Fields = {
  __typename?: 'transaction_var_samp_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Var_Samp_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Transaction_Variance_Fields = {
  __typename?: 'transaction_variance_fields',
  amount?: Maybe<Scalars['Float']>,
};

export type Transaction_Variance_Order_By = {
  amount?: Maybe<Order_By>,
};

export type Update_Order_Total_Response = {
  __typename?: 'update_order_total_response',
  affected_rows: Scalars['numeric'],
};

export type Update_User_Email_Verification_Response = {
  __typename?: 'update_user_email_verification_response',
  affected_rows: Scalars['numeric'],
};

export type Update_User_Password_Phone_Response = {
  __typename?: 'Update_User_Password_Phone_Response',
  message: Scalars['String'],
};

export type Upload_Credential = {
  __typename?: 'upload_credential',
  expires_at?: Maybe<Scalars['String']>,
  url: Scalars['String'],
};

export type User = {
  __typename?: 'user',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles: Scalars['String'],
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at: Scalars['timestamptz'],
  default_role: Scalars['String'],
  email: Scalars['String'],
  email_verified: Scalars['Boolean'],
  experiments?: Maybe<Scalars['jsonb']>,
  external_auths: Array<External_Auth>,
  external_auths_aggregate: External_Auth_Aggregate,
  first_name?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id: Scalars['uuid'],
  initial_submitted_via?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  listings: Array<Listing>,
  listings_aggregate: Listing_Aggregate,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified: Scalars['Boolean'],
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email: Scalars['Boolean'],
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  submitted_via?: Maybe<Scalars['String']>,
  unique_number: Scalars['Int'],
  updated_at?: Maybe<Scalars['timestamptz']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
  verified: Scalars['Boolean'],
};


export type UserExperimentsArgs = {
  path?: Maybe<Scalars['String']>
};


export type UserExternal_AuthsArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type UserExternal_Auths_AggregateArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type UserListingsArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type UserListings_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};

export type User_Aggregate = {
  __typename?: 'user_aggregate',
  aggregate?: Maybe<User_Aggregate_Fields>,
  nodes: Array<User>,
};

export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields',
  avg?: Maybe<User_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<User_Max_Fields>,
  min?: Maybe<User_Min_Fields>,
  stddev?: Maybe<User_Stddev_Fields>,
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>,
  sum?: Maybe<User_Sum_Fields>,
  var_pop?: Maybe<User_Var_Pop_Fields>,
  var_samp?: Maybe<User_Var_Samp_Fields>,
  variance?: Maybe<User_Variance_Fields>,
};


export type User_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type User_Aggregate_Order_By = {
  avg?: Maybe<User_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<User_Max_Order_By>,
  min?: Maybe<User_Min_Order_By>,
  stddev?: Maybe<User_Stddev_Order_By>,
  stddev_pop?: Maybe<User_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<User_Stddev_Samp_Order_By>,
  sum?: Maybe<User_Sum_Order_By>,
  var_pop?: Maybe<User_Var_Pop_Order_By>,
  var_samp?: Maybe<User_Var_Samp_Order_By>,
  variance?: Maybe<User_Variance_Order_By>,
};

export type User_Append_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export type User_Arr_Rel_Insert_Input = {
  data: Array<User_Insert_Input>,
  on_conflict?: Maybe<User_On_Conflict>,
};

export type User_Avg_Fields = {
  __typename?: 'user_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Bool_Exp>>>,
  _not?: Maybe<User_Bool_Exp>,
  _or?: Maybe<Array<Maybe<User_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  allowed_roles?: Maybe<String_Comparison_Exp>,
  code_timestamp?: Maybe<Timestamptz_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  default_role?: Maybe<String_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  email_verified?: Maybe<Boolean_Comparison_Exp>,
  experiments?: Maybe<Jsonb_Comparison_Exp>,
  external_auths?: Maybe<External_Auth_Bool_Exp>,
  first_name?: Maybe<String_Comparison_Exp>,
  ga_client_id?: Maybe<String_Comparison_Exp>,
  gclid?: Maybe<String_Comparison_Exp>,
  hash?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  initial_submitted_via?: Maybe<String_Comparison_Exp>,
  last_name?: Maybe<String_Comparison_Exp>,
  listings?: Maybe<Listing_Bool_Exp>,
  middle_name?: Maybe<String_Comparison_Exp>,
  onboarding_email_sent_on?: Maybe<Timestamptz_Comparison_Exp>,
  password?: Maybe<String_Comparison_Exp>,
  phone_number?: Maybe<String_Comparison_Exp>,
  phone_number_verified?: Maybe<Boolean_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  send_welcome_email?: Maybe<Boolean_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  submitted_via?: Maybe<String_Comparison_Exp>,
  unique_number?: Maybe<Int_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  utm_campaign?: Maybe<String_Comparison_Exp>,
  utm_content?: Maybe<String_Comparison_Exp>,
  utm_medium?: Maybe<String_Comparison_Exp>,
  utm_source?: Maybe<String_Comparison_Exp>,
  utm_term?: Maybe<String_Comparison_Exp>,
  verified?: Maybe<Boolean_Comparison_Exp>,
};

export enum User_Constraint {
  UserAgentPointIdKey = 'user_agent_point_id_key',
  UserEmailKey = 'user_email_key',
  UserHashKey = 'user_hash_key',
  UserIdKey = 'user_id_key',
  UserPkey = 'user_pkey',
  UserUniqueNumberKey = 'user_unique_number_key'
}

export type User_Delete_At_Path_Input = {
  experiments?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type User_Delete_Elem_Input = {
  experiments?: Maybe<Scalars['Int']>,
};

export type User_Delete_Key_Input = {
  experiments?: Maybe<Scalars['String']>,
};

export type User_Detail = {
  __typename?: 'user_detail',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_verified?: Maybe<Scalars['Boolean']>,
  external_auths: Array<External_Auth>,
  external_auths_aggregate: External_Auth_Aggregate,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  listings: Array<Listing>,
  listings_aggregate: Listing_Aggregate,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email?: Maybe<Scalars['Boolean']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  verified?: Maybe<Scalars['Boolean']>,
};


export type User_DetailExternal_AuthsArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type User_DetailExternal_Auths_AggregateArgs = {
  distinct_on?: Maybe<Array<External_Auth_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<External_Auth_Order_By>>,
  where?: Maybe<External_Auth_Bool_Exp>
};


export type User_DetailListingsArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};


export type User_DetailListings_AggregateArgs = {
  distinct_on?: Maybe<Array<Listing_Select_Column>>,
  limit?: Maybe<Scalars['Int']>,
  offset?: Maybe<Scalars['Int']>,
  order_by?: Maybe<Array<Listing_Order_By>>,
  where?: Maybe<Listing_Bool_Exp>
};

export type User_Detail_Aggregate = {
  __typename?: 'user_detail_aggregate',
  aggregate?: Maybe<User_Detail_Aggregate_Fields>,
  nodes: Array<User_Detail>,
};

export type User_Detail_Aggregate_Fields = {
  __typename?: 'user_detail_aggregate_fields',
  avg?: Maybe<User_Detail_Avg_Fields>,
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<User_Detail_Max_Fields>,
  min?: Maybe<User_Detail_Min_Fields>,
  stddev?: Maybe<User_Detail_Stddev_Fields>,
  stddev_pop?: Maybe<User_Detail_Stddev_Pop_Fields>,
  stddev_samp?: Maybe<User_Detail_Stddev_Samp_Fields>,
  sum?: Maybe<User_Detail_Sum_Fields>,
  var_pop?: Maybe<User_Detail_Var_Pop_Fields>,
  var_samp?: Maybe<User_Detail_Var_Samp_Fields>,
  variance?: Maybe<User_Detail_Variance_Fields>,
};


export type User_Detail_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Detail_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type User_Detail_Aggregate_Order_By = {
  avg?: Maybe<User_Detail_Avg_Order_By>,
  count?: Maybe<Order_By>,
  max?: Maybe<User_Detail_Max_Order_By>,
  min?: Maybe<User_Detail_Min_Order_By>,
  stddev?: Maybe<User_Detail_Stddev_Order_By>,
  stddev_pop?: Maybe<User_Detail_Stddev_Pop_Order_By>,
  stddev_samp?: Maybe<User_Detail_Stddev_Samp_Order_By>,
  sum?: Maybe<User_Detail_Sum_Order_By>,
  var_pop?: Maybe<User_Detail_Var_Pop_Order_By>,
  var_samp?: Maybe<User_Detail_Var_Samp_Order_By>,
  variance?: Maybe<User_Detail_Variance_Order_By>,
};

export type User_Detail_Arr_Rel_Insert_Input = {
  data: Array<User_Detail_Insert_Input>,
};

export type User_Detail_Avg_Fields = {
  __typename?: 'user_detail_avg_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Avg_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Detail_Bool_Exp>>>,
  _not?: Maybe<User_Detail_Bool_Exp>,
  _or?: Maybe<Array<Maybe<User_Detail_Bool_Exp>>>,
  agent_point_id?: Maybe<Numeric_Comparison_Exp>,
  allowed_roles?: Maybe<String_Comparison_Exp>,
  code_timestamp?: Maybe<Timestamptz_Comparison_Exp>,
  created_at?: Maybe<Timestamptz_Comparison_Exp>,
  default_role?: Maybe<String_Comparison_Exp>,
  email?: Maybe<String_Comparison_Exp>,
  email_verified?: Maybe<Boolean_Comparison_Exp>,
  external_auths?: Maybe<External_Auth_Bool_Exp>,
  first_name?: Maybe<String_Comparison_Exp>,
  full_name?: Maybe<String_Comparison_Exp>,
  hash?: Maybe<String_Comparison_Exp>,
  id?: Maybe<Uuid_Comparison_Exp>,
  last_name?: Maybe<String_Comparison_Exp>,
  listings?: Maybe<Listing_Bool_Exp>,
  middle_name?: Maybe<String_Comparison_Exp>,
  onboarding_email_sent_on?: Maybe<Timestamptz_Comparison_Exp>,
  password?: Maybe<String_Comparison_Exp>,
  phone_number?: Maybe<String_Comparison_Exp>,
  phone_number_verified?: Maybe<Boolean_Comparison_Exp>,
  salesforce_id?: Maybe<String_Comparison_Exp>,
  send_welcome_email?: Maybe<Boolean_Comparison_Exp>,
  sf_updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  updated_at?: Maybe<Timestamptz_Comparison_Exp>,
  verified?: Maybe<Boolean_Comparison_Exp>,
};

export type User_Detail_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type User_Detail_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_verified?: Maybe<Scalars['Boolean']>,
  external_auths?: Maybe<External_Auth_Arr_Rel_Insert_Input>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  listings?: Maybe<Listing_Arr_Rel_Insert_Input>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email?: Maybe<Scalars['Boolean']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  verified?: Maybe<Scalars['Boolean']>,
};

export type User_Detail_Max_Fields = {
  __typename?: 'user_detail_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type User_Detail_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type User_Detail_Min_Fields = {
  __typename?: 'user_detail_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
};

export type User_Detail_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
};

export type User_Detail_Mutation_Response = {
  __typename?: 'user_detail_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<User_Detail>,
};

export type User_Detail_Obj_Rel_Insert_Input = {
  data: User_Detail_Insert_Input,
};

export type User_Detail_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  email_verified?: Maybe<Order_By>,
  external_auths_aggregate?: Maybe<External_Auth_Aggregate_Order_By>,
  first_name?: Maybe<Order_By>,
  full_name?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  listings_aggregate?: Maybe<Listing_Aggregate_Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  phone_number_verified?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  send_welcome_email?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  verified?: Maybe<Order_By>,
};

export enum User_Detail_Select_Column {
  AgentPointId = 'agent_point_id',
  AllowedRoles = 'allowed_roles',
  CodeTimestamp = 'code_timestamp',
  CreatedAt = 'created_at',
  DefaultRole = 'default_role',
  Email = 'email',
  EmailVerified = 'email_verified',
  FirstName = 'first_name',
  FullName = 'full_name',
  Hash = 'hash',
  Id = 'id',
  LastName = 'last_name',
  MiddleName = 'middle_name',
  OnboardingEmailSentOn = 'onboarding_email_sent_on',
  Password = 'password',
  PhoneNumber = 'phone_number',
  PhoneNumberVerified = 'phone_number_verified',
  SalesforceId = 'salesforce_id',
  SendWelcomeEmail = 'send_welcome_email',
  SfUpdatedAt = 'sf_updated_at',
  UpdatedAt = 'updated_at',
  Verified = 'verified'
}

export type User_Detail_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_verified?: Maybe<Scalars['Boolean']>,
  first_name?: Maybe<Scalars['String']>,
  full_name?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email?: Maybe<Scalars['Boolean']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  verified?: Maybe<Scalars['Boolean']>,
};

export type User_Detail_Stddev_Fields = {
  __typename?: 'user_detail_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Stddev_Pop_Fields = {
  __typename?: 'user_detail_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Stddev_Samp_Fields = {
  __typename?: 'user_detail_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Sum_Fields = {
  __typename?: 'user_detail_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
};

export type User_Detail_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Var_Pop_Fields = {
  __typename?: 'user_detail_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Var_Samp_Fields = {
  __typename?: 'user_detail_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Detail_Variance_Fields = {
  __typename?: 'user_detail_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
};

export type User_Detail_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
};

export type User_Inc_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  unique_number?: Maybe<Scalars['Int']>,
};

export type User_Insert_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_verified?: Maybe<Scalars['Boolean']>,
  experiments?: Maybe<Scalars['jsonb']>,
  external_auths?: Maybe<External_Auth_Arr_Rel_Insert_Input>,
  first_name?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  initial_submitted_via?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  listings?: Maybe<Listing_Arr_Rel_Insert_Input>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email?: Maybe<Scalars['Boolean']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  submitted_via?: Maybe<Scalars['String']>,
  unique_number?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
  verified?: Maybe<Scalars['Boolean']>,
};

export type User_Max_Fields = {
  __typename?: 'user_max_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  first_name?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  initial_submitted_via?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  submitted_via?: Maybe<Scalars['String']>,
  unique_number?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
};

export type User_Max_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  ga_client_id?: Maybe<Order_By>,
  gclid?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  initial_submitted_via?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  submitted_via?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  utm_campaign?: Maybe<Order_By>,
  utm_content?: Maybe<Order_By>,
  utm_medium?: Maybe<Order_By>,
  utm_source?: Maybe<Order_By>,
  utm_term?: Maybe<Order_By>,
};

export type User_Min_Fields = {
  __typename?: 'user_min_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  first_name?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  initial_submitted_via?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  salesforce_id?: Maybe<Scalars['String']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  submitted_via?: Maybe<Scalars['String']>,
  unique_number?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
};

export type User_Min_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  first_name?: Maybe<Order_By>,
  ga_client_id?: Maybe<Order_By>,
  gclid?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  initial_submitted_via?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  submitted_via?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  utm_campaign?: Maybe<Order_By>,
  utm_content?: Maybe<Order_By>,
  utm_medium?: Maybe<Order_By>,
  utm_source?: Maybe<Order_By>,
  utm_term?: Maybe<Order_By>,
};

export type User_Mutation_Response = {
  __typename?: 'user_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<User>,
};

export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input,
  on_conflict?: Maybe<User_On_Conflict>,
};

export type User_On_Conflict = {
  constraint: User_Constraint,
  update_columns: Array<User_Update_Column>,
  where?: Maybe<User_Bool_Exp>,
};

export type User_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  allowed_roles?: Maybe<Order_By>,
  code_timestamp?: Maybe<Order_By>,
  created_at?: Maybe<Order_By>,
  default_role?: Maybe<Order_By>,
  email?: Maybe<Order_By>,
  email_verified?: Maybe<Order_By>,
  experiments?: Maybe<Order_By>,
  external_auths_aggregate?: Maybe<External_Auth_Aggregate_Order_By>,
  first_name?: Maybe<Order_By>,
  ga_client_id?: Maybe<Order_By>,
  gclid?: Maybe<Order_By>,
  hash?: Maybe<Order_By>,
  id?: Maybe<Order_By>,
  initial_submitted_via?: Maybe<Order_By>,
  last_name?: Maybe<Order_By>,
  listings_aggregate?: Maybe<Listing_Aggregate_Order_By>,
  middle_name?: Maybe<Order_By>,
  onboarding_email_sent_on?: Maybe<Order_By>,
  password?: Maybe<Order_By>,
  phone_number?: Maybe<Order_By>,
  phone_number_verified?: Maybe<Order_By>,
  salesforce_id?: Maybe<Order_By>,
  send_welcome_email?: Maybe<Order_By>,
  sf_updated_at?: Maybe<Order_By>,
  submitted_via?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
  updated_at?: Maybe<Order_By>,
  utm_campaign?: Maybe<Order_By>,
  utm_content?: Maybe<Order_By>,
  utm_medium?: Maybe<Order_By>,
  utm_source?: Maybe<Order_By>,
  utm_term?: Maybe<Order_By>,
  verified?: Maybe<Order_By>,
};

export type User_Pk_Columns_Input = {
  id: Scalars['uuid'],
};

export type User_Prepend_Input = {
  experiments?: Maybe<Scalars['jsonb']>,
};

export enum User_Select_Column {
  AgentPointId = 'agent_point_id',
  AllowedRoles = 'allowed_roles',
  CodeTimestamp = 'code_timestamp',
  CreatedAt = 'created_at',
  DefaultRole = 'default_role',
  Email = 'email',
  EmailVerified = 'email_verified',
  Experiments = 'experiments',
  FirstName = 'first_name',
  GaClientId = 'ga_client_id',
  Gclid = 'gclid',
  Hash = 'hash',
  Id = 'id',
  InitialSubmittedVia = 'initial_submitted_via',
  LastName = 'last_name',
  MiddleName = 'middle_name',
  OnboardingEmailSentOn = 'onboarding_email_sent_on',
  Password = 'password',
  PhoneNumber = 'phone_number',
  PhoneNumberVerified = 'phone_number_verified',
  SalesforceId = 'salesforce_id',
  SendWelcomeEmail = 'send_welcome_email',
  SfUpdatedAt = 'sf_updated_at',
  SubmittedVia = 'submitted_via',
  UniqueNumber = 'unique_number',
  UpdatedAt = 'updated_at',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmMedium = 'utm_medium',
  UtmSource = 'utm_source',
  UtmTerm = 'utm_term',
  Verified = 'verified'
}

export type User_Set_Input = {
  agent_point_id?: Maybe<Scalars['numeric']>,
  allowed_roles?: Maybe<Scalars['String']>,
  code_timestamp?: Maybe<Scalars['timestamptz']>,
  created_at?: Maybe<Scalars['timestamptz']>,
  default_role?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_verified?: Maybe<Scalars['Boolean']>,
  experiments?: Maybe<Scalars['jsonb']>,
  first_name?: Maybe<Scalars['String']>,
  ga_client_id?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>,
  hash?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['uuid']>,
  initial_submitted_via?: Maybe<Scalars['String']>,
  last_name?: Maybe<Scalars['String']>,
  middle_name?: Maybe<Scalars['String']>,
  onboarding_email_sent_on?: Maybe<Scalars['timestamptz']>,
  password?: Maybe<Scalars['String']>,
  phone_number?: Maybe<Scalars['String']>,
  phone_number_verified?: Maybe<Scalars['Boolean']>,
  salesforce_id?: Maybe<Scalars['String']>,
  send_welcome_email?: Maybe<Scalars['Boolean']>,
  sf_updated_at?: Maybe<Scalars['timestamptz']>,
  submitted_via?: Maybe<Scalars['String']>,
  unique_number?: Maybe<Scalars['Int']>,
  updated_at?: Maybe<Scalars['timestamptz']>,
  utm_campaign?: Maybe<Scalars['String']>,
  utm_content?: Maybe<Scalars['String']>,
  utm_medium?: Maybe<Scalars['String']>,
  utm_source?: Maybe<Scalars['String']>,
  utm_term?: Maybe<Scalars['String']>,
  verified?: Maybe<Scalars['Boolean']>,
};

export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Stddev_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Stddev_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Stddev_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Sum_Fields = {
  __typename?: 'user_sum_fields',
  agent_point_id?: Maybe<Scalars['numeric']>,
  unique_number?: Maybe<Scalars['Int']>,
};

export type User_Sum_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export enum User_Update_Column {
  AgentPointId = 'agent_point_id',
  AllowedRoles = 'allowed_roles',
  CodeTimestamp = 'code_timestamp',
  CreatedAt = 'created_at',
  DefaultRole = 'default_role',
  Email = 'email',
  EmailVerified = 'email_verified',
  Experiments = 'experiments',
  FirstName = 'first_name',
  GaClientId = 'ga_client_id',
  Gclid = 'gclid',
  Hash = 'hash',
  Id = 'id',
  InitialSubmittedVia = 'initial_submitted_via',
  LastName = 'last_name',
  MiddleName = 'middle_name',
  OnboardingEmailSentOn = 'onboarding_email_sent_on',
  Password = 'password',
  PhoneNumber = 'phone_number',
  PhoneNumberVerified = 'phone_number_verified',
  SalesforceId = 'salesforce_id',
  SendWelcomeEmail = 'send_welcome_email',
  SfUpdatedAt = 'sf_updated_at',
  SubmittedVia = 'submitted_via',
  UniqueNumber = 'unique_number',
  UpdatedAt = 'updated_at',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmMedium = 'utm_medium',
  UtmSource = 'utm_source',
  UtmTerm = 'utm_term',
  Verified = 'verified'
}

export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Var_Pop_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Var_Samp_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};

export type User_Variance_Fields = {
  __typename?: 'user_variance_fields',
  agent_point_id?: Maybe<Scalars['Float']>,
  unique_number?: Maybe<Scalars['Float']>,
};

export type User_Variance_Order_By = {
  agent_point_id?: Maybe<Order_By>,
  unique_number?: Maybe<Order_By>,
};


export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>,
  _gt?: Maybe<Scalars['uuid']>,
  _gte?: Maybe<Scalars['uuid']>,
  _in?: Maybe<Array<Scalars['uuid']>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _lt?: Maybe<Scalars['uuid']>,
  _lte?: Maybe<Scalars['uuid']>,
  _neq?: Maybe<Scalars['uuid']>,
  _nin?: Maybe<Array<Scalars['uuid']>>,
};

export type VerifyDocumentResult_Dlau = {
  __typename?: 'VerifyDocumentResult_dlau',
  ActivityId?: Maybe<Scalars['String']>,
  OriginatingAgencyCode?: Maybe<Scalars['String']>,
  VerificationRequestNumber?: Maybe<Scalars['String']>,
  VerificationResultCode?: Maybe<Scalars['String']>,
  attributes?: Maybe<Attributes_Dlau>,
};

export type VerifyDocumentResult_Ppau = {
  __typename?: 'VerifyDocumentResult_ppau',
  ActivityId?: Maybe<Scalars['String']>,
  OriginatingAgencyCode?: Maybe<Scalars['String']>,
  VerificationRequestNumber?: Maybe<Scalars['String']>,
  VerificationResultCode?: Maybe<Scalars['String']>,
  attributes?: Maybe<Attributes>,
};

export type VerifyItemAddressV22_Dlnz = {
  __typename?: 'VerifyItemAddressV22_dlnz',
  AddressFromDate?: Maybe<Scalars['Date']>,
  AddressLine1?: Maybe<Scalars['String']>,
  AddressVerified?: Maybe<Scalars['String']>,
  EncumberanceLodged?: Maybe<Scalars['Date']>,
};

export type VerifyItemAddressV22_Nicn = {
  __typename?: 'VerifyItemAddressV22_nicn',
  AddressFromDate?: Maybe<Scalars['Date']>,
  AddressLine1?: Maybe<Scalars['String']>,
  AddressVerified?: Maybe<Scalars['String']>,
  EncumberanceLodged?: Maybe<Scalars['Date']>,
};

export type VerifyItemAddressV22_Ppnz = {
  __typename?: 'VerifyItemAddressV22_ppnz',
  AddressFromDate?: Maybe<Scalars['Date']>,
  AddressLine1?: Maybe<Scalars['String']>,
  AddressVerified?: Maybe<Scalars['String']>,
  EncumberanceLodged?: Maybe<Scalars['Date']>,
};

export type VerifyItemV22_Dlnz = {
  __typename?: 'VerifyItemV22_dlnz',
  Addresses?: Maybe<Addresses_Dlnz>,
  DateofBirth?: Maybe<Scalars['Date']>,
  DateofBirthVerified?: Maybe<Scalars['String']>,
  FirstNameVerified?: Maybe<Scalars['String']>,
  FullName?: Maybe<Scalars['String']>,
  Gender?: Maybe<Scalars['String']>,
  IDCardNo?: Maybe<Scalars['String']>,
  IDCardNoValid?: Maybe<Scalars['String']>,
  LastNameVerified?: Maybe<Scalars['String']>,
  LastOdometerReading?: Maybe<Scalars['String']>,
  LastOdometerReadingDate?: Maybe<Scalars['Date']>,
  LastReviewed?: Maybe<Scalars['Date']>,
  LicenseNoVerified?: Maybe<Scalars['String']>,
  MiddleNameVerified?: Maybe<Scalars['String']>,
  PassportExpiry?: Maybe<Scalars['Date']>,
  SourceVerified?: Maybe<Scalars['String']>,
  VehicleOwnershipDate?: Maybe<Scalars['Date']>,
  VehicleRegistrationVerified?: Maybe<Scalars['String']>,
};

export type VerifyItemV22_Nicn = {
  __typename?: 'VerifyItemV22_nicn',
  Addresses?: Maybe<Addresses_Nicn>,
  DateofBirth?: Maybe<Scalars['Date']>,
  DateofBirthVerified?: Maybe<Scalars['String']>,
  FirstNameVerified?: Maybe<Scalars['String']>,
  FullName?: Maybe<Scalars['String']>,
  Gender?: Maybe<Scalars['String']>,
  IDCardNo?: Maybe<Scalars['String']>,
  IDCardNoValid?: Maybe<Scalars['String']>,
  LastNameVerified?: Maybe<Scalars['String']>,
  LastOdometerReading?: Maybe<Scalars['String']>,
  LastOdometerReadingDate?: Maybe<Scalars['Date']>,
  LastReviewed?: Maybe<Scalars['Date']>,
  LicenseNoVerified?: Maybe<Scalars['String']>,
  MiddleNameVerified?: Maybe<Scalars['String']>,
  PassportExpiry?: Maybe<Scalars['Date']>,
  SourceVerified?: Maybe<Scalars['String']>,
  VehicleOwnershipDate?: Maybe<Scalars['Date']>,
  VehicleRegistrationVerified?: Maybe<Scalars['String']>,
};

export type VerifyItemV22_Ppnz = {
  __typename?: 'VerifyItemV22_ppnz',
  Addresses?: Maybe<Addresses_Ppnz>,
  DateofBirth?: Maybe<Scalars['Date']>,
  DateofBirthVerified?: Maybe<Scalars['String']>,
  FirstNameVerified?: Maybe<Scalars['String']>,
  FullName?: Maybe<Scalars['String']>,
  Gender?: Maybe<Scalars['String']>,
  IDCardNo?: Maybe<Scalars['String']>,
  IDCardNoValid?: Maybe<Scalars['String']>,
  LastNameVerified?: Maybe<Scalars['String']>,
  LastOdometerReading?: Maybe<Scalars['String']>,
  LastOdometerReadingDate?: Maybe<Scalars['Date']>,
  LastReviewed?: Maybe<Scalars['Date']>,
  LicenseNoVerified?: Maybe<Scalars['String']>,
  MiddleNameVerified?: Maybe<Scalars['String']>,
  PassportExpiry?: Maybe<Scalars['Date']>,
  SourceVerified?: Maybe<Scalars['String']>,
  VehicleOwnershipDate?: Maybe<Scalars['Date']>,
  VehicleRegistrationVerified?: Maybe<Scalars['String']>,
};

export type VerifyMobileResponse = {
  __typename?: 'VerifyMobileResponse',
  channel: Scalars['String'],
  error: Scalars['Boolean'],
  serviceSid: Scalars['String'],
  status: Scalars['String'],
  to: Scalars['String'],
};

export type VerifyResultV22_Dlnz = {
  __typename?: 'VerifyResultV22_dlnz',
  DataSource?: Maybe<Scalars['String']>,
  Item?: Maybe<Item_Dlnz>,
  Status?: Maybe<Scalars['String']>,
  safe_harbour_score?: Maybe<Scalars['String']>,
};

export type VerifyResultV22_Nicn = {
  __typename?: 'VerifyResultV22_nicn',
  DataSource?: Maybe<Scalars['String']>,
  Item?: Maybe<Item_Nicn>,
  Status?: Maybe<Scalars['String']>,
  safe_harbour_score?: Maybe<Scalars['String']>,
};

export type VerifyResultV22_Ppnz = {
  __typename?: 'VerifyResultV22_ppnz',
  DataSource?: Maybe<Scalars['String']>,
  Item?: Maybe<Item>,
  Status?: Maybe<Scalars['String']>,
  safe_harbour_score?: Maybe<Scalars['String']>,
};

export type Zone_Type = {
  __typename?: 'zone_type',
  description: Scalars['String'],
  value: Scalars['String'],
};

export type Zone_Type_Aggregate = {
  __typename?: 'zone_type_aggregate',
  aggregate?: Maybe<Zone_Type_Aggregate_Fields>,
  nodes: Array<Zone_Type>,
};

export type Zone_Type_Aggregate_Fields = {
  __typename?: 'zone_type_aggregate_fields',
  count?: Maybe<Scalars['Int']>,
  max?: Maybe<Zone_Type_Max_Fields>,
  min?: Maybe<Zone_Type_Min_Fields>,
};


export type Zone_Type_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Zone_Type_Select_Column>>,
  distinct?: Maybe<Scalars['Boolean']>
};

export type Zone_Type_Aggregate_Order_By = {
  count?: Maybe<Order_By>,
  max?: Maybe<Zone_Type_Max_Order_By>,
  min?: Maybe<Zone_Type_Min_Order_By>,
};

export type Zone_Type_Arr_Rel_Insert_Input = {
  data: Array<Zone_Type_Insert_Input>,
  on_conflict?: Maybe<Zone_Type_On_Conflict>,
};

export type Zone_Type_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Zone_Type_Bool_Exp>>>,
  _not?: Maybe<Zone_Type_Bool_Exp>,
  _or?: Maybe<Array<Maybe<Zone_Type_Bool_Exp>>>,
  description?: Maybe<String_Comparison_Exp>,
  value?: Maybe<String_Comparison_Exp>,
};

export enum Zone_Type_Constraint {
  ZoneTypePkey = 'zone_type_pkey'
}

export enum Zone_Type_Enum {
  Zone_1 = 'ZONE_1',
  Zone_2 = 'ZONE_2'
}

export type Zone_Type_Enum_Comparison_Exp = {
  _eq?: Maybe<Zone_Type_Enum>,
  _in?: Maybe<Array<Zone_Type_Enum>>,
  _is_null?: Maybe<Scalars['Boolean']>,
  _neq?: Maybe<Zone_Type_Enum>,
  _nin?: Maybe<Array<Zone_Type_Enum>>,
};

export type Zone_Type_Insert_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Zone_Type_Max_Fields = {
  __typename?: 'zone_type_max_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Zone_Type_Max_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Zone_Type_Min_Fields = {
  __typename?: 'zone_type_min_fields',
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export type Zone_Type_Min_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Zone_Type_Mutation_Response = {
  __typename?: 'zone_type_mutation_response',
  affected_rows: Scalars['Int'],
  returning: Array<Zone_Type>,
};

export type Zone_Type_Obj_Rel_Insert_Input = {
  data: Zone_Type_Insert_Input,
  on_conflict?: Maybe<Zone_Type_On_Conflict>,
};

export type Zone_Type_On_Conflict = {
  constraint: Zone_Type_Constraint,
  update_columns: Array<Zone_Type_Update_Column>,
  where?: Maybe<Zone_Type_Bool_Exp>,
};

export type Zone_Type_Order_By = {
  description?: Maybe<Order_By>,
  value?: Maybe<Order_By>,
};

export type Zone_Type_Pk_Columns_Input = {
  value: Scalars['String'],
};

export enum Zone_Type_Select_Column {
  Description = 'description',
  Value = 'value'
}

export type Zone_Type_Set_Input = {
  description?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>,
};

export enum Zone_Type_Update_Column {
  Description = 'description',
  Value = 'value'
}

/** 
 * One possible value for a given Enum. Enum values are unique values, not a
 * placeholder for a string or numeric value. However an Enum value is returned in
 * a JSON response as a string.
 **/
export type __EnumValue = {
  __typename?: '__EnumValue',
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  isDeprecated: Scalars['Boolean'],
  deprecationReason?: Maybe<Scalars['String']>,
};

/** 
 * Object and Interface types are described by a list of Fields, each of which has
 * a name, potentially a list of arguments, and a return type.
 **/
export type __Field = {
  __typename?: '__Field',
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  args: Array<__InputValue>,
  type: __Type,
  isDeprecated: Scalars['Boolean'],
  deprecationReason?: Maybe<Scalars['String']>,
};

/** 
 * Arguments provided to Fields or Directives and the input fields of an
 * InputObject are represented as Input Values which describe their type and
 * optionally a default value.
 **/
export type __InputValue = {
  __typename?: '__InputValue',
  name: Scalars['String'],
  description?: Maybe<Scalars['String']>,
  type: __Type,
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']>,
};

/** 
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 * 
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 **/
export type __Type = {
  __typename?: '__Type',
  kind: __TypeKind,
  name?: Maybe<Scalars['String']>,
  description?: Maybe<Scalars['String']>,
  fields?: Maybe<Array<__Field>>,
  interfaces?: Maybe<Array<__Type>>,
  possibleTypes?: Maybe<Array<__Type>>,
  enumValues?: Maybe<Array<__EnumValue>>,
  inputFields?: Maybe<Array<__InputValue>>,
  ofType?: Maybe<__Type>,
};


/** 
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 * 
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 **/
export type __TypeFieldsArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>
};


/** 
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of
 * types in GraphQL as represented by the `__TypeKind` enum.
 * 
 * Depending on the kind of a type, certain fields describe information about that
 * type. Scalar types provide no information beyond a name and description, while
 * Enum types provide their values. Object and Interface types provide the fields
 * they describe. Abstract types, Union and Interface, provide the Object types
 * possible at runtime. List and NonNull types compose other types.
 **/
export type __TypeEnumValuesArgs = {
  includeDeprecated?: Maybe<Scalars['Boolean']>
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields` and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}
export type GetDocumentsSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetDocumentsSubscription = ({ __typename?: 'subscription_root' } & { listing_document: Array<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'id' | 'type' | 'url' | 'description' | 'status' | 'created_at'>)> });

export type SetDocumentStatusMutationVariables = {
  documentId: Listing_Document_Pk_Columns_Input,
  newStatus: Listing_Document_Status_Enum,
  desc?: Maybe<Scalars['String']>
};


export type SetDocumentStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing_document_by_pk: Maybe<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'id' | 'status' | 'description'>)> });

export type SetDocumentSubmissionStatusMutationVariables = {
  listingId: Listing_Pk_Columns_Input,
  newStatus: Listing_Document_Status_Enum
};


export type SetDocumentSubmissionStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'proof_of_ownership_status'>)> });

export type DeclineDocumentSubmissionMutationVariables = {
  listingId: Scalars['uuid'],
  declineReason: Scalars['jsonb']
};


export type DeclineDocumentSubmissionMutation = ({ __typename?: 'mutation_root' } & { update_listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'proof_of_ownership_status'>)>, insert_listing_event_one: Maybe<({ __typename?: 'listing_event' } & Pick<Listing_Event, 'id'>)> });

export type GetDocumentSubmissionDateSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetDocumentSubmissionDateSubscription = ({ __typename?: 'subscription_root' } & { listing_event: Array<({ __typename?: 'listing_event' } & Pick<Listing_Event, 'created_at' | 'listingId'>)> });

export type PublishStatusAndErrorsSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type PublishStatusAndErrorsSubscription = ({ __typename?: 'subscription_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'commercial_status' | 'publishing_status' | 'owner_id'> & { listing_publish_statuses: Array<({ __typename?: 'listing_publish_status' } & Pick<Listing_Publish_Status, 'id' | 'portal_source' | 'portal_source_id' | 'publish_status' | 'request' | 'response' | 'updated_at' | 'test_xml' | 'test_xml_name' | 'xml_file_name' | 'current_portal_status' | 'enabled'>)>, listing_publish_errors: Array<({ __typename?: 'listing_publish_errors' } & Pick<Listing_Publish_Errors, 'id' | 'error_field' | 'error_message' | 'portal_source' | 'agent_id' | 'updated_at'>)> })> });

export type UpdatePortalPublishStatusMutationVariables = {
  listingId: Scalars['uuid'],
  portalSource: Listing_Publish_Portal_Source_Enum,
  status: Listing_Publish_Status_Type_Enum,
  isTest?: Maybe<Scalars['Boolean']>
};


export type UpdatePortalPublishStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing_publish_status: Maybe<({ __typename?: 'listing_publish_status_mutation_response' } & Pick<Listing_Publish_Status_Mutation_Response, 'affected_rows'>)> });

export type UpdatePortalCustomStatusMutationVariables = {
  listingId: Scalars['uuid'],
  portalSource: Listing_Publish_Portal_Source_Enum,
  input?: Maybe<Listing_Publish_Status_Set_Input>
};


export type UpdatePortalCustomStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing_publish_status: Maybe<({ __typename?: 'listing_publish_status_mutation_response' } & Pick<Listing_Publish_Status_Mutation_Response, 'affected_rows'>)> });

export type EnableDisablePortalMutationVariables = {
  listingId: Scalars['uuid'],
  portalSource: Listing_Publish_Portal_Source_Enum,
  enabled: Scalars['Boolean']
};


export type EnableDisablePortalMutation = ({ __typename?: 'mutation_root' } & { update_listing_publish_status: Maybe<({ __typename?: 'listing_publish_status_mutation_response' } & Pick<Listing_Publish_Status_Mutation_Response, 'affected_rows'>)> });

export type ResetPortalCustomStatusMutationVariables = {
  listingId: Scalars['uuid'],
  portalSource?: Maybe<Listing_Publish_Portal_Source_Enum>
};


export type ResetPortalCustomStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing_publish_status: Maybe<({ __typename?: 'listing_publish_status_mutation_response' } & Pick<Listing_Publish_Status_Mutation_Response, 'affected_rows'>)> });

export type GetListingAndUserInfoSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetListingAndUserInfoSubscription = ({ __typename?: 'subscription_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'enquiry_code' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_street' | 'propertyDetails_address_suburb' | 'propertyDetails_address_state' | 'propertyDetails_address_postcode' | 'propertyDetails_address_suggestedGeoLocation_latitude' | 'propertyDetails_address_suggestedGeoLocation_longitude' | 'propertyDetails_address_displayOption' | 'propertyDetails_bathRooms' | 'propertyDetails_bedRooms' | 'propertyDetails_carSpaces' | 'propertyDetails_energyEfficiencyRating' | 'propertyDetails_landArea_value' | 'propertyDetails_landArea_unit' | 'propertyDetails_area_value' | 'propertyDetails_area_unit' | 'features' | 'propertyDetails_propertyType' | 'saleType' | 'updated_at' | 'price_asking' | 'price_single' | 'price_from' | 'price_to' | 'price_displayText' | 'price_textOption' | 'price_displayOption' | 'commercial_status' | 'proof_of_ownership_status' | 'owner_id' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces'> & { user: ({ __typename?: 'user' } & Pick<User, 'first_name' | 'last_name' | 'email' | 'email_verified' | 'phone_number' | 'phone_number_verified' | 'created_at'>), listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'type' | 'url'>)>, listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'skipped' | 'finished'>)>, declined_events: Array<({ __typename?: 'listing_event' } & Pick<Listing_Event, 'event_type' | 'event_data' | 'created_at'> & { user: ({ __typename?: 'user' } & Pick<User, 'first_name' | 'last_name' | 'email' | 'phone_number'>) })> })> });

export type GetListingMediaForPhotosQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingMediaForPhotosQuery = ({ __typename?: 'query_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'order' | 'attachment_id' | 'type' | 'thumbnail_185' | 'thumbnail_370' | 'thumbnail_555'>)> });

export type ReplaceStockPhotoMutationVariables = {
  listingId: Scalars['uuid'],
  stockPhotoUrl: Scalars['String'],
  thumbnail_185?: Maybe<Scalars['String']>,
  thumbnail_284?: Maybe<Scalars['String']>,
  thumbnail_370?: Maybe<Scalars['String']>,
  thumbnail_555?: Maybe<Scalars['String']>,
  thumbnail_568?: Maybe<Scalars['String']>,
  thumbnail_606?: Maybe<Scalars['String']>,
  thumbnail_852?: Maybe<Scalars['String']>,
  thumbnail_1212?: Maybe<Scalars['String']>,
  thumbnail_1818?: Maybe<Scalars['String']>
};


export type ReplaceStockPhotoMutation = ({ __typename?: 'mutation_root' } & { delete_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'>)>, insert_listing_media_one: Maybe<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'>)> });

export type GetStockPhotosQueryVariables = {};


export type GetStockPhotosQuery = ({ __typename?: 'query_root' } & { stock_photo: Array<({ __typename?: 'stock_photo' } & Pick<Stock_Photo, 'url' | 'thumbnail_185' | 'thumbnail_284' | 'thumbnail_370' | 'thumbnail_555' | 'thumbnail_568' | 'thumbnail_606' | 'thumbnail_852' | 'thumbnail_1212' | 'thumbnail_1818'>)> });

export type ProofOfOwnershipStatusSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type ProofOfOwnershipStatusSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'proof_of_ownership_status'>)> });

export type ListingDocumentsSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type ListingDocumentsSubscription = ({ __typename?: 'subscription_root' } & { listing_document: Array<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'type'>)> });

export type CountDocDeclineEventsQueryVariables = {
  listingId: Scalars['uuid']
};


export type CountDocDeclineEventsQuery = ({ __typename?: 'query_root' } & { listing_event_aggregate: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }) });

export type ListingMediaCountSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type ListingMediaCountSubscription = ({ __typename?: 'subscription_root' } & { listing_media_aggregate: ({ __typename?: 'listing_media_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_media_aggregate_fields' } & Pick<Listing_Media_Aggregate_Fields, 'count'>)> }) });

export type GetListingPreviewByIdSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetListingPreviewByIdSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'propertyDetails_area_value' | 'propertyDetails_area_unit' | 'propertyDetails_bathRooms' | 'propertyDetails_bedRooms' | 'propertyDetails_carSpaces' | 'propertyDetails_propertyType' | 'propertyDetails_landArea_value' | 'propertyDetails_landArea_unit' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_1' | 'propertyDetails_address_2' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_street' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_postcode' | 'saleType' | 'price_displayText' | 'price_textOption' | 'price_displayOption' | 'price_single' | 'price_from' | 'price_to' | 'price_asking' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating'>)> });

export type ListingPreviewModelQueryVariables = {
  listingId: Scalars['uuid']
};


export type ListingPreviewModelQuery = ({ __typename?: 'query_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'enquiry_code' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_suburb' | 'propertyDetails_address_state' | 'propertyDetails_address_postcode' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_street' | 'propertyDetails_address_1' | 'propertyDetails_address_2' | 'propertyDetails_bedRooms' | 'propertyDetails_bathRooms' | 'propertyDetails_carSpaces' | 'commercial_status' | 'publishing_status' | 'saleType' | 'owner_id' | 'propertyDetails_propertyType' | 'propertyDetails_landArea_value' | 'propertyDetails_landArea_unit' | 'propertyDetails_area_value' | 'propertyDetails_area_unit' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating' | 'price_asking' | 'price_single' | 'price_from' | 'price_to' | 'price_displayText' | 'price_displayOption' | 'price_textOption'> & { listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'finished' | 'skipped'>)>, listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'thumbnail_284' | 'thumbnail_568' | 'thumbnail_852'>)> })> });

export type GetListingPhotosSubSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetListingPhotosSubSubscription = ({ __typename?: 'subscription_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'order' | 'thumbnail_606' | 'thumbnail_1212' | 'thumbnail_1818'>)> });

export type PropertyPriceModelQueryVariables = {
  listingId: Scalars['uuid']
};


export type PropertyPriceModelQuery = ({ __typename?: 'query_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'price_asking' | 'price_single' | 'price_from' | 'price_to' | 'price_displayText' | 'price_textOption' | 'price_displayOption' | 'saleType' | 'propertyDetails_address_state'>)> });

export type PhotosForPreviewSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type PhotosForPreviewSubscription = ({ __typename?: 'subscription_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'thumbnail_185' | 'thumbnail_370' | 'thumbnail_555'>)> });

export type GetAddressDetailsQueryVariables = {
  addressId: Scalars['String']
};


export type GetAddressDetailsQuery = ({ __typename?: 'query_root' } & { get_address_detail: Maybe<({ __typename?: 'address_detail' } & Pick<Address_Detail, 'id' | 'address_line_1' | 'address_line_2' | 'box_identifier' | 'box_type' | 'canonical_address' | 'canonical_address_id' | 'dpid' | 'full_address' | 'gnaf_id' | 'latitude' | 'legal_parcel_id' | 'level_number' | 'level_type' | 'locality_name' | 'longitude' | 'lot_identifier' | 'meshblock' | 'meshblock_2016' | 'postcode' | 'primary_point_indicator' | 'sa1_id' | 'sa2_id' | 'site_name' | 'state_territory' | 'street' | 'street_name' | 'street_number_1' | 'street_number_2' | 'street_suffix' | 'street_type' | 'success' | 'unit_identifier' | 'unit_type'>)> });

export type GetAutoCompleteQueryVariables = {
  addressInput: Scalars['String']
};


export type GetAutoCompleteQuery = ({ __typename?: 'query_root' } & { address_auto_complete: Maybe<({ __typename?: 'address_auto_complete_group' } & { completions: Maybe<Array<Maybe<({ __typename?: 'address_auto_complete' } & Pick<Address_Auto_Complete, 'id' | 'canonical_address_id' | 'full_address' | 'highlighted_full_address'>)>>> })> });

export type GetLocationAutoCompleteQueryVariables = {
  locationInput: Scalars['String'],
  locationType: Scalars['String']
};


export type GetLocationAutoCompleteQuery = ({ __typename?: 'query_root' } & { location_auto_complete: Maybe<({ __typename?: 'location_auto_complete_group' } & { completions: Maybe<Array<Maybe<({ __typename?: 'location_auto_complete' } & Pick<Location_Auto_Complete, 'full_location' | 'id' | 'location_type' | 'state_territory'>)>>> })> });

export type SignUpMutationVariables = {
  email: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  password: Scalars['String'],
  utmCampaign?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmSource?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  submittedVia?: Maybe<Scalars['String']>,
  gaClientId?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>
};


export type SignUpMutation = ({ __typename?: 'mutation_root' } & { sign_up: Maybe<({ __typename?: 'signup_auth_response' } & Pick<Signup_Auth_Response, 'jwt' | 'redirectUrl'>)> });

export type SetPasswordMutationVariables = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type SetPasswordMutation = ({ __typename?: 'mutation_root' } & { set_password: Maybe<({ __typename?: 'auth_response' } & Pick<Auth_Response, 'jwt'>)> });

export type ResetPasswordMutationVariables = {
  password: Scalars['String'],
  verifyToken: Scalars['String']
};


export type ResetPasswordMutation = ({ __typename?: 'mutation_root' } & { reset_password: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error'>)> });

export type VerifyUserEmailMutationVariables = {
  hash: Scalars['String']
};


export type VerifyUserEmailMutation = ({ __typename?: 'mutation_root' } & { verify_user_email: Maybe<({ __typename?: 'json_response' } & Pick<Json_Response, 'success' | 'message' | 'data'>)> });

export type MobileVerificationQueryVariables = {
  mobileNumber: Scalars['String'],
  type: Scalars['String'],
  channel: Scalars['String']
};


export type MobileVerificationQuery = ({ __typename?: 'query_root' } & { verify_mobile_number: Maybe<({ __typename?: 'VerifyMobileResponse' } & Pick<VerifyMobileResponse, 'serviceSid' | 'status' | 'to' | 'channel' | 'error'>)> });

export type CodeVerificationQueryVariables = {
  mobileNumber: Scalars['String'],
  code: Scalars['String'],
  verificationSid: Scalars['String']
};


export type CodeVerificationQuery = ({ __typename?: 'query_root' } & { mobile_code_verification: Maybe<({ __typename?: 'mobileCodeVerification' } & Pick<MobileCodeVerification, 'status' | 'error' | 'jwt'>)> });

export type SendEmailQueryVariables = {
  email: Scalars['String'],
  type: Scalars['String']
};


export type SendEmailQuery = ({ __typename?: 'query_root' } & { send_email: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error'>)> });

export type SignInQueryVariables = {
  email: Scalars['String'],
  password: Scalars['String'],
  rememberLogin: Scalars['Boolean']
};


export type SignInQuery = ({ __typename?: 'query_root' } & { sign_in: Maybe<({ __typename?: 'auth_response' } & Pick<Auth_Response, 'jwt'>)> });

export type ImpersonateSignInQueryVariables = {
  userId: Scalars['uuid']
};


export type ImpersonateSignInQuery = ({ __typename?: 'query_root' } & { impersonate_sign_in: Maybe<({ __typename?: 'auth_response' } & Pick<Auth_Response, 'jwt'>)> });

export type ImpersonateSignOutQueryVariables = {};


export type ImpersonateSignOutQuery = ({ __typename?: 'query_root' } & { impersonate_logout: Maybe<({ __typename?: 'auth_response' } & Pick<Auth_Response, 'jwt'>)> });

export type GetGoogleAuthUrlQueryVariables = {
  webAppUrl: Scalars['String']
};


export type GetGoogleAuthUrlQuery = ({ __typename?: 'query_root' } & { google_auth_url: Maybe<({ __typename?: 'google_auth_url_response' } & Pick<Google_Auth_Url_Response, 'url' | 'error'>)> });

export type ResendEmailVerificationLinkQueryVariables = {
  redirectUrl?: Maybe<Scalars['String']>
};


export type ResendEmailVerificationLinkQuery = ({ __typename?: 'query_root' } & { resend_email_verification_link: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error'>)> });

export type VerifyHashQueryVariables = {
  hash: Scalars['String']
};


export type VerifyHashQuery = ({ __typename?: 'query_root' } & { verify_hash: Maybe<({ __typename?: 'json_response' } & Pick<Json_Response, 'success' | 'message' | 'data'>)> });

export type UpdateUserUtmParamsMutationVariables = {
  userId: Scalars['uuid'],
  utmCampaign?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmSource?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  submittedVia?: Maybe<Scalars['String']>,
  gclid?: Maybe<Scalars['String']>
};


export type UpdateUserUtmParamsMutation = ({ __typename?: 'mutation_root' } & { update: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)>, update_submittedvia: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)>, update_gclid: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)> });

export type UpdateGaClientIdMutationVariables = {
  userId: Scalars['uuid'],
  gaClientId?: Maybe<Scalars['String']>
};


export type UpdateGaClientIdMutation = ({ __typename?: 'mutation_root' } & { update_ga_client_id: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)> });

export type UpdateUserPasswordPhoneNumberMutationVariables = {
  userId: Scalars['String'],
  mobileNumber: Scalars['String'],
  password: Scalars['String']
};


export type UpdateUserPasswordPhoneNumberMutation = ({ __typename?: 'mutation_root' } & { update_user_password_phone: Maybe<({ __typename?: 'Update_User_Password_Phone_Response' } & Pick<Update_User_Password_Phone_Response, 'message'>)> });

export type GetSellingPointsByCampaignIdQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetSellingPointsByCampaignIdQuery = ({ __typename?: 'query_root' } & { selling_point: Array<({ __typename?: 'selling_point' } & Pick<Selling_Point, 'name' | 'description' | 'image'>)>, campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'name'>)> });

export type GetCampaignsSubSubscriptionVariables = {};


export type GetCampaignsSubSubscription = ({ __typename?: 'subscription_root' } & { campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'desc' | 'price'>)> });

export type GetCampaignsQueryVariables = {
  campaignCodes?: Maybe<Array<Scalars['String']>>
};


export type GetCampaignsQuery = ({ __typename?: 'query_root' } & { campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'desc' | 'price' | 'code'>)> });

export type CreateCampaignMutationVariables = {
  id: Scalars['uuid'],
  name: Scalars['String'],
  price: Scalars['Int'],
  desc?: Maybe<Scalars['String']>,
  priceDescription?: Maybe<Scalars['String']>,
  type?: Maybe<Scalars['String']>,
  order: Scalars['Int'],
  code: Scalars['String'],
  image: Scalars['String']
};


export type CreateCampaignMutation = ({ __typename?: 'mutation_root' } & { insert_campaign: Maybe<({ __typename?: 'campaign_mutation_response' } & { returning: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'id'>)> })> });

export type DeleteCampaignMutationVariables = {
  campaignId: Scalars['uuid']
};


export type DeleteCampaignMutation = ({ __typename?: 'mutation_root' } & { delete_campaign: Maybe<({ __typename?: 'campaign_mutation_response' } & Pick<Campaign_Mutation_Response, 'affected_rows'>)> });

export type GetCampaignAddonGroupQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetCampaignAddonGroupQuery = ({ __typename?: 'query_root' } & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'desc' | 'price'>)>, addonGroups: Array<({ __typename?: 'campaign_addon_group' } & { addon_group: ({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'order' | 'title' | 'subtitle' | 'type' | 'short_title'> & { addons: Array<({ __typename?: 'addon_addon_group' } & { addon: ({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'type' | 'group_order' | 'default_status' | 'image' | 'price' | 'min_qty' | 'max_qty' | 'front_desc_small_screen' | 'front_desc_large_screen' | 'back_desc_small_screen' | 'back_desc_large_screen' | 'recommended_flag'>) })> }) })> });

export type GetAddonGroupsByCampaignIdQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetAddonGroupsByCampaignIdQuery = ({ __typename?: 'query_root' } & { addonGroups: Array<({ __typename?: 'campaign_addon_group' } & Pick<Campaign_Addon_Group, 'id' | 'addon_group_id'>)> });

export type GetAllCampaignInclusionsQueryVariables = {};


export type GetAllCampaignInclusionsQuery = ({ __typename?: 'query_root' } & { campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'type' | 'desc' | 'price' | 'price_description' | 'id' | 'code' | 'name' | 'image' | 'image_nonprimary_hero_apartment' | 'image_nonprimary_hero_house' | 'image_nonprimary_hero_land' | 'image_nonprimary_hero_townhouse' | 'image_nonprimary_hero_unit'> & { campaign_inclusion_groups: Array<({ __typename?: 'campaign_inclusion_group' } & { inclusion_group: ({ __typename?: 'inclusion_group' } & { inclusions: Array<({ __typename?: 'inclusion' } & Pick<Inclusion, 'name' | 'description' | 'order' | 'metro' | 'zone'>)> }) })> })> });

export type GetAllCampaignNoInclusionsQueryVariables = {};


export type GetAllCampaignNoInclusionsQuery = ({ __typename?: 'query_root' } & { campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'type' | 'desc' | 'price' | 'price_description' | 'id' | 'code' | 'name' | 'image' | 'image_nonprimary_hero_apartment' | 'image_nonprimary_hero_house' | 'image_nonprimary_hero_land' | 'image_nonprimary_hero_townhouse' | 'image_nonprimary_hero_unit'>)> });

export type GetInclusionsByCampaignIdQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetInclusionsByCampaignIdQuery = ({ __typename?: 'query_root' } & { campaign_inclusion_group: Array<({ __typename?: 'campaign_inclusion_group' } & { inclusion_group: ({ __typename?: 'inclusion_group' } & Pick<Inclusion_Group, 'name'> & { inclusions: Array<({ __typename?: 'inclusion' } & Pick<Inclusion, 'name' | 'description' | 'metro' | 'zone'> & { inclusion_addons: Array<({ __typename?: 'inclusion_addon' } & { addon: ({ __typename?: 'addon' } & Pick<Addon, 'id' | 'min_qty' | 'type'>) })> })> }) })> });

export type GetAddonsByAddonGroupIdQueryVariables = {
  addonGroupId: Scalars['uuid']
};


export type GetAddonsByAddonGroupIdQuery = ({ __typename?: 'query_root' } & { addon_group: Array<({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'title' | 'subtitle' | 'type' | 'short_title'> & { addon_addon_groups: Array<({ __typename?: 'addon_addon_group' } & { addon: ({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'type' | 'default_status' | 'image' | 'price' | 'min_qty' | 'max_qty' | 'front_desc_small_screen' | 'front_desc_large_screen' | 'back_desc_small_screen' | 'back_desc_large_screen' | 'recommended_flag'> & { benefits: Array<({ __typename?: 'benefit' } & Pick<Benefit, 'id' | 'description'>)> }) })> })> });

export type GetCampaignByIdQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetCampaignByIdQuery = ({ __typename?: 'query_root' } & { campaign_by_pk: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'desc' | 'price' | 'price_description' | 'type' | 'code' | 'image' | 'image_primary_hero_house' | 'image_primary_hero_land' | 'image_primary_hero_townhouse' | 'image_primary_hero_apartment' | 'image_primary_hero_unit' | 'image_primary_overlay_house' | 'image_primary_overlay_land' | 'image_primary_overlay_townhouse' | 'image_primary_overlay_apartment' | 'image_primary_overlay_unit'>)> });

export type GetAddonGroupByIdQueryVariables = {
  addonGroupId: Scalars['uuid']
};


export type GetAddonGroupByIdQuery = ({ __typename?: 'query_root' } & { addon_group: Maybe<({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'title' | 'subtitle' | 'short_title' | 'order' | 'type'> & { addons: Array<({ __typename?: 'addon_addon_group' } & { addon: ({ __typename?: 'addon' } & Pick<Addon, 'id' | 'image' | 'max_qty' | 'min_qty' | 'name' | 'price' | 'type' | 'recommended_flag' | 'group_order' | 'front_desc_small_screen' | 'front_desc_large_screen' | 'default_status' | 'back_desc_small_screen' | 'back_desc_large_screen' | 'absolute_order' | 'exclusion_group'> & { benefits: Array<({ __typename?: 'benefit' } & Pick<Benefit, 'id' | 'description' | 'order'>)> }) })> })> });

export type GetCampaignAddonsQueryVariables = {
  campaignId: Scalars['uuid']
};


export type GetCampaignAddonsQuery = ({ __typename?: 'query_root' } & { addon: Array<({ __typename?: 'addon' } & Pick<Addon, 'id'>)> });

export type GetRecommendedCampaignsByListingQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetRecommendedCampaignsByListingQuery = ({ __typename?: 'query_root' } & { recommended_campaigns: Maybe<Array<Maybe<({ __typename?: 'RecommendedCampaignOutput' } & Pick<RecommendedCampaignOutput, 'index' | 'campaign_code'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'code' | 'name' | 'price'>)> })>>> });

export type GetRecommendedAddonsByCampaignCodeQueryVariables = {
  campaign_code: Scalars['String'],
  listingId: Scalars['uuid']
};


export type GetRecommendedAddonsByCampaignCodeQuery = ({ __typename?: 'query_root' } & { recommended_addons: Maybe<Array<Maybe<({ __typename?: 'RecommendedAddonOutput' } & Pick<RecommendedAddonOutput, 'addon_code' | 'index' | 'use_special_price' | 'special_price'> & { addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'image' | 'max_qty' | 'min_qty' | 'name' | 'price' | 'type' | 'recommended_flag' | 'group_order' | 'front_desc_small_screen' | 'front_desc_large_screen' | 'default_status' | 'back_desc_small_screen' | 'back_desc_large_screen' | 'absolute_order' | 'exclusion_group' | 'is_one_time_purchase' | 'code'> & { benefits: Array<({ __typename?: 'benefit' } & Pick<Benefit, 'id' | 'description' | 'order'>)> })> })>>> });

export type GetAddonGroupsByAddonCodeQueryVariables = {
  campaign_id: Scalars['uuid'],
  addon_codes?: Maybe<Array<Scalars['String']>>
};


export type GetAddonGroupsByAddonCodeQuery = ({ __typename?: 'query_root' } & { addon_group: Array<({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'title' | 'subtitle' | 'short_title' | 'order' | 'type'> & { addons: Array<({ __typename?: 'addon_addon_group' } & { addon: ({ __typename?: 'addon' } & Pick<Addon, 'id' | 'image' | 'max_qty' | 'min_qty' | 'name' | 'price' | 'type' | 'recommended_flag' | 'group_order' | 'front_desc_small_screen' | 'front_desc_large_screen' | 'default_status' | 'back_desc_small_screen' | 'back_desc_large_screen' | 'absolute_order' | 'exclusion_group' | 'is_one_time_purchase' | 'code'> & { benefits: Array<({ __typename?: 'benefit' } & Pick<Benefit, 'id' | 'description' | 'order'>)> }) })> })> });

export type GetListingAdvisorContextQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingAdvisorContextQuery = ({ __typename?: 'query_root' } & { get_listing_advisor_context: Maybe<({ __typename?: 'listing_advisor_context_response' } & Pick<Listing_Advisor_Context_Response, 'zone' | 'metro'>)> });

export type GetBasicRecommendedAddonsByCampaignCodeQueryVariables = {
  campaign_code: Scalars['String'],
  listingId: Scalars['uuid']
};


export type GetBasicRecommendedAddonsByCampaignCodeQuery = ({ __typename?: 'query_root' } & { recommended_addons: Maybe<Array<Maybe<({ __typename?: 'RecommendedAddonOutput' } & Pick<RecommendedAddonOutput, 'addon_code' | 'use_special_price' | 'special_price'> & { addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'price' | 'type' | 'min_qty'>)> })>>> });

export type GetCampaignByCodeQueryVariables = {
  code: Scalars['String']
};


export type GetCampaignByCodeQuery = ({ __typename?: 'query_root' } & { campaign: Array<({ __typename?: 'campaign' } & Pick<Campaign, 'id'>)> });

export type GetListingSaleTypeQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingSaleTypeQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'saleType'>)> });

export type GetAddonByIdQueryVariables = {
  addOnId: Scalars['uuid']
};


export type GetAddonByIdQuery = ({ __typename?: 'query_root' } & { addon_by_pk: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'price' | 'image' | 'code'>)> });

export type ApplyCouponMutationVariables = {
  couponCode: Scalars['String'],
  orderId: Scalars['uuid']
};


export type ApplyCouponMutation = ({ __typename?: 'mutation_root' } & { apply_coupon: Maybe<({ __typename?: 'coupon_update_order_response' } & Pick<Coupon_Update_Order_Response, 'updated'>)> });

export type RecalculateCouponDiscountMutationVariables = {
  orderId: Scalars['uuid']
};


export type RecalculateCouponDiscountMutation = ({ __typename?: 'mutation_root' } & { recalculate_coupon_discounts_order: Maybe<({ __typename?: 'coupon_update_order_response' } & Pick<Coupon_Update_Order_Response, 'updated'>)> });

export type RecalculateCouponDiscountListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type RecalculateCouponDiscountListingMutation = ({ __typename?: 'mutation_root' } & { recalculate_coupon_discounts_listing: Maybe<({ __typename?: 'coupon_update_order_response' } & Pick<Coupon_Update_Order_Response, 'updated'>)> });

export type DeleteCouponMutationVariables = {
  couponId: Scalars['uuid']
};


export type DeleteCouponMutation = ({ __typename?: 'mutation_root' } & { delete_coupon: Maybe<({ __typename?: 'coupon_mutation_response' } & Pick<Coupon_Mutation_Response, 'affected_rows'>)> });

export type GetUserFirstNameQueryVariables = {
  userId: Scalars['uuid']
};


export type GetUserFirstNameQuery = ({ __typename?: 'query_root' } & { user: Array<({ __typename?: 'user' } & Pick<User, 'first_name'>)> });

export type GetListingAddressAndDetailsQueryVariables = {
  id: Scalars['uuid']
};


export type GetListingAddressAndDetailsQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'propertyDetails_address_postcode' | 'propertyDetails_address_state' | 'propertyDetails_address_street' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_suburb' | 'propertyDetails_address_displayOption' | 'saleType' | 'propertyDetails_propertyType' | 'propertyDetails_bathRooms' | 'propertyDetails_bedRooms' | 'availableFrom' | 'propertyDetails_landArea_unit' | 'propertyDetails_landArea_value' | 'propertyDetails_area_unit' | 'propertyDetails_area_value' | 'propertyDetails_carSpaces' | 'propertyDetails_yearBuilt' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating'>)> });

export type GetEntityFeldsQueryVariables = {
  typeName: Scalars['String']
};


export type GetEntityFeldsQuery = ({ __typename?: 'query_root' } & { __type: Maybe<({ __typename?: '__Type' } & { fields: Maybe<Array<({ __typename?: '__Field' } & Pick<__Field, 'name' | 'description'> & { type: ({ __typename?: '__Type' } & Pick<__Type, 'kind' | 'name'> & { ofType: Maybe<({ __typename?: '__Type' } & Pick<__Type, 'name' | 'kind'> & { enumValues: Maybe<Array<({ __typename?: '__EnumValue' } & Pick<__EnumValue, 'name' | 'description'>)>> })> }) })>> })> });

export type GetUserExperimentsQueryVariables = {
  userId: Scalars['uuid']
};


export type GetUserExperimentsQuery = ({ __typename?: 'query_root' } & { user_by_pk: Maybe<({ __typename?: 'user' } & Pick<User, 'experiments'>)> });

export type GetUserUniqueNumberQueryVariables = {
  userId: Scalars['uuid']
};


export type GetUserUniqueNumberQuery = ({ __typename?: 'query_root' } & { user_by_pk: Maybe<({ __typename?: 'user' } & Pick<User, 'unique_number'>)> });

export type GetExperimentNamesQueryVariables = {};


export type GetExperimentNamesQuery = ({ __typename?: 'query_root' } & { experiment: Array<({ __typename?: 'experiment' } & Pick<Experiment, 'name'>)> });

export type GetExperimentsQueryVariables = {};


export type GetExperimentsQuery = ({ __typename?: 'query_root' } & { experiment: Array<({ __typename?: 'experiment' } & Pick<Experiment, 'name' | 'desc'>)> });

export type InsertFeedbackMutationVariables = {
  score: Scalars['numeric'],
  message?: Maybe<Scalars['String']>,
  message_type?: Maybe<Scalars['String']>,
  listingId: Scalars['uuid'],
  eventType?: Maybe<Listing_Event_Type_Enum>,
  feedbackItems?: Maybe<Scalars['jsonb']>
};


export type InsertFeedbackMutation = ({ __typename?: 'mutation_root' } & { insert_feedback: Maybe<({ __typename?: 'feedback_mutation_response' } & { returning: Array<({ __typename?: 'feedback' } & Pick<Feedback, 'id'>)> })> });

export type GetFrontendConfigQueryVariables = {};


export type GetFrontendConfigQuery = ({ __typename?: 'query_root' } & { frontend_config: Maybe<({ __typename?: 'frontend_config_response' } & Pick<Frontend_Config_Response, 'stripe_public_key'>)> });

export type SendDocumentEmailMutationVariables = {
  listingId: Scalars['uuid']
};


export type SendDocumentEmailMutation = ({ __typename?: 'mutation_root' } & { doc_verification_email: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error' | 'message'>)> });

export type InsertListingEventMutationVariables = {
  listingId: Scalars['uuid'],
  eventType: Listing_Event_Type_Enum
};


export type InsertListingEventMutation = ({ __typename?: 'mutation_root' } & { insert_listing_event_one: Maybe<({ __typename?: 'listing_event' } & Pick<Listing_Event, 'id'>)> });

export type GetListingEventQueryVariables = {
  listingId: Scalars['uuid'],
  eventType: Listing_Event_Type_Enum
};


export type GetListingEventQuery = ({ __typename?: 'query_root' } & { listing_event_aggregate: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }) });

export type GetListingEventByIdAndTypeQueryVariables = {
  listingId: Scalars['uuid'],
  listingEventType?: Maybe<Array<Listing_Event_Type_Enum>>
};


export type GetListingEventByIdAndTypeQuery = ({ __typename?: 'query_root' } & { listing_event: Array<({ __typename?: 'listing_event' } & Pick<Listing_Event, 'id' | 'created_at'>)> });

export type GetReasonSellingQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetReasonSellingQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'reason_selling' | 'reason_selling_other'> & { listing: ({ __typename?: 'listing' } & Pick<Listing, 'propertyDetails_propertyType'>) })> });

export type UpdateReasonSellingMutationVariables = {
  listingId: Scalars['uuid'],
  reasonSelling?: Maybe<Onboarding_Reason_Selling_Enum>,
  reasonSellingOther?: Maybe<Scalars['String']>
};


export type UpdateReasonSellingMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & { returning: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id'>)> })> });

export type GetTimeFrameSellingQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetTimeFrameSellingQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'timeframe_selling'>)> });

export type UpdateTimeframeSellingMutationVariables = {
  listingId: Scalars['uuid'],
  timeframeSelling?: Maybe<Onboarding_Timeframe_Selling_Enum>
};


export type UpdateTimeframeSellingMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & { returning: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id'>)> })> });

export type GetBudgetSizeQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetBudgetSizeQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'budget_size'>)> });

export type UpdateBudgetSizeMutationVariables = {
  listingId: Scalars['uuid'],
  budgetSize?: Maybe<Onboarding_Budget_Size_Enum>
};


export type UpdateBudgetSizeMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & { returning: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id'>)> })> });

export type GetFeedbackQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetFeedbackQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id' | 'rating_inspection' | 'rating_negotiation' | 'rating_overall' | 'rating_technology' | 'rating_valuing'>)> });

export type UpdateFeedbackMutationVariables = {
  listingId: Scalars['uuid'],
  ratingInspection?: Maybe<Scalars['Int']>,
  ratingNegotiation?: Maybe<Scalars['Int']>,
  ratingOverall?: Maybe<Scalars['Int']>,
  ratingTechnology?: Maybe<Scalars['Int']>,
  ratingValuing?: Maybe<Scalars['Int']>
};


export type UpdateFeedbackMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & { returning: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'rating_inspection' | 'rating_negotiation' | 'rating_overall' | 'rating_technology' | 'rating_valuing'>)> })> });

export type CreateOnboardingProgressMutationVariables = {
  listingId: Scalars['uuid']
};


export type CreateOnboardingProgressMutation = ({ __typename?: 'mutation_root' } & { insert_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & { returning: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id'>)> })> });

export type GetOnboardingProgressQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetOnboardingProgressQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id' | 'finished' | 'skipped' | 'step_completed' | 'user_id'>)> });

export type UpdateStepMutationVariables = {
  onboardingId: Scalars['uuid'],
  step_completed?: Maybe<Scalars['Int']>
};


export type UpdateStepMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & Pick<Listing_Onboarding_Mutation_Response, 'affected_rows'>)> });

export type UpdateFinishMutationVariables = {
  onboardingId: Scalars['uuid'],
  finished?: Maybe<Scalars['Boolean']>
};


export type UpdateFinishMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & Pick<Listing_Onboarding_Mutation_Response, 'affected_rows'>)> });

export type UpdateSkipMutationVariables = {
  onboardingId: Scalars['uuid'],
  skipped?: Maybe<Scalars['Boolean']>
};


export type UpdateSkipMutation = ({ __typename?: 'mutation_root' } & { update_listing_onboarding: Maybe<({ __typename?: 'listing_onboarding_mutation_response' } & Pick<Listing_Onboarding_Mutation_Response, 'affected_rows'>)> });

export type GetOnboardingProgressByUserQueryVariables = {
  userId: Scalars['uuid']
};


export type GetOnboardingProgressByUserQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id' | 'finished' | 'skipped' | 'listing_id' | 'step_completed'>)> });

export type GetOnboardingDataByListingIdQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetOnboardingDataByListingIdQuery = ({ __typename?: 'query_root' } & { listing_onboarding: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'finished' | 'skipped' | 'step_completed' | 'rating_inspection' | 'rating_technology' | 'rating_negotiation' | 'rating_valuing' | 'rating_overall' | 'reason_selling' | 'reason_selling_other' | 'timeframe_selling' | 'budget_size'>)> });

export type GetListingZoneQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingZoneQuery = ({ __typename?: 'query_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'zone'>)> });

export type GetListingByIdQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingByIdQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'summary' | 'description' | 'propertyDetails_address_1' | 'propertyDetails_address_2' | 'propertyDetails_address_street' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_municipality' | 'propertyDetails_address_postcode' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_streetDirectory_page' | 'propertyDetails_address_streetDirectory_type' | 'propertyDetails_address_streetDirectory_reference' | 'propertyDetails_address_suggestedGeoLocation' | 'propertyDetails_address_suggestedGeoLocation_latitude' | 'propertyDetails_address_suggestedGeoLocation_longitude' | 'delivery_address_1' | 'delivery_address_2' | 'delivery_address_street' | 'delivery_address_streetNumber' | 'delivery_address_state' | 'delivery_address_suburb' | 'delivery_address_postcode' | 'delivery_address_unitNumber' | 'delivery_address_suggestedGeoLocation_latitude' | 'delivery_address_suggestedGeoLocation_longitude' | 'delivery_to_property_address' | 'propertyDetails_propertyType' | 'propertyDetails_bedRooms' | 'propertyDetails_bathRooms' | 'propertyDetails_landArea_unit' | 'propertyDetails_landArea_value' | 'propertyDetails_area_value' | 'propertyDetails_area_unit' | 'propertyDetails_carSpaces' | 'availableFrom' | 'saleType' | 'propertyDetails_yearBuilt' | 'features' | 'price_asking' | 'price_single' | 'price_from' | 'price_to' | 'price_displayOption' | 'price_displayText' | 'price_textOption' | 'created_at' | 'updated_at' | 'status' | 'auction_dateTime' | 'auction_online' | 'commercial_status' | 'publishing_status' | 'proof_of_ownership_status' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating'> & { listing_inspections: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id' | 'from' | 'to' | 'is_private' | 'repeat'>)>, user: ({ __typename?: 'user' } & Pick<User, 'id' | 'phone_number' | 'phone_number_verified'>), paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status'>)> })> });

export type GetBasicListingDetailsByIdSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetBasicListingDetailsByIdSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'summary' | 'status' | 'commercial_status' | 'publishing_status' | 'saleType' | 'proof_of_ownership_status' | 'propertyDetails_address_state'> & { paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'>)> })>, openOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id' | 'addon_id'>)> })>, listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'>)> })> });

export type GetListingsSubscriptionVariables = {};


export type GetListingsSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'enquiry_code' | 'propertyDetails_address_street' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_municipality' | 'propertyDetails_address_postcode' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_streetDirectory_page' | 'propertyDetails_address_streetDirectory_type' | 'propertyDetails_address_streetDirectory_reference' | 'propertyDetails_address_suggestedGeoLocation' | 'propertyDetails_address_suggestedGeoLocation_latitude' | 'propertyDetails_address_suggestedGeoLocation_longitude' | 'status' | 'created_at' | 'updated_at' | 'commercial_status'> & { paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status'>)> })> });

export type GetOnboardingPropertyDetailByIdQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetOnboardingPropertyDetailByIdQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'saleType' | 'propertyDetails_propertyType' | 'propertyDetails_bedRooms' | 'propertyDetails_landArea_unit' | 'propertyDetails_landArea_value' | 'propertyDetails_address_suburb' | 'propertyDetails_address_state' | 'propertyDetails_address_postcode'>)> });

export type UpdateOnboardingPropertyDetailMutationVariables = {
  listingId: Scalars['uuid'],
  saleType?: Maybe<Scalars['String']>,
  propertyType?: Maybe<Scalars['String']>,
  bedrooms?: Maybe<Scalars['Int']>,
  landArea?: Maybe<Scalars['numeric']>,
  landAreaUnit?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  postCode?: Maybe<Scalars['String']>
};


export type UpdateOnboardingPropertyDetailMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type CreateEmptyListingMutationVariables = {
  insertPublishObject: Array<Listing_Publish_Status_Insert_Input>
};


export type CreateEmptyListingMutation = ({ __typename?: 'mutation_root' } & { insert_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'created_at'>)> })> });

export type DeleteListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type DeleteListingMutation = ({ __typename?: 'mutation_root' } & { delete_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateAddressDetailsMutationVariables = {
  listingId: Scalars['uuid'],
  street?: Maybe<Scalars['String']>,
  streetNumber?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  unitNumber?: Maybe<Scalars['String']>,
  displayOption?: Maybe<Scalars['String']>,
  lat?: Maybe<Scalars['numeric']>,
  lon?: Maybe<Scalars['numeric']>,
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>
};


export type UpdateAddressDetailsMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateAddressDetailsForPaymentMutationVariables = {
  listingId: Scalars['uuid'],
  street?: Maybe<Scalars['String']>,
  streetNumber?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  unitNumber?: Maybe<Scalars['String']>,
  displayOption?: Maybe<Scalars['String']>,
  lat?: Maybe<Scalars['numeric']>,
  lon?: Maybe<Scalars['numeric']>,
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>
};


export type UpdateAddressDetailsForPaymentMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateDeliveryAddressForPaymentMutationVariables = {
  listingId: Scalars['uuid'],
  street?: Maybe<Scalars['String']>,
  streetNumber?: Maybe<Scalars['String']>,
  state?: Maybe<Scalars['String']>,
  suburb?: Maybe<Scalars['String']>,
  postcode?: Maybe<Scalars['String']>,
  unitNumber?: Maybe<Scalars['String']>,
  lat?: Maybe<Scalars['numeric']>,
  lon?: Maybe<Scalars['numeric']>,
  address1?: Maybe<Scalars['String']>,
  address2?: Maybe<Scalars['String']>,
  deliverToPropertyAddress: Scalars['Boolean']
};


export type UpdateDeliveryAddressForPaymentMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type GetListingOwnerQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingOwnerQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & { paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id'>)>, user: ({ __typename?: 'user' } & Pick<User, 'id' | 'email_verified'>) })> });

export type GetListingsWithPaginationQueryVariables = {
  limit: Scalars['Int'],
  offset: Scalars['Int'],
  orderBy?: Maybe<Array<Listing_Order_By>>
};


export type GetListingsWithPaginationQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'status' | 'propertyDetails_address_state' | 'propertyDetails_address_postcode' | 'propertyDetails_address_suburb' | 'proof_of_ownership_status'> & { user: ({ __typename?: 'user' } & Pick<User, 'id' | 'email'>) })> });

export type GetListingsLengthSubscriptionVariables = {};


export type GetListingsLengthSubscription = ({ __typename?: 'subscription_root' } & { listing_aggregate: ({ __typename?: 'listing_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_aggregate_fields' } & Pick<Listing_Aggregate_Fields, 'count'>)> }) });

export type GetListingAddressDetailsByIdQueryQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingAddressDetailsByIdQueryQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'propertyDetails_address_street' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_postcode' | 'propertyDetails_address_unitNumber' | 'saleType'>)> });

export type GetDuplicateListingsForAddressQueryQueryVariables = {
  listingId: Scalars['String']
};


export type GetDuplicateListingsForAddressQueryQuery = ({ __typename?: 'query_root' } & { check_duplicate_listing_for_address: Maybe<({ __typename?: 'check_duplicate_listing_for_address' } & Pick<Check_Duplicate_Listing_For_Address, 'duplicate'>)> });

export type UpdateDescriptionMutationVariables = {
  listingId: Scalars['uuid'],
  headline: Scalars['String'],
  description: Scalars['String']
};


export type UpdateDescriptionMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateListingStatusMutationVariables = {
  userId: Scalars['uuid'],
  status?: Maybe<Scalars['String']>
};


export type UpdateListingStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateDetailsMutationVariables = {
  listingId: Scalars['uuid'],
  saleType: Scalars['String'],
  propertyType: Scalars['String'],
  bedrooms?: Maybe<Scalars['Int']>,
  bathrooms?: Maybe<Scalars['Int']>,
  availableFrom?: Maybe<Scalars['timestamptz']>,
  landArea?: Maybe<Scalars['numeric']>,
  landAreaUnit?: Maybe<Scalars['String']>,
  propertyArea?: Maybe<Scalars['numeric']>,
  propertyAreaUnit?: Maybe<Scalars['String']>,
  carSpaces?: Maybe<Scalars['Int']>,
  yearBuilt?: Maybe<Scalars['Int']>,
  garageSpaces?: Maybe<Scalars['Int']>,
  carportSpaces?: Maybe<Scalars['Int']>,
  energyRating?: Maybe<Scalars['numeric']>
};


export type UpdateDetailsMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdateFeaturesMutationVariables = {
  listingId: Scalars['uuid'],
  features: Scalars['String']
};


export type UpdateFeaturesMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type UpdatePriceMutationVariables = {
  listingId: Scalars['uuid'],
  askingPrice?: Maybe<Scalars['Int']>,
  singlePrice: Scalars['Int'],
  minPrice?: Maybe<Scalars['Int']>,
  maxPrice?: Maybe<Scalars['Int']>,
  displayText?: Maybe<Scalars['String']>,
  displayOption: Scalars['String'],
  textPriceOption?: Maybe<Scalars['String']>
};


export type UpdatePriceMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type InsertInspectionMutationVariables = {
  listingId: Scalars['uuid'],
  from?: Maybe<Scalars['timestamptz']>,
  to?: Maybe<Scalars['timestamptz']>,
  isPrivate?: Maybe<Scalars['Boolean']>,
  repeat?: Maybe<Scalars['Boolean']>
};


export type InsertInspectionMutation = ({ __typename?: 'mutation_root' } & { insert_listing_inspection: Maybe<({ __typename?: 'listing_inspection_mutation_response' } & { returning: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id' | 'from' | 'to' | 'repeat' | 'is_private'>)> })> });

export type UpdateInspectionMutationVariables = {
  inspectionId: Scalars['uuid'],
  from?: Maybe<Scalars['timestamptz']>,
  to?: Maybe<Scalars['timestamptz']>,
  isPrivate?: Maybe<Scalars['Boolean']>,
  repeat?: Maybe<Scalars['Boolean']>
};


export type UpdateInspectionMutation = ({ __typename?: 'mutation_root' } & { update_listing_inspection: Maybe<({ __typename?: 'listing_inspection_mutation_response' } & { returning: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id' | 'from' | 'to' | 'is_private' | 'repeat'>)> })> });

export type DeleteInspectionMutationVariables = {
  inspectionId: Scalars['uuid']
};


export type DeleteInspectionMutation = ({ __typename?: 'mutation_root' } & { delete_listing_inspection: Maybe<({ __typename?: 'listing_inspection_mutation_response' } & Pick<Listing_Inspection_Mutation_Response, 'affected_rows'>)> });

export type SetAuctionMutationVariables = {
  listingId: Scalars['uuid'],
  timestamp?: Maybe<Scalars['timestamptz']>,
  isOnline?: Maybe<Scalars['Boolean']>
};


export type SetAuctionMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & { returning: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'auction_dateTime' | 'auction_online'>)> })> });

export type GetListingEventsSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetListingEventsSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'auction_dateTime' | 'auction_online'> & { listing_inspections: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id' | 'from' | 'to' | 'is_private' | 'repeat'>)> })> });

export type GetListingByUserIdQueryVariables = {
  userId: Scalars['uuid']
};


export type GetListingByUserIdQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id'>)> });

export type GetListOfListingsSubscriptionVariables = {
  commercialStatus?: Maybe<Array<Commercial_Status_Type_Enum>>,
  publishingStatus?: Maybe<Array<Publishing_Status_Type_Enum>>
};


export type GetListOfListingsSubscription = ({ __typename?: 'subscription_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'price_displayText' | 'enquiry_code' | 'propertyDetails_area_value' | 'propertyDetails_area_unit' | 'propertyDetails_bathRooms' | 'propertyDetails_bedRooms' | 'propertyDetails_carSpaces' | 'propertyDetails_propertyType' | 'propertyDetails_landArea_value' | 'propertyDetails_landArea_unit' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_street' | 'propertyDetails_address_1' | 'propertyDetails_address_2' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_postcode' | 'saleType' | 'price_displayText' | 'price_textOption' | 'price_displayOption' | 'price_single' | 'price_from' | 'price_to' | 'price_asking' | 'commercial_status' | 'publishing_status' | 'proof_of_ownership_status' | 'auction_dateTime' | 'availableFrom' | 'summary' | 'description' | 'features' | 'owner_id' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating'> & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url'>)>, listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'finished' | 'skipped'>)>, user: ({ __typename?: 'user' } & Pick<User, 'phone_number_verified'>), listing_inspections: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id'>)>, paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id'>)>, feedbacks_aggregate: ({ __typename?: 'feedback_aggregate' } & { aggregate: Maybe<({ __typename?: 'feedback_aggregate_fields' } & Pick<Feedback_Aggregate_Fields, 'count'>)> }), visitedPreview: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }), visitedCampaign: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }) })> });

export type UpdateListingStatusByIdMutationVariables = {
  listingId: Scalars['uuid'],
  status?: Maybe<Scalars['String']>
};


export type UpdateListingStatusByIdMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type GetPaidCampaignOrdersByListingIdQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetPaidCampaignOrdersByListingIdQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'id'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'code'>)> })> })> });

export type GetOpenCampaignOrdersByListingIdQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetOpenCampaignOrdersByListingIdQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'created_from_template'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'code'>)> })> })> });

export type GetFeedbackCountQueryVariables = {
  listingId: Scalars['uuid'],
  eventType?: Maybe<Listing_Event_Type_Enum>
};


export type GetFeedbackCountQuery = ({ __typename?: 'query_root' } & { feedback_aggregate: ({ __typename?: 'feedback_aggregate' } & { aggregate: Maybe<({ __typename?: 'feedback_aggregate_fields' } & Pick<Feedback_Aggregate_Fields, 'count'>)> }) });

export type ReactivateListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type ReactivateListingMutation = ({ __typename?: 'mutation_root' } & { reactivate_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type GetRelistingAddonQueryVariables = {
  listingId: Scalars['String']
};


export type GetRelistingAddonQuery = ({ __typename?: 'query_root' } & { get_relisting_addon: Maybe<({ __typename?: 'AddonResponse' } & Pick<AddonResponse, 'id' | 'price'>)> });

export type UpdateListingCommercialStatusMutationVariables = {
  listingId: Scalars['uuid'],
  commercialStatus: Commercial_Status_Type_Enum
};


export type UpdateListingCommercialStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type SellListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type SellListingMutation = ({ __typename?: 'mutation_root' } & { sell_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type RentListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type RentListingMutation = ({ __typename?: 'mutation_root' } & { rent_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type UnderReviewListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type UnderReviewListingMutation = ({ __typename?: 'mutation_root' } & { under_review_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type WithdrawListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type WithdrawListingMutation = ({ __typename?: 'mutation_root' } & { withdraw_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type OnHoldListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type OnHoldListingMutation = ({ __typename?: 'mutation_root' } & { on_hold_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type UnderOfferListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type UnderOfferListingMutation = ({ __typename?: 'mutation_root' } & { under_offer_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type ListListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type ListListingMutation = ({ __typename?: 'mutation_root' } & { list_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type CheckAddonsBoughtByListingIdQueryVariables = {
  listingId: Scalars['uuid'],
  addon_ids?: Maybe<Array<Scalars['uuid']>>
};


export type CheckAddonsBoughtByListingIdQuery = ({ __typename?: 'query_root' } & { order_item: Array<({ __typename?: 'order_item' } & { addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id'>)> })> });

export type GetListingDataQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingDataQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'saleType' | 'commercial_status' | 'publishing_status' | 'auction_dateTime' | 'proof_of_ownership_status'> & { user: ({ __typename?: 'user' } & Pick<User, 'phone_number_verified'>), listing_inspections: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id'>)> })> });

export type FailPublishListingMutationVariables = {
  listingId: Scalars['uuid'],
  emailSend?: Maybe<Scalars['Boolean']>,
  message?: Maybe<Scalars['String']>
};


export type FailPublishListingMutation = ({ __typename?: 'mutation_root' } & { fail_publish_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type PendingPublishListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type PendingPublishListingMutation = ({ __typename?: 'mutation_root' } & { pending_publish_listing: Maybe<({ __typename?: 'ListingResponse' } & Pick<ListingResponse, 'updated'>)> });

export type GetListingOwnerWithOnBoardQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingOwnerWithOnBoardQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & { user: ({ __typename?: 'user' } & Pick<User, 'id'>), listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'id' | 'finished' | 'skipped' | 'step_completed' | 'user_id'>)> })> });

export type CheckOverlappingEventsQueryVariables = {
  listing_id: Scalars['uuid'],
  from: Scalars['timestamptz'],
  to: Scalars['timestamptz'],
  listing_inspection_id?: Maybe<Scalars['uuid']>
};


export type CheckOverlappingEventsQuery = ({ __typename?: 'query_root' } & { listing_inspection_aggregate: ({ __typename?: 'listing_inspection_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_inspection_aggregate_fields' } & Pick<Listing_Inspection_Aggregate_Fields, 'count'>)> }) });

export type CheckAuctionOverlappingInspectionEventsQueryVariables = {
  listing_id: Scalars['uuid'],
  date: Scalars['timestamptz']
};


export type CheckAuctionOverlappingInspectionEventsQuery = ({ __typename?: 'query_root' } & { listing_inspection_aggregate: ({ __typename?: 'listing_inspection_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_inspection_aggregate_fields' } & Pick<Listing_Inspection_Aggregate_Fields, 'count'>)> }) });

export type GetListingDetailsQueryVariables = {
  id: Scalars['uuid']
};


export type GetListingDetailsQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'propertyDetails_bathRooms' | 'propertyDetails_bedRooms' | 'propertyDetails_carSpaces' | 'propertyDetails_propertyType' | 'propertyDetails_landArea_value' | 'propertyDetails_address_streetNumber' | 'propertyDetails_address_unitNumber' | 'propertyDetails_address_street' | 'propertyDetails_address_displayOption' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_postcode' | 'saleType' | 'commercial_status' | 'publishing_status' | 'proof_of_ownership_status' | 'auction_dateTime' | 'availableFrom' | 'features' | 'description' | 'summary' | 'price_asking' | 'propertyDetails_garageSpaces' | 'propertyDetails_carportSpaces' | 'propertyDetails_energyEfficiencyRating'> & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url'>)>, listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'finished' | 'skipped'>)>, user: ({ __typename?: 'user' } & Pick<User, 'phone_number_verified'>), listing_inspections: Array<({ __typename?: 'listing_inspection' } & Pick<Listing_Inspection, 'id'>)>, paidOrders: Array<({ __typename?: 'order' } & Pick<Order, 'id'>)>, visitedPreview: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }), visitedCampaign: ({ __typename?: 'listing_event_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_event_aggregate_fields' } & Pick<Listing_Event_Aggregate_Fields, 'count'>)> }) })> });

export type UpdateListingPublishingStatusMutationVariables = {
  listingId: Scalars['uuid'],
  publishingStatus: Publishing_Status_Type_Enum
};


export type UpdateListingPublishingStatusMutation = ({ __typename?: 'mutation_root' } & { update_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'>)> });

export type InsertListingMetadataMutationVariables = {
  listingId: Scalars['uuid'],
  type?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['String']>
};


export type InsertListingMetadataMutation = ({ __typename?: 'mutation_root' } & { insert_listing_metadata_one: Maybe<({ __typename?: 'listing_metadata' } & Pick<Listing_Metadata, 'id'>)> });

export type GetNonProcessedListingMetadataQueryVariables = {
  listingId: Scalars['uuid'],
  type?: Maybe<Scalars['String']>
};


export type GetNonProcessedListingMetadataQuery = ({ __typename?: 'query_root' } & { listing_metadata: Array<({ __typename?: 'listing_metadata' } & Pick<Listing_Metadata, 'value'> & { listing: ({ __typename?: 'listing' } & Pick<Listing, 'saleType'>) })> });

export type MarkListingMetadataProcessedMutationVariables = {
  listingId: Scalars['uuid'],
  type?: Maybe<Scalars['String']>
};


export type MarkListingMetadataProcessedMutation = ({ __typename?: 'mutation_root' } & { update_listing_metadata: Maybe<({ __typename?: 'listing_metadata_mutation_response' } & Pick<Listing_Metadata_Mutation_Response, 'affected_rows'>)> });

export type DelistListingMutationVariables = {
  listingId: Scalars['uuid']
};


export type DelistListingMutation = ({ __typename?: 'mutation_root' } & { delist_from_all_portals: Maybe<({ __typename?: 'delist_response' } & Pick<Delist_Response, 'success' | 'error'>)> });

export type GetAllListingsQueryVariables = {};


export type GetAllListingsQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id'> & { listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'step_completed'>)>, orders: Array<({ __typename?: 'order' } & Pick<Order, 'status' | 'processed_by_id'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'>)> })> })> });

export type CreateEmptyListingByAdminMutationVariables = {
  ownerId: Scalars['uuid'],
  portalStatuses: Array<Listing_Publish_Status_Insert_Input>
};


export type CreateEmptyListingByAdminMutation = ({ __typename?: 'mutation_root' } & { insert_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'created_at'>)> })> });

export type ListingCreatedAtQueryVariables = {
  listingId: Scalars['uuid']
};


export type ListingCreatedAtQuery = ({ __typename?: 'query_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'created_at'>)> });

export type CreateOrderMutationVariables = {
  listingId: Scalars['uuid'],
  campaignId?: Maybe<Scalars['uuid']>,
  createdFromTemplate?: Maybe<Scalars['Boolean']>
};


export type CreateOrderMutation = ({ __typename?: 'mutation_root' } & { create_order: Maybe<({ __typename?: 'create_order_response' } & Pick<Create_Order_Response, 'id'>)> });

export type GetOrderByIdQueryVariables = {
  orderId: Scalars['uuid']
};


export type GetOrderByIdQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order_detail' } & Pick<Order_Detail, 'id' | 'listing_id' | 'status' | 'created_at' | 'updated_at' | 'order_total' | 'created_from_template'> & { listing: Maybe<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'enquiry_code'>)>, order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'id' | 'price' | 'item_qty' | 'processed_by_id' | 'qty_processed_by_admin'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'code'>)>, addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'code'>)> })>, transactions: Array<({ __typename?: 'transaction' } & Pick<Transaction, 'id' | 'amount' | 'order_id' | 'origin_id' | 'origin_type' | 'origin_status' | 'status' | 'json'>)> })> });

export type GetOrderByIdSubSubscriptionVariables = {
  orderId: Scalars['uuid']
};


export type GetOrderByIdSubSubscription = ({ __typename?: 'subscription_root' } & { order: Array<({ __typename?: 'order_detail' } & Pick<Order_Detail, 'id' | 'listing_id' | 'status' | 'created_at' | 'updated_at' | 'order_total' | 'order_total_without_discount'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'id' | 'price' | 'item_qty' | 'type' | 'removed' | 'name' | 'processed_by_id' | 'qty_processed_by_admin'> & { addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'price' | 'max_qty' | 'min_qty' | 'code'> & { order: Addon['group_order'] } & { addon_addon_groups: Array<({ __typename?: 'addon_addon_group' } & { addon_group: ({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'short_title' | 'order' | 'type'> & { campaign: Array<({ __typename?: 'campaign_addon_group' } & { id: Campaign_Addon_Group['campaign_id'] })> }) })>, inclusion_addons: Array<({ __typename?: 'inclusion_addon' } & { inclusion: ({ __typename?: 'inclusion' } & { inclusion_group: ({ __typename?: 'inclusion_group' } & { campaign_inclusion_groups: Array<({ __typename?: 'campaign_inclusion_group' } & Pick<Campaign_Inclusion_Group, 'campaign_id'>)> }) }) })> })>, campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'price' | 'price_description' | 'code'>)>, coupon: Maybe<({ __typename?: 'coupon' } & Pick<Coupon, 'code' | 'description' | 'campaign_id'>)> })>, transactions: Array<({ __typename?: 'transaction' } & Pick<Transaction, 'id' | 'amount' | 'order_id' | 'origin_id' | 'origin_type' | 'origin_status' | 'status'>)>, paidOrders: Maybe<({ __typename?: 'listing' } & { orders: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status'>)> })> })> });

export type DeleteOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type DeleteOrderMutation = ({ __typename?: 'mutation_root' } & { remove_order: Maybe<({ __typename?: 'remove_order_response' } & Pick<Remove_Order_Response, 'affected_rows'>)> });

export type GetListingOrdersQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetListingOrdersQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'id' | 'status' | 'created_at' | 'updated_at'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'id' | 'price'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name'>)> })> })> });

export type AddCampaignToOrderMutationVariables = {
  orderId: Scalars['uuid'],
  campaignId: Scalars['uuid']
};


export type AddCampaignToOrderMutation = ({ __typename?: 'mutation_root' } & { add_campaign_to_order: Maybe<({ __typename?: 'add_campaign_to_order_response' } & Pick<Add_Campaign_To_Order_Response, 'affected_rows'>)> });

export type ModifyOrderItemAddonMutationVariables = {
  addonId: Scalars['uuid'],
  orderId: Scalars['uuid'],
  qty: Scalars['Int']
};


export type ModifyOrderItemAddonMutation = ({ __typename?: 'mutation_root' } & { modify_order_item_addon: Maybe<({ __typename?: 'modify_order_item_addon_response' } & Pick<Modify_Order_Item_Addon_Response, 'affected_rows'>)> });

export type GetUnpaidOrderSubSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type GetUnpaidOrderSubSubscription = ({ __typename?: 'subscription_root' } & { order: Array<({ __typename?: 'order_detail' } & Pick<Order_Detail, 'id' | 'listing_id' | 'status' | 'order_total' | 'order_total_without_discount' | 'created_from_template'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'id' | 'price' | 'item_qty' | 'type' | 'removed' | 'name' | 'processed_by_id' | 'qty_processed_by_admin'> & { addon: Maybe<({ __typename?: 'addon' } & Pick<Addon, 'id' | 'name' | 'code' | 'price' | 'max_qty' | 'min_qty'> & { order: Addon['group_order'] } & { addon_addon_groups: Array<({ __typename?: 'addon_addon_group' } & { addon_group: ({ __typename?: 'addon_group' } & Pick<Addon_Group, 'id' | 'short_title' | 'order' | 'type'>) })>, inclusion_addons: Array<({ __typename?: 'inclusion_addon' } & { inclusion: ({ __typename?: 'inclusion' } & { inclusion_group: ({ __typename?: 'inclusion_group' } & { campaign_inclusion_groups: Array<({ __typename?: 'campaign_inclusion_group' } & Pick<Campaign_Inclusion_Group, 'campaign_id'>)> }) }) })> })>, campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'id' | 'name' | 'price' | 'price_description' | 'code'>)>, coupon: Maybe<({ __typename?: 'coupon' } & Pick<Coupon, 'code' | 'description' | 'campaign_id'>)> })> })> });

export type GetTransactionByListingAndStatusQueryVariables = {
  listingId: Scalars['uuid'],
  status?: Maybe<Transaction_Status_Enum>
};


export type GetTransactionByListingAndStatusQuery = ({ __typename?: 'query_root' } & { transaction: Array<({ __typename?: 'transaction' } & Pick<Transaction, 'id' | 'order_id' | 'origin_id' | 'origin_type'> & { order: ({ __typename?: 'order' } & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'>)> }) })> });

export type FindOpenTransactionByOrderIdQueryVariables = {
  orderId: Scalars['uuid']
};


export type FindOpenTransactionByOrderIdQuery = ({ __typename?: 'query_root' } & { transaction: Array<({ __typename?: 'transaction' } & Pick<Transaction, 'id' | 'order_id' | 'amount' | 'status' | 'origin_status' | 'origin_id' | 'origin_type' | 'payment_url' | 'json'>)> });

export type RemoveOrderItemMutationVariables = {
  orderItemId: Scalars['uuid']
};


export type RemoveOrderItemMutation = ({ __typename?: 'mutation_root' } & { delete_order_item_by_pk: Maybe<({ __typename?: 'order_item' } & Pick<Order_Item, 'id'>)> });

export type RemoveAllOrderItemsFromOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type RemoveAllOrderItemsFromOrderMutation = ({ __typename?: 'mutation_root' } & { delete_order_item: Maybe<({ __typename?: 'order_item_mutation_response' } & Pick<Order_Item_Mutation_Response, 'affected_rows'>)> });

export type ClearAddonsFromOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type ClearAddonsFromOrderMutation = ({ __typename?: 'mutation_root' } & { clear_addons_from_order: Maybe<({ __typename?: 'clear_addons_from_order_response' } & Pick<Clear_Addons_From_Order_Response, 'affected_rows'>)> });

export type RequestCancelOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type RequestCancelOrderMutation = ({ __typename?: 'mutation_root' } & { request_cancel_order: Maybe<({ __typename?: 'request_cancel_order_response' } & Pick<Request_Cancel_Order_Response, 'affected_rows'>)> });

export type CancelOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type CancelOrderMutation = ({ __typename?: 'mutation_root' } & { cancel_order: Maybe<({ __typename?: 'cancel_order_response' } & Pick<Cancel_Order_Response, 'affected_rows'>)> });

export type PayOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type PayOrderMutation = ({ __typename?: 'mutation_root' } & { pay_order: Maybe<({ __typename?: 'paid_order_response' } & Pick<Paid_Order_Response, 'affected_rows'>)> });

export type GetPaidOrdersQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetPaidOrdersQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'id'>)> });

export type GetOpenOrdersQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetOpenOrdersQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'id'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id'>)> })> });

export type GetAddonQtyByIdQueryVariables = {
  orderId: Scalars['uuid'],
  addonId: Scalars['uuid']
};


export type GetAddonQtyByIdQuery = ({ __typename?: 'query_root' } & { order_item: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'item_qty'>)> });

export type CheckoutOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type CheckoutOrderMutation = ({ __typename?: 'mutation_root' } & { checkout_order: Maybe<({ __typename?: 'checkout_order_response' } & Pick<Checkout_Order_Response, 'success' | 'fromPaymentMethod' | 'originId' | 'orderId'>)> });

export type ClearNormalAddonsFromOrderMutationVariables = {
  orderId: Scalars['uuid']
};


export type ClearNormalAddonsFromOrderMutation = ({ __typename?: 'mutation_root' } & { clear_normal_addons_from_order: Maybe<({ __typename?: 'clear_normal_addons_from_order_response' } & Pick<Clear_Normal_Addons_From_Order_Response, 'affected_rows'>)> });

export type UpdateOrderTotalByOrderIdMutationVariables = {
  orderId: Scalars['uuid'],
  newOrderTotal?: Maybe<Scalars['numeric']>
};


export type UpdateOrderTotalByOrderIdMutation = ({ __typename?: 'mutation_root' } & { update_order_total: Maybe<({ __typename?: 'update_order_total_response' } & Pick<Update_Order_Total_Response, 'affected_rows'>)> });

export type UpdateOrderItemStatusMutationVariables = {
  id: Scalars['uuid'],
  status: Order_Status_Enum
};


export type UpdateOrderItemStatusMutation = ({ __typename?: 'mutation_root' } & { update_order_item: Maybe<({ __typename?: 'order_item_mutation_response' } & Pick<Order_Item_Mutation_Response, 'affected_rows'>)> });

export type UpdateOrderItemRefundStatusMutationVariables = {
  id: Scalars['uuid'],
  status?: Maybe<Scalars['String']>
};


export type UpdateOrderItemRefundStatusMutation = ({ __typename?: 'mutation_root' } & { update_order_item: Maybe<({ __typename?: 'order_item_mutation_response' } & Pick<Order_Item_Mutation_Response, 'affected_rows'>)> });

export type UpdateOrderItemFulfillmentStatusMutationVariables = {
  id: Scalars['uuid'],
  status?: Maybe<Scalars['String']>
};


export type UpdateOrderItemFulfillmentStatusMutation = ({ __typename?: 'mutation_root' } & { update_order_item: Maybe<({ __typename?: 'order_item_mutation_response' } & Pick<Order_Item_Mutation_Response, 'affected_rows'>)> });

export type IsOrderRefundedQueryVariables = {
  orderId: Scalars['uuid']
};


export type IsOrderRefundedQuery = ({ __typename?: 'query_root' } & { order_item: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'refund_status'>)> });

export type CheckAddonPurchasedQueryVariables = {
  listingId: Scalars['uuid'],
  addonCodes?: Maybe<Array<Scalars['String']>>
};


export type CheckAddonPurchasedQuery = ({ __typename?: 'query_root' } & { order_item_aggregate: ({ __typename?: 'order_item_aggregate' } & { aggregate: Maybe<({ __typename?: 'order_item_aggregate_fields' } & Pick<Order_Item_Aggregate_Fields, 'count'>)> }) });

export type GetPurchasedAddonQtyByListingIdQueryVariables = {
  listingId: Scalars['uuid'],
  addonCode: Scalars['String']
};


export type GetPurchasedAddonQtyByListingIdQuery = ({ __typename?: 'query_root' } & { order_item_aggregate: ({ __typename?: 'order_item_aggregate' } & { aggregate: Maybe<({ __typename?: 'order_item_aggregate_fields' } & { sum: Maybe<({ __typename?: 'order_item_sum_fields' } & Pick<Order_Item_Sum_Fields, 'item_qty'>)> })> }) });

export type GetAllOpenOrdersQueryVariables = {};


export type GetAllOpenOrdersQuery = ({ __typename?: 'query_root' } & { order: Array<({ __typename?: 'order' } & Pick<Order, 'listing_id' | 'created_from_template'> & { order_items: Array<({ __typename?: 'order_item' } & Pick<Order_Item, 'campaign_id' | 'type'> & { campaign: Maybe<({ __typename?: 'campaign' } & Pick<Campaign, 'code'>)> })> })> });

export type HasPaidOrderQueryVariables = {
  listingId: Scalars['uuid']
};


export type HasPaidOrderQuery = ({ __typename?: 'query_root' } & { listing_by_pk: Maybe<({ __typename?: 'listing' } & { orders: Array<({ __typename?: 'order' } & Pick<Order, 'status'>)> })> });

export type OpenPayPayMutationVariables = {
  orderId: Scalars['uuid'],
  successUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  cancelUrl: Scalars['String']
};


export type OpenPayPayMutation = ({ __typename?: 'mutation_root' } & { openpay_pay: Maybe<({ __typename?: 'pay_response' } & Pick<Pay_Response, 'url'>)> });

export type OpenPayCheckTransactionMutationVariables = {
  originId: Scalars['String']
};


export type OpenPayCheckTransactionMutation = ({ __typename?: 'mutation_root' } & { openpay_check_transaction: Maybe<({ __typename?: 'check_transaction_response' } & Pick<Check_Transaction_Response, 'status'>)> });

export type PayPalPayMutationVariables = {
  orderId: Scalars['uuid'],
  successUrl: Scalars['String'],
  cancelUrl: Scalars['String']
};


export type PayPalPayMutation = ({ __typename?: 'mutation_root' } & { paypal_pay: Maybe<({ __typename?: 'pay_response' } & Pick<Pay_Response, 'url'>)> });

export type PayPalCheckTransactionMutationVariables = {
  originId: Scalars['String']
};


export type PayPalCheckTransactionMutation = ({ __typename?: 'mutation_root' } & { paypal_check_transaction: Maybe<({ __typename?: 'check_transaction_response' } & Pick<Check_Transaction_Response, 'status'>)> });

export type PoliPayMutationVariables = {
  orderId: Scalars['uuid'],
  successUrl: Scalars['String'],
  failureUrl: Scalars['String'],
  cancelUrl: Scalars['String'],
  homePageUrl: Scalars['String']
};


export type PoliPayMutation = ({ __typename?: 'mutation_root' } & { poli_pay: Maybe<({ __typename?: 'pay_response' } & Pick<Pay_Response, 'url'>)> });

export type PoliCheckTransactionMutationVariables = {
  originId: Scalars['String']
};


export type PoliCheckTransactionMutation = ({ __typename?: 'mutation_root' } & { poli_check_transaction: Maybe<({ __typename?: 'check_transaction_response' } & Pick<Check_Transaction_Response, 'status'>)> });

export type StripePayMutationVariables = {
  orderId: Scalars['uuid']
};


export type StripePayMutation = ({ __typename?: 'mutation_root' } & { stripe_pay: Maybe<({ __typename?: 'pay_response' } & Pick<Pay_Response, 'url'>)> });

export type StripeCheckTransactionMutationVariables = {
  originId: Scalars['String']
};


export type StripeCheckTransactionMutation = ({ __typename?: 'mutation_root' } & { stripe_check_transaction: Maybe<({ __typename?: 'check_transaction_response' } & Pick<Check_Transaction_Response, 'status'>)> });

export type CreateListingMutationVariables = {};


export type CreateListingMutation = ({ __typename?: 'mutation_root' } & { insert_listing: Maybe<({ __typename?: 'listing_mutation_response' } & Pick<Listing_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing' } & Pick<Listing, 'id'>)> })> });

export type UpdateOrderToMutationVariables = {
  listingMediaId?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['smallint']>
};


export type UpdateOrderToMutation = ({ __typename?: 'mutation_root' } & { update_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'order'>)> })> });

export type CreateListingMediaMutationVariables = {
  listingId?: Maybe<Scalars['uuid']>,
  type: Listing_Media_Type_Enum,
  order?: Maybe<Scalars['smallint']>
};


export type CreateListingMediaMutation = ({ __typename?: 'mutation_root' } & { delete_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'>)>, insert_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'>)> })> });

export type CreateListingDocumentMutationVariables = {
  listingId?: Maybe<Scalars['uuid']>,
  type: Listing_Document_Type_Enum
};


export type CreateListingDocumentMutation = ({ __typename?: 'mutation_root' } & { insert_listing_document: Maybe<({ __typename?: 'listing_document_mutation_response' } & Pick<Listing_Document_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'id'>)> })> });

export type DeleteListingMediaMutationVariables = {
  listingMediaId?: Maybe<Scalars['uuid']>
};


export type DeleteListingMediaMutation = ({ __typename?: 'mutation_root' } & { delete_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing_media' } & { listing: ({ __typename?: 'listing' } & Pick<Listing, 'id'>), attachment: Array<({ __typename?: 'attachment' } & Pick<Attachment, 'status'>)> })> })> });

export type DeleteListingDocumentMutationVariables = {
  listingDocumentId: Scalars['uuid']
};


export type DeleteListingDocumentMutation = ({ __typename?: 'mutation_root' } & { delete_listing_document: Maybe<({ __typename?: 'listing_document_mutation_response' } & Pick<Listing_Document_Mutation_Response, 'affected_rows'>)> });

export type InsertAttachmentMutationVariables = {
  listingMediaId?: Maybe<Scalars['uuid']>,
  type: Attachment_Type_Enum,
  parentType: Attachment_Parent_Type_Enum
};


export type InsertAttachmentMutation = ({ __typename?: 'mutation_root' } & { insert_attachment: Maybe<({ __typename?: 'attachment_mutation_response' } & { returning: Array<({ __typename?: 'attachment' } & Pick<Attachment, 'id'>)> })> });

export type GetAttachmentUploadQueryVariables = {
  attachmentId: Scalars['uuid'],
  extension: Scalars['String']
};


export type GetAttachmentUploadQuery = ({ __typename?: 'query_root' } & { attachment_upload_credential: Maybe<({ __typename?: 'upload_credential' } & Pick<Upload_Credential, 'expires_at' | 'url'>)> });

export type GetAttachmentsFromListingQueryVariables = {
  listingId?: Maybe<Scalars['uuid']>,
  type?: Maybe<Attachment_Type_Enum>
};


export type GetAttachmentsFromListingQuery = ({ __typename?: 'query_root' } & { listing: Array<({ __typename?: 'listing' } & Pick<Listing, 'id'> & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'> & { attachment: Array<({ __typename?: 'attachment' } & Pick<Attachment, 'created_at' | 'download_url' | 'id' | 'type' | 'parent_id' | 'status' | 'updated_at'>)> })> })> });

export type UpdateAttachmentDownloadUrlMutationMutationVariables = {
  attachmentId: Scalars['uuid'],
  url: Scalars['String']
};


export type UpdateAttachmentDownloadUrlMutationMutation = ({ __typename?: 'mutation_root' } & { update_attachment: Maybe<({ __typename?: 'attachment_mutation_response' } & { returning: Array<({ __typename?: 'attachment' } & Pick<Attachment, 'id'>)> })> });

export type ListingMediaDataQueryVariables = {
  listingId: Scalars['uuid']
};


export type ListingMediaDataQuery = ({ __typename?: 'query_root' } & { listing_media_aggregate: ({ __typename?: 'listing_media_aggregate' } & { aggregate: Maybe<({ __typename?: 'listing_media_aggregate_fields' } & Pick<Listing_Media_Aggregate_Fields, 'count'>)> }) });

export type CreateStatementOfInformationMediaMutationVariables = {
  listingId?: Maybe<Scalars['uuid']>
};


export type CreateStatementOfInformationMediaMutation = ({ __typename?: 'mutation_root' } & { insert_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'>)> })> });

export type GetUsersQueryVariables = {};


export type GetUsersQuery = ({ __typename?: 'query_root' } & { user: Array<({ __typename?: 'user' } & Pick<User, 'id' | 'first_name' | 'email'>)> });

export type GetUserByIdQueryVariables = {
  userId: Scalars['uuid']
};


export type GetUserByIdQuery = ({ __typename?: 'query_root' } & { user: Array<({ __typename?: 'user' } & Pick<User, 'id' | 'first_name' | 'last_name' | 'email' | 'email_verified' | 'submitted_via' | 'initial_submitted_via'>)> });

export type UpdateUserRoleMutationVariables = {
  userId: Scalars['uuid'],
  role?: Maybe<Scalars['String']>,
  allowedRole?: Maybe<Scalars['String']>
};


export type UpdateUserRoleMutation = ({ __typename?: 'mutation_root' } & { update_user: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)> });

export type SendOnboardingEmailQueryVariables = {
  userId: Scalars['String']
};


export type SendOnboardingEmailQuery = ({ __typename?: 'query_root' } & { send_onboarding_email: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error'>)> });

export type SendPurchaseEmailQueryVariables = {
  orderId: Scalars['String']
};


export type SendPurchaseEmailQuery = ({ __typename?: 'query_root' } & { send_purchase_email: Maybe<({ __typename?: 'MailSentResponse' } & Pick<MailSentResponse, 'success' | 'error'>)> });

export type GetStaffUsersSubscriptionVariables = {};


export type GetStaffUsersSubscription = ({ __typename?: 'subscription_root' } & { user: Array<({ __typename?: 'user' } & Pick<User, 'id' | 'first_name' | 'last_name' | 'email'>)> });

export type SetUserEmailVerificationMutationVariables = {
  userId: Scalars['uuid'],
  email_verified?: Maybe<Scalars['Boolean']>
};


export type SetUserEmailVerificationMutation = ({ __typename?: 'mutation_root' } & { update_user_email_verification: Maybe<({ __typename?: 'update_user_email_verification_response' } & Pick<Update_User_Email_Verification_Response, 'affected_rows'>)> });

export type GetUserDetailByIdQueryVariables = {
  userId: Scalars['uuid']
};


export type GetUserDetailByIdQuery = ({ __typename?: 'query_root' } & { user: Array<({ __typename?: 'user' } & Pick<User, 'id' | 'phone_number_verified'> & { listings: Array<({ __typename?: 'listing' } & Pick<Listing, 'id' | 'propertyDetails_address_1' | 'propertyDetails_address_2' | 'propertyDetails_address_state' | 'propertyDetails_address_suburb' | 'propertyDetails_address_postcode'> & { listing_onboardings: Array<({ __typename?: 'listing_onboarding' } & Pick<Listing_Onboarding, 'finished' | 'skipped'>)> })> })> });

export type UpdateUserPhoneNumberMutationVariables = {
  id: Scalars['uuid'],
  mobileNumber: Scalars['String']
};


export type UpdateUserPhoneNumberMutation = ({ __typename?: 'mutation_root' } & { update_user: Maybe<({ __typename?: 'user_mutation_response' } & Pick<User_Mutation_Response, 'affected_rows'>)> });

export type CreateEmptyMediaLinkMutationVariables = {
  listingId: Scalars['uuid'],
  type: Listing_Media_Type_Enum
};


export type CreateEmptyMediaLinkMutation = ({ __typename?: 'mutation_root' } & { insert_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'> & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'created_at'>)> })> });

export type UpdateMediaLinkMutationVariables = {
  listingId: Scalars['uuid'],
  type: Listing_Media_Type_Enum,
  url?: Maybe<Scalars['String']>
};


export type UpdateMediaLinkMutation = ({ __typename?: 'mutation_root' } & { update_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'>)> });

export type GetMediaLinkByListingIdQueryVariables = {
  listingId: Scalars['uuid'],
  type: Listing_Media_Type_Enum
};


export type GetMediaLinkByListingIdQuery = ({ __typename?: 'query_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'url'>)> });

export type HeroImageSubscriptionVariables = {
  listingId: Scalars['uuid']
};


export type HeroImageSubscription = ({ __typename?: 'subscription_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'url' | 'thumbnail_284' | 'thumbnail_568' | 'thumbnail_852'>)> });

export type GetStockPhotosForMediaQueryVariables = {};


export type GetStockPhotosForMediaQuery = ({ __typename?: 'query_root' } & { stock_photo: Array<({ __typename?: 'stock_photo' } & Pick<Stock_Photo, 'url'>)> });

export type ReplaceStockPhotoForMediaMutationVariables = {
  listingId: Scalars['uuid'],
  stockPhotoUrl: Scalars['String']
};


export type ReplaceStockPhotoForMediaMutation = ({ __typename?: 'mutation_root' } & { delete_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & Pick<Listing_Media_Mutation_Response, 'affected_rows'>)>, insert_listing_media_one: Maybe<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id'>)> });

export type UpdateAttachmentDownloadUrlMutationVariables = {
  attachmentId: Scalars['uuid'],
  url: Scalars['String']
};


export type UpdateAttachmentDownloadUrlMutation = ({ __typename?: 'mutation_root' } & { update_attachment: Maybe<({ __typename?: 'attachment_mutation_response' } & { returning: Array<({ __typename?: 'attachment' } & Pick<Attachment, 'id'>)> })> });

export type GetFloorPlansForMediaQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetFloorPlansForMediaQuery = ({ __typename?: 'query_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'order' | 'attachment_id' | 'type'>)> });

export type UpdateFloorPlanOrderMutationVariables = {
  listingMediaId?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['smallint']>
};


export type UpdateFloorPlanOrderMutation = ({ __typename?: 'mutation_root' } & { update_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'order'>)> })> });

export type GetPhotosForMediaQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetPhotosForMediaQuery = ({ __typename?: 'query_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'order' | 'attachment_id' | 'type'>)> });

export type UpdatePhotoOrderMutationVariables = {
  listingMediaId?: Maybe<Scalars['uuid']>,
  order?: Maybe<Scalars['smallint']>
};


export type UpdatePhotoOrderMutation = ({ __typename?: 'mutation_root' } & { update_listing_media: Maybe<({ __typename?: 'listing_media_mutation_response' } & { returning: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'order'>)> })> });

export type GetProofOfIdForMediaQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetProofOfIdForMediaQuery = ({ __typename?: 'query_root' } & { listing_document: Array<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'id' | 'url' | 'type'>)> });

export type GetProofOfOwnershipIdForMediaQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetProofOfOwnershipIdForMediaQuery = ({ __typename?: 'query_root' } & { listing_document: Array<({ __typename?: 'listing_document' } & Pick<Listing_Document, 'id' | 'url' | 'type'>)> });

export type GetStatementOfInformationMediaQueryVariables = {
  listingId: Scalars['uuid']
};


export type GetStatementOfInformationMediaQuery = ({ __typename?: 'query_root' } & { listing_media: Array<({ __typename?: 'listing_media' } & Pick<Listing_Media, 'id' | 'url' | 'order' | 'attachment_id' | 'type'>)> });
